export default {
    "scalars": [
        7,
        12,
        18,
        22,
        26,
        27,
        28,
        32,
        33,
        39,
        40,
        41,
        49,
        50,
        55,
        61,
        64,
        65,
        69,
        71,
        73,
        74,
        79,
        80,
        83,
        84,
        87,
        89,
        100,
        101,
        106,
        111,
        113,
        119,
        120,
        122,
        132,
        133,
        137,
        144,
        146,
        147,
        167,
        168,
        169,
        173,
        174,
        179,
        187,
        198,
        199,
        206,
        212,
        214,
        221,
        225,
        232,
        233,
        240,
        242,
        243,
        244,
        249,
        258,
        259,
        265,
        266,
        271,
        276,
        286,
        289,
        351,
        352,
        355,
        357,
        364,
        370,
        371,
        376,
        382,
        384,
        389,
        393,
        394,
        399,
        407,
        410,
        421,
        423,
        424,
        425,
        426,
        431,
        433,
        434,
        436,
        443,
        448,
        451,
        453,
        454,
        455,
        468,
        469,
        475,
        484,
        488,
        490,
        493,
        502,
        503,
        507,
        508,
        509,
        510,
        515,
        523,
        527,
        529,
        531,
        534,
        535,
        536,
        537,
        538,
        546,
        553,
        562,
        564,
        570,
        572,
        573,
        592,
        598,
        600,
        601,
        602,
        603,
        607,
        608,
        613,
        615,
        616,
        617,
        618,
        619,
        629,
        630,
        632,
        637,
        643,
        658,
        668,
        669,
        670,
        680,
        686,
        691,
        700,
        701,
        703,
        704,
        705,
        710,
        712,
        716,
        721,
        723,
        724,
        726,
        732,
        733,
        740,
        747,
        753,
        760,
        764,
        768,
        770,
        779,
        797,
        798,
        803,
        808,
        810,
        817,
        822,
        828,
        833,
        834,
        837,
        846,
        848,
        855,
        867,
        873,
        876,
        881,
        886,
        892,
        898,
        903,
        912,
        913,
        916,
        918,
        919,
        920,
        925,
        927,
        948,
        956,
        959,
        961,
        962,
        965,
        967,
        968,
        969,
        970,
        977,
        981,
        983,
        986,
        991,
        999,
        1003,
        1005,
        1006,
        1016,
        1021,
        1023,
        1024,
        1026,
        1034,
        1036,
        1037,
        1038,
        1049,
        1052,
        1056,
        1062,
        1063,
        1064,
        1065,
        1073,
        1077,
        1078,
        1084,
        1088,
        1089,
        1101,
        1108,
        1109,
        1110,
        1114,
        1116,
        1117,
        1119,
        1120,
        1124,
        1125,
        1128,
        1140,
        1142,
        1143,
        1149,
        1155,
        1165,
        1166,
        1171,
        1172,
        1179,
        1183,
        1187,
        1188,
        1193,
        1199,
        1209,
        1214,
        1215,
        1222,
        1233,
        1235,
        1236,
        1237,
        1245,
        1247,
        1248,
        1249,
        1251,
        1258,
        1260,
        1261,
        1269,
        1271,
        1272,
        1274,
        1277,
        1284,
        1285,
        1287,
        1294,
        1298,
        1303,
        1304,
        1307,
        1308,
        1311,
        1371,
        1376,
        1387,
        1388,
        1389,
        1391,
        1396,
        1400,
        1401,
        1410,
        1414,
        1415,
        1421,
        1423,
        1425,
        1433,
        1437,
        1439,
        1440,
        1443,
        1444,
        1446
    ],
    "types": {
        "AcceptCustomerInvitationInput": {
            "token": [
                1199
            ],
            "userData": [
                1381
            ],
            "__typename": [
                1199
            ]
        },
        "AcceptCustomerInvitationResult": {
            "customerOrganizationId": [
                607
            ],
            "customerOrganizationName": [
                1199
            ],
            "invitation": [
                367
            ],
            "success": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "AccessURLPayload": {
            "expiresAt": [
                1247
            ],
            "url": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "Account": {
            "accountManagerIds": [
                607
            ],
            "accountManagers": [
                1372
            ],
            "addresses": [
                4
            ],
            "balances": [
                835
            ],
            "bills": [
                110
            ],
            "canBeInvited": [
                137
            ],
            "contacts": [
                255
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "customAttributes": [
                828
            ],
            "defaultPurchasePaymentTerm": [
                921
            ],
            "defaultPurchasePaymentTermId": [
                607
            ],
            "defaultSalesPaymentTerm": [
                921
            ],
            "defaultSalesPaymentTermId": [
                607
            ],
            "dotNumber": [
                1199
            ],
            "email": [
                1199
            ],
            "id": [
                607
            ],
            "individualDetails": [
                19
            ],
            "insuranceExpiration": [
                168
            ],
            "invoices": [
                713
            ],
            "linkedOrganizationId": [
                607
            ],
            "mcNumber": [
                1199
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "paymentSchedulePreference": [
                1199
            ],
            "paymentTypePreference": [
                1199
            ],
            "pendingTransactions": [
                619
            ],
            "phone": [
                1199
            ],
            "primaryContact": [
                255
            ],
            "purchasesVolume": [
                835
            ],
            "relationship": [
                23
            ],
            "salesVolume": [
                835
            ],
            "scac": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "type": [
                27
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "w9OnFile": [
                137
            ],
            "website": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "AccountAddress": {
            "account": [
                3
            ],
            "accountId": [
                607
            ],
            "address": [
                30
            ],
            "contacts": [
                255
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "customAttributes": [
                828
            ],
            "id": [
                607
            ],
            "locationType": [
                32
            ],
            "name": [
                1199
            ],
            "operatingHours": [
                828
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "AccountAddressFilter": {
            "accountId": [
                607
            ],
            "accountIds": [
                607
            ],
            "addressType": [
                1199
            ],
            "city": [
                1199
            ],
            "country": [
                1199
            ],
            "ids": [
                607
            ],
            "isCustomer": [
                137
            ],
            "isSupplier": [
                137
            ],
            "locationType": [
                32
            ],
            "locationTypes": [
                32
            ],
            "name": [
                1199
            ],
            "postalCode": [
                1199
            ],
            "searchByAccountName": [
                137
            ],
            "searchTerm": [
                1199
            ],
            "state": [
                1199
            ],
            "streetAddress": [
                1199
            ],
            "streetAddress2": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "AccountAddressResultPage": {
            "entries": [
                4
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "AccountAddressSortOption": {},
        "AccountBankDetail": {
            "accountId": [
                607
            ],
            "accountNumber": [
                1199
            ],
            "accountType": [
                1199
            ],
            "bankName": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "id": [
                607
            ],
            "isPrimary": [
                137
            ],
            "nickname": [
                1199
            ],
            "routingNumber": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "AccountBankDetailFilter": {
            "accountId": [
                607
            ],
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "AccountBankDetailInput": {
            "accountId": [
                607
            ],
            "accountNumber": [
                1199
            ],
            "accountType": [
                1199
            ],
            "bankName": [
                1199
            ],
            "isPrimary": [
                137
            ],
            "nickname": [
                1199
            ],
            "routingNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "AccountBankDetailResultPage": {
            "entries": [
                8
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "AccountBankDetailSortOption": {},
        "AccountBankDetailUpdateInput": {
            "accountId": [
                607
            ],
            "accountNumber": [
                1199
            ],
            "accountType": [
                1199
            ],
            "bankName": [
                1199
            ],
            "isPrimary": [
                137
            ],
            "nickname": [
                1199
            ],
            "routingNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "AccountFilter": {
            "accountManagerIds": [
                607
            ],
            "accountType": [
                27
            ],
            "defaultPurchasePaymentTermId": [
                607
            ],
            "defaultPurchasePaymentTermIds": [
                607
            ],
            "defaultSalesPaymentTermId": [
                607
            ],
            "defaultSalesPaymentTermIds": [
                607
            ],
            "dotNumber": [
                1199
            ],
            "email": [
                1199
            ],
            "fromInsuranceExpiration": [
                168
            ],
            "ids": [
                607
            ],
            "includeContacts": [
                137
            ],
            "isCarrier": [
                137
            ],
            "isCustomer": [
                137
            ],
            "isSupplier": [
                137
            ],
            "linkedOrganizationId": [
                607
            ],
            "linkedOrganizationIds": [
                607
            ],
            "mcNumber": [
                1199
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "paymentSchedulePreference": [
                1199
            ],
            "paymentTypePreference": [
                1199
            ],
            "phone": [
                1199
            ],
            "scac": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "toInsuranceExpiration": [
                168
            ],
            "website": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "AccountIdentityDocument": {
            "accountIndividualDetailsId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "documentNumber": [
                1199
            ],
            "documentType": [
                608
            ],
            "expirationDate": [
                168
            ],
            "id": [
                607
            ],
            "individualDetails": [
                19
            ],
            "issueDate": [
                168
            ],
            "issuingState": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "AccountIdentityDocumentFilter": {
            "accountIndividualDetailsIds": [
                607
            ],
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "AccountIdentityDocumentResultPage": {
            "entries": [
                15
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "AccountIdentityDocumentSortOption": {},
        "AccountIndividualDetails": {
            "account": [
                3
            ],
            "accountId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "dateOfBirth": [
                168
            ],
            "employer": [
                1199
            ],
            "eyeColor": [
                615
            ],
            "hairColor": [
                616
            ],
            "height": [
                619
            ],
            "id": [
                607
            ],
            "identityDocuments": [
                15
            ],
            "race": [
                617
            ],
            "sex": [
                618
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "weight": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "AccountIndividualDetailsFilter": {
            "accountIds": [
                607
            ],
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "AccountIndividualDetailsResultPage": {
            "entries": [
                19
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "AccountIndividualDetailsSortOption": {},
        "AccountRelationship": {
            "isCarrier": [
                137
            ],
            "isCustomer": [
                137
            ],
            "isSupplier": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "AccountRelationshipInput": {
            "isCarrier": [
                137
            ],
            "isCustomer": [
                137
            ],
            "isSupplier": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "AccountResultPage": {
            "entries": [
                3
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "AccountSortOption": {},
        "AccountType": {},
        "ActionType": {},
        "AddUsersToRoleInput": {
            "facilityId": [
                607
            ],
            "roleId": [
                607
            ],
            "userIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "Address": {
            "addressType": [
                33
            ],
            "city": [
                1199
            ],
            "coordinates": [
                274
            ],
            "country": [
                1199
            ],
            "isMailingAddress": [
                137
            ],
            "postalCode": [
                1199
            ],
            "state": [
                1199
            ],
            "streetAddress": [
                1199
            ],
            "streetAddress2": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "AddressInput": {
            "addressType": [
                33
            ],
            "city": [
                1199
            ],
            "coordinates": [
                275
            ],
            "country": [
                1199
            ],
            "isMailingAddress": [
                137
            ],
            "postalCode": [
                1199
            ],
            "state": [
                1199
            ],
            "streetAddress": [
                1199
            ],
            "streetAddress2": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "AddressLocationType": {},
        "AddressType": {},
        "AffectedLoad": {
            "documentNumber": [
                1199
            ],
            "id": [
                607
            ],
            "status": [
                798
            ],
            "__typename": [
                1199
            ]
        },
        "Agent": {
            "agentIdentifier": [
                1199
            ],
            "content": [
                1199
            ],
            "createdById": [
                607
            ],
            "description": [
                1199
            ],
            "id": [
                607
            ],
            "isActive": [
                137
            ],
            "model": [
                1199
            ],
            "modelProvider": [
                834
            ],
            "name": [
                1199
            ],
            "organizationId": [
                607
            ],
            "providerApiKey": [
                1199
            ],
            "providerBaseUrl": [
                1199
            ],
            "reasoningBudget": [
                619
            ],
            "reasoningEnabled": [
                137
            ],
            "temperature": [
                538
            ],
            "timestamps": [
                1250
            ],
            "tools": [
                1199
            ],
            "type": [
                40
            ],
            "version": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "AgentFilter": {
            "agentIdentifier": [
                1199
            ],
            "ids": [
                607
            ],
            "isActive": [
                137
            ],
            "name": [
                1199
            ],
            "organizationId": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "type": [
                40
            ],
            "__typename": [
                1199
            ]
        },
        "AgentMetadata": {
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "version": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "AgentResultPage": {
            "entries": [
                35
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "AgentSortOption": {},
        "AgentType": {},
        "Any": {},
        "ApplyAdvanceInput": {
            "appliedAmount": [
                836
            ],
            "documentId": [
                607
            ],
            "documentType": [
                913
            ],
            "paymentId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ApplyPaymentToBillInput": {
            "appliedAmount": [
                836
            ],
            "billId": [
                607
            ],
            "paymentId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ApplyPaymentToInvoiceInput": {
            "appliedAmount": [
                836
            ],
            "invoiceId": [
                607
            ],
            "paymentId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ApprovalNode": {
            "approvers": [
                51
            ],
            "description": [
                1199
            ],
            "id": [
                607
            ],
            "instructions": [
                1199
            ],
            "label": [
                1199
            ],
            "position": [
                949
            ],
            "timeoutAction": [
                1248
            ],
            "timeoutDuration": [
                619
            ],
            "timeoutEnabled": [
                137
            ],
            "timeoutUnit": [
                1249
            ],
            "type": [
                848
            ],
            "__typename": [
                1199
            ]
        },
        "ApprovalRequest": {
            "automation": [
                94
            ],
            "automationId": [
                607
            ],
            "comment": [
                1199
            ],
            "executionData": [
                828
            ],
            "executionRun": [
                465
            ],
            "executionRunId": [
                607
            ],
            "expiresAt": [
                1446
            ],
            "id": [
                607
            ],
            "instructions": [
                1199
            ],
            "nodeId": [
                1199
            ],
            "nodeLabel": [
                1199
            ],
            "organization": [
                887
            ],
            "organizationId": [
                607
            ],
            "requestedAt": [
                1446
            ],
            "respondedAt": [
                1446
            ],
            "respondedBy": [
                607
            ],
            "respondedByUser": [
                1372
            ],
            "status": [
                50
            ],
            "timestamps": [
                1250
            ],
            "workflowId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ApprovalRequestFilter": {
            "automationId": [
                607
            ],
            "executionRunId": [
                607
            ],
            "status": [
                50
            ],
            "__typename": [
                1199
            ]
        },
        "ApprovalRequestResultPage": {
            "entries": [
                46
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ApprovalRequestSortOption": {},
        "ApprovalRequestStatus": {},
        "ApproverConfig": {
            "roleIds": [
                1199
            ],
            "userIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ApproverConfigInput": {
            "roleIds": [
                1199
            ],
            "userIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ArchiveDownloadPayload": {
            "downloadUrl": [
                1199
            ],
            "estimatedSize": [
                538
            ],
            "expiresAt": [
                1247
            ],
            "fileName": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "Asset": {
            "account": [
                3
            ],
            "accountAddress": [
                4
            ],
            "accountAddressId": [
                607
            ],
            "accountId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "currentLocation": [
                30
            ],
            "customAttributes": [
                828
            ],
            "description": [
                1199
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "fillState": [
                55
            ],
            "id": [
                607
            ],
            "identifier": [
                1199
            ],
            "lastLocationTime": [
                1446
            ],
            "locationHistory": [
                57
            ],
            "notes": [
                1199
            ],
            "status": [
                65
            ],
            "tareWeight": [
                1424
            ],
            "timestamps": [
                1250
            ],
            "type": [
                66
            ],
            "typeId": [
                607
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "AssetFillState": {},
        "AssetFilter": {
            "accountAddressIds": [
                607
            ],
            "accountIds": [
                607
            ],
            "facilityIds": [
                607
            ],
            "identifier": [
                1199
            ],
            "ids": [
                607
            ],
            "lastUpdatedAt": [
                1446
            ],
            "searchTerm": [
                1199
            ],
            "status": [
                65
            ],
            "typeIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "AssetLocationHistory": {
            "asset": [
                54
            ],
            "assetId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "id": [
                607
            ],
            "source": [
                1199
            ],
            "timestamp": [
                1446
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "AssetLocationHistoryFilter": {
            "assetId": [
                607
            ],
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "AssetLocationHistoryInput": {
            "assetId": [
                607
            ],
            "location": [
                943
            ],
            "source": [
                1199
            ],
            "timestamp": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "AssetLocationHistoryResultPage": {
            "entries": [
                57
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "AssetLocationHistorySortOption": {},
        "AssetLocationHistoryUpdateInput": {
            "assetId": [
                607
            ],
            "location": [
                943
            ],
            "source": [
                1199
            ],
            "timestamp": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "AssetResultPage": {
            "entries": [
                54
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "AssetSortOption": {},
        "AssetStatus": {},
        "AssetType": {
            "capacity": [
                538
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "description": [
                1199
            ],
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "AssetTypeFilter": {
            "accountAddressIds": [
                607
            ],
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "name": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "AssetTypeResultPage": {
            "entries": [
                66
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "AssetTypeSortOption": {},
        "AssignUserRoleInput": {
            "facilityId": [
                607
            ],
            "roleId": [
                607
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "AssignmentStatus": {},
        "AssistantAgentStreamEvent": {
            "chatId": [
                607
            ],
            "content": [
                1199
            ],
            "conversationTitle": [
                1199
            ],
            "error": [
                1199
            ],
            "issuedAt": [
                1446
            ],
            "metadata": [
                828
            ],
            "thinkingStep": [
                1199
            ],
            "toolCall": [
                1275
            ],
            "type": [
                73
            ],
            "__typename": [
                1199
            ]
        },
        "AssistantAgentStreamEventType": {},
        "AssistantAggregateType": {},
        "AssistantChat": {
            "agent": [
                37
            ],
            "agentId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "id": [
                607
            ],
            "isShared": [
                137
            ],
            "messages": [
                77
            ],
            "organizationId": [
                607
            ],
            "shareLink": [
                82
            ],
            "status": [
                84
            ],
            "timestamps": [
                1250
            ],
            "title": [
                1199
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "AssistantChatFilter": {
            "createdBy": [
                607
            ],
            "ids": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "status": [
                84
            ],
            "updatedBy": [
                607
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "AssistantChatMessage": {
            "agent": [
                37
            ],
            "agentId": [
                607
            ],
            "chatId": [
                607
            ],
            "createdAt": [
                1446
            ],
            "id": [
                607
            ],
            "parts": [
                78
            ],
            "role": [
                80
            ],
            "__typename": [
                1199
            ]
        },
        "AssistantChatMessagePart": {
            "data": [
                828
            ],
            "dataType": [
                1199
            ],
            "errorText": [
                1199
            ],
            "filename": [
                1199
            ],
            "id": [
                607
            ],
            "input": [
                828
            ],
            "mediaType": [
                1199
            ],
            "output": [
                828
            ],
            "providerExecuted": [
                137
            ],
            "providerMetadata": [
                828
            ],
            "sequence": [
                619
            ],
            "sourceId": [
                1199
            ],
            "state": [
                1199
            ],
            "text": [
                1199
            ],
            "title": [
                1199
            ],
            "toolCallId": [
                1199
            ],
            "toolCallState": [
                87
            ],
            "toolName": [
                1199
            ],
            "type": [
                79
            ],
            "url": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "AssistantChatMessagePartType": {},
        "AssistantChatMessageRole": {},
        "AssistantChatResultPage": {
            "entries": [
                75
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "AssistantChatShareLink": {
            "chatId": [
                607
            ],
            "createdAt": [
                1446
            ],
            "id": [
                607
            ],
            "token": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "AssistantChatSortOption": {},
        "AssistantChatStatus": {},
        "AssistantOutboxEventCounts": {
            "chat": [
                619
            ],
            "chatMessage": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "AssistantOutboxEventFilter": {
            "aggregateId": [
                607
            ],
            "aggregateTypes": [
                74
            ],
            "createdAtRange": [
                1447
            ],
            "statuses": [
                903
            ],
            "__typename": [
                1199
            ]
        },
        "AssistantToolCallState": {},
        "Attachment": {
            "bookingId": [
                607
            ],
            "confirmed": [
                137
            ],
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "type": [
                89
            ],
            "uploadUrl": [
                1199
            ],
            "url": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "AttachmentType": {},
        "AuthenticationImpersonator": {
            "email": [
                1199
            ],
            "reason": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "AuthenticationOrganization": {
            "id": [
                1199
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "AuthenticationResponse": {
            "accessToken": [
                1199
            ],
            "impersonator": [
                90
            ],
            "organization": [
                887
            ],
            "user": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "AuthenticationResult": {
            "on_AuthenticationResponse": [
                92
            ],
            "on_EmailVerificationRequiredError": [
                461
            ],
            "on_InvalidCredentialsError": [
                621
            ],
            "on_InvalidOneTimeCode": [
                622
            ],
            "on_MfaChallengeError": [
                830
            ],
            "on_MfaEnrollmentRequiredError": [
                831
            ],
            "on_OneTimeCodeExpired": [
                884
            ],
            "on_OrganizationSelectionError": [
                891
            ],
            "on_SsoRequiredError": [
                1194
            ],
            "on_PendingAuthenticationError": [
                928
            ],
            "__typename": [
                1199
            ]
        },
        "Automation": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "description": [
                1199
            ],
            "edges": [
                456
            ],
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "nodes": [
                844
            ],
            "organization": [
                887
            ],
            "organizationId": [
                607
            ],
            "status": [
                101
            ],
            "timestamps": [
                1250
            ],
            "triggerConfig": [
                1296
            ],
            "triggerType": [
                1298
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "webhookEndpoint": [
                1422
            ],
            "workflowId": [
                1199
            ],
            "workflowRunId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "AutomationBulkInput": {
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "AutomationBulkOperationResult": {
            "failedCount": [
                619
            ],
            "failedIds": [
                607
            ],
            "successCount": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "AutomationDeleteResult": {
            "deleted": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "AutomationFilter": {
            "ids": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "status": [
                101
            ],
            "triggerType": [
                1298
            ],
            "__typename": [
                1199
            ]
        },
        "AutomationResultPage": {
            "entries": [
                94
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "AutomationSortOption": {},
        "AutomationStatus": {},
        "AutomationVersion": {
            "automationId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "description": [
                1199
            ],
            "flowSnapshot": [
                770
            ],
            "id": [
                607
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "versionNumber": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "AutomationVersionFilter": {
            "automationId": [
                607
            ],
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "AutomationVersionInput": {
            "automationId": [
                607
            ],
            "description": [
                1199
            ],
            "flowSnapshot": [
                770
            ],
            "versionNumber": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "AutomationVersionResultPage": {
            "entries": [
                102
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "AutomationVersionSortOption": {},
        "AutomationVersionUpdateInput": {
            "automationId": [
                607
            ],
            "description": [
                1199
            ],
            "flowSnapshot": [
                770
            ],
            "versionNumber": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "BatchCreateInventoryTagInput": {
            "customAttributes": [
                828
            ],
            "facilityId": [
                607
            ],
            "generatedAt": [
                1446
            ],
            "grossQuantity": [
                393
            ],
            "isRevised": [
                137
            ],
            "itemId": [
                607
            ],
            "lotId": [
                607
            ],
            "quantityCaptureMethod": [
                1026
            ],
            "status": [
                701
            ],
            "tagNumber": [
                1199
            ],
            "tagType": [
                1214
            ],
            "tare": [
                393
            ],
            "tareCaptureMethod": [
                1026
            ],
            "__typename": [
                1199
            ]
        },
        "BatchItemPricingUpdateItem": {
            "input": [
                766
            ],
            "itemPricingId": [
                607
            ],
            "tiers": [
                320
            ],
            "__typename": [
                1199
            ]
        },
        "Bill": {
            "account": [
                3
            ],
            "amount": [
                835
            ],
            "compliance": [
                111
            ],
            "documentDate": [
                168
            ],
            "documentNumber": [
                1199
            ],
            "dueDate": [
                168
            ],
            "eligibleAt": [
                168
            ],
            "facility": [
                470
            ],
            "id": [
                607
            ],
            "lineItems": [
                115
            ],
            "notes": [
                1199
            ],
            "openAmount": [
                835
            ],
            "paymentTerm": [
                920
            ],
            "paymentTermEntity": [
                921
            ],
            "payments": [
                911
            ],
            "preferredPaymentMethod": [
                916
            ],
            "scaleTicketId": [
                607
            ],
            "status": [
                120
            ],
            "timestamps": [
                1250
            ],
            "type": [
                122
            ],
            "__typename": [
                1199
            ]
        },
        "BillComplianceRule": {},
        "BillEntityReference": {
            "entityId": [
                607
            ],
            "entityType": [
                113
            ],
            "__typename": [
                1199
            ]
        },
        "BillEntityReferenceType": {},
        "BillFilter": {
            "accountIDs": [
                607
            ],
            "compliance": [
                111
            ],
            "currencyCode": [
                355
            ],
            "facilityIDs": [
                607
            ],
            "fromDueDate": [
                168
            ],
            "ids": [
                607
            ],
            "maxOpenBalance": [
                393
            ],
            "minOpenBalance": [
                393
            ],
            "searchTerm": [
                1199
            ],
            "statuses": [
                120
            ],
            "toDueDate": [
                168
            ],
            "types": [
                122
            ],
            "__typename": [
                1199
            ]
        },
        "BillLineItem": {
            "description": [
                1199
            ],
            "groupName": [
                1199
            ],
            "id": [
                607
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "quantity": [
                393
            ],
            "sortOrder": [
                619
            ],
            "sourceReference": [
                112
            ],
            "timestamps": [
                1250
            ],
            "totalPrice": [
                835
            ],
            "unit": [
                1199
            ],
            "unitPrice": [
                835
            ],
            "__typename": [
                1199
            ]
        },
        "BillLineItemInput": {
            "description": [
                1199
            ],
            "groupName": [
                1199
            ],
            "id": [
                607
            ],
            "itemId": [
                607
            ],
            "quantity": [
                393
            ],
            "sortOrder": [
                619
            ],
            "totalPrice": [
                836
            ],
            "unit": [
                1199
            ],
            "unitPrice": [
                836
            ],
            "__typename": [
                1199
            ]
        },
        "BillPaymentApplication": {
            "appliedAmount": [
                835
            ],
            "appliedAt": [
                1446
            ],
            "bill": [
                110
            ],
            "__typename": [
                1199
            ]
        },
        "BillResultPage": {
            "entries": [
                110
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "BillSortOption": {},
        "BillStatus": {},
        "BillStatusCounts": {
            "paid": [
                619
            ],
            "pending": [
                619
            ],
            "voided": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "BillType": {},
        "Booking": {
            "containerInstanceCounts": [
                267
            ],
            "containerInstances": [
                260
            ],
            "containers": [
                124
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "cutOffDate": [
                168
            ],
            "destinationPort": [
                945
            ],
            "destinationPortId": [
                607
            ],
            "documentNumber": [
                1199
            ],
            "dropoffTerminal": [
                1240
            ],
            "dropoffTerminalId": [
                607
            ],
            "earlyReturnDate": [
                168
            ],
            "externalNotes": [
                1199
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "files": [
                494
            ],
            "id": [
                607
            ],
            "internalNotes": [
                1199
            ],
            "loadStatusSummary": [
                130
            ],
            "loadingPort": [
                945
            ],
            "loadingPortId": [
                607
            ],
            "oceanFreight": [
                1199
            ],
            "organization": [
                887
            ],
            "organizationId": [
                607
            ],
            "photoRequirements": [
                936
            ],
            "pickupTerminal": [
                1240
            ],
            "pickupTerminalId": [
                607
            ],
            "salesOrders": [
                1090
            ],
            "status": [
                133
            ],
            "steamshipLine": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "vesselArrivalDate": [
                168
            ],
            "vesselDepartureDate": [
                168
            ],
            "vesselName": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "BookingContainer": {
            "containerType": [
                268
            ],
            "quantity": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "BookingContainerInput": {
            "containerTypeId": [
                607
            ],
            "quantity": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "BookingFileCreatePayload": {
            "file": [
                494
            ],
            "uploadUrl": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "BookingFileInput": {
            "fileName": [
                1199
            ],
            "fileSize": [
                619
            ],
            "mimeType": [
                1199
            ],
            "public": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "BookingFilter": {
            "createdBy": [
                607
            ],
            "documentNumber": [
                1199
            ],
            "facilityIds": [
                607
            ],
            "fromCutOffDate": [
                168
            ],
            "fromDepartureDate": [
                168
            ],
            "ids": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "status": [
                133
            ],
            "toCutOffDate": [
                168
            ],
            "toDepartureDate": [
                168
            ],
            "updatedBy": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "BookingInput": {
            "containers": [
                125
            ],
            "cutOffDate": [
                168
            ],
            "destinationPortId": [
                607
            ],
            "documentNumber": [
                1199
            ],
            "dropoffTerminalId": [
                607
            ],
            "earlyReturnDate": [
                168
            ],
            "externalNotes": [
                1199
            ],
            "facilityId": [
                607
            ],
            "internalNotes": [
                1199
            ],
            "loadingPortId": [
                607
            ],
            "oceanFreight": [
                1199
            ],
            "photoRequirements": [
                937
            ],
            "pickupTerminalId": [
                607
            ],
            "salesOrderIds": [
                607
            ],
            "status": [
                133
            ],
            "steamshipLine": [
                1199
            ],
            "vesselArrivalDate": [
                168
            ],
            "vesselDepartureDate": [
                168
            ],
            "vesselName": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "BookingLoadStatusSummary": {
            "allReceived": [
                137
            ],
            "allReconciled": [
                137
            ],
            "allShipped": [
                137
            ],
            "received": [
                619
            ],
            "reconciled": [
                619
            ],
            "shipped": [
                619
            ],
            "total": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "BookingResultPage": {
            "entries": [
                123
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "BookingSortOption": {},
        "BookingStatus": {},
        "BookingStatusCounts": {
            "completed": [
                619
            ],
            "draft": [
                619
            ],
            "open": [
                619
            ],
            "shipped": [
                619
            ],
            "voided": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "BookingUpdateInput": {
            "containers": [
                125
            ],
            "cutOffDate": [
                168
            ],
            "destinationPortId": [
                607
            ],
            "documentNumber": [
                1199
            ],
            "dropoffTerminalId": [
                607
            ],
            "earlyReturnDate": [
                168
            ],
            "externalNotes": [
                1199
            ],
            "facilityId": [
                607
            ],
            "internalNotes": [
                1199
            ],
            "loadingPortId": [
                607
            ],
            "oceanFreight": [
                1199
            ],
            "photoRequirements": [
                937
            ],
            "pickupTerminalId": [
                607
            ],
            "salesOrderIds": [
                607
            ],
            "status": [
                133
            ],
            "steamshipLine": [
                1199
            ],
            "vesselArrivalDate": [
                168
            ],
            "vesselDepartureDate": [
                168
            ],
            "vesselName": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "BookingUpdateResult": {
            "blockingLoads": [
                34
            ],
            "booking": [
                123
            ],
            "removedSalesOrderId": [
                607
            ],
            "requiresConfirmation": [
                137
            ],
            "unlinkableLoads": [
                34
            ],
            "__typename": [
                1199
            ]
        },
        "Boolean": {},
        "BrokeredOrder": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "customers": [
                3
            ],
            "id": [
                607
            ],
            "lineItems": [
                141
            ],
            "margin": [
                835
            ],
            "marginPercent": [
                393
            ],
            "notes": [
                1199
            ],
            "orderNumber": [
                1199
            ],
            "purchaseOrders": [
                1008
            ],
            "purchaseTotal": [
                835
            ],
            "salesOrders": [
                1090
            ],
            "salesTotal": [
                835
            ],
            "status": [
                147
            ],
            "suppliers": [
                3
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "BrokeredOrderFilter": {
            "customerIds": [
                607
            ],
            "fromCreatedAt": [
                1446
            ],
            "ids": [
                607
            ],
            "includeLineItems": [
                137
            ],
            "orderNumber": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "statuses": [
                147
            ],
            "supplierIds": [
                607
            ],
            "toCreatedAt": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "BrokeredOrderInput": {
            "lineItems": [
                301
            ],
            "notes": [
                1199
            ],
            "orderNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "BrokeredOrderLineItem": {
            "brokeredOrder": [
                138
            ],
            "brokeredOrderId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "id": [
                607
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "margin": [
                835
            ],
            "marginPercent": [
                393
            ],
            "notes": [
                1199
            ],
            "purchaseTotal": [
                835
            ],
            "purchaseUnitPrice": [
                835
            ],
            "quantity": [
                393
            ],
            "salesTotal": [
                835
            ],
            "salesUnitPrice": [
                835
            ],
            "timestamps": [
                1250
            ],
            "unit": [
                1307
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "BrokeredOrderLineItemFilter": {
            "brokeredOrderId": [
                607
            ],
            "brokeredOrderIds": [
                607
            ],
            "ids": [
                607
            ],
            "itemId": [
                607
            ],
            "itemIds": [
                607
            ],
            "notes": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "BrokeredOrderLineItemResultPage": {
            "entries": [
                141
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "BrokeredOrderLineItemSortOption": {},
        "BrokeredOrderResultPage": {
            "entries": [
                138
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "BrokeredOrderSortOption": {},
        "BrokeredOrderStatus": {},
        "BrokeredOrderUpdateInput": {
            "lineItems": [
                1325
            ],
            "notes": [
                1199
            ],
            "orderNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "BrokeredOrderValidationError": {
            "code": [
                1199
            ],
            "itemId": [
                607
            ],
            "message": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "BrokeredOrderValidationResult": {
            "errors": [
                149
            ],
            "valid": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "BulkOperationResult": {
            "failedCount": [
                619
            ],
            "failedIds": [
                607
            ],
            "successCount": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "BulkPaymentResult": {
            "failedCount": [
                619
            ],
            "results": [
                915
            ],
            "successCount": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "BulkRoleInput": {
            "roleIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "BulkUserInput": {
            "userIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "BulkVoidBookingInput": {
            "forceUnlink": [
                137
            ],
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "BulkVoidBookingResult": {
            "failedCount": [
                619
            ],
            "results": [
                1402
            ],
            "successCount": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "BulkVoidLoadInput": {
            "ids": [
                607
            ],
            "voidReason": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "BulkVoidLoadResult": {
            "failedCount": [
                619
            ],
            "failedIds": [
                607
            ],
            "successCount": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "BulkVoidSalesOrderInput": {
            "forceUnlink": [
                137
            ],
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "BulkVoidSalesOrderResult": {
            "failedCount": [
                619
            ],
            "results": [
                1404
            ],
            "successCount": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "BusinessEventTriggerConfigOutput": {
            "entityType": [
                1199
            ],
            "eventCase": [
                1199
            ],
            "filterExpression": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "BusinessEventTriggerNode": {
            "description": [
                1199
            ],
            "eventType": [
                1199
            ],
            "filter": [
                828
            ],
            "id": [
                607
            ],
            "label": [
                1199
            ],
            "position": [
                949
            ],
            "type": [
                848
            ],
            "__typename": [
                1199
            ]
        },
        "CalculateBrokeredMarginsInput": {
            "method": [
                1199
            ],
            "purchaseOrderIds": [
                607
            ],
            "salesOrderIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CalculateWorkOrderQuantitiesInput": {
            "direction": [
                167
            ],
            "outputItemId": [
                607
            ],
            "referenceQuantity": [
                393
            ],
            "referenceUnit": [
                1307
            ],
            "workOrderId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CalculatedRecipeItem": {
            "isNoCost": [
                137
            ],
            "isPrimary": [
                137
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "quantity": [
                393
            ],
            "quantityUnit": [
                1307
            ],
            "__typename": [
                1199
            ]
        },
        "CalculatedRecipeResult": {
            "inputs": [
                165
            ],
            "outputs": [
                165
            ],
            "__typename": [
                1199
            ]
        },
        "CalculationDirection": {},
        "CalendarDate": {},
        "CalendarDateTime": {},
        "Camera": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "driverType": [
                1199
            ],
            "firmwareVersion": [
                1199
            ],
            "hasFloodlight": [
                137
            ],
            "hasPtz": [
                137
            ],
            "hasSiren": [
                137
            ],
            "id": [
                607
            ],
            "initialized": [
                137
            ],
            "ipAddress": [
                1199
            ],
            "lastSeenAt": [
                1446
            ],
            "manufacturer": [
                1199
            ],
            "model": [
                1199
            ],
            "name": [
                1199
            ],
            "online": [
                137
            ],
            "passwordDecrypted": [
                1199
            ],
            "sidecar": [
                1181
            ],
            "sidecarId": [
                607
            ],
            "snapshotUrl": [
                1199
            ],
            "status": [
                174
            ],
            "streamProfile": [
                1199
            ],
            "streamUrl": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "uniqueId": [
                1199
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "username": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CameraFilter": {
            "facilityId": [
                607
            ],
            "ids": [
                607
            ],
            "sidecarId": [
                607
            ],
            "status": [
                174
            ],
            "__typename": [
                1199
            ]
        },
        "CameraResultPage": {
            "entries": [
                170
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "CameraSortOption": {},
        "CameraStatus": {},
        "Category": {
            "attributes": [
                770
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "description": [
                1199
            ],
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "CategoryFilter": {
            "description": [
                1199
            ],
            "ids": [
                607
            ],
            "name": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CategoryInput": {
            "attributes": [
                770
            ],
            "customAttributes": [
                828
            ],
            "description": [
                1199
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CategoryResultPage": {
            "entries": [
                175
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "CategorySortOption": {},
        "CategoryUpdateInput": {
            "attributes": [
                770
            ],
            "customAttributes": [
                828
            ],
            "description": [
                1199
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ChangeUserRoleInput": {
            "facilityId": [
                607
            ],
            "newRoleId": [
                607
            ],
            "oldRoleId": [
                607
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ChatMetadataInput": {
            "firstName": [
                1199
            ],
            "lastName": [
                1199
            ],
            "timezone": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CheckTemplate": {
            "checkFont": [
                1199
            ],
            "checkFontSize": [
                619
            ],
            "checkLayout": [
                1199
            ],
            "checkType": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "displayAccountNumber": [
                137
            ],
            "displayAmount": [
                137
            ],
            "displayAmountWords": [
                137
            ],
            "displayBankInfo": [
                137
            ],
            "displayCheckNumber": [
                137
            ],
            "displayCompanyAddress": [
                137
            ],
            "displayCompanyName": [
                137
            ],
            "displayCompanyPhone": [
                137
            ],
            "displayDate": [
                137
            ],
            "displayMemo": [
                137
            ],
            "displayMicr": [
                137
            ],
            "displayPayeeAddress": [
                137
            ],
            "displayPayeeName": [
                137
            ],
            "displaySecondSignature": [
                137
            ],
            "displaySignature": [
                137
            ],
            "facilityId": [
                607
            ],
            "financialAccountId": [
                607
            ],
            "id": [
                607
            ],
            "maxAmountSecondSignature": [
                393
            ],
            "minAmountSignature": [
                393
            ],
            "secondSignatureId": [
                607
            ],
            "signatureId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "CheckTemplateFilter": {
            "facilityIds": [
                607
            ],
            "financialAccountId": [
                607
            ],
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CheckTemplateInput": {
            "checkFont": [
                1199
            ],
            "checkFontSize": [
                619
            ],
            "checkLayout": [
                1199
            ],
            "checkType": [
                1199
            ],
            "displayAccountNumber": [
                137
            ],
            "displayAmount": [
                137
            ],
            "displayAmountWords": [
                137
            ],
            "displayBankInfo": [
                137
            ],
            "displayCheckNumber": [
                137
            ],
            "displayCompanyAddress": [
                137
            ],
            "displayCompanyName": [
                137
            ],
            "displayCompanyPhone": [
                137
            ],
            "displayDate": [
                137
            ],
            "displayMemo": [
                137
            ],
            "displayMicr": [
                137
            ],
            "displayPayeeAddress": [
                137
            ],
            "displayPayeeName": [
                137
            ],
            "displaySecondSignature": [
                137
            ],
            "displaySignature": [
                137
            ],
            "facilityId": [
                607
            ],
            "financialAccountId": [
                607
            ],
            "maxAmountSecondSignature": [
                393
            ],
            "minAmountSignature": [
                393
            ],
            "secondSignatureId": [
                607
            ],
            "signatureId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CheckTemplateResultPage": {
            "entries": [
                183
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "CheckTemplateSortOption": {},
        "CheckTemplateUpdateInput": {
            "checkFont": [
                1199
            ],
            "checkFontSize": [
                619
            ],
            "checkLayout": [
                1199
            ],
            "checkType": [
                1199
            ],
            "displayAccountNumber": [
                137
            ],
            "displayAmount": [
                137
            ],
            "displayAmountWords": [
                137
            ],
            "displayBankInfo": [
                137
            ],
            "displayCheckNumber": [
                137
            ],
            "displayCompanyAddress": [
                137
            ],
            "displayCompanyName": [
                137
            ],
            "displayCompanyPhone": [
                137
            ],
            "displayDate": [
                137
            ],
            "displayMemo": [
                137
            ],
            "displayMicr": [
                137
            ],
            "displayPayeeAddress": [
                137
            ],
            "displayPayeeName": [
                137
            ],
            "displaySecondSignature": [
                137
            ],
            "displaySignature": [
                137
            ],
            "facilityId": [
                607
            ],
            "financialAccountId": [
                607
            ],
            "maxAmountSecondSignature": [
                393
            ],
            "minAmountSignature": [
                393
            ],
            "secondSignatureId": [
                607
            ],
            "signatureId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CompleteWorkOrderInputItemInput": {
            "actualQuantity": [
                393
            ],
            "actualQuantityUnit": [
                1307
            ],
            "inputItemId": [
                607
            ],
            "lotId": [
                607
            ],
            "tagId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CompleteWorkOrderOutputItemInput": {
            "actualQuantity": [
                393
            ],
            "actualQuantityUnit": [
                1307
            ],
            "outputItemId": [
                607
            ],
            "targetLotId": [
                607
            ],
            "targetTagId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CompleteWorkOrderWithActualsInput": {
            "actualInputs": [
                189
            ],
            "actualOutputs": [
                190
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceCheck": {
            "accountId": [
                607
            ],
            "checkedAt": [
                1446
            ],
            "checkedByUserId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "id": [
                607
            ],
            "notes": [
                1199
            ],
            "overriddenAt": [
                1446
            ],
            "overriddenByUserId": [
                607
            ],
            "overrideReason": [
                1199
            ],
            "purchaseLoadId": [
                607
            ],
            "results": [
                828
            ],
            "status": [
                199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceCheckFilter": {
            "accountId": [
                607
            ],
            "ids": [
                607
            ],
            "purchaseLoadId": [
                607
            ],
            "status": [
                199
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceCheckInput": {
            "accountId": [
                607
            ],
            "checkedAt": [
                1446
            ],
            "checkedByUserId": [
                607
            ],
            "notes": [
                1199
            ],
            "overriddenAt": [
                1446
            ],
            "overriddenByUserId": [
                607
            ],
            "overrideReason": [
                1199
            ],
            "purchaseLoadId": [
                607
            ],
            "results": [
                828
            ],
            "status": [
                199
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceCheckOverrideInput": {
            "notes": [
                1199
            ],
            "overrideReason": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceCheckResultItem": {
            "category": [
                1199
            ],
            "enforcementLevel": [
                1199
            ],
            "message": [
                1199
            ],
            "passed": [
                137
            ],
            "ruleCode": [
                1199
            ],
            "ruleName": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceCheckResultPage": {
            "entries": [
                192
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceCheckSortOption": {},
        "ComplianceCheckStatus": {},
        "ComplianceCheckUpdateInput": {
            "accountId": [
                607
            ],
            "checkedAt": [
                1446
            ],
            "checkedByUserId": [
                607
            ],
            "notes": [
                1199
            ],
            "overriddenAt": [
                1446
            ],
            "overriddenByUserId": [
                607
            ],
            "overrideReason": [
                1199
            ],
            "purchaseLoadId": [
                607
            ],
            "results": [
                828
            ],
            "status": [
                199
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceDailyTotalsInput": {
            "totalPrice": [
                393
            ],
            "totalWeight": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceDispatchImage": {
            "category": [
                424
            ],
            "complianceDispatchRecord": [
                208
            ],
            "complianceDispatchRecordId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "externalId": [
                1199
            ],
            "fileId": [
                607
            ],
            "fileType": [
                1199
            ],
            "id": [
                607
            ],
            "status": [
                425
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceDispatchImageFilter": {
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceDispatchImageInput": {
            "category": [
                424
            ],
            "complianceDispatchRecordId": [
                607
            ],
            "externalId": [
                1199
            ],
            "fileId": [
                607
            ],
            "fileType": [
                1199
            ],
            "status": [
                425
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceDispatchImageResultPage": {
            "entries": [
                202
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceDispatchImageSortOption": {},
        "ComplianceDispatchImageUpdateInput": {
            "category": [
                424
            ],
            "complianceDispatchRecordId": [
                607
            ],
            "externalId": [
                1199
            ],
            "fileId": [
                607
            ],
            "fileType": [
                1199
            ],
            "status": [
                425
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceDispatchRecord": {
            "batchId": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "dispatchType": [
                1199
            ],
            "errorMessage": [
                1199
            ],
            "errorType": [
                423
            ],
            "externalReferenceId": [
                1199
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "governmentReportingConfiguration": [
                588
            ],
            "governmentReportingConfigurationId": [
                607
            ],
            "id": [
                607
            ],
            "isRetriable": [
                137
            ],
            "maxRetryCount": [
                619
            ],
            "nextRetryAt": [
                1446
            ],
            "payload": [
                828
            ],
            "purchaseLoad": [
                987
            ],
            "purchaseLoadId": [
                607
            ],
            "retryCount": [
                619
            ],
            "status": [
                426
            ],
            "submittedAt": [
                1446
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceDispatchRecordFilter": {
            "batchId": [
                1199
            ],
            "facilityId": [
                607
            ],
            "fromSubmittedAt": [
                1446
            ],
            "governmentReportingConfigurationId": [
                607
            ],
            "ids": [
                607
            ],
            "status": [
                426
            ],
            "toSubmittedAt": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceDispatchRecordInput": {
            "batchId": [
                1199
            ],
            "dispatchType": [
                1199
            ],
            "errorMessage": [
                1199
            ],
            "errorType": [
                423
            ],
            "externalReferenceId": [
                1199
            ],
            "facilityId": [
                607
            ],
            "governmentReportingConfigurationId": [
                607
            ],
            "isRetriable": [
                137
            ],
            "maxRetryCount": [
                619
            ],
            "nextRetryAt": [
                1446
            ],
            "payload": [
                828
            ],
            "purchaseLoadId": [
                607
            ],
            "retryCount": [
                619
            ],
            "status": [
                426
            ],
            "submittedAt": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceDispatchRecordResultPage": {
            "entries": [
                208
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceDispatchRecordSortOption": {},
        "ComplianceDispatchRecordUpdateInput": {
            "batchId": [
                1199
            ],
            "dispatchType": [
                1199
            ],
            "errorMessage": [
                1199
            ],
            "errorType": [
                423
            ],
            "externalReferenceId": [
                1199
            ],
            "facilityId": [
                607
            ],
            "governmentReportingConfigurationId": [
                607
            ],
            "isRetriable": [
                137
            ],
            "maxRetryCount": [
                619
            ],
            "nextRetryAt": [
                1446
            ],
            "payload": [
                828
            ],
            "purchaseLoadId": [
                607
            ],
            "retryCount": [
                619
            ],
            "status": [
                426
            ],
            "submittedAt": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceEnforcementLevel": {},
        "ComplianceEvaluateTransactionInput": {
            "accountId": [
                607
            ],
            "dailyTotals": [
                201
            ],
            "facilityId": [
                607
            ],
            "isFrequentSeller": [
                137
            ],
            "items": [
                235
            ],
            "paymentMethod": [
                1199
            ],
            "purchaseLoadId": [
                607
            ],
            "supplier": [
                251
            ],
            "transactionDate": [
                1446
            ],
            "transactionTotal": [
                393
            ],
            "vehicle": [
                252
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceEvaluationResult": {
            "holdDetails": [
                224
            ],
            "holdRequired": [
                137
            ],
            "results": [
                196
            ],
            "status": [
                199
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceFacilityRule": {
            "applicableCategoryIds": [
                828
            ],
            "configuredValue": [
                828
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "effectiveFrom": [
                1446
            ],
            "effectiveTo": [
                1446
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "isEnabled": [
                137
            ],
            "notes": [
                1199
            ],
            "ruleDefinition": [
                245
            ],
            "ruleDefinitionId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceFacilityRuleFilter": {
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceFacilityRuleInput": {
            "applicableCategoryIds": [
                828
            ],
            "configuredValue": [
                828
            ],
            "effectiveFrom": [
                1446
            ],
            "effectiveTo": [
                1446
            ],
            "facilityId": [
                607
            ],
            "isEnabled": [
                137
            ],
            "notes": [
                1199
            ],
            "ruleDefinitionId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceFacilityRuleResultPage": {
            "entries": [
                217
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceFacilityRuleSortOption": {},
        "ComplianceFacilityRuleUpdateInput": {
            "applicableCategoryIds": [
                828
            ],
            "configuredValue": [
                828
            ],
            "effectiveFrom": [
                1446
            ],
            "effectiveTo": [
                1446
            ],
            "facilityId": [
                607
            ],
            "isEnabled": [
                137
            ],
            "notes": [
                1199
            ],
            "ruleDefinitionId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceHold": {
            "accountId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "exemptionReason": [
                602
            ],
            "holdDays": [
                619
            ],
            "holdEnd": [
                1446
            ],
            "holdStart": [
                1446
            ],
            "id": [
                607
            ],
            "jurisdictionCode": [
                1199
            ],
            "maxImmediateCash": [
                393
            ],
            "notes": [
                1199
            ],
            "purchaseLoadId": [
                607
            ],
            "releasedAt": [
                1446
            ],
            "releasedByUserId": [
                607
            ],
            "status": [
                233
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceHoldEvaluation": {
            "exemptionReason": [
                225
            ],
            "holdDays": [
                619
            ],
            "holdEnd": [
                1446
            ],
            "maxImmediateCash": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceHoldExemptionReason": {},
        "ComplianceHoldExtendInput": {
            "holdDays": [
                619
            ],
            "holdEnd": [
                1446
            ],
            "notes": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceHoldFilter": {
            "accountId": [
                607
            ],
            "ids": [
                607
            ],
            "purchaseLoadId": [
                607
            ],
            "status": [
                233
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceHoldFlagPoliceInput": {
            "notes": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceHoldInput": {
            "accountId": [
                607
            ],
            "exemptionReason": [
                602
            ],
            "holdDays": [
                619
            ],
            "holdEnd": [
                1446
            ],
            "holdStart": [
                1446
            ],
            "jurisdictionCode": [
                1199
            ],
            "maxImmediateCash": [
                393
            ],
            "notes": [
                1199
            ],
            "purchaseLoadId": [
                607
            ],
            "releasedAt": [
                1446
            ],
            "releasedByUserId": [
                607
            ],
            "status": [
                233
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceHoldReleaseInput": {
            "notes": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceHoldResultPage": {
            "entries": [
                223
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceHoldSortOption": {},
        "ComplianceHoldStatus": {},
        "ComplianceHoldUpdateInput": {
            "accountId": [
                607
            ],
            "exemptionReason": [
                602
            ],
            "holdDays": [
                619
            ],
            "holdEnd": [
                1446
            ],
            "holdStart": [
                1446
            ],
            "jurisdictionCode": [
                1199
            ],
            "maxImmediateCash": [
                393
            ],
            "notes": [
                1199
            ],
            "purchaseLoadId": [
                607
            ],
            "releasedAt": [
                1446
            ],
            "releasedByUserId": [
                607
            ],
            "status": [
                233
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceItemInput": {
            "categoryId": [
                607
            ],
            "deductions": [
                393
            ],
            "itemId": [
                607
            ],
            "quantity": [
                393
            ],
            "tax": [
                393
            ],
            "totalAmount": [
                393
            ],
            "weight": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceItemJurisdictionCode": {
            "code": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "description": [
                1199
            ],
            "id": [
                607
            ],
            "isReportable": [
                137
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "serviceType": [
                600
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceItemJurisdictionCodeFilter": {
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceItemJurisdictionCodeInput": {
            "code": [
                1199
            ],
            "description": [
                1199
            ],
            "isReportable": [
                137
            ],
            "itemId": [
                607
            ],
            "serviceType": [
                600
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceItemJurisdictionCodeResultPage": {
            "entries": [
                236
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceItemJurisdictionCodeSortOption": {},
        "ComplianceItemJurisdictionCodeUpdateInput": {
            "code": [
                1199
            ],
            "description": [
                1199
            ],
            "isReportable": [
                137
            ],
            "itemId": [
                607
            ],
            "serviceType": [
                600
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceRuleAppliesTo": {},
        "ComplianceRuleCategory": {},
        "ComplianceRuleDataType": {},
        "ComplianceRuleDefinition": {
            "allowedValues": [
                828
            ],
            "appliesTo": [
                242
            ],
            "category": [
                243
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "dataType": [
                244
            ],
            "defaultValue": [
                828
            ],
            "description": [
                1199
            ],
            "enforcementLevel": [
                214
            ],
            "id": [
                607
            ],
            "isActive": [
                137
            ],
            "isSystem": [
                137
            ],
            "jurisdictionCode": [
                1199
            ],
            "name": [
                1199
            ],
            "ruleCode": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceRuleDefinitionFilter": {
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceRuleDefinitionInput": {
            "allowedValues": [
                828
            ],
            "appliesTo": [
                242
            ],
            "category": [
                243
            ],
            "dataType": [
                244
            ],
            "defaultValue": [
                828
            ],
            "description": [
                1199
            ],
            "enforcementLevel": [
                214
            ],
            "isActive": [
                137
            ],
            "isSystem": [
                137
            ],
            "jurisdictionCode": [
                1199
            ],
            "name": [
                1199
            ],
            "ruleCode": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceRuleDefinitionResultPage": {
            "entries": [
                245
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceRuleDefinitionSortOption": {},
        "ComplianceRuleDefinitionUpdateInput": {
            "allowedValues": [
                828
            ],
            "appliesTo": [
                242
            ],
            "category": [
                243
            ],
            "dataType": [
                244
            ],
            "defaultValue": [
                828
            ],
            "description": [
                1199
            ],
            "enforcementLevel": [
                214
            ],
            "isActive": [
                137
            ],
            "isSystem": [
                137
            ],
            "jurisdictionCode": [
                1199
            ],
            "name": [
                1199
            ],
            "ruleCode": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceSupplierInput": {
            "address": [
                1199
            ],
            "contactId": [
                607
            ],
            "dateOfBirth": [
                1446
            ],
            "employer": [
                1199
            ],
            "firstName": [
                1199
            ],
            "hasDlBack": [
                137
            ],
            "hasDlFront": [
                137
            ],
            "hasPhoto": [
                137
            ],
            "hasSignature": [
                137
            ],
            "hasThumbprint": [
                137
            ],
            "height": [
                1199
            ],
            "idExpiration": [
                1446
            ],
            "idNumber": [
                1199
            ],
            "idState": [
                1199
            ],
            "idType": [
                1199
            ],
            "lastName": [
                1199
            ],
            "sex": [
                1199
            ],
            "weight": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ComplianceVehicleInput": {
            "color": [
                1199
            ],
            "licensePlate": [
                1199
            ],
            "make": [
                1199
            ],
            "model": [
                1199
            ],
            "state": [
                1199
            ],
            "vin": [
                1199
            ],
            "year": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ConditionNode": {
            "description": [
                1199
            ],
            "expression": [
                1199
            ],
            "falseBranchLabel": [
                1199
            ],
            "id": [
                607
            ],
            "label": [
                1199
            ],
            "position": [
                949
            ],
            "trueBranchLabel": [
                1199
            ],
            "type": [
                848
            ],
            "__typename": [
                1199
            ]
        },
        "ConfirmPaymentsInput": {
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "Contact": {
            "account": [
                3
            ],
            "accountId": [
                607
            ],
            "address": [
                4
            ],
            "addressAs": [
                1199
            ],
            "addressId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "customAttributes": [
                828
            ],
            "department": [
                1199
            ],
            "email": [
                1199
            ],
            "fullName": [
                1199
            ],
            "id": [
                607
            ],
            "isPrimary": [
                137
            ],
            "notes": [
                1199
            ],
            "owner": [
                1372
            ],
            "ownerUserId": [
                607
            ],
            "phone": [
                1199
            ],
            "prefix": [
                1199
            ],
            "role": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "user": [
                1372
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ContactFilter": {
            "accountId": [
                607
            ],
            "accountIds": [
                607
            ],
            "addressAs": [
                1199
            ],
            "addressId": [
                607
            ],
            "addressIds": [
                607
            ],
            "department": [
                1199
            ],
            "email": [
                1199
            ],
            "fullName": [
                1199
            ],
            "ids": [
                607
            ],
            "notes": [
                1199
            ],
            "ownerUserId": [
                607
            ],
            "ownerUserIds": [
                607
            ],
            "phone": [
                1199
            ],
            "prefix": [
                1199
            ],
            "role": [
                1199
            ],
            "roles": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "userId": [
                607
            ],
            "userIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ContactResultPage": {
            "entries": [
                255
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ContactSortOption": {},
        "ContactType": {},
        "Container": {
            "arrivedAtFacilityAt": [
                1446
            ],
            "booking": [
                123
            ],
            "bookingId": [
                607
            ],
            "containerNumber": [
                1199
            ],
            "containerType": [
                268
            ],
            "containerTypeId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "departedFacilityAt": [
                1446
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "load": [
                772
            ],
            "loadId": [
                607
            ],
            "loadedAt": [
                1446
            ],
            "organization": [
                887
            ],
            "organizationId": [
                607
            ],
            "pickedUpAt": [
                1446
            ],
            "returnedToPortAt": [
                1446
            ],
            "sealNumber": [
                1199
            ],
            "shippedAt": [
                1446
            ],
            "status": [
                266
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ContainerBatchCreateInput": {
            "bookingId": [
                607
            ],
            "containerTypeId": [
                607
            ],
            "facilityId": [
                607
            ],
            "quantity": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "ContainerFilter": {
            "bookingIds": [
                607
            ],
            "containerNumber": [
                1199
            ],
            "containerTypeIds": [
                607
            ],
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "loadIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "status": [
                266
            ],
            "__typename": [
                1199
            ]
        },
        "ContainerInput": {
            "bookingId": [
                607
            ],
            "containerNumber": [
                1199
            ],
            "containerTypeId": [
                607
            ],
            "facilityId": [
                607
            ],
            "sealNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ContainerResultPage": {
            "entries": [
                260
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ContainerSortOption": {},
        "ContainerStatus": {},
        "ContainerStatusCounts": {
            "atFacilityEmpty": [
                619
            ],
            "atFacilityLoaded": [
                619
            ],
            "atPort": [
                619
            ],
            "atPortReadyToShip": [
                619
            ],
            "inTransitToFacility": [
                619
            ],
            "inTransitToPort": [
                619
            ],
            "shipped": [
                619
            ],
            "total": [
                619
            ],
            "voided": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "ContainerType": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ContainerTypeFilter": {
            "ids": [
                607
            ],
            "includeDeleted": [
                137
            ],
            "name": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ContainerTypeResultPage": {
            "entries": [
                268
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ContainerTypeSortOption": {},
        "ContainerUpdateInput": {
            "containerNumber": [
                1199
            ],
            "facilityId": [
                607
            ],
            "sealNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ConversationParticipantInput": {
            "contactType": [
                259
            ],
            "email": [
                1199
            ],
            "fullName": [
                1199
            ],
            "organizationName": [
                1199
            ],
            "participantId": [
                607
            ],
            "phone": [
                1199
            ],
            "role": [
                1199
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "Coordinates": {
            "latitude": [
                393
            ],
            "longitude": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "CoordinatesInput": {
            "latitude": [
                393
            ],
            "longitude": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "CoreAggregateType": {},
        "CoreOutboxEventCounts": {
            "facility": [
                619
            ],
            "facilityGroup": [
                619
            ],
            "organization": [
                619
            ],
            "user": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "CoreOutboxEventFilter": {
            "aggregateId": [
                607
            ],
            "aggregateTypes": [
                276
            ],
            "createdAtRange": [
                1447
            ],
            "statuses": [
                903
            ],
            "__typename": [
                1199
            ]
        },
        "CounterpartyGroup": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "id": [
                607
            ],
            "memberCount": [
                619
            ],
            "name": [
                1199
            ],
            "operationType": [
                886
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedById": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "CounterpartyGroupFilter": {
            "ids": [
                607
            ],
            "operationTypes": [
                886
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CounterpartyGroupInput": {
            "name": [
                1199
            ],
            "operationType": [
                886
            ],
            "updatedById": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CounterpartyGroupMember": {
            "accountId": [
                607
            ],
            "addedById": [
                607
            ],
            "counterpartyGroupId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "id": [
                607
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "CounterpartyGroupMemberFilter": {
            "accountId": [
                607
            ],
            "accountIds": [
                607
            ],
            "addedById": [
                607
            ],
            "addedByIds": [
                607
            ],
            "counterpartyGroupId": [
                607
            ],
            "counterpartyGroupIds": [
                607
            ],
            "ids": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CounterpartyGroupMemberInput": {
            "accountId": [
                607
            ],
            "addedById": [
                607
            ],
            "counterpartyGroupId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CounterpartyGroupMemberResultPage": {
            "entries": [
                282
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "CounterpartyGroupMemberSortOption": {},
        "CounterpartyGroupMemberUpdateInput": {
            "accountId": [
                607
            ],
            "addedById": [
                607
            ],
            "counterpartyGroupId": [
                607
            ],
            "id": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CounterpartyGroupResultPage": {
            "entries": [
                279
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "CounterpartyGroupSortOption": {},
        "CounterpartyGroupUpdateInput": {
            "name": [
                1199
            ],
            "operationType": [
                886
            ],
            "updatedById": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CreateAccountAddressInput": {
            "accountId": [
                607
            ],
            "address": [
                31
            ],
            "contacts": [
                303
            ],
            "customAttributes": [
                828
            ],
            "locationType": [
                32
            ],
            "name": [
                1199
            ],
            "operatingHours": [
                828
            ],
            "__typename": [
                1199
            ]
        },
        "CreateAccountIdentityDocumentInput": {
            "accountIndividualDetailsId": [
                607
            ],
            "documentNumber": [
                1199
            ],
            "documentType": [
                608
            ],
            "expirationDate": [
                168
            ],
            "issueDate": [
                168
            ],
            "issuingState": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateAccountIndividualDetailsInput": {
            "accountId": [
                607
            ],
            "dateOfBirth": [
                168
            ],
            "employer": [
                1199
            ],
            "eyeColor": [
                615
            ],
            "hairColor": [
                616
            ],
            "height": [
                619
            ],
            "identityDocuments": [
                292
            ],
            "race": [
                617
            ],
            "sex": [
                618
            ],
            "weight": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "CreateAccountInput": {
            "accountManagerIds": [
                607
            ],
            "addresses": [
                291
            ],
            "customAttributes": [
                828
            ],
            "defaultPurchasePaymentTermId": [
                607
            ],
            "defaultSalesPaymentTermId": [
                607
            ],
            "dotNumber": [
                1199
            ],
            "email": [
                1199
            ],
            "individualDetails": [
                293
            ],
            "insuranceExpiration": [
                168
            ],
            "linkedOrganizationId": [
                607
            ],
            "mcNumber": [
                1199
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "paymentSchedulePreference": [
                1199
            ],
            "paymentTypePreference": [
                1199
            ],
            "phone": [
                1199
            ],
            "relationship": [
                24
            ],
            "scac": [
                1199
            ],
            "type": [
                27
            ],
            "w9OnFile": [
                137
            ],
            "website": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateAgentInput": {
            "agentIdentifier": [
                1199
            ],
            "content": [
                1199
            ],
            "description": [
                1199
            ],
            "model": [
                1199
            ],
            "modelProvider": [
                834
            ],
            "name": [
                1199
            ],
            "organizationId": [
                607
            ],
            "providerApiKey": [
                1199
            ],
            "providerBaseUrl": [
                1199
            ],
            "reasoningBudget": [
                619
            ],
            "reasoningEnabled": [
                137
            ],
            "temperature": [
                538
            ],
            "type": [
                40
            ],
            "__typename": [
                1199
            ]
        },
        "CreateAssetInput": {
            "accountAddressId": [
                607
            ],
            "accountId": [
                607
            ],
            "currentLocation": [
                31
            ],
            "customAttributes": [
                828
            ],
            "description": [
                1199
            ],
            "facilityId": [
                607
            ],
            "fillState": [
                55
            ],
            "identifier": [
                1199
            ],
            "lastLocationTime": [
                1446
            ],
            "notes": [
                1199
            ],
            "status": [
                65
            ],
            "tareWeight": [
                1426
            ],
            "typeId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CreateAssetTypeInput": {
            "capacity": [
                538
            ],
            "description": [
                1199
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateAssistantChatInput": {
            "title": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateAutomationInput": {
            "description": [
                1199
            ],
            "edges": [
                457
            ],
            "name": [
                1199
            ],
            "nodes": [
                847
            ],
            "triggerConfig": [
                1297
            ],
            "triggerType": [
                1298
            ],
            "__typename": [
                1199
            ]
        },
        "CreateBillInput": {
            "accountID": [
                607
            ],
            "amount": [
                836
            ],
            "compliance": [
                111
            ],
            "documentDate": [
                168
            ],
            "documentNumber": [
                1199
            ],
            "dueDate": [
                168
            ],
            "eligibleAt": [
                168
            ],
            "facilityID": [
                607
            ],
            "lineItems": [
                116
            ],
            "notes": [
                1199
            ],
            "outboundScaleTicketID": [
                607
            ],
            "paymentTerm": [
                920
            ],
            "paymentTermId": [
                607
            ],
            "preferredPaymentMethod": [
                916
            ],
            "scaleTicketID": [
                607
            ],
            "type": [
                122
            ],
            "__typename": [
                1199
            ]
        },
        "CreateBrokeredOrderLineItemInput": {
            "brokeredOrderId": [
                607
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "quantity": [
                393
            ],
            "unit": [
                1307
            ],
            "__typename": [
                1199
            ]
        },
        "CreateCameraInput": {
            "driverType": [
                1199
            ],
            "name": [
                1199
            ],
            "sidecarId": [
                607
            ],
            "snapshotUrl": [
                1199
            ],
            "streamProfile": [
                1199
            ],
            "streamUrl": [
                1199
            ],
            "uniqueId": [
                1199
            ],
            "username": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateContactInput": {
            "accountId": [
                607
            ],
            "addressAs": [
                1199
            ],
            "addressId": [
                607
            ],
            "customAttributes": [
                828
            ],
            "department": [
                1199
            ],
            "email": [
                1199
            ],
            "fullName": [
                1199
            ],
            "isPrimary": [
                137
            ],
            "notes": [
                1199
            ],
            "ownerUserId": [
                607
            ],
            "phone": [
                1199
            ],
            "prefix": [
                1199
            ],
            "role": [
                1199
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CreateContainerTypeInput": {
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateConversationInput": {
            "conversationId": [
                1199
            ],
            "custom": [
                41
            ],
            "participants": [
                273
            ],
            "subject": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateConversationResult": {
            "conversationId": [
                1199
            ],
            "participants": [
                1373
            ],
            "__typename": [
                1199
            ]
        },
        "CreateCustomAttributeInput": {
            "constraints": [
                492
            ],
            "dataType": [
                493
            ],
            "entityType": [
                357
            ],
            "name": [
                1199
            ],
            "order": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "CreateCustomerInvitationInput": {
            "accountId": [
                607
            ],
            "email": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateDriverCertificationInput": {
            "driverId": [
                607
            ],
            "expirationDate": [
                1446
            ],
            "issuedDate": [
                1446
            ],
            "issuingBody": [
                1199
            ],
            "number": [
                1199
            ],
            "type": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateDriverInput": {
            "address": [
                31
            ],
            "currentLocation": [
                943
            ],
            "defaultTrailerId": [
                607
            ],
            "defaultTruckId": [
                607
            ],
            "email": [
                1199
            ],
            "firstName": [
                1199
            ],
            "lastLocationTime": [
                1446
            ],
            "lastName": [
                1199
            ],
            "licenseExpiration": [
                1446
            ],
            "licenseNumber": [
                1199
            ],
            "phoneNumber": [
                1199
            ],
            "status": [
                454
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CreateFileError": {
            "message": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateFileInput": {
            "entityId": [
                607
            ],
            "entityType": [
                1199
            ],
            "expiresAt": [
                1247
            ],
            "fileName": [
                1199
            ],
            "fileSize": [
                619
            ],
            "fileType": [
                509
            ],
            "metadata": [
                828
            ],
            "mimeType": [
                1199
            ],
            "parentId": [
                607
            ],
            "public": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "CreateFilePayload": {
            "file": [
                494
            ],
            "uploadUrl": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateFileResult": {
            "on_CreateFileError": [
                311
            ],
            "on_CreateFileSuccess": [
                315
            ],
            "__typename": [
                1199
            ]
        },
        "CreateFileSuccess": {
            "file": [
                494
            ],
            "uploadUrl": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateFilesPayload": {
            "failed": [
                311
            ],
            "succeeded": [
                315
            ],
            "__typename": [
                1199
            ]
        },
        "CreateFinancialAccountInput": {
            "accountNumber": [
                1199
            ],
            "bankName": [
                1199
            ],
            "checkBusinessName": [
                1199
            ],
            "checkLogo": [
                1199
            ],
            "checkMailingAddress": [
                1199
            ],
            "checkNumberGeneration": [
                137
            ],
            "checkPhoneNumber": [
                1199
            ],
            "checkSignature": [
                1199
            ],
            "currency": [
                355
            ],
            "customAttributes": [
                828
            ],
            "ezcashEndpoint": [
                1199
            ],
            "ezcashTimeoutSeconds": [
                619
            ],
            "ezcashToken": [
                1199
            ],
            "facilityID": [
                607
            ],
            "initialBalance": [
                393
            ],
            "lastCheckNumber": [
                619
            ],
            "nachaCompanyIdentification": [
                1199
            ],
            "nachaCompanyName": [
                1199
            ],
            "nachaDefaultSecCode": [
                1199
            ],
            "name": [
                1199
            ],
            "paymentAllocationMethod": [
                912
            ],
            "roundingMethod": [
                1064
            ],
            "roundingPrecision": [
                1065
            ],
            "routingNumber": [
                1199
            ],
            "type": [
                537
            ],
            "visibleInPayments": [
                137
            ],
            "warningThreshold": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "CreateFinancialAccountTransactionInput": {
            "amount": [
                393
            ],
            "authorizedDate": [
                168
            ],
            "channel": [
                529
            ],
            "checkNumber": [
                1199
            ],
            "counterpartyIds": [
                607
            ],
            "date": [
                168
            ],
            "financialAccountId": [
                607
            ],
            "financialAccountOwnerId": [
                1199
            ],
            "imageUrl": [
                1199
            ],
            "location": [
                31
            ],
            "pendingTransactionId": [
                607
            ],
            "reference": [
                1199
            ],
            "status": [
                535
            ],
            "transferNumber": [
                1199
            ],
            "type": [
                536
            ],
            "website": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateInvoiceInput": {
            "accountID": [
                607
            ],
            "amount": [
                836
            ],
            "documentDate": [
                168
            ],
            "documentNumber": [
                1199
            ],
            "facilityID": [
                607
            ],
            "lineItems": [
                719
            ],
            "notes": [
                1199
            ],
            "paymentTerm": [
                920
            ],
            "paymentTermId": [
                607
            ],
            "sourceReferences": [
                715
            ],
            "status": [
                724
            ],
            "type": [
                726
            ],
            "__typename": [
                1199
            ]
        },
        "CreateItemPricingTierInput": {
            "itemPricingId": [
                607
            ],
            "maxAmount": [
                393
            ],
            "maxPrice": [
                1310
            ],
            "minPrice": [
                1310
            ],
            "position": [
                619
            ],
            "scrapValue": [
                393
            ],
            "targetPrice": [
                1310
            ],
            "__typename": [
                1199
            ]
        },
        "CreateLoadDeductionInput": {
            "applicationType": [
                394
            ],
            "deductionTypeId": [
                607
            ],
            "facilityId": [
                607
            ],
            "loadId": [
                607
            ],
            "loadLineItemId": [
                607
            ],
            "notes": [
                1199
            ],
            "percentage": [
                393
            ],
            "priceValue": [
                836
            ],
            "weightValue": [
                1426
            ],
            "__typename": [
                1199
            ]
        },
        "CreateOrganizationInput": {
            "domain": [
                1199
            ],
            "idpId": [
                1199
            ],
            "name": [
                1199
            ],
            "onboardAt": [
                1446
            ],
            "timezone": [
                1251
            ],
            "__typename": [
                1199
            ]
        },
        "CreatePaymentInput": {
            "accountId": [
                607
            ],
            "achNumber": [
                1199
            ],
            "amount": [
                836
            ],
            "atmId": [
                1199
            ],
            "atmPaymentNumber": [
                1199
            ],
            "barcode": [
                1199
            ],
            "barcodeRowId": [
                619
            ],
            "billIds": [
                607
            ],
            "checkAttn": [
                1199
            ],
            "checkFacilityId": [
                607
            ],
            "checkMemo": [
                1199
            ],
            "checkNumber": [
                1199
            ],
            "documentNumber": [
                1199
            ],
            "financialAccountId": [
                607
            ],
            "financialAccountTransactionId": [
                607
            ],
            "invoiceIds": [
                607
            ],
            "paymentMethod": [
                916
            ],
            "paymentType": [
                927
            ],
            "supplierPhotoId": [
                607
            ],
            "transactionDate": [
                168
            ],
            "wireNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreatePrinterInput": {
            "driverType": [
                1199
            ],
            "name": [
                1199
            ],
            "pageSize": [
                965
            ],
            "printerType": [
                970
            ],
            "rollWidth": [
                967
            ],
            "sidecarId": [
                607
            ],
            "uniqueId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateProcessingTypeInputItemInput": {
            "isPrimary": [
                137
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "processingTypeId": [
                607
            ],
            "sortOrder": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "CreateProcessingTypeOutputItemInput": {
            "costAllocationPercentage": [
                393
            ],
            "isNoCost": [
                137
            ],
            "isPrimary": [
                137
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "outputUnit": [
                1307
            ],
            "processingTypeId": [
                607
            ],
            "sortOrder": [
                619
            ],
            "yieldPercentage": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "CreatePurchaseLoadDeductionInput": {
            "applicationType": [
                394
            ],
            "deductionTypeId": [
                607
            ],
            "notes": [
                1199
            ],
            "percentage": [
                393
            ],
            "priceValue": [
                836
            ],
            "purchaseLoadId": [
                607
            ],
            "purchaseLoadLineItemId": [
                607
            ],
            "weightValue": [
                1426
            ],
            "__typename": [
                1199
            ]
        },
        "CreatePurchaseLoadLineItemInput": {
            "catComplianceStatus": [
                1199
            ],
            "catOemCode": [
                1199
            ],
            "catSerialNumber": [
                1199
            ],
            "estimatedPrice": [
                836
            ],
            "grossWeight": [
                1426
            ],
            "itemId": [
                607
            ],
            "netWeight": [
                1426
            ],
            "notes": [
                1199
            ],
            "parentLineItemId": [
                607
            ],
            "pricingUnit": [
                1307
            ],
            "purchaseLoadId": [
                607
            ],
            "purchaseOrderLineId": [
                607
            ],
            "requiresSorting": [
                137
            ],
            "settlementBasis": [
                1172
            ],
            "tagId": [
                607
            ],
            "tareWeight": [
                1426
            ],
            "type": [
                986
            ],
            "unitPrice": [
                836
            ],
            "vehicleMake": [
                1199
            ],
            "vehicleModel": [
                1199
            ],
            "vehicleTitleStatus": [
                1199
            ],
            "vehicleVin": [
                1199
            ],
            "vehicleYear": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "CreatePurchaseLoadPaymentInput": {
            "amount": [
                836
            ],
            "checkMemo": [
                1199
            ],
            "checkNumber": [
                1199
            ],
            "creatorId": [
                607
            ],
            "financialAccountId": [
                607
            ],
            "legalHold": [
                137
            ],
            "paymentMethod": [
                1199
            ],
            "paymentTerm": [
                1199
            ],
            "percentage": [
                393
            ],
            "purchaseLoadId": [
                607
            ],
            "roundingMethod": [
                1199
            ],
            "roundingPrecision": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreatePurchaseOrderInput": {
            "accountAddressId": [
                607
            ],
            "accountContactId": [
                607
            ],
            "accountId": [
                607
            ],
            "accountRepresentativeId": [
                607
            ],
            "completionNotes": [
                1199
            ],
            "counterpartyReferenceNumber": [
                1199
            ],
            "customAttributes": [
                828
            ],
            "documentNumber": [
                1199
            ],
            "endDate": [
                168
            ],
            "facilityId": [
                607
            ],
            "freightTerm": [
                572
            ],
            "lineItems": [
                331
            ],
            "notes": [
                1199
            ],
            "paymentCurrency": [
                1199
            ],
            "paymentTerm": [
                920
            ],
            "startDate": [
                168
            ],
            "status": [
                1024
            ],
            "__typename": [
                1199
            ]
        },
        "CreatePurchaseOrderLineItemInput": {
            "itemId": [
                607
            ],
            "purchaseOrderId": [
                607
            ],
            "quantity": [
                393
            ],
            "totalPrice": [
                836
            ],
            "unit": [
                1307
            ],
            "unitPrice": [
                836
            ],
            "__typename": [
                1199
            ]
        },
        "CreateQuoteLineItemInput": {
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "packageFormat": [
                1199
            ],
            "quantity": [
                393
            ],
            "quoteId": [
                607
            ],
            "unit": [
                1307
            ],
            "unitPrice": [
                836
            ],
            "__typename": [
                1199
            ]
        },
        "CreateRoleInput": {
            "description": [
                1199
            ],
            "name": [
                1199
            ],
            "permissions": [
                1199
            ],
            "type": [
                1063
            ],
            "__typename": [
                1199
            ]
        },
        "CreateRouteInput": {
            "driverId": [
                607
            ],
            "facilityGroupId": [
                607
            ],
            "haulerId": [
                607
            ],
            "routeDate": [
                1446
            ],
            "status": [
                1078
            ],
            "trailerId": [
                607
            ],
            "truckId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CreateScaleInput": {
            "baudRate": [
                619
            ],
            "cameraId": [
                607
            ],
            "connectionType": [
                1114
            ],
            "dataBits": [
                619
            ],
            "measurementIncrement": [
                393
            ],
            "measurementMode": [
                1117
            ],
            "name": [
                1199
            ],
            "onDemandString": [
                1199
            ],
            "parity": [
                1199
            ],
            "scaleFormatType": [
                1116
            ],
            "serialPortPath": [
                1199
            ],
            "sidecarId": [
                607
            ],
            "stopBits": [
                1199
            ],
            "tcpHost": [
                1199
            ],
            "tcpPort": [
                619
            ],
            "unitOfMeasurement": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateScannerInput": {
            "driverType": [
                1199
            ],
            "name": [
                1199
            ],
            "sidecarId": [
                607
            ],
            "uniqueId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateServiceInput": {
            "accountAddressId": [
                607
            ],
            "accountId": [
                607
            ],
            "actions": [
                1135
            ],
            "address": [
                31
            ],
            "assetTypes": [
                1137
            ],
            "assets": [
                1136
            ],
            "assignmentStatus": [
                71
            ],
            "contactId": [
                607
            ],
            "deadline": [
                1446
            ],
            "destinationFacilityId": [
                607
            ],
            "driverId": [
                607
            ],
            "driverNotes": [
                1199
            ],
            "estimatedArrival": [
                1446
            ],
            "externalNotes": [
                1199
            ],
            "facilityGroupId": [
                607
            ],
            "facilityId": [
                607
            ],
            "haulerId": [
                607
            ],
            "internalNotes": [
                1199
            ],
            "isRequest": [
                137
            ],
            "isTemplate": [
                137
            ],
            "priority": [
                619
            ],
            "rank": [
                1199
            ],
            "recurringSchedule": [
                1051
            ],
            "recurringTaskId": [
                607
            ],
            "routeId": [
                607
            ],
            "routePosition": [
                393
            ],
            "scheduledWindowEnd": [
                1446
            ],
            "scheduledWindowStart": [
                1446
            ],
            "serviceTypeId": [
                607
            ],
            "status": [
                1143
            ],
            "trailerId": [
                607
            ],
            "truckId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CreateServiceTypeWithDefinitionsInput": {
            "description": [
                1199
            ],
            "isActive": [
                137
            ],
            "isSystemDefault": [
                137
            ],
            "name": [
                1199
            ],
            "taskDefinitions": [
                1152
            ],
            "__typename": [
                1199
            ]
        },
        "CreateSettingInput": {
            "constraints": [
                492
            ],
            "dataType": [
                493
            ],
            "defaultValue": [
                41
            ],
            "description": [
                1199
            ],
            "id": [
                1199
            ],
            "name": [
                1199
            ],
            "scope": [
                1165
            ],
            "settingsGroupId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CreateSettingsGroupInput": {
            "description": [
                1199
            ],
            "icon": [
                1199
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateSidecarInput": {
            "facilityId": [
                607
            ],
            "name": [
                1199
            ],
            "operatingSystem": [
                1183
            ],
            "operatingSystemVersion": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateTollReceiptItemInput": {
            "itemId": [
                607
            ],
            "lotId": [
                607
            ],
            "notes": [
                1199
            ],
            "quantity": [
                393
            ],
            "quantityUnit": [
                1307
            ],
            "tollReceiptId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CreateTollShipmentItemInput": {
            "itemId": [
                607
            ],
            "lotId": [
                607
            ],
            "notes": [
                1199
            ],
            "processingFee": [
                836
            ],
            "quantity": [
                393
            ],
            "quantityUnit": [
                1307
            ],
            "tollShipmentId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CreateTrailerInput": {
            "capacity": [
                538
            ],
            "country": [
                1199
            ],
            "currentLocation": [
                943
            ],
            "facilityId": [
                607
            ],
            "lastLocationTime": [
                1446
            ],
            "licensePlate": [
                1199
            ],
            "licensePlateExpiration": [
                1446
            ],
            "notes": [
                1199
            ],
            "state": [
                1199
            ],
            "status": [
                1285
            ],
            "transportationTypeId": [
                607
            ],
            "vin": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateTransportationTypeInput": {
            "description": [
                1199
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateTruckInput": {
            "capacity": [
                538
            ],
            "country": [
                1199
            ],
            "currentLocation": [
                943
            ],
            "defaultTrailerId": [
                607
            ],
            "facilityId": [
                607
            ],
            "lastLocationTime": [
                1446
            ],
            "licensePlate": [
                1199
            ],
            "licensePlateExpiration": [
                1446
            ],
            "model": [
                1199
            ],
            "notes": [
                1199
            ],
            "state": [
                1199
            ],
            "status": [
                1304
            ],
            "transportationTypeId": [
                607
            ],
            "vin": [
                1199
            ],
            "year": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "CreateUserInput": {
            "email": [
                1199
            ],
            "firstName": [
                1199
            ],
            "idpId": [
                1199
            ],
            "lastName": [
                1199
            ],
            "organizationId": [
                607
            ],
            "phoneNumber": [
                1199
            ],
            "roleAssignments": [
                1385
            ],
            "timezone": [
                1251
            ],
            "__typename": [
                1199
            ]
        },
        "CreateWarehouseCredentialInput": {
            "databaseName": [
                1199
            ],
            "enabled": [
                137
            ],
            "host": [
                1199
            ],
            "port": [
                619
            ],
            "ssl": [
                137
            ],
            "username": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CreateWorkOrderInputItemInput": {
            "actualQuantity": [
                393
            ],
            "actualQuantityUnit": [
                1307
            ],
            "itemId": [
                607
            ],
            "lotId": [
                607
            ],
            "notes": [
                1199
            ],
            "plannedQuantity": [
                393
            ],
            "plannedQuantityUnit": [
                1307
            ],
            "tagId": [
                607
            ],
            "unitCost": [
                836
            ],
            "workOrderId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CreateWorkOrderOutputItemInput": {
            "actualQuantity": [
                393
            ],
            "actualQuantityUnit": [
                1307
            ],
            "allocatedCost": [
                836
            ],
            "costAllocationPercentage": [
                393
            ],
            "expectedQuantity": [
                393
            ],
            "expectedQuantityUnit": [
                1307
            ],
            "isNoCost": [
                137
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "targetLotId": [
                607
            ],
            "targetTagId": [
                607
            ],
            "unitCost": [
                836
            ],
            "workOrderId": [
                607
            ],
            "yieldPercentage": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "CreatorPlatform": {},
        "CrmAggregateType": {},
        "CrmOutboxEventCounts": {
            "account": [
                619
            ],
            "accountAddress": [
                619
            ],
            "contact": [
                619
            ],
            "customerInvitation": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "CrmOutboxEventFilter": {
            "aggregateId": [
                607
            ],
            "aggregateTypes": [
                352
            ],
            "createdAtRange": [
                1447
            ],
            "statuses": [
                903
            ],
            "__typename": [
                1199
            ]
        },
        "CurrencyCode": {},
        "CustomAttribute": {
            "constraints": [
                491
            ],
            "dataType": [
                493
            ],
            "entityType": [
                357
            ],
            "id": [
                607
            ],
            "isDisabled": [
                137
            ],
            "name": [
                1199
            ],
            "order": [
                619
            ],
            "timestamps": [
                1250
            ],
            "__typename": [
                1199
            ]
        },
        "CustomAttributeEntityType": {},
        "CustomAttributeFilter": {
            "entityTypes": [
                357
            ],
            "__typename": [
                1199
            ]
        },
        "CustomPriceList": {
            "archivedAt": [
                1446
            ],
            "counterpartyGroupId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "currency": [
                1199
            ],
            "endDate": [
                1446
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "isPublished": [
                137
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "operationType": [
                886
            ],
            "pricingMode": [
                962
            ],
            "startDate": [
                1446
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "CustomPriceListDraftInput": {
            "counterpartyGroupId": [
                607
            ],
            "currency": [
                1199
            ],
            "endDate": [
                1446
            ],
            "facilityId": [
                607
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "operationType": [
                886
            ],
            "pricingMode": [
                962
            ],
            "startDate": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "CustomPriceListFilter": {
            "ids": [
                607
            ],
            "isArchived": [
                137
            ],
            "isPublished": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "CustomPriceListInput": {
            "archivedAt": [
                1446
            ],
            "counterpartyGroupId": [
                607
            ],
            "currency": [
                1199
            ],
            "endDate": [
                1446
            ],
            "facilityId": [
                607
            ],
            "isPublished": [
                137
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "operationType": [
                886
            ],
            "pricingMode": [
                962
            ],
            "startDate": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "CustomPriceListResultPage": {
            "entries": [
                359
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "CustomPriceListSortOption": {},
        "CustomPriceListStatusCounts": {
            "active": [
                619
            ],
            "archived": [
                619
            ],
            "draft": [
                619
            ],
            "expired": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "CustomPriceListUpdateInput": {
            "archivedAt": [
                1446
            ],
            "counterpartyGroupId": [
                607
            ],
            "currency": [
                1199
            ],
            "endDate": [
                1446
            ],
            "facilityId": [
                607
            ],
            "isPublished": [
                137
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "operationType": [
                886
            ],
            "pricingMode": [
                962
            ],
            "startDate": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "CustomerInvitation": {
            "acceptedAt": [
                1247
            ],
            "account": [
                3
            ],
            "accountId": [
                607
            ],
            "email": [
                1199
            ],
            "expiresAt": [
                1247
            ],
            "id": [
                607
            ],
            "invitationStatus": [
                712
            ],
            "invitedByUserId": [
                607
            ],
            "linkedOrganizationId": [
                607
            ],
            "sentAt": [
                1247
            ],
            "timestamps": [
                1250
            ],
            "__typename": [
                1199
            ]
        },
        "CustomerInvitationFilter": {
            "accountIds": [
                607
            ],
            "email": [
                1199
            ],
            "includeAccount": [
                137
            ],
            "invitationIds": [
                607
            ],
            "invitationStatuses": [
                712
            ],
            "invitedByUserId": [
                607
            ],
            "linkedOrganizationId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CustomerInvitationResultPage": {
            "entries": [
                367
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "CustomerInvitationSortOption": {},
        "CycleCountFrequency": {},
        "CycleCountLine": {
            "adjustmentMovement": [
                662
            ],
            "adjustmentMovementId": [
                607
            ],
            "adjustmentStatus": [
                1199
            ],
            "countedAt": [
                1446
            ],
            "countedBy": [
                607
            ],
            "countedByUser": [
                1372
            ],
            "countedQuantity": [
                393
            ],
            "countedQuantityUnit": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "cycleCountTask": [
                385
            ],
            "cycleCountTaskId": [
                607
            ],
            "expectedQuantity": [
                393
            ],
            "expectedQuantityUnit": [
                1199
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "recountRequested": [
                137
            ],
            "stockAccount": [
                625
            ],
            "stockAccountId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "toleranceThreshold": [
                393
            ],
            "unitCostOverride": [
                393
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "variancePercentage": [
                393
            ],
            "varianceQuantity": [
                393
            ],
            "withinTolerance": [
                137
            ],
            "zone": [
                706
            ],
            "zoneId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CycleCountLineFilter": {
            "adjustmentStatus": [
                1199
            ],
            "cycleCountTaskIds": [
                607
            ],
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "itemIds": [
                607
            ],
            "stockAccountIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CycleCountLineInput": {
            "adjustmentMovementId": [
                607
            ],
            "adjustmentStatus": [
                1199
            ],
            "countedAt": [
                1446
            ],
            "countedBy": [
                607
            ],
            "countedQuantity": [
                393
            ],
            "countedQuantityUnit": [
                1199
            ],
            "cycleCountTaskId": [
                607
            ],
            "expectedQuantity": [
                393
            ],
            "expectedQuantityUnit": [
                1199
            ],
            "facilityId": [
                607
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "recountRequested": [
                137
            ],
            "stockAccountId": [
                607
            ],
            "toleranceThreshold": [
                393
            ],
            "unitCostOverride": [
                393
            ],
            "variancePercentage": [
                393
            ],
            "varianceQuantity": [
                393
            ],
            "withinTolerance": [
                137
            ],
            "zoneId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CycleCountLineResultPage": {
            "entries": [
                372
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "CycleCountLineSortOption": {},
        "CycleCountLineUpdateInput": {
            "adjustmentMovementId": [
                607
            ],
            "adjustmentStatus": [
                1199
            ],
            "countedAt": [
                1446
            ],
            "countedBy": [
                607
            ],
            "countedQuantity": [
                393
            ],
            "countedQuantityUnit": [
                1199
            ],
            "cycleCountTaskId": [
                607
            ],
            "expectedQuantity": [
                393
            ],
            "expectedQuantityUnit": [
                1199
            ],
            "facilityId": [
                607
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "recountRequested": [
                137
            ],
            "stockAccountId": [
                607
            ],
            "toleranceThreshold": [
                393
            ],
            "unitCostOverride": [
                393
            ],
            "variancePercentage": [
                393
            ],
            "varianceQuantity": [
                393
            ],
            "withinTolerance": [
                137
            ],
            "zoneId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CycleCountSchedule": {
            "abcClassification": [
                1199
            ],
            "categoryTolerances": [
                828
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "defaultTolerancePercentage": [
                393
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "frequency": [
                371
            ],
            "id": [
                607
            ],
            "isActive": [
                137
            ],
            "isBlindCount": [
                137
            ],
            "lastGeneratedAt": [
                1446
            ],
            "name": [
                1199
            ],
            "nextGenerationAt": [
                1446
            ],
            "scopeCategories": [
                828
            ],
            "scopeType": [
                384
            ],
            "scopeZones": [
                828
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "valueThreshold": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "CycleCountScheduleFilter": {
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CycleCountScheduleInput": {
            "abcClassification": [
                1199
            ],
            "categoryTolerances": [
                828
            ],
            "defaultTolerancePercentage": [
                393
            ],
            "facilityId": [
                607
            ],
            "frequency": [
                371
            ],
            "isBlindCount": [
                137
            ],
            "name": [
                1199
            ],
            "scopeCategories": [
                828
            ],
            "scopeType": [
                384
            ],
            "scopeZones": [
                828
            ],
            "valueThreshold": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "CycleCountScheduleResultPage": {
            "entries": [
                378
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "CycleCountScheduleSortOption": {},
        "CycleCountScheduleUpdateInput": {
            "abcClassification": [
                1199
            ],
            "categoryTolerances": [
                828
            ],
            "defaultTolerancePercentage": [
                393
            ],
            "frequency": [
                371
            ],
            "isBlindCount": [
                137
            ],
            "name": [
                1199
            ],
            "scopeCategories": [
                828
            ],
            "scopeType": [
                384
            ],
            "scopeZones": [
                828
            ],
            "valueThreshold": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "CycleCountScopeType": {},
        "CycleCountTask": {
            "abcClassification": [
                1199
            ],
            "approvedAt": [
                1446
            ],
            "approvedBy": [
                607
            ],
            "approvedByUser": [
                1372
            ],
            "assignedTo": [
                607
            ],
            "assignedToUser": [
                1372
            ],
            "completedAt": [
                1446
            ],
            "countType": [
                384
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "defaultTolerancePercentage": [
                393
            ],
            "dueDate": [
                168
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "isBlindCount": [
                137
            ],
            "isFrozen": [
                137
            ],
            "notes": [
                1199
            ],
            "schedule": [
                378
            ],
            "scheduleId": [
                607
            ],
            "scopeCategories": [
                828
            ],
            "scopeZones": [
                828
            ],
            "snapshotMovementId": [
                607
            ],
            "startedAt": [
                1446
            ],
            "status": [
                1199
            ],
            "taskNumber": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "valueThreshold": [
                393
            ],
            "zone": [
                706
            ],
            "zoneId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CycleCountTaskFilter": {
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "status": [
                1199
            ],
            "statuses": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "CycleCountTaskInput": {
            "abcClassification": [
                1199
            ],
            "assignedTo": [
                607
            ],
            "countType": [
                384
            ],
            "defaultTolerancePercentage": [
                393
            ],
            "dueDate": [
                168
            ],
            "facilityId": [
                607
            ],
            "isBlindCount": [
                137
            ],
            "notes": [
                1199
            ],
            "scheduleId": [
                607
            ],
            "scopeCategories": [
                828
            ],
            "scopeZones": [
                828
            ],
            "taskNumber": [
                1199
            ],
            "valueThreshold": [
                393
            ],
            "zoneId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "CycleCountTaskResultPage": {
            "entries": [
                385
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "CycleCountTaskSortOption": {},
        "CycleCountTaskUpdateInput": {
            "abcClassification": [
                1199
            ],
            "assignedTo": [
                607
            ],
            "countType": [
                384
            ],
            "defaultTolerancePercentage": [
                393
            ],
            "dueDate": [
                168
            ],
            "isBlindCount": [
                137
            ],
            "notes": [
                1199
            ],
            "scheduleId": [
                607
            ],
            "scopeCategories": [
                828
            ],
            "scopeZones": [
                828
            ],
            "taskNumber": [
                1199
            ],
            "valueThreshold": [
                393
            ],
            "zoneId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "DateRangeInput": {
            "end": [
                168
            ],
            "start": [
                168
            ],
            "__typename": [
                1199
            ]
        },
        "DateTimeRangeInput": {
            "end": [
                169
            ],
            "start": [
                169
            ],
            "__typename": [
                1199
            ]
        },
        "Decimal": {},
        "DeductionApplicationType": {},
        "DeductionType": {
            "applicationType": [
                394
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "DeductionTypeFilter": {
            "applicationType": [
                394
            ],
            "ids": [
                607
            ],
            "name": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "DeductionTypeInput": {
            "applicationType": [
                394
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "DeductionTypeResultPage": {
            "entries": [
                395
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "DeductionTypeSortOption": {},
        "DeductionTypeUpdateInput": {
            "applicationType": [
                394
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "DefaultPhotoRequirement": {
            "createdById": [
                607
            ],
            "id": [
                607
            ],
            "isRequired": [
                137
            ],
            "name": [
                1199
            ],
            "order": [
                538
            ],
            "timestamps": [
                1250
            ],
            "__typename": [
                1199
            ]
        },
        "DefaultPhotoRequirementInput": {
            "isRequired": [
                137
            ],
            "name": [
                1199
            ],
            "order": [
                538
            ],
            "__typename": [
                1199
            ]
        },
        "DefaultPriceList": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "currency": [
                1199
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "notes": [
                1199
            ],
            "operationType": [
                886
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "DefaultPriceListFilter": {
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "DefaultPriceListInput": {
            "currency": [
                1199
            ],
            "facilityId": [
                607
            ],
            "notes": [
                1199
            ],
            "operationType": [
                886
            ],
            "__typename": [
                1199
            ]
        },
        "DefaultPriceListResultPage": {
            "entries": [
                403
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "DefaultPriceListSortOption": {},
        "DefaultPriceListUpdateInput": {
            "currency": [
                1199
            ],
            "facilityId": [
                607
            ],
            "notes": [
                1199
            ],
            "operationType": [
                886
            ],
            "__typename": [
                1199
            ]
        },
        "DelayNode": {
            "delayType": [
                410
            ],
            "description": [
                1199
            ],
            "duration": [
                619
            ],
            "durationUnit": [
                455
            ],
            "id": [
                607
            ],
            "label": [
                1199
            ],
            "position": [
                949
            ],
            "type": [
                848
            ],
            "untilDateTime": [
                1199
            ],
            "untilExpression": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "DelayType": {},
        "DeleteFileError": {
            "fileId": [
                607
            ],
            "message": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "DeleteFilePayload": {
            "success": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "DeleteFileResult": {
            "on_DeleteFileError": [
                411
            ],
            "on_DeleteFileSuccess": [
                414
            ],
            "__typename": [
                1199
            ]
        },
        "DeleteFileSuccess": {
            "fileId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "DeleteFilesPayload": {
            "failed": [
                411
            ],
            "succeeded": [
                414
            ],
            "__typename": [
                1199
            ]
        },
        "DeleteResult": {
            "blockingLoads": [
                34
            ],
            "deleted": [
                137
            ],
            "unlinkableLoads": [
                34
            ],
            "__typename": [
                1199
            ]
        },
        "Detention": {
            "carrier": [
                3
            ],
            "carrierId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "endDate": [
                168
            ],
            "freeMinutes": [
                619
            ],
            "id": [
                607
            ],
            "location": [
                470
            ],
            "locationId": [
                607
            ],
            "ratePerMinute": [
                393
            ],
            "startDate": [
                168
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "DetentionFilter": {
            "carrierId": [
                607
            ],
            "ids": [
                607
            ],
            "locationId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "DetentionInput": {
            "carrierId": [
                607
            ],
            "endDate": [
                168
            ],
            "freeMinutes": [
                619
            ],
            "locationId": [
                607
            ],
            "ratePerMinute": [
                393
            ],
            "startDate": [
                168
            ],
            "__typename": [
                1199
            ]
        },
        "DetentionResultPage": {
            "entries": [
                417
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "DetentionSortOption": {},
        "DetentionUpdateInput": {
            "carrierId": [
                607
            ],
            "endDate": [
                168
            ],
            "freeMinutes": [
                619
            ],
            "locationId": [
                607
            ],
            "ratePerMinute": [
                393
            ],
            "startDate": [
                168
            ],
            "__typename": [
                1199
            ]
        },
        "DispatchErrorType": {},
        "DispatchImageCategory": {},
        "DispatchImageStatus": {},
        "DispatchRecordStatus": {},
        "DoNotBuyEntry": {
            "account": [
                3
            ],
            "accountId": [
                607
            ],
            "addedByUser": [
                1372
            ],
            "addedByUserId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "effectiveFrom": [
                1446
            ],
            "effectiveTo": [
                1446
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "notes": [
                1199
            ],
            "originType": [
                433
            ],
            "reason": [
                1199
            ],
            "removedByUser": [
                1372
            ],
            "removedByUserId": [
                607
            ],
            "status": [
                434
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "DoNotBuyEntryFilter": {
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "DoNotBuyEntryInput": {
            "accountId": [
                607
            ],
            "addedByUserId": [
                607
            ],
            "effectiveFrom": [
                1446
            ],
            "effectiveTo": [
                1446
            ],
            "facilityId": [
                607
            ],
            "notes": [
                1199
            ],
            "originType": [
                433
            ],
            "reason": [
                1199
            ],
            "removedByUserId": [
                607
            ],
            "status": [
                434
            ],
            "__typename": [
                1199
            ]
        },
        "DoNotBuyEntryResultPage": {
            "entries": [
                427
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "DoNotBuyEntrySortOption": {},
        "DoNotBuyEntryUpdateInput": {
            "accountId": [
                607
            ],
            "addedByUserId": [
                607
            ],
            "effectiveFrom": [
                1446
            ],
            "effectiveTo": [
                1446
            ],
            "facilityId": [
                607
            ],
            "notes": [
                1199
            ],
            "originType": [
                433
            ],
            "reason": [
                1199
            ],
            "removedByUserId": [
                607
            ],
            "status": [
                434
            ],
            "__typename": [
                1199
            ]
        },
        "DoNotBuyOriginType": {},
        "DoNotBuyStatus": {},
        "DocumentGenerationResult": {
            "documentType": [
                1199
            ],
            "errorMessage": [
                1199
            ],
            "fileId": [
                607
            ],
            "success": [
                137
            ],
            "workflowId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "DocumentType": {},
        "DraftBookingInput": {
            "containers": [
                125
            ],
            "cutOffDate": [
                168
            ],
            "destinationPortId": [
                607
            ],
            "documentNumber": [
                1199
            ],
            "dropoffTerminalId": [
                607
            ],
            "earlyReturnDate": [
                168
            ],
            "externalNotes": [
                1199
            ],
            "facilityId": [
                607
            ],
            "internalNotes": [
                1199
            ],
            "loadingPortId": [
                607
            ],
            "oceanFreight": [
                1199
            ],
            "photoRequirements": [
                937
            ],
            "pickupTerminalId": [
                607
            ],
            "salesOrderIds": [
                607
            ],
            "steamshipLine": [
                1199
            ],
            "vesselArrivalDate": [
                168
            ],
            "vesselDepartureDate": [
                168
            ],
            "vesselName": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "DraftBookingUpdateInput": {
            "containers": [
                125
            ],
            "cutOffDate": [
                168
            ],
            "destinationPortId": [
                607
            ],
            "documentNumber": [
                1199
            ],
            "dropoffTerminalId": [
                607
            ],
            "earlyReturnDate": [
                168
            ],
            "externalNotes": [
                1199
            ],
            "facilityId": [
                607
            ],
            "internalNotes": [
                1199
            ],
            "loadingPortId": [
                607
            ],
            "oceanFreight": [
                1199
            ],
            "photoRequirements": [
                937
            ],
            "pickupTerminalId": [
                607
            ],
            "salesOrderIds": [
                607
            ],
            "steamshipLine": [
                1199
            ],
            "vesselArrivalDate": [
                168
            ],
            "vesselDepartureDate": [
                168
            ],
            "vesselName": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "Driver": {
            "address": [
                30
            ],
            "assignments": [
                1133
            ],
            "certifications": [
                440
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "currentLocation": [
                942
            ],
            "currentService": [
                1133
            ],
            "currentTrailer": [
                1281
            ],
            "currentTruck": [
                1299
            ],
            "defaultTrailer": [
                1281
            ],
            "defaultTrailerId": [
                607
            ],
            "defaultTruck": [
                1299
            ],
            "defaultTruckId": [
                607
            ],
            "displayOrder": [
                1199
            ],
            "email": [
                1199
            ],
            "firstName": [
                1199
            ],
            "id": [
                607
            ],
            "lastLocationTime": [
                1446
            ],
            "lastName": [
                1199
            ],
            "licenseExpiration": [
                1446
            ],
            "licenseNumber": [
                1199
            ],
            "phoneNumber": [
                1199
            ],
            "status": [
                454
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "user": [
                1372
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "DriverCertification": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "driver": [
                439
            ],
            "driverId": [
                607
            ],
            "expirationDate": [
                1446
            ],
            "id": [
                607
            ],
            "issuedDate": [
                1446
            ],
            "issuingBody": [
                1199
            ],
            "number": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "type": [
                1199
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "DriverCertificationFilter": {
            "driverId": [
                607
            ],
            "fromExpirationDate": [
                1446
            ],
            "ids": [
                607
            ],
            "toExpirationDate": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "DriverCertificationResultPage": {
            "entries": [
                440
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "DriverCertificationSortOption": {},
        "DriverDisplayOrder": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "driverId": [
                607
            ],
            "id": [
                607
            ],
            "rank": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "DriverDisplayOrderFilter": {
            "driverId": [
                607
            ],
            "driverIds": [
                607
            ],
            "ids": [
                607
            ],
            "rank": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "userId": [
                607
            ],
            "userIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "DriverDisplayOrderInput": {
            "driverId": [
                607
            ],
            "rank": [
                1199
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "DriverDisplayOrderResultPage": {
            "entries": [
                444
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "DriverDisplayOrderSortOption": {},
        "DriverDisplayOrderUpdateInput": {
            "driverId": [
                607
            ],
            "rank": [
                1199
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "DriverFilter": {
            "email": [
                1199
            ],
            "firstName": [
                1199
            ],
            "fromLicenseExpiration": [
                1446
            ],
            "hasActiveTasks": [
                137
            ],
            "haulerId": [
                607
            ],
            "ids": [
                607
            ],
            "lastName": [
                1199
            ],
            "lastUpdatedAt": [
                1446
            ],
            "licenseNumber": [
                1199
            ],
            "phoneNumber": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "status": [
                454
            ],
            "toLicenseExpiration": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "DriverProgress": {},
        "DriverResultPage": {
            "entries": [
                439
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "DriverSortOption": {},
        "DriverStatus": {},
        "DurationUnit": {},
        "Edge": {
            "id": [
                607
            ],
            "source": [
                607
            ],
            "sourceHandle": [
                1199
            ],
            "target": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "EdgeInput": {
            "id": [
                607
            ],
            "source": [
                607
            ],
            "sourceHandle": [
                1199
            ],
            "target": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "EmailActionNode": {
            "bcc": [
                1199
            ],
            "body": [
                1199
            ],
            "bodyType": [
                1199
            ],
            "cc": [
                1199
            ],
            "continueOnFail": [
                137
            ],
            "description": [
                1199
            ],
            "id": [
                607
            ],
            "label": [
                1199
            ],
            "position": [
                949
            ],
            "replyTo": [
                1199
            ],
            "subject": [
                1199
            ],
            "to": [
                1199
            ],
            "type": [
                848
            ],
            "__typename": [
                1199
            ]
        },
        "EmailRecipientInput": {
            "bcc": [
                1199
            ],
            "cc": [
                1199
            ],
            "htmlBody": [
                1199
            ],
            "replyTo": [
                1199
            ],
            "subject": [
                1199
            ],
            "templateData": [
                1239
            ],
            "templateId": [
                1199
            ],
            "textBody": [
                1199
            ],
            "to": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "EmailSendingResult": {
            "errorMessage": [
                1199
            ],
            "messageId": [
                1199
            ],
            "success": [
                137
            ],
            "workflowId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "EmailVerificationRequiredError": {
            "pendingAuthenticationToken": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "EvaluatedFormula": {
            "error": [
                1199
            ],
            "formula": [
                1199
            ],
            "value": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "EvaluatedItemPricing": {
            "evaluatedTiers": [
                464
            ],
            "itemPricing": [
                755
            ],
            "__typename": [
                1199
            ]
        },
        "EvaluatedTier": {
            "maxPrice": [
                393
            ],
            "minPrice": [
                393
            ],
            "targetPrice": [
                393
            ],
            "tier": [
                761
            ],
            "__typename": [
                1199
            ]
        },
        "ExecutionRun": {
            "actionsExecuted": [
                619
            ],
            "automation": [
                94
            ],
            "automationId": [
                607
            ],
            "completedAt": [
                1446
            ],
            "durationMs": [
                619
            ],
            "errorMessage": [
                1199
            ],
            "executionDurationMs": [
                619
            ],
            "id": [
                607
            ],
            "isTest": [
                137
            ],
            "nodeExecutions": [
                845
            ],
            "nodesExecuted": [
                619
            ],
            "organization": [
                887
            ],
            "organizationId": [
                607
            ],
            "startedAt": [
                1446
            ],
            "status": [
                469
            ],
            "timestamps": [
                1250
            ],
            "triggerPayload": [
                828
            ],
            "triggeredAt": [
                1446
            ],
            "workflowId": [
                1199
            ],
            "workflowRunId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ExecutionRunFilter": {
            "automationId": [
                607
            ],
            "fromDate": [
                1446
            ],
            "isTest": [
                137
            ],
            "status": [
                469
            ],
            "toDate": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "ExecutionRunResultPage": {
            "entries": [
                465
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ExecutionRunSortOption": {},
        "ExecutionStatus": {},
        "Facility": {
            "address": [
                30
            ],
            "customAttributes": [
                828
            ],
            "facilityGroup": [
                480
            ],
            "facilityName": [
                1199
            ],
            "facilityType": [
                1199
            ],
            "id": [
                607
            ],
            "timestamps": [
                1250
            ],
            "timezone": [
                1251
            ],
            "__typename": [
                1199
            ]
        },
        "FacilityAtm": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "enabled": [
                137
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "tranactYardId": [
                1199
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "FacilityAtmFilter": {
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "FacilityAtmInput": {
            "enabled": [
                137
            ],
            "facilityId": [
                607
            ],
            "name": [
                1199
            ],
            "tranactYardId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FacilityAtmResultPage": {
            "entries": [
                471
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "FacilityAtmSortOption": {},
        "FacilityAtmUpdateInput": {
            "enabled": [
                137
            ],
            "facilityId": [
                607
            ],
            "name": [
                1199
            ],
            "tranactYardId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FacilityCreateInput": {
            "address": [
                31
            ],
            "customAttributes": [
                828
            ],
            "facilityGroupId": [
                607
            ],
            "facilityName": [
                1199
            ],
            "facilityType": [
                1199
            ],
            "timezone": [
                1251
            ],
            "__typename": [
                1199
            ]
        },
        "FacilityFilter": {
            "facilityGroupId": [
                607
            ],
            "facilityTypes": [
                1199
            ],
            "latitude": [
                538
            ],
            "longitude": [
                538
            ],
            "radiusInMeters": [
                538
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FacilityGeneralPreferences": {
            "allowedUnitSystems": [
                1311
            ],
            "currency": [
                355
            ],
            "dateFormat": [
                1199
            ],
            "defaultUnitSystem": [
                1311
            ],
            "language": [
                1199
            ],
            "timezone": [
                1199
            ],
            "weekStartDay": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FacilityGroup": {
            "customAttributes": [
                828
            ],
            "defaultFacility": [
                470
            ],
            "facilities": [
                470
            ],
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "__typename": [
                1199
            ]
        },
        "FacilityGroupFilter": {
            "lastUpdatedAt": [
                1446
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FacilityGroupInput": {
            "customAttributes": [
                828
            ],
            "defaultFacilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FacilityGroupResultPage": {
            "entries": [
                480
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "FacilityGroupSortOption": {},
        "FacilityGroupUpdateInput": {
            "customAttributes": [
                828
            ],
            "defaultFacilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FacilityResultPage": {
            "entries": [
                470
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "FacilitySalesPreferences": {
            "askForDeletionConfirmation": [
                137
            ],
            "defaultPort": [
                1199
            ],
            "defaultWeightDisplayUnit": [
                1199
            ],
            "enableDefaultPrinting": [
                137
            ],
            "photoInstructions": [
                934
            ],
            "skipScalePayment": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "FacilitySortOption": {},
        "FacilityUpdateInput": {
            "address": [
                31
            ],
            "customAttributes": [
                828
            ],
            "facilityGroupId": [
                607
            ],
            "facilityName": [
                1199
            ],
            "facilityType": [
                1199
            ],
            "timezone": [
                1251
            ],
            "__typename": [
                1199
            ]
        },
        "FieldConstraintObjectType": {},
        "FieldConstraints": {
            "maxLength": [
                619
            ],
            "maxValue": [
                538
            ],
            "minLength": [
                619
            ],
            "minValue": [
                538
            ],
            "multipleValues": [
                137
            ],
            "objectType": [
                490
            ],
            "required": [
                137
            ],
            "selectOptions": [
                1199
            ],
            "unique": [
                137
            ],
            "validationExpr": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FieldConstraintsInput": {
            "maxLength": [
                619
            ],
            "maxValue": [
                538
            ],
            "minLength": [
                619
            ],
            "minValue": [
                538
            ],
            "multipleValues": [
                137
            ],
            "objectType": [
                490
            ],
            "required": [
                137
            ],
            "selectOptions": [
                1199
            ],
            "unique": [
                137
            ],
            "validationExpr": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FieldDataType": {},
        "File": {
            "children": [
                494
            ],
            "creator": [
                1372
            ],
            "entityId": [
                607
            ],
            "entityType": [
                1199
            ],
            "expiresAt": [
                1247
            ],
            "fileName": [
                1199
            ],
            "fileSize": [
                619
            ],
            "fileType": [
                509
            ],
            "id": [
                607
            ],
            "metadata": [
                828
            ],
            "mimeType": [
                1199
            ],
            "parent": [
                494
            ],
            "parentId": [
                607
            ],
            "path": [
                1199
            ],
            "public": [
                137
            ],
            "status": [
                503
            ],
            "subDirectories": [
                494
            ],
            "template": [
                137
            ],
            "timestamps": [
                1250
            ],
            "uploadUrl": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FileAccessURLResult": {
            "error": [
                1199
            ],
            "expiresAt": [
                1247
            ],
            "fileId": [
                607
            ],
            "url": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FileChangedEvent": {
            "file": [
                607
            ],
            "parent": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "FileConnection": {
            "edges": [
                499
            ],
            "total": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "FileCursor": {
            "limit": [
                619
            ],
            "offset": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "FileEdge": {
            "cursor": [
                1199
            ],
            "node": [
                494
            ],
            "__typename": [
                1199
            ]
        },
        "FileError": {
            "fileID": [
                607
            ],
            "fileName": [
                1199
            ],
            "message": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FileFilter": {
            "entityId": [
                607
            ],
            "entityType": [
                1199
            ],
            "fileType": [
                509
            ],
            "parentIds": [
                607
            ],
            "public": [
                137
            ],
            "searchTerm": [
                1199
            ],
            "status": [
                503
            ],
            "__typename": [
                1199
            ]
        },
        "FilePermission": {},
        "FileStatus": {},
        "FileTemplate": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "description": [
                1199
            ],
            "file": [
                494
            ],
            "fileId": [
                607
            ],
            "id": [
                607
            ],
            "isDefault": [
                137
            ],
            "organizationId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "type": [
                508
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "FileTemplateFilter": {
            "createdBy": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "types": [
                508
            ],
            "updatedBy": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "FileTemplateResultPage": {
            "entries": [
                504
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "FileTemplateSortOption": {},
        "FileTemplateType": {},
        "FileType": {},
        "FilesAggregateType": {},
        "FilesOutboxEventCounts": {
            "file": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "FilesOutboxEventFilter": {
            "aggregateId": [
                607
            ],
            "aggregateTypes": [
                510
            ],
            "createdAtRange": [
                1447
            ],
            "statuses": [
                903
            ],
            "__typename": [
                1199
            ]
        },
        "FilterNode": {
            "description": [
                1199
            ],
            "expression": [
                1199
            ],
            "id": [
                607
            ],
            "label": [
                1199
            ],
            "position": [
                949
            ],
            "type": [
                848
            ],
            "__typename": [
                1199
            ]
        },
        "FinanceAccountBalanceFilter": {
            "currencies": [
                355
            ],
            "maxBalance": [
                393
            ],
            "minBalance": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "FinanceAggregateType": {},
        "FinanceOutboxEventCounts": {
            "bill": [
                619
            ],
            "invoice": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "FinanceOutboxEventFilter": {
            "aggregateId": [
                607
            ],
            "aggregateTypes": [
                515
            ],
            "createdAtRange": [
                1447
            ],
            "statuses": [
                903
            ],
            "__typename": [
                1199
            ]
        },
        "FinancialAccount": {
            "accountNumberMasked": [
                1199
            ],
            "allowRepeatedCheckNumbers": [
                137
            ],
            "bankName": [
                1199
            ],
            "checkBusinessName": [
                1199
            ],
            "checkLogo": [
                1199
            ],
            "checkMailingAddress": [
                1199
            ],
            "checkNumberGeneration": [
                137
            ],
            "checkPhoneNumber": [
                1199
            ],
            "checkSignature": [
                1199
            ],
            "currency": [
                355
            ],
            "currentBalance": [
                835
            ],
            "customAttributes": [
                828
            ],
            "disabled": [
                137
            ],
            "ezcashEndpoint": [
                1199
            ],
            "ezcashTimeoutSeconds": [
                619
            ],
            "facility": [
                470
            ],
            "id": [
                607
            ],
            "lastCheckNumber": [
                619
            ],
            "linked": [
                137
            ],
            "nachaCompanyIdentification": [
                1199
            ],
            "nachaCompanyName": [
                1199
            ],
            "nachaDefaultSecCode": [
                1199
            ],
            "name": [
                1199
            ],
            "paymentAllocationMethod": [
                912
            ],
            "roundingMethod": [
                1064
            ],
            "roundingPrecision": [
                1065
            ],
            "routingNumber": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "type": [
                537
            ],
            "visibleInPayments": [
                137
            ],
            "warningThreshold": [
                835
            ],
            "__typename": [
                1199
            ]
        },
        "FinancialAccountAdjustment": {
            "amount": [
                393
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "creatorId": [
                607
            ],
            "currencyCode": [
                1199
            ],
            "date": [
                1446
            ],
            "facilityId": [
                607
            ],
            "financialAccountId": [
                607
            ],
            "id": [
                607
            ],
            "paymentId": [
                607
            ],
            "physicalCount": [
                393
            ],
            "reason": [
                1199
            ],
            "systemBalanceAtTime": [
                393
            ],
            "timestamps": [
                1250
            ],
            "type": [
                1199
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "FinancialAccountAdjustmentFilter": {
            "facilityIds": [
                607
            ],
            "financialAccountId": [
                607
            ],
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "FinancialAccountAdjustmentInput": {
            "amount": [
                393
            ],
            "creatorId": [
                607
            ],
            "currencyCode": [
                1199
            ],
            "date": [
                1446
            ],
            "facilityId": [
                607
            ],
            "financialAccountId": [
                607
            ],
            "paymentId": [
                607
            ],
            "physicalCount": [
                393
            ],
            "reason": [
                1199
            ],
            "systemBalanceAtTime": [
                393
            ],
            "type": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FinancialAccountAdjustmentResultPage": {
            "entries": [
                519
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "FinancialAccountAdjustmentSortOption": {},
        "FinancialAccountAdjustmentUpdateInput": {
            "amount": [
                393
            ],
            "creatorId": [
                607
            ],
            "currencyCode": [
                1199
            ],
            "date": [
                1446
            ],
            "facilityId": [
                607
            ],
            "financialAccountId": [
                607
            ],
            "paymentId": [
                607
            ],
            "physicalCount": [
                393
            ],
            "reason": [
                1199
            ],
            "systemBalanceAtTime": [
                393
            ],
            "type": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FinancialAccountFilter": {
            "currencies": [
                1199
            ],
            "facilityIDs": [
                607
            ],
            "ids": [
                607
            ],
            "includeDisabled": [
                137
            ],
            "maxBalance": [
                836
            ],
            "minBalance": [
                836
            ],
            "searchTerm": [
                1199
            ],
            "types": [
                537
            ],
            "visibleInPayments": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "FinancialAccountResultPage": {
            "entries": [
                518
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "FinancialAccountSortOption": {},
        "FinancialAccountTransaction": {
            "amount": [
                393
            ],
            "authorizedDate": [
                168
            ],
            "channel": [
                529
            ],
            "checkNumber": [
                1199
            ],
            "counterparties": [
                530
            ],
            "date": [
                168
            ],
            "financialAccountId": [
                607
            ],
            "financialAccountOwnerId": [
                1199
            ],
            "id": [
                607
            ],
            "imageUrl": [
                1199
            ],
            "location": [
                30
            ],
            "pendingTransactionId": [
                607
            ],
            "reference": [
                1199
            ],
            "status": [
                535
            ],
            "timestamps": [
                1250
            ],
            "transferNumber": [
                1199
            ],
            "type": [
                536
            ],
            "website": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FinancialAccountTransactionChannel": {},
        "FinancialAccountTransactionCounterparty": {
            "account": [
                3
            ],
            "id": [
                607
            ],
            "imageUrl": [
                1199
            ],
            "name": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "type": [
                531
            ],
            "__typename": [
                1199
            ]
        },
        "FinancialAccountTransactionCounterpartyType": {},
        "FinancialAccountTransactionFilter": {
            "authorizedDateFrom": [
                168
            ],
            "authorizedDateTo": [
                168
            ],
            "channels": [
                529
            ],
            "counterpartyIds": [
                607
            ],
            "dateFrom": [
                168
            ],
            "dateTo": [
                168
            ],
            "financialAccountIds": [
                607
            ],
            "hasCounterparty": [
                137
            ],
            "hasLocation": [
                137
            ],
            "isPending": [
                137
            ],
            "maxAmount": [
                393
            ],
            "minAmount": [
                393
            ],
            "searchTerm": [
                1199
            ],
            "statuses": [
                535
            ],
            "types": [
                536
            ],
            "__typename": [
                1199
            ]
        },
        "FinancialAccountTransactionResultPage": {
            "entries": [
                528
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "FinancialAccountTransactionSortOption": {},
        "FinancialAccountTransactionStatus": {},
        "FinancialAccountTransactionType": {},
        "FinancialAccountType": {},
        "Float": {},
        "FlowValidationResult": {
            "issues": [
                1390
            ],
            "valid": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "FreightCharge": {
            "accruedAmount": [
                835
            ],
            "chargebackAmount": [
                835
            ],
            "deliveryNumber": [
                1199
            ],
            "freightLane": [
                1199
            ],
            "hauler": [
                1199
            ],
            "id": [
                607
            ],
            "netAmount": [
                835
            ],
            "notes": [
                1199
            ],
            "reconciliationId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "__typename": [
                1199
            ]
        },
        "FreightChargeInput": {
            "accruedAmount": [
                836
            ],
            "chargebackAmount": [
                836
            ],
            "deliveryNumber": [
                1199
            ],
            "freightLane": [
                1199
            ],
            "hauler": [
                1199
            ],
            "id": [
                607
            ],
            "notes": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FreightForwarder": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "FreightForwarderFilter": {
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FreightForwarderInput": {
            "facilityId": [
                607
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FreightForwarderResultPage": {
            "entries": [
                542
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "FreightForwarderSortOption": {},
        "FreightForwarderUpdateInput": {
            "facilityId": [
                607
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLane": {
            "active": [
                137
            ],
            "carrier": [
                3
            ],
            "carrierId": [
                607
            ],
            "commodityCategory": [
                1199
            ],
            "costs": [
                549
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "destinationCity": [
                1199
            ],
            "destinationCountry": [
                1199
            ],
            "destinationState": [
                1199
            ],
            "destinationZipCode": [
                1199
            ],
            "equipmentType": [
                1199
            ],
            "freightLaneRouteId": [
                607
            ],
            "freight_lane_route": [
                558
            ],
            "id": [
                607
            ],
            "notes": [
                1199
            ],
            "originLocationId": [
                607
            ],
            "originLocationType": [
                1199
            ],
            "origin_location": [
                802
            ],
            "timestamps": [
                1250
            ],
            "transportationMode": [
                1199
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLaneCost": {
            "chargebackFormula": [
                1199
            ],
            "chargebackVariableIds": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "currency": [
                1199
            ],
            "endDate": [
                168
            ],
            "freightLaneId": [
                607
            ],
            "freight_lane": [
                548
            ],
            "fuelSurchargeFormula": [
                1199
            ],
            "fuelSurchargeMode": [
                1199
            ],
            "fuelSurchargeVariableIds": [
                1199
            ],
            "id": [
                607
            ],
            "minimumChargeAmount": [
                393
            ],
            "minimumChargeCurrencyCode": [
                1199
            ],
            "minimumChargebackAmount": [
                393
            ],
            "minimumChargebackCurrencyCode": [
                1199
            ],
            "rateFormula": [
                1199
            ],
            "rateVariableIds": [
                1199
            ],
            "startDate": [
                168
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLaneCostFilter": {
            "freightLaneId": [
                607
            ],
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLaneCostInput": {
            "chargebackFormula": [
                1199
            ],
            "chargebackVariableIds": [
                1199
            ],
            "currency": [
                1199
            ],
            "endDate": [
                168
            ],
            "freightLaneId": [
                607
            ],
            "fuelSurchargeFormula": [
                1199
            ],
            "fuelSurchargeMode": [
                1199
            ],
            "fuelSurchargeVariableIds": [
                1199
            ],
            "minimumChargeAmount": [
                393
            ],
            "minimumChargeCurrencyCode": [
                1199
            ],
            "minimumChargebackAmount": [
                393
            ],
            "minimumChargebackCurrencyCode": [
                1199
            ],
            "rateFormula": [
                1199
            ],
            "rateVariableIds": [
                1199
            ],
            "startDate": [
                168
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLaneCostResultPage": {
            "entries": [
                549
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLaneCostSortOption": {},
        "FreightLaneCostUpdateInput": {
            "chargebackFormula": [
                1199
            ],
            "chargebackVariableIds": [
                1199
            ],
            "currency": [
                1199
            ],
            "endDate": [
                168
            ],
            "freightLaneId": [
                607
            ],
            "fuelSurchargeFormula": [
                1199
            ],
            "fuelSurchargeMode": [
                1199
            ],
            "fuelSurchargeVariableIds": [
                1199
            ],
            "minimumChargeAmount": [
                393
            ],
            "minimumChargeCurrencyCode": [
                1199
            ],
            "minimumChargebackAmount": [
                393
            ],
            "minimumChargebackCurrencyCode": [
                1199
            ],
            "rateFormula": [
                1199
            ],
            "rateVariableIds": [
                1199
            ],
            "startDate": [
                168
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLaneFilter": {
            "carrierId": [
                607
            ],
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLaneInput": {
            "active": [
                137
            ],
            "carrierId": [
                607
            ],
            "commodityCategory": [
                1199
            ],
            "destinationCity": [
                1199
            ],
            "destinationCountry": [
                1199
            ],
            "destinationState": [
                1199
            ],
            "destinationZipCode": [
                1199
            ],
            "equipmentType": [
                1199
            ],
            "freightLaneRouteId": [
                607
            ],
            "notes": [
                1199
            ],
            "originLocationId": [
                607
            ],
            "originLocationType": [
                1199
            ],
            "transportationMode": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLaneResultPage": {
            "entries": [
                548
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLaneRoute": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "distance": [
                393
            ],
            "id": [
                607
            ],
            "locationAId": [
                607
            ],
            "locationAType": [
                810
            ],
            "locationBId": [
                607
            ],
            "locationBType": [
                810
            ],
            "location_a": [
                802
            ],
            "location_b": [
                802
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLaneRouteFilter": {
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLaneRouteInput": {
            "distance": [
                393
            ],
            "locationAId": [
                607
            ],
            "locationAType": [
                810
            ],
            "locationBId": [
                607
            ],
            "locationBType": [
                810
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLaneRouteResultPage": {
            "entries": [
                558
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLaneRouteSortOption": {},
        "FreightLaneRouteUpdateInput": {
            "distance": [
                393
            ],
            "locationAId": [
                607
            ],
            "locationAType": [
                810
            ],
            "locationBId": [
                607
            ],
            "locationBType": [
                810
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLaneSortOption": {},
        "FreightLaneUpdateInput": {
            "active": [
                137
            ],
            "carrierId": [
                607
            ],
            "commodityCategory": [
                1199
            ],
            "destinationCity": [
                1199
            ],
            "destinationCountry": [
                1199
            ],
            "destinationState": [
                1199
            ],
            "destinationZipCode": [
                1199
            ],
            "equipmentType": [
                1199
            ],
            "freightLaneRouteId": [
                607
            ],
            "notes": [
                1199
            ],
            "originLocationId": [
                607
            ],
            "originLocationType": [
                1199
            ],
            "transportationMode": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLine": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLineFilter": {
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLineInput": {
            "facilityId": [
                607
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLineResultPage": {
            "entries": [
                566
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "FreightLineSortOption": {},
        "FreightLineUpdateInput": {
            "facilityId": [
                607
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "FreightTerm": {},
        "FreightTerms": {},
        "GenerateCheckPdfPayload": {
            "fileId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "GenerateDocumentInput": {
            "documents": [
                576
            ],
            "__typename": [
                1199
            ]
        },
        "GenerateDocumentRequestInput": {
            "bookingId": [
                607
            ],
            "documentType": [
                436
            ],
            "dueDate": [
                1199
            ],
            "invoiceAmount": [
                1199
            ],
            "invoiceDate": [
                1199
            ],
            "invoiceNumber": [
                1199
            ],
            "loadId": [
                607
            ],
            "purchaseOrderId": [
                607
            ],
            "salesOrderId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "GenerateDocumentResult": {
            "documents": [
                435
            ],
            "__typename": [
                1199
            ]
        },
        "GenerateDocumentsAndSendEmailInput": {
            "documents": [
                576
            ],
            "email": [
                459
            ],
            "__typename": [
                1199
            ]
        },
        "GenerateDocumentsAndSendEmailResult": {
            "documents": [
                435
            ],
            "email": [
                460
            ],
            "__typename": [
                1199
            ]
        },
        "GenerateFileAccessURLPayload": {
            "results": [
                495
            ],
            "__typename": [
                1199
            ]
        },
        "GenerateNachaFileInput": {
            "effectiveEntryDate": [
                168
            ],
            "financialAccountId": [
                607
            ],
            "paymentIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "GenerateNachaFilePayload": {
            "entryCount": [
                619
            ],
            "fileContent": [
                1199
            ],
            "totalAmount": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "GeneratePositivePayFileInput": {
            "dateFrom": [
                168
            ],
            "dateTo": [
                168
            ],
            "financialAccountId": [
                607
            ],
            "templateId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "GeneratePriceListDocumentInput": {
            "priceListId": [
                607
            ],
            "priceListType": [
                1199
            ],
            "templateFileId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "GeneratePriceListDocumentResult": {
            "fileId": [
                607
            ],
            "workflowId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "GenerateWOPITokenInput": {
            "expiresInSeconds": [
                619
            ],
            "fileId": [
                607
            ],
            "permission": [
                1415
            ],
            "__typename": [
                1199
            ]
        },
        "GenerateWOPITokenPayload": {
            "token": [
                1417
            ],
            "__typename": [
                1199
            ]
        },
        "GovernmentReportingConfiguration": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "daysOfWeek": [
                828
            ],
            "encryptedCredentials": [
                1199
            ],
            "fields": [
                828
            ],
            "id": [
                607
            ],
            "isActive": [
                137
            ],
            "name": [
                1199
            ],
            "processBatchesAsUnit": [
                137
            ],
            "recyclerId": [
                1199
            ],
            "serviceType": [
                600
            ],
            "timestamps": [
                1250
            ],
            "toEmailAddress": [
                1199
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "uploadTimezone": [
                1199
            ],
            "uploadType": [
                1056
            ],
            "__typename": [
                1199
            ]
        },
        "GovernmentReportingConfigurationFilter": {
            "ids": [
                607
            ],
            "serviceType": [
                600
            ],
            "__typename": [
                1199
            ]
        },
        "GovernmentReportingConfigurationInput": {
            "daysOfWeek": [
                828
            ],
            "encryptedCredentials": [
                1199
            ],
            "fields": [
                828
            ],
            "isActive": [
                137
            ],
            "name": [
                1199
            ],
            "processBatchesAsUnit": [
                137
            ],
            "recyclerId": [
                1199
            ],
            "serviceType": [
                600
            ],
            "toEmailAddress": [
                1199
            ],
            "uploadTimezone": [
                1199
            ],
            "uploadType": [
                1056
            ],
            "__typename": [
                1199
            ]
        },
        "GovernmentReportingConfigurationResultPage": {
            "entries": [
                588
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "GovernmentReportingConfigurationSortOption": {},
        "GovernmentReportingConfigurationUpdateInput": {
            "daysOfWeek": [
                828
            ],
            "encryptedCredentials": [
                1199
            ],
            "fields": [
                828
            ],
            "isActive": [
                137
            ],
            "name": [
                1199
            ],
            "processBatchesAsUnit": [
                137
            ],
            "recyclerId": [
                1199
            ],
            "serviceType": [
                600
            ],
            "toEmailAddress": [
                1199
            ],
            "uploadTimezone": [
                1199
            ],
            "uploadType": [
                1056
            ],
            "__typename": [
                1199
            ]
        },
        "GovernmentReportingFacility": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "governmentReportingConfiguration": [
                588
            ],
            "governmentReportingConfigurationId": [
                607
            ],
            "id": [
                607
            ],
            "mlid": [
                1199
            ],
            "reportingFacilityId": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "GovernmentReportingFacilityFilter": {
            "facilityId": [
                607
            ],
            "governmentReportingConfigurationId": [
                607
            ],
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "GovernmentReportingFacilityInput": {
            "facilityId": [
                607
            ],
            "governmentReportingConfigurationId": [
                607
            ],
            "mlid": [
                1199
            ],
            "reportingFacilityId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "GovernmentReportingFacilityResultPage": {
            "entries": [
                594
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "GovernmentReportingFacilitySortOption": {},
        "GovernmentReportingFacilityUpdateInput": {
            "facilityId": [
                607
            ],
            "governmentReportingConfigurationId": [
                607
            ],
            "mlid": [
                1199
            ],
            "reportingFacilityId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "GovernmentReportingServiceType": {},
        "HaulerProgress": {},
        "HoldExemptionReason": {},
        "HttpMethod": {},
        "HttpRequestActionNode": {
            "bodyType": [
                1199
            ],
            "continueOnFail": [
                137
            ],
            "description": [
                1199
            ],
            "headers": [
                828
            ],
            "id": [
                607
            ],
            "label": [
                1199
            ],
            "method": [
                603
            ],
            "position": [
                949
            ],
            "requestBody": [
                1199
            ],
            "retryCount": [
                619
            ],
            "timeout": [
                619
            ],
            "type": [
                848
            ],
            "url": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "HttpWebhookTriggerConfigOutput": {
            "path": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "HttpWebhookTriggerNode": {
            "description": [
                1199
            ],
            "id": [
                607
            ],
            "label": [
                1199
            ],
            "position": [
                949
            ],
            "type": [
                848
            ],
            "__typename": [
                1199
            ]
        },
        "ID": {},
        "IdentityDocumentType": {},
        "InboundTollingAgreement": {
            "agreementNumber": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "customerAccount": [
                3
            ],
            "customerAccountId": [
                607
            ],
            "effectiveDate": [
                168
            ],
            "expectedYieldPercentage": [
                393
            ],
            "expirationDate": [
                168
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "invoicePricingBasis": [
                721
            ],
            "isActive": [
                137
            ],
            "pricePerUnit": [
                835
            ],
            "priceUnit": [
                1199
            ],
            "processingType": [
                971
            ],
            "processingTypeId": [
                607
            ],
            "terms": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "InboundTollingAgreementFilter": {
            "agreementNumber": [
                1199
            ],
            "customerAccountId": [
                607
            ],
            "customerAccountIds": [
                607
            ],
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "fromEffectiveDate": [
                168
            ],
            "fromExpirationDate": [
                168
            ],
            "ids": [
                607
            ],
            "invoicePricingBasis": [
                721
            ],
            "isActive": [
                137
            ],
            "priceUnit": [
                1199
            ],
            "processingTypeId": [
                607
            ],
            "processingTypeIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "terms": [
                1199
            ],
            "toEffectiveDate": [
                168
            ],
            "toExpirationDate": [
                168
            ],
            "__typename": [
                1199
            ]
        },
        "InboundTollingAgreementInput": {
            "agreementNumber": [
                1199
            ],
            "customerAccountId": [
                607
            ],
            "effectiveDate": [
                168
            ],
            "expectedYieldPercentage": [
                393
            ],
            "expirationDate": [
                168
            ],
            "facilityId": [
                607
            ],
            "invoicePricingBasis": [
                721
            ],
            "isActive": [
                137
            ],
            "pricePerUnit": [
                836
            ],
            "priceUnit": [
                1199
            ],
            "processingTypeId": [
                607
            ],
            "terms": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "InboundTollingAgreementResultPage": {
            "entries": [
                609
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "InboundTollingAgreementSortOption": {},
        "InboundTollingAgreementUpdateInput": {
            "agreementNumber": [
                1199
            ],
            "customerAccountId": [
                607
            ],
            "effectiveDate": [
                168
            ],
            "expectedYieldPercentage": [
                393
            ],
            "expirationDate": [
                168
            ],
            "facilityId": [
                607
            ],
            "invoicePricingBasis": [
                721
            ],
            "isActive": [
                137
            ],
            "pricePerUnit": [
                836
            ],
            "priceUnit": [
                1199
            ],
            "processingTypeId": [
                607
            ],
            "terms": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "IndividualEyeColor": {},
        "IndividualHairColor": {},
        "IndividualRace": {},
        "IndividualSex": {},
        "Int": {},
        "Integration": {
            "category": [
                1199
            ],
            "icon": [
                1199
            ],
            "key": [
                1199
            ],
            "name": [
                1199
            ],
            "operations": [
                885
            ],
            "type": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "InvalidCredentialsError": {
            "email": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "InvalidOneTimeCode": {
            "pendingAuthenticationToken": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "InvalidSignUpInvitationError": {
            "reason": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "InvalidUserInvitationError": {
            "reason": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryAccount": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "customAttributes": [
                828
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "taggingType": [
                703
            ],
            "timestamps": [
                1250
            ],
            "type": [
                630
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryAccountFilter": {
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "name": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "taggingType": [
                703
            ],
            "type": [
                630
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryAccountInput": {
            "customAttributes": [
                828
            ],
            "facilityId": [
                607
            ],
            "name": [
                1199
            ],
            "taggingType": [
                703
            ],
            "type": [
                630
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryAccountResultPage": {
            "entries": [
                625
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryAccountSortOption": {},
        "InventoryAccountType": {},
        "InventoryAccountUpdateInput": {
            "customAttributes": [
                828
            ],
            "facilityId": [
                607
            ],
            "name": [
                1199
            ],
            "taggingType": [
                703
            ],
            "type": [
                630
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryAggregateType": {},
        "InventoryFacilitySettings": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "defaultCountTolerancePercentage": [
                393
            ],
            "enforceLooseStockOnTagging": [
                137
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "wacComponents": [
                828
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryFacilitySettingsFilter": {
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryFacilitySettingsInput": {
            "defaultCountTolerancePercentage": [
                393
            ],
            "enforceLooseStockOnTagging": [
                137
            ],
            "facilityId": [
                607
            ],
            "wacComponents": [
                828
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryFacilitySettingsResultPage": {
            "entries": [
                633
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryFacilitySettingsSortOption": {},
        "InventoryFacilitySettingsUpdateInput": {
            "defaultCountTolerancePercentage": [
                393
            ],
            "enforceLooseStockOnTagging": [
                137
            ],
            "facilityId": [
                607
            ],
            "wacComponents": [
                828
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLevel": {
            "currencyValues": [
                640
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "ownerAccount": [
                3
            ],
            "ownerAccountId": [
                607
            ],
            "processorAccount": [
                3
            ],
            "processorAccountId": [
                607
            ],
            "quantity": [
                1424
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLevelCurrencyValue": {
            "currencyCode": [
                355
            ],
            "totalValue": [
                393
            ],
            "weightedAverageCost": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLevelFilter": {
            "facilityIds": [
                607
            ],
            "hideZeroQuantity": [
                137
            ],
            "itemIds": [
                607
            ],
            "locationFilterType": [
                803
            ],
            "searchTerm": [
                1199
            ],
            "taggingTypes": [
                1215
            ],
            "viewMode": [
                705
            ],
            "zoneIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLevelResultPage": {
            "entries": [
                639
            ],
            "page": [
                905
            ],
            "stats": [
                644
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLevelSortOption": {},
        "InventoryLevelStats": {
            "itemsWithStock": [
                619
            ],
            "totalItems": [
                619
            ],
            "totalQuantity": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLot": {
            "allocations": [
                816,
                {
                    "filter": [
                        814
                    ],
                    "pagination": [
                        906
                    ]
                }
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "description": [
                1199
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "isToll": [
                137
            ],
            "lotNumber": [
                1199
            ],
            "mergedInto": [
                645
            ],
            "mergedIntoId": [
                607
            ],
            "quantitySummary": [
                820
            ],
            "status": [
                822
            ],
            "tags": [
                699
            ],
            "timestamps": [
                1250
            ],
            "tollCustomerAccount": [
                3
            ],
            "tollCustomerAccountId": [
                607
            ],
            "tollReceiptId": [
                607
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "valuation": [
                827
            ],
            "zone": [
                706
            ],
            "zoneId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLotAllocateInput": {
            "allocations": [
                648
            ],
            "lotId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLotAllocateResult": {
            "allocations": [
                812
            ],
            "lot": [
                645
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLotAllocationItemInput": {
            "movementId": [
                607
            ],
            "quantity": [
                1426
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLotCreateFromMovementsInput": {
            "description": [
                1199
            ],
            "facilityId": [
                607
            ],
            "filter": [
                819
            ],
            "lotNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLotCreateFromMovementsResult": {
            "allocationsCreated": [
                619
            ],
            "lot": [
                645
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLotCreateInput": {
            "description": [
                1199
            ],
            "facilityId": [
                607
            ],
            "isToll": [
                137
            ],
            "lotNumber": [
                1199
            ],
            "status": [
                822
            ],
            "tollCustomerAccountId": [
                607
            ],
            "tollReceiptId": [
                607
            ],
            "zoneId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLotDeallocateInput": {
            "allocationIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLotFilter": {
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "lotNumber": [
                1199
            ],
            "status": [
                822
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLotInput": {
            "description": [
                1199
            ],
            "facilityId": [
                607
            ],
            "isToll": [
                137
            ],
            "lotNumber": [
                1199
            ],
            "mergedIntoId": [
                607
            ],
            "status": [
                822
            ],
            "tollCustomerAccountId": [
                607
            ],
            "tollReceiptId": [
                607
            ],
            "zoneId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLotMergeInput": {
            "sourceLotIds": [
                607
            ],
            "targetLotId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLotMergeResult": {
            "mergedLots": [
                645
            ],
            "targetLot": [
                645
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLotResultPage": {
            "entries": [
                645
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLotSortOption": {},
        "InventoryLotSplitInput": {
            "newDescription": [
                1199
            ],
            "newLotNumber": [
                1199
            ],
            "sourceLotId": [
                607
            ],
            "transfers": [
                821
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLotSplitResult": {
            "newLot": [
                645
            ],
            "sourceLot": [
                645
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryLotUpdateInput": {
            "description": [
                1199
            ],
            "facilityId": [
                607
            ],
            "isToll": [
                137
            ],
            "lotNumber": [
                1199
            ],
            "mergedIntoId": [
                607
            ],
            "status": [
                822
            ],
            "tollCustomerAccountId": [
                607
            ],
            "tollReceiptId": [
                607
            ],
            "zoneId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryMovement": {
            "allocatedQuantity": [
                1424
            ],
            "allocatedQuantityToTags": [
                1424
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "customAttributes": [
                828
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "fromAccountId": [
                607
            ],
            "fromZoneId": [
                607
            ],
            "id": [
                607
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "lotAllocations": [
                812
            ],
            "metadata": [
                828
            ],
            "movementType": [
                670
            ],
            "occurredAt": [
                1446
            ],
            "originTransactionItemId": [
                1199
            ],
            "originTransactionType": [
                704
            ],
            "ownerAccount": [
                3
            ],
            "ownerAccountId": [
                607
            ],
            "quantity": [
                1424
            ],
            "status": [
                669
            ],
            "tagAllocations": [
                1205
            ],
            "timestamps": [
                1250
            ],
            "toAccountId": [
                607
            ],
            "toZoneId": [
                607
            ],
            "totalCost": [
                835
            ],
            "unallocatedQuantity": [
                1424
            ],
            "unallocatedQuantityFromTags": [
                1424
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryMovementFilter": {
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "fromOccurredAt": [
                1446
            ],
            "ids": [
                607
            ],
            "itemId": [
                607
            ],
            "movementType": [
                670
            ],
            "originTransactionType": [
                704
            ],
            "status": [
                669
            ],
            "toOccurredAt": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryMovementHistoryFilter": {
            "currencyCode": [
                355
            ],
            "facilityId": [
                607
            ],
            "itemId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryMovementHistoryResultPage": {
            "entries": [
                672
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryMovementInput": {
            "customAttributes": [
                828
            ],
            "facilityId": [
                607
            ],
            "fromAccountId": [
                607
            ],
            "fromZoneId": [
                607
            ],
            "itemId": [
                607
            ],
            "metadata": [
                828
            ],
            "movementType": [
                670
            ],
            "occurredAt": [
                1446
            ],
            "originTransactionItemId": [
                1199
            ],
            "originTransactionType": [
                704
            ],
            "quantity": [
                1426
            ],
            "status": [
                669
            ],
            "toAccountId": [
                607
            ],
            "toZoneId": [
                607
            ],
            "totalCost": [
                836
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryMovementResultPage": {
            "entries": [
                662
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryMovementSortOption": {},
        "InventoryMovementStatus": {},
        "InventoryMovementType": {},
        "InventoryMovementUpdateInput": {
            "customAttributes": [
                828
            ],
            "facilityId": [
                607
            ],
            "fromAccountId": [
                607
            ],
            "fromZoneId": [
                607
            ],
            "itemId": [
                607
            ],
            "metadata": [
                828
            ],
            "movementType": [
                670
            ],
            "occurredAt": [
                1446
            ],
            "originTransactionItemId": [
                1199
            ],
            "originTransactionType": [
                704
            ],
            "quantity": [
                1426
            ],
            "status": [
                669
            ],
            "toAccountId": [
                607
            ],
            "toZoneId": [
                607
            ],
            "totalCost": [
                836
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryMovementWithHistory": {
            "movement": [
                662
            ],
            "runningTotals": [
                840
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryOutboxEventCounts": {
            "category": [
                619
            ],
            "inventoryTag": [
                619
            ],
            "item": [
                619
            ],
            "itemGroup": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryOutboxEventFilter": {
            "aggregateId": [
                607
            ],
            "aggregateTypes": [
                632
            ],
            "createdAtRange": [
                1447
            ],
            "statuses": [
                903
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryPeriod": {
            "closedAt": [
                1446
            ],
            "closedBy": [
                607
            ],
            "closedByUser": [
                1372
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "endDate": [
                1446
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "lockedAt": [
                1446
            ],
            "lockedBy": [
                607
            ],
            "lockedByUser": [
                1372
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "periodType": [
                1199
            ],
            "startDate": [
                1446
            ],
            "status": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "unlockExpiresAt": [
                1446
            ],
            "unlockReason": [
                1199
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryPeriodBalance": {
            "account": [
                625
            ],
            "accountId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "currencyCode": [
                1199
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "inventoryPeriodId": [
                607
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "quantity": [
                393
            ],
            "quantityUnit": [
                1307
            ],
            "timestamps": [
                1250
            ],
            "totalValue": [
                393
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "wacPerUnit": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryPeriodBalanceFilter": {
            "accountIds": [
                607
            ],
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "inventoryPeriodIds": [
                607
            ],
            "itemIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryPeriodBalanceInput": {
            "accountId": [
                607
            ],
            "currencyCode": [
                1199
            ],
            "facilityId": [
                607
            ],
            "inventoryPeriodId": [
                607
            ],
            "itemId": [
                607
            ],
            "quantity": [
                393
            ],
            "quantityUnit": [
                1307
            ],
            "totalValue": [
                393
            ],
            "wacPerUnit": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryPeriodBalanceResultPage": {
            "entries": [
                676
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryPeriodBalanceSortOption": {},
        "InventoryPeriodBalanceUpdateInput": {
            "accountId": [
                607
            ],
            "currencyCode": [
                1199
            ],
            "facilityId": [
                607
            ],
            "inventoryPeriodId": [
                607
            ],
            "itemId": [
                607
            ],
            "quantity": [
                393
            ],
            "quantityUnit": [
                1307
            ],
            "totalValue": [
                393
            ],
            "wacPerUnit": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryPeriodConfig": {
            "allowStraddleCompletion": [
                137
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "fiscalYearStartMonth": [
                619
            ],
            "id": [
                607
            ],
            "periodType": [
                1199
            ],
            "requireStraddleApproval": [
                137
            ],
            "straddleWindowPeriods": [
                619
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryPeriodConfigFilter": {
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryPeriodConfigInput": {
            "allowStraddleCompletion": [
                137
            ],
            "fiscalYearStartMonth": [
                619
            ],
            "periodType": [
                1199
            ],
            "requireStraddleApproval": [
                137
            ],
            "straddleWindowPeriods": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryPeriodConfigResultPage": {
            "entries": [
                682
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryPeriodConfigSortOption": {},
        "InventoryPeriodConfigUpdateInput": {
            "allowStraddleCompletion": [
                137
            ],
            "fiscalYearStartMonth": [
                619
            ],
            "periodType": [
                1199
            ],
            "requireStraddleApproval": [
                137
            ],
            "straddleWindowPeriods": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryPeriodFilter": {
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "status": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryPeriodInput": {
            "endDate": [
                1446
            ],
            "facilityId": [
                607
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "periodType": [
                1199
            ],
            "startDate": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryPeriodResultPage": {
            "entries": [
                675
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryPeriodSortOption": {},
        "InventoryPeriodUpdateInput": {
            "endDate": [
                1446
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "periodType": [
                1199
            ],
            "startDate": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryTag": {
            "allocations": [
                1208,
                {
                    "pagination": [
                        906
                    ]
                }
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "customAttributes": [
                828
            ],
            "facilityId": [
                607
            ],
            "generatedAt": [
                1446
            ],
            "grossQuantity": [
                393
            ],
            "id": [
                607
            ],
            "isReconciled": [
                137
            ],
            "isRevised": [
                137
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "lot": [
                645
            ],
            "lotId": [
                607
            ],
            "netQuantity": [
                538
            ],
            "quantityCaptureMethod": [
                1026
            ],
            "quantityDiscrepancy": [
                393
            ],
            "quantitySummary": [
                1212
            ],
            "status": [
                701
            ],
            "tagNumber": [
                1199
            ],
            "tagType": [
                1214
            ],
            "tare": [
                393
            ],
            "tareCaptureMethod": [
                1026
            ],
            "timestamps": [
                1250
            ],
            "trackedQuantity": [
                393
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryTagAllocateInput": {
            "allocations": [
                1211
            ],
            "tagId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryTagAllocateResult": {
            "allocations": [
                1205
            ],
            "tag": [
                693
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryTagDeallocateInput": {
            "allocationIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryTagFilter": {
            "facilityIds": [
                607
            ],
            "generatedAtFrom": [
                1446
            ],
            "generatedAtTo": [
                1446
            ],
            "hasLot": [
                137
            ],
            "ids": [
                607
            ],
            "itemIds": [
                607
            ],
            "lotIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "statuses": [
                701
            ],
            "tagNumbers": [
                1199
            ],
            "tagTypes": [
                1214
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryTagInput": {
            "customAttributes": [
                828
            ],
            "facilityId": [
                607
            ],
            "generatedAt": [
                1446
            ],
            "grossQuantity": [
                393
            ],
            "isRevised": [
                137
            ],
            "itemId": [
                607
            ],
            "lotId": [
                607
            ],
            "quantityCaptureMethod": [
                1026
            ],
            "status": [
                701
            ],
            "tagNumber": [
                1199
            ],
            "tagType": [
                1214
            ],
            "tare": [
                393
            ],
            "tareCaptureMethod": [
                1026
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryTagResultPage": {
            "entries": [
                693
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryTagSortOption": {},
        "InventoryTagStatus": {},
        "InventoryTagUpdateInput": {
            "customAttributes": [
                828
            ],
            "facilityId": [
                607
            ],
            "generatedAt": [
                1446
            ],
            "grossQuantity": [
                393
            ],
            "isRevised": [
                137
            ],
            "itemId": [
                607
            ],
            "lotId": [
                607
            ],
            "quantityCaptureMethod": [
                1026
            ],
            "status": [
                701
            ],
            "tagNumber": [
                1199
            ],
            "tagType": [
                1214
            ],
            "tare": [
                393
            ],
            "tareCaptureMethod": [
                1026
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryTaggingType": {},
        "InventoryTransactionType": {},
        "InventoryViewMode": {},
        "InventoryZone": {
            "capacityUnit": [
                1199
            ],
            "capacityValue": [
                393
            ],
            "children": [
                706
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "customAttributes": [
                828
            ],
            "description": [
                1199
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "parentZone": [
                706
            ],
            "parentZoneId": [
                607
            ],
            "status": [
                1443
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "utilization": [
                1445
            ],
            "zoneCode": [
                1199
            ],
            "zoneType": [
                1444
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryZoneFilter": {
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "parentZoneIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "status": [
                1443
            ],
            "zoneType": [
                1444
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryZoneInput": {
            "capacityUnit": [
                1199
            ],
            "capacityValue": [
                393
            ],
            "customAttributes": [
                828
            ],
            "description": [
                1199
            ],
            "facilityId": [
                607
            ],
            "name": [
                1199
            ],
            "parentZoneId": [
                607
            ],
            "status": [
                1443
            ],
            "zoneCode": [
                1199
            ],
            "zoneType": [
                1444
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryZoneResultPage": {
            "entries": [
                706
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "InventoryZoneSortOption": {},
        "InventoryZoneUpdateInput": {
            "capacityUnit": [
                1199
            ],
            "capacityValue": [
                393
            ],
            "customAttributes": [
                828
            ],
            "description": [
                1199
            ],
            "name": [
                1199
            ],
            "parentZoneId": [
                607
            ],
            "zoneCode": [
                1199
            ],
            "zoneType": [
                1444
            ],
            "__typename": [
                1199
            ]
        },
        "InvitationStatus": {},
        "Invoice": {
            "account": [
                3
            ],
            "amount": [
                835
            ],
            "documentDate": [
                168
            ],
            "documentNumber": [
                1199
            ],
            "dueDate": [
                168
            ],
            "facility": [
                470
            ],
            "id": [
                607
            ],
            "lineItems": [
                718
            ],
            "notes": [
                1199
            ],
            "openAmount": [
                835
            ],
            "paymentTerm": [
                920
            ],
            "paymentTermEntity": [
                921
            ],
            "payments": [
                911
            ],
            "sourceReferences": [
                714
            ],
            "status": [
                724
            ],
            "timestamps": [
                1250
            ],
            "type": [
                726
            ],
            "__typename": [
                1199
            ]
        },
        "InvoiceEntityReference": {
            "entityId": [
                607
            ],
            "entityType": [
                716
            ],
            "__typename": [
                1199
            ]
        },
        "InvoiceEntityReferenceInput": {
            "entityId": [
                607
            ],
            "entityType": [
                716
            ],
            "__typename": [
                1199
            ]
        },
        "InvoiceEntityReferenceType": {},
        "InvoiceFilter": {
            "accountIDs": [
                607
            ],
            "currencyCode": [
                355
            ],
            "facilityIDs": [
                607
            ],
            "fromDueDate": [
                168
            ],
            "ids": [
                607
            ],
            "maxOpenBalance": [
                393
            ],
            "minOpenBalance": [
                393
            ],
            "searchTerm": [
                1199
            ],
            "statuses": [
                724
            ],
            "toDueDate": [
                168
            ],
            "types": [
                726
            ],
            "__typename": [
                1199
            ]
        },
        "InvoiceLineItem": {
            "description": [
                1199
            ],
            "groupName": [
                1199
            ],
            "id": [
                607
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "quantity": [
                393
            ],
            "sortOrder": [
                619
            ],
            "sourceReference": [
                714
            ],
            "timestamps": [
                1250
            ],
            "totalPrice": [
                835
            ],
            "unit": [
                1199
            ],
            "unitPrice": [
                835
            ],
            "__typename": [
                1199
            ]
        },
        "InvoiceLineItemInput": {
            "description": [
                1199
            ],
            "groupName": [
                1199
            ],
            "id": [
                607
            ],
            "itemId": [
                607
            ],
            "quantity": [
                393
            ],
            "sortOrder": [
                619
            ],
            "sourceReference": [
                715
            ],
            "totalPrice": [
                836
            ],
            "unit": [
                1199
            ],
            "unitPrice": [
                836
            ],
            "__typename": [
                1199
            ]
        },
        "InvoicePaymentApplication": {
            "appliedAmount": [
                835
            ],
            "appliedAt": [
                1446
            ],
            "invoice": [
                713
            ],
            "__typename": [
                1199
            ]
        },
        "InvoicePricingBasis": {},
        "InvoiceResultPage": {
            "entries": [
                713
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "InvoiceSortOption": {},
        "InvoiceStatus": {},
        "InvoiceStatusCounts": {
            "paid": [
                619
            ],
            "pending": [
                619
            ],
            "proForma": [
                619
            ],
            "voided": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "InvoiceType": {},
        "Item": {
            "attributeValues": [
                770
            ],
            "category": [
                175
            ],
            "categoryId": [
                607
            ],
            "colorHue": [
                619
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "customAttributes": [
                828
            ],
            "description": [
                1199
            ],
            "effectivePricingUnit": [
                1199
            ],
            "id": [
                607
            ],
            "itemGroup": [
                736
            ],
            "itemGroupId": [
                607
            ],
            "measurementUnit": [
                1199
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "pricingUnitOverride": [
                1199
            ],
            "skuNumber": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ItemAlias": {
            "account": [
                3
            ],
            "accountId": [
                607
            ],
            "aliasCode": [
                1199
            ],
            "aliasName": [
                1199
            ],
            "aliasType": [
                733
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "id": [
                607
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "organization": [
                887
            ],
            "organizationId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ItemAliasFilter": {
            "accountIds": [
                607
            ],
            "aliasTypes": [
                733
            ],
            "ids": [
                607
            ],
            "itemIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ItemAliasInput": {
            "accountId": [
                607
            ],
            "aliasCode": [
                1199
            ],
            "aliasName": [
                1199
            ],
            "aliasType": [
                733
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ItemAliasResultPage": {
            "entries": [
                728
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ItemAliasSortOption": {},
        "ItemAliasType": {},
        "ItemAliasUpdateInput": {
            "aliasCode": [
                1199
            ],
            "aliasName": [
                1199
            ],
            "aliasType": [
                733
            ],
            "notes": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ItemFilter": {
            "categoryId": [
                607
            ],
            "categoryIds": [
                607
            ],
            "description": [
                1199
            ],
            "ids": [
                607
            ],
            "includeDeleted": [
                137
            ],
            "itemGroupId": [
                607
            ],
            "itemGroupIds": [
                607
            ],
            "measurementUnit": [
                1199
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "pricingUnitOverride": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "skuNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ItemGroup": {
            "colorHue": [
                619
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "defaultPricingUnit": [
                1199
            ],
            "description": [
                1199
            ],
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "number": [
                1199
            ],
            "parentId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ItemGroupFilter": {
            "defaultPricingUnit": [
                1199
            ],
            "description": [
                1199
            ],
            "ids": [
                607
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "number": [
                1199
            ],
            "parentId": [
                607
            ],
            "parentIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ItemGroupInput": {
            "colorHue": [
                619
            ],
            "customAttributes": [
                828
            ],
            "defaultPricingUnit": [
                1199
            ],
            "description": [
                1199
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "number": [
                1199
            ],
            "parentId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ItemGroupResultPage": {
            "entries": [
                736
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ItemGroupSortOption": {},
        "ItemGroupUpdateInput": {
            "colorHue": [
                619
            ],
            "customAttributes": [
                828
            ],
            "defaultPricingUnit": [
                1199
            ],
            "description": [
                1199
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "number": [
                1199
            ],
            "parentId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ItemInput": {
            "attributeValues": [
                770
            ],
            "categoryId": [
                607
            ],
            "colorHue": [
                619
            ],
            "customAttributes": [
                828
            ],
            "description": [
                1199
            ],
            "itemGroupId": [
                607
            ],
            "measurementUnit": [
                1199
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "pricingUnitOverride": [
                1199
            ],
            "skuNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ItemMarginResult": {
            "itemId": [
                607
            ],
            "margin": [
                835
            ],
            "marginPercent": [
                393
            ],
            "purchaseTotal": [
                835
            ],
            "purchaseUnitPrice": [
                835
            ],
            "quantity": [
                393
            ],
            "salesTotal": [
                835
            ],
            "salesUnitPrice": [
                835
            ],
            "unit": [
                1307
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPosition": {
            "currentInventory": [
                393
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "incoming": [
                393
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "netPosition": [
                393
            ],
            "outgoing": [
                393
            ],
            "unit": [
                1307
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPositionFilter": {
            "facilityIds": [
                607
            ],
            "itemIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "showOnlyNegative": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPositionResultPage": {
            "entries": [
                744
            ],
            "page": [
                905
            ],
            "stats": [
                951
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPositionSortOption": {},
        "ItemPrice": {
            "configuration": [
                749
            ],
            "itemPricings": [
                463
            ],
            "sourceId": [
                607
            ],
            "sourceType": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPriceConfiguration": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "currency": [
                1199
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "itemId": [
                607
            ],
            "operationType": [
                886
            ],
            "pricingUnits": [
                828
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPriceConfigurationFilter": {
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "itemIds": [
                607
            ],
            "operationType": [
                886
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPriceConfigurationInput": {
            "currency": [
                1199
            ],
            "facilityId": [
                607
            ],
            "itemId": [
                607
            ],
            "operationType": [
                886
            ],
            "pricingUnits": [
                828
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPriceConfigurationResultPage": {
            "entries": [
                749
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPriceConfigurationSortOption": {},
        "ItemPriceConfigurationUpdateInput": {
            "currency": [
                1199
            ],
            "facilityId": [
                607
            ],
            "itemId": [
                607
            ],
            "operationType": [
                886
            ],
            "pricingUnits": [
                828
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPricing": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "customPriceListId": [
                607
            ],
            "defaultPriceListId": [
                607
            ],
            "id": [
                607
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "position": [
                619
            ],
            "pricingUnit": [
                1307
            ],
            "tiers": [
                761
            ],
            "tiersEffectiveAt": [
                1446
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPricingDirtyAwareResult": {
            "entries": [
                755
            ],
            "preservedDirtyNodes": [
                755
            ],
            "visibleDirtyIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPricingFilter": {
            "customPriceListId": [
                607
            ],
            "customPriceListIds": [
                607
            ],
            "defaultPriceListId": [
                607
            ],
            "defaultPriceListIds": [
                607
            ],
            "fromTiersEffectiveAt": [
                1446
            ],
            "ids": [
                607
            ],
            "itemId": [
                607
            ],
            "itemIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "toTiersEffectiveAt": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPricingInput": {
            "customPriceListId": [
                607
            ],
            "defaultPriceListId": [
                607
            ],
            "itemId": [
                607
            ],
            "position": [
                619
            ],
            "pricingUnit": [
                1307
            ],
            "tiers": [
                320
            ],
            "tiersEffectiveAt": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPricingResultPage": {
            "entries": [
                755
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPricingSortOption": {},
        "ItemPricingTier": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "id": [
                607
            ],
            "itemPricingId": [
                607
            ],
            "maxAmount": [
                393
            ],
            "maxPrice": [
                1309
            ],
            "minPrice": [
                1309
            ],
            "position": [
                619
            ],
            "scrapValue": [
                393
            ],
            "targetPrice": [
                1309
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPricingTierFilter": {
            "ids": [
                607
            ],
            "itemPricingId": [
                607
            ],
            "itemPricingIds": [
                607
            ],
            "maxPriceFormula": [
                1199
            ],
            "minPriceFormula": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "targetPriceFormula": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPricingTierResultPage": {
            "entries": [
                761
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPricingTierSortOption": {},
        "ItemPricingTierUpdateInput": {
            "itemPricingId": [
                607
            ],
            "maxAmount": [
                393
            ],
            "maxPrice": [
                1310
            ],
            "minPrice": [
                1310
            ],
            "position": [
                619
            ],
            "scrapValue": [
                393
            ],
            "targetPrice": [
                1310
            ],
            "__typename": [
                1199
            ]
        },
        "ItemPricingUpdateInput": {
            "customPriceListId": [
                607
            ],
            "defaultPriceListId": [
                607
            ],
            "itemId": [
                607
            ],
            "position": [
                619
            ],
            "pricingUnit": [
                1307
            ],
            "tiersEffectiveAt": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "ItemResultPage": {
            "entries": [
                727
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ItemSortOption": {},
        "ItemUpdateInput": {
            "attributeValues": [
                770
            ],
            "categoryId": [
                607
            ],
            "colorHue": [
                619
            ],
            "customAttributes": [
                828
            ],
            "description": [
                1199
            ],
            "itemGroupId": [
                607
            ],
            "measurementUnit": [
                1199
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "pricingUnitOverride": [
                1199
            ],
            "skuNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "JSON": {},
        "LinkBrokeredOrdersInput": {
            "addPurchaseOrderIds": [
                607
            ],
            "addSalesOrderIds": [
                607
            ],
            "removePurchaseOrderIds": [
                607
            ],
            "removeSalesOrderIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "Load": {
            "billId": [
                607
            ],
            "bolNumber": [
                1199
            ],
            "booking": [
                123
            ],
            "bookingId": [
                607
            ],
            "brokeredOrder": [
                138
            ],
            "brokeredOrderId": [
                607
            ],
            "canBeReconciled": [
                137
            ],
            "carrierAccount": [
                3
            ],
            "carrierAccountId": [
                607
            ],
            "container": [
                260
            ],
            "containerAtFacilityAt": [
                1446
            ],
            "containerInTransitAt": [
                1446
            ],
            "containerLoadedAt": [
                1446
            ],
            "containerNumber": [
                1199
            ],
            "containerPickedUpAt": [
                1446
            ],
            "containerReadyToShipAt": [
                1446
            ],
            "containerReturningAt": [
                1446
            ],
            "containerType": [
                268
            ],
            "containerTypeId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "currencyCode": [
                355
            ],
            "customerAccount": [
                3
            ],
            "customerAccountAddress": [
                4
            ],
            "customerAccountAddressId": [
                607
            ],
            "customerAccountId": [
                607
            ],
            "customerExternalNotes": [
                1199
            ],
            "customerFiles": [
                494
            ],
            "customerInternalNotes": [
                1199
            ],
            "deductions": [
                776
            ],
            "deductionsTotal": [
                835
            ],
            "deliveryNumber": [
                1199
            ],
            "description": [
                1199
            ],
            "documentNumber": [
                1199
            ],
            "driverName": [
                1199
            ],
            "expectedShipDate": [
                168
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "freightCost": [
                835
            ],
            "freightForwarder": [
                1199
            ],
            "freightTerms": [
                573
            ],
            "grandTotal": [
                835
            ],
            "heavyWeight": [
                1424
            ],
            "id": [
                607
            ],
            "isReconciled": [
                137
            ],
            "lightWeight": [
                1424
            ],
            "lineItems": [
                782
            ],
            "loadReceivedDate": [
                168
            ],
            "millReceivedWeightPostDate": [
                168
            ],
            "organization": [
                887
            ],
            "organizationId": [
                607
            ],
            "outboundTollingAgreement": [
                894
            ],
            "outboundTollingAgreementId": [
                607
            ],
            "purchaseOrder": [
                1008
            ],
            "purchaseOrderId": [
                607
            ],
            "receivedTicketIssueDate": [
                168
            ],
            "receivingFacility": [
                470
            ],
            "receivingFacilityId": [
                607
            ],
            "receivingTicketNumber": [
                1199
            ],
            "reconciliation": [
                788
            ],
            "recyclerExternalNotes": [
                1199
            ],
            "recyclerFiles": [
                494
            ],
            "recyclerInternalNotes": [
                1199
            ],
            "releaseNumber": [
                1199
            ],
            "reviewed": [
                137
            ],
            "salesOrder": [
                1090
            ],
            "salesOrderId": [
                607
            ],
            "scac": [
                1199
            ],
            "sealNumber": [
                1199
            ],
            "shippedDate": [
                168
            ],
            "shippingCarrierName": [
                1199
            ],
            "status": [
                798
            ],
            "subtotal": [
                835
            ],
            "supplier": [
                3
            ],
            "supplierAddress": [
                4
            ],
            "supplierAddressId": [
                607
            ],
            "supplierId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "trailerNumber": [
                1199
            ],
            "truckFreight": [
                1199
            ],
            "truckNumber": [
                1199
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "version": [
                619
            ],
            "voidReason": [
                1199
            ],
            "weightDisplayUnit": [
                1425
            ],
            "__typename": [
                1199
            ]
        },
        "LoadBoard": {
            "drivers": [
                439
            ],
            "services": [
                1133
            ],
            "__typename": [
                1199
            ]
        },
        "LoadCustomerFileCreatePayload": {
            "file": [
                494
            ],
            "uploadUrl": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "LoadCustomerFileInput": {
            "fileName": [
                1199
            ],
            "fileSize": [
                619
            ],
            "mimeType": [
                1199
            ],
            "public": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "LoadDeduction": {
            "applicationType": [
                394
            ],
            "calculatedAmount": [
                835
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "deductionType": [
                395
            ],
            "deductionTypeId": [
                607
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "lineItem": [
                782
            ],
            "load": [
                772
            ],
            "loadId": [
                607
            ],
            "loadLineItemId": [
                607
            ],
            "notes": [
                1199
            ],
            "percentage": [
                393
            ],
            "priceValue": [
                835
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "weightValue": [
                1424
            ],
            "__typename": [
                1199
            ]
        },
        "LoadDeductionFilter": {
            "applicationType": [
                394
            ],
            "deductionTypeId": [
                607
            ],
            "deductionTypeIds": [
                607
            ],
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "loadId": [
                607
            ],
            "loadIds": [
                607
            ],
            "loadLineItemId": [
                607
            ],
            "loadLineItemIds": [
                607
            ],
            "notes": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "LoadDeductionResultPage": {
            "entries": [
                776
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "LoadDeductionSortOption": {},
        "LoadFilter": {
            "accountIds": [
                607
            ],
            "bookingIds": [
                607
            ],
            "brokeredOrderIds": [
                607
            ],
            "carrierAccountIds": [
                607
            ],
            "createdBy": [
                607
            ],
            "customerAccountIds": [
                607
            ],
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "freightTerms": [
                573
            ],
            "fromExpectedShipDate": [
                168
            ],
            "fromShippedDate": [
                168
            ],
            "hasSupplier": [
                137
            ],
            "ids": [
                607
            ],
            "phases": [
                1089
            ],
            "purchaseOrderIds": [
                607
            ],
            "receivingFacilityIds": [
                607
            ],
            "salesOrderId": [
                607
            ],
            "salesOrderIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "status": [
                798
            ],
            "supplierIds": [
                607
            ],
            "toExpectedShipDate": [
                168
            ],
            "toShippedDate": [
                168
            ],
            "updatedBy": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "LoadInput": {
            "bolNumber": [
                1199
            ],
            "bookingId": [
                607
            ],
            "brokeredOrderId": [
                607
            ],
            "carrierAccountId": [
                607
            ],
            "containerNumber": [
                1199
            ],
            "containerTypeId": [
                607
            ],
            "currencyCode": [
                355
            ],
            "customerAccountAddressId": [
                607
            ],
            "customerAccountId": [
                607
            ],
            "customerExternalNotes": [
                1199
            ],
            "customerInternalNotes": [
                1199
            ],
            "deliveryNumber": [
                1199
            ],
            "description": [
                1199
            ],
            "documentNumber": [
                1199
            ],
            "driverName": [
                1199
            ],
            "expectedShipDate": [
                168
            ],
            "facilityId": [
                607
            ],
            "freightCost": [
                836
            ],
            "freightForwarder": [
                1199
            ],
            "freightTerms": [
                573
            ],
            "heavyWeight": [
                1426
            ],
            "lightWeight": [
                1426
            ],
            "lineItems": [
                783
            ],
            "outboundTollingAgreementId": [
                607
            ],
            "purchaseOrderId": [
                607
            ],
            "receivingFacilityId": [
                607
            ],
            "recyclerExternalNotes": [
                1199
            ],
            "recyclerInternalNotes": [
                1199
            ],
            "releaseNumber": [
                1199
            ],
            "salesOrderId": [
                607
            ],
            "scac": [
                1199
            ],
            "sealNumber": [
                1199
            ],
            "shippingCarrierName": [
                1199
            ],
            "supplierAddressId": [
                607
            ],
            "supplierId": [
                607
            ],
            "trailerNumber": [
                1199
            ],
            "truckFreight": [
                1199
            ],
            "truckNumber": [
                1199
            ],
            "weightDisplayUnit": [
                1425
            ],
            "__typename": [
                1199
            ]
        },
        "LoadLineItem": {
            "estimatedPrice": [
                835
            ],
            "id": [
                607
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "loadId": [
                607
            ],
            "notes": [
                1199
            ],
            "phase": [
                1089
            ],
            "pricingUnit": [
                1199
            ],
            "purchaseOrder": [
                1008
            ],
            "purchaseOrderId": [
                607
            ],
            "quantityVariance": [
                393
            ],
            "receivedLineItems": [
                1043
            ],
            "salesOrderLine": [
                1103
            ],
            "salesOrderLineId": [
                607
            ],
            "tagId": [
                607
            ],
            "totalReceivedQuantity": [
                393
            ],
            "type": [
                1088
            ],
            "unitPrice": [
                835
            ],
            "weights": [
                828
            ],
            "__typename": [
                1199
            ]
        },
        "LoadLineItemInput": {
            "estimatedPrice": [
                836
            ],
            "id": [
                607
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "phase": [
                1089
            ],
            "pricingUnit": [
                1199
            ],
            "purchaseOrderId": [
                607
            ],
            "salesOrderLineId": [
                607
            ],
            "tagId": [
                607
            ],
            "type": [
                1088
            ],
            "unitPrice": [
                836
            ],
            "weights": [
                828
            ],
            "__typename": [
                1199
            ]
        },
        "LoadLineItemReconcileInput": {
            "id": [
                607
            ],
            "shippedQuantity": [
                393
            ],
            "shippedWeight": [
                1426
            ],
            "__typename": [
                1199
            ]
        },
        "LoadPhotoCreatePayload": {
            "file": [
                494
            ],
            "uploadUrl": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "LoadPhotoInput": {
            "fileName": [
                1199
            ],
            "fileSize": [
                619
            ],
            "isPhotoRequirement": [
                137
            ],
            "mimeType": [
                1199
            ],
            "notes": [
                1199
            ],
            "photoRequirementId": [
                607
            ],
            "public": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "LoadPhotoUpdateInput": {
            "notes": [
                1199
            ],
            "photoRequirementId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "LoadReconciliation": {
            "deductions": [
                1047
            ],
            "externalNotes": [
                1199
            ],
            "files": [
                494
            ],
            "freightCharges": [
                540
            ],
            "id": [
                607
            ],
            "internalNotes": [
                1199
            ],
            "invoice": [
                713
            ],
            "invoiceId": [
                607
            ],
            "invoiceType": [
                1199
            ],
            "loadId": [
                607
            ],
            "loadReceivedDate": [
                168
            ],
            "millReceivedWeightPostDate": [
                168
            ],
            "netDelta": [
                393
            ],
            "netReceivedWeight": [
                393
            ],
            "netShippedWeight": [
                393
            ],
            "receivedLineItems": [
                1043
            ],
            "receivedLoadTotal": [
                835
            ],
            "shippedLoadTotal": [
                835
            ],
            "ticketIssueDate": [
                168
            ],
            "ticketNumber": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "totalDeductions": [
                835
            ],
            "totalDelta": [
                835
            ],
            "__typename": [
                1199
            ]
        },
        "LoadReconciliationFileCreatePayload": {
            "file": [
                494
            ],
            "uploadUrl": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "LoadReconciliationFileInput": {
            "fileName": [
                1199
            ],
            "fileSize": [
                619
            ],
            "mimeType": [
                1199
            ],
            "public": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "LoadReconciliationSummary": {
            "expectedShipDate": [
                168
            ],
            "isReconciled": [
                137
            ],
            "loadId": [
                607
            ],
            "netDelta": [
                393
            ],
            "netReceivedWeight": [
                393
            ],
            "netShippedWeight": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "LoadReconciliationSummaryResultPage": {
            "entries": [
                791
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "LoadRecyclerFileCreatePayload": {
            "file": [
                494
            ],
            "uploadUrl": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "LoadRecyclerFileInput": {
            "fileName": [
                1199
            ],
            "fileSize": [
                619
            ],
            "mimeType": [
                1199
            ],
            "public": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "LoadResultPage": {
            "entries": [
                772
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "LoadReviewInput": {
            "id": [
                607
            ],
            "millReceivedWeightPostDate": [
                168
            ],
            "receivedTicketIssueDate": [
                168
            ],
            "receivingTicketNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "LoadSortOption": {},
        "LoadStatus": {},
        "LoadStatusCounts": {
            "containerAtFacility": [
                619
            ],
            "containerAtPort": [
                619
            ],
            "containerInTransit": [
                619
            ],
            "containerLoaded": [
                619
            ],
            "containerReadyToShip": [
                619
            ],
            "containerReturning": [
                619
            ],
            "pending": [
                619
            ],
            "received": [
                619
            ],
            "reconciled": [
                619
            ],
            "shipped": [
                619
            ],
            "unassigned": [
                619
            ],
            "voided": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "LoadUpdateInput": {
            "bolNumber": [
                1199
            ],
            "bookingId": [
                607
            ],
            "brokeredOrderId": [
                607
            ],
            "carrierAccountId": [
                607
            ],
            "containerNumber": [
                1199
            ],
            "containerTypeId": [
                607
            ],
            "currencyCode": [
                355
            ],
            "customerAccountAddressId": [
                607
            ],
            "customerAccountId": [
                607
            ],
            "customerExternalNotes": [
                1199
            ],
            "customerInternalNotes": [
                1199
            ],
            "deductions": [
                1338
            ],
            "deliveryNumber": [
                1199
            ],
            "description": [
                1199
            ],
            "driverName": [
                1199
            ],
            "expectedShipDate": [
                168
            ],
            "expectedVersion": [
                619
            ],
            "facilityId": [
                607
            ],
            "freightCost": [
                836
            ],
            "freightForwarder": [
                1199
            ],
            "freightTerms": [
                573
            ],
            "heavyWeight": [
                1426
            ],
            "lightWeight": [
                1426
            ],
            "lineItems": [
                783
            ],
            "outboundTollingAgreementId": [
                607
            ],
            "purchaseOrderId": [
                607
            ],
            "receivingFacilityId": [
                607
            ],
            "recyclerExternalNotes": [
                1199
            ],
            "recyclerInternalNotes": [
                1199
            ],
            "releaseNumber": [
                1199
            ],
            "salesOrderId": [
                607
            ],
            "scac": [
                1199
            ],
            "sealNumber": [
                1199
            ],
            "shippingCarrierName": [
                1199
            ],
            "supplierAddressId": [
                607
            ],
            "supplierId": [
                607
            ],
            "trailerNumber": [
                1199
            ],
            "truckFreight": [
                1199
            ],
            "truckNumber": [
                1199
            ],
            "weightDisplayUnit": [
                1425
            ],
            "__typename": [
                1199
            ]
        },
        "LoadUpdateResult": {
            "load": [
                772
            ],
            "orphanedLink": [
                893
            ],
            "__typename": [
                1199
            ]
        },
        "Location": {
            "accountAddress": [
                4
            ],
            "facility": [
                470
            ],
            "id": [
                607
            ],
            "type": [
                810
            ],
            "__typename": [
                1199
            ]
        },
        "LocationFilterType": {},
        "LocationFreightPricing": {
            "consumerChargebackFormula": [
                1199
            ],
            "consumerChargebackVariableIds": [
                1199
            ],
            "consumerFreightEnabled": [
                137
            ],
            "consumerFuelSurchargeFormula": [
                1199
            ],
            "consumerFuelSurchargeMode": [
                1199
            ],
            "consumerFuelSurchargeVariableIds": [
                1199
            ],
            "consumerNegativeCharge": [
                137
            ],
            "consumerRateFormula": [
                1199
            ],
            "consumerRateVariableIds": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "id": [
                607
            ],
            "location": [
                802
            ],
            "locationId": [
                607
            ],
            "locationType": [
                810
            ],
            "supplierChargebackFormula": [
                1199
            ],
            "supplierChargebackVariableIds": [
                1199
            ],
            "supplierFreightEnabled": [
                137
            ],
            "supplierFuelSurchargeFormula": [
                1199
            ],
            "supplierFuelSurchargeMode": [
                1199
            ],
            "supplierFuelSurchargeVariableIds": [
                1199
            ],
            "supplierRateFormula": [
                1199
            ],
            "supplierRateVariableIds": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "LocationFreightPricingFilter": {
            "ids": [
                607
            ],
            "locationId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "LocationFreightPricingInput": {
            "consumerChargebackFormula": [
                1199
            ],
            "consumerChargebackVariableIds": [
                1199
            ],
            "consumerFreightEnabled": [
                137
            ],
            "consumerFuelSurchargeFormula": [
                1199
            ],
            "consumerFuelSurchargeMode": [
                1199
            ],
            "consumerFuelSurchargeVariableIds": [
                1199
            ],
            "consumerNegativeCharge": [
                137
            ],
            "consumerRateFormula": [
                1199
            ],
            "consumerRateVariableIds": [
                1199
            ],
            "locationId": [
                607
            ],
            "locationType": [
                810
            ],
            "supplierChargebackFormula": [
                1199
            ],
            "supplierChargebackVariableIds": [
                1199
            ],
            "supplierFreightEnabled": [
                137
            ],
            "supplierFuelSurchargeFormula": [
                1199
            ],
            "supplierFuelSurchargeMode": [
                1199
            ],
            "supplierFuelSurchargeVariableIds": [
                1199
            ],
            "supplierRateFormula": [
                1199
            ],
            "supplierRateVariableIds": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "LocationFreightPricingResultPage": {
            "entries": [
                804
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "LocationFreightPricingSortOption": {},
        "LocationFreightPricingUpdateInput": {
            "consumerChargebackFormula": [
                1199
            ],
            "consumerChargebackVariableIds": [
                1199
            ],
            "consumerFreightEnabled": [
                137
            ],
            "consumerFuelSurchargeFormula": [
                1199
            ],
            "consumerFuelSurchargeMode": [
                1199
            ],
            "consumerFuelSurchargeVariableIds": [
                1199
            ],
            "consumerNegativeCharge": [
                137
            ],
            "consumerRateFormula": [
                1199
            ],
            "consumerRateVariableIds": [
                1199
            ],
            "locationId": [
                607
            ],
            "locationType": [
                810
            ],
            "supplierChargebackFormula": [
                1199
            ],
            "supplierChargebackVariableIds": [
                1199
            ],
            "supplierFreightEnabled": [
                137
            ],
            "supplierFuelSurchargeFormula": [
                1199
            ],
            "supplierFuelSurchargeMode": [
                1199
            ],
            "supplierFuelSurchargeVariableIds": [
                1199
            ],
            "supplierRateFormula": [
                1199
            ],
            "supplierRateVariableIds": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "LocationType": {},
        "LoopNode": {
            "arrayExpression": [
                1199
            ],
            "description": [
                1199
            ],
            "id": [
                607
            ],
            "itemVariableName": [
                1199
            ],
            "label": [
                1199
            ],
            "maxIterations": [
                619
            ],
            "position": [
                949
            ],
            "type": [
                848
            ],
            "__typename": [
                1199
            ]
        },
        "LotAllocation": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "lot": [
                645
            ],
            "lotId": [
                607
            ],
            "movement": [
                662
            ],
            "movementId": [
                607
            ],
            "quantity": [
                1424
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "LotAllocationFilter": {
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "lotId": [
                607
            ],
            "lotIds": [
                607
            ],
            "movementId": [
                607
            ],
            "movementIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "LotAllocationFilterInput": {
            "excludeTransactionTypes": [
                704
            ],
            "includeTransactionTypes": [
                704
            ],
            "__typename": [
                1199
            ]
        },
        "LotAllocationInput": {
            "lotId": [
                607
            ],
            "movementId": [
                607
            ],
            "quantity": [
                1426
            ],
            "__typename": [
                1199
            ]
        },
        "LotAllocationResultPage": {
            "entries": [
                812
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "LotAllocationSortOption": {},
        "LotAllocationUpdateInput": {
            "lotId": [
                607
            ],
            "movementId": [
                607
            ],
            "quantity": [
                1426
            ],
            "__typename": [
                1199
            ]
        },
        "LotMovementFilterInput": {
            "itemId": [
                607
            ],
            "occurredAtFrom": [
                1446
            ],
            "occurredAtTo": [
                1446
            ],
            "originTransactionTypes": [
                704
            ],
            "supplierIds": [
                607
            ],
            "unallocatedOnly": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "LotQuantitySummary": {
            "inQuantity": [
                1424
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "outQuantity": [
                1424
            ],
            "quantity": [
                1424
            ],
            "__typename": [
                1199
            ]
        },
        "LotSplitTransferInput": {
            "allocationId": [
                607
            ],
            "quantity": [
                1426
            ],
            "__typename": [
                1199
            ]
        },
        "LotStatus": {},
        "LotTraceBackwardResult": {
            "lot": [
                645
            ],
            "purchases": [
                825
            ],
            "__typename": [
                1199
            ]
        },
        "LotTraceForwardResult": {
            "lot": [
                645
            ],
            "sales": [
                826
            ],
            "__typename": [
                1199
            ]
        },
        "LotTracePurchase": {
            "allocation": [
                812
            ],
            "cost": [
                835
            ],
            "quantity": [
                1424
            ],
            "__typename": [
                1199
            ]
        },
        "LotTraceSale": {
            "allocation": [
                812
            ],
            "quantity": [
                1424
            ],
            "__typename": [
                1199
            ]
        },
        "LotValuation": {
            "currentWAC": [
                835
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "lotSpecificCost": [
                835
            ],
            "lotSpecificValue": [
                835
            ],
            "quantity": [
                1424
            ],
            "wacValue": [
                835
            ],
            "__typename": [
                1199
            ]
        },
        "Map": {},
        "MfaChallenge": {
            "expiresAt": [
                1199
            ],
            "id": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "MfaChallengeError": {
            "authenticationFactors": [
                832
            ],
            "pendingAuthenticationToken": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "MfaEnrollmentRequiredError": {
            "pendingAuthenticationToken": [
                1199
            ],
            "user": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "MfaFactor": {
            "id": [
                1199
            ],
            "totp": [
                1276
            ],
            "type": [
                833
            ],
            "__typename": [
                1199
            ]
        },
        "MfaFactorType": {},
        "ModelProvider": {},
        "Money": {
            "amount": [
                393
            ],
            "currencyCode": [
                355
            ],
            "__typename": [
                1199
            ]
        },
        "MoneyInput": {
            "amount": [
                393
            ],
            "currencyCode": [
                355
            ],
            "__typename": [
                1199
            ]
        },
        "MonthlyOccurrence": {},
        "MoveFileInput": {
            "fileId": [
                607
            ],
            "newParentId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "MoveFilePayload": {
            "file": [
                494
            ],
            "__typename": [
                1199
            ]
        },
        "MovementRunningTotals": {
            "calculatedMovementValue": [
                835
            ],
            "runningQuantity": [
                1424
            ],
            "runningValue": [
                835
            ],
            "runningWeightedAverageCost": [
                835
            ],
            "__typename": [
                1199
            ]
        },
        "Mutation": {
            "_placeholder": [
                137
            ],
            "_pricingNoop": [
                137
            ],
            "assistantActivateAgent": [
                35,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "assistantArchiveChat": [
                75,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "assistantCreateAgent": [
                35,
                {
                    "input": [
                        295,
                        "CreateAgentInput!"
                    ]
                }
            ],
            "assistantCreateChat": [
                75,
                {
                    "input": [
                        298,
                        "CreateAssistantChatInput!"
                    ]
                }
            ],
            "assistantDeactivateAgent": [
                35,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "assistantSendChatMessage": [
                137,
                {
                    "chatId": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1130,
                        "SendAssistantChatMessageInput!"
                    ]
                }
            ],
            "assistantSetAgentTools": [
                35,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1158,
                        "SetAgentToolsInput!"
                    ]
                }
            ],
            "assistantShareChat": [
                82,
                {
                    "chatId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "assistantUnshareChat": [
                75,
                {
                    "chatId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "assistantUpdateAgent": [
                35,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1319,
                        "UpdateAgentInput!"
                    ]
                }
            ],
            "assistantUpdateChat": [
                75,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1322,
                        "UpdateAssistantChatInput!"
                    ]
                }
            ],
            "authenticationAcceptUserInvitation": [
                1378,
                {
                    "password": [
                        1199,
                        "String!"
                    ],
                    "token": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "authenticationAuthenticateWithMagicAuth": [
                93,
                {
                    "clientId": [
                        1199,
                        "String!"
                    ],
                    "code": [
                        1199,
                        "String!"
                    ],
                    "email": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "authenticationCompleteSignUp": [
                1189,
                {
                    "firstName": [
                        1199,
                        "String!"
                    ],
                    "lastName": [
                        1199,
                        "String!"
                    ],
                    "organizationName": [
                        1199,
                        "String!"
                    ],
                    "password": [
                        1199,
                        "String!"
                    ],
                    "timezone": [
                        1199,
                        "String!"
                    ],
                    "token": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "authenticationCompleteStandaloneAuth": [
                1195,
                {
                    "externalAuthId": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "authenticationCreateMagicAuth": [
                137,
                {
                    "email": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "authenticationRefreshSession": [
                93,
                {
                    "clientId": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "authenticationSelectOrganization": [
                93,
                {
                    "clientId": [
                        1199,
                        "String!"
                    ],
                    "organizationId": [
                        1199,
                        "String!"
                    ],
                    "pendingAuthenticationToken": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "authenticationSendEmailVerification": [
                137,
                {
                    "email": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "authenticationSignIn": [
                93,
                {
                    "clientId": [
                        1199,
                        "String!"
                    ],
                    "email": [
                        1199,
                        "String!"
                    ],
                    "password": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "authenticationSignOut": [
                137
            ],
            "authenticationSignUp": [
                1191,
                {
                    "email": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "authenticationVerifyEmail": [
                93,
                {
                    "clientId": [
                        1199,
                        "String!"
                    ],
                    "code": [
                        1199,
                        "String!"
                    ],
                    "pendingAuthenticationToken": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "authenticationVerifyTotp": [
                93,
                {
                    "authenticationChallengeId": [
                        1199,
                        "String!"
                    ],
                    "clientId": [
                        1199,
                        "String!"
                    ],
                    "code": [
                        1199,
                        "String!"
                    ],
                    "pendingAuthenticationToken": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "automationsApprovalRespond": [
                46,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1058,
                        "RespondApprovalInput!"
                    ]
                }
            ],
            "automationsAutomationActivate": [
                94,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "automationsAutomationBulkActivate": [
                96,
                {
                    "input": [
                        95,
                        "AutomationBulkInput!"
                    ]
                }
            ],
            "automationsAutomationBulkDelete": [
                96,
                {
                    "input": [
                        95,
                        "AutomationBulkInput!"
                    ]
                }
            ],
            "automationsAutomationBulkPause": [
                96,
                {
                    "input": [
                        95,
                        "AutomationBulkInput!"
                    ]
                }
            ],
            "automationsAutomationCreate": [
                94,
                {
                    "input": [
                        299,
                        "CreateAutomationInput!"
                    ]
                }
            ],
            "automationsAutomationDelete": [
                97,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "automationsAutomationDuplicate": [
                94,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "automationsAutomationPause": [
                94,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "automationsAutomationTest": [
                465,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "testPayload": [
                        828
                    ]
                }
            ],
            "automationsAutomationUpdate": [
                94,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1323,
                        "UpdateAutomationInput!"
                    ]
                }
            ],
            "automationsAutomationVersionCreate": [
                102,
                {
                    "input": [
                        104,
                        "AutomationVersionInput!"
                    ]
                }
            ],
            "automationsAutomationVersionDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "automationsAutomationVersionUpdate": [
                102,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        107,
                        "AutomationVersionUpdateInput!"
                    ]
                }
            ],
            "automationsExecutionRunCancel": [
                465,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "automationsWebhookRegenerateSecret": [
                1422,
                {
                    "automationId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "complianceComplianceDispatchRecordCreate": [
                208,
                {
                    "input": [
                        210,
                        "ComplianceDispatchRecordInput!"
                    ]
                }
            ],
            "complianceComplianceDispatchRecordRetry": [
                208,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "complianceComplianceDispatchRecordUpdate": [
                208,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        213,
                        "ComplianceDispatchRecordUpdateInput!"
                    ]
                }
            ],
            "complianceComplianceFacilityRuleApplyJurisdictionPack": [
                217,
                {
                    "facilityId": [
                        607,
                        "ID!"
                    ],
                    "jurisdictionCode": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "complianceComplianceFacilityRuleCreate": [
                217,
                {
                    "input": [
                        219,
                        "ComplianceFacilityRuleInput!"
                    ]
                }
            ],
            "complianceComplianceFacilityRuleDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "complianceComplianceFacilityRuleUpdate": [
                217,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        222,
                        "ComplianceFacilityRuleUpdateInput!"
                    ]
                }
            ],
            "complianceComplianceItemJurisdictionCodeCreate": [
                236,
                {
                    "input": [
                        238,
                        "ComplianceItemJurisdictionCodeInput!"
                    ]
                }
            ],
            "complianceComplianceItemJurisdictionCodeDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "complianceComplianceItemJurisdictionCodeUpdate": [
                236,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        241,
                        "ComplianceItemJurisdictionCodeUpdateInput!"
                    ]
                }
            ],
            "complianceComplianceRuleDefinitionCreate": [
                245,
                {
                    "input": [
                        247,
                        "ComplianceRuleDefinitionInput!"
                    ]
                }
            ],
            "complianceComplianceRuleDefinitionDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "complianceComplianceRuleDefinitionUpdate": [
                245,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        250,
                        "ComplianceRuleDefinitionUpdateInput!"
                    ]
                }
            ],
            "complianceDoNotBuyEntryCreate": [
                427,
                {
                    "input": [
                        429,
                        "DoNotBuyEntryInput!"
                    ]
                }
            ],
            "complianceDoNotBuyEntryDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "complianceDoNotBuyEntryUpdate": [
                427,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        432,
                        "DoNotBuyEntryUpdateInput!"
                    ]
                }
            ],
            "complianceGovernmentReportingConfigurationCreate": [
                588,
                {
                    "input": [
                        590,
                        "GovernmentReportingConfigurationInput!"
                    ]
                }
            ],
            "complianceGovernmentReportingConfigurationDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "complianceGovernmentReportingConfigurationUpdate": [
                588,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        593,
                        "GovernmentReportingConfigurationUpdateInput!"
                    ]
                }
            ],
            "complianceGovernmentReportingFacilityCreate": [
                594,
                {
                    "input": [
                        596,
                        "GovernmentReportingFacilityInput!"
                    ]
                }
            ],
            "complianceGovernmentReportingFacilityDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "complianceGovernmentReportingFacilityUpdate": [
                594,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        599,
                        "GovernmentReportingFacilityUpdateInput!"
                    ]
                }
            ],
            "confirmAttachmentUpload": [
                88,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreCustomAttributeCreate": [
                356,
                {
                    "input": [
                        307,
                        "CreateCustomAttributeInput!"
                    ]
                }
            ],
            "coreCustomAttributeDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreCustomAttributeDisable": [
                356,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreCustomAttributeUpdate": [
                356,
                {
                    "input": [
                        1329,
                        "UpdateCustomAttributeInput!"
                    ]
                }
            ],
            "coreFacilityCreate": [
                470,
                {
                    "input": [
                        477,
                        "FacilityCreateInput!"
                    ]
                }
            ],
            "coreFacilityDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreFacilityGroupCreate": [
                480,
                {
                    "input": [
                        482,
                        "FacilityGroupInput!"
                    ]
                }
            ],
            "coreFacilityGroupDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreFacilityGroupUpdate": [
                480,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        485,
                        "FacilityGroupUpdateInput!"
                    ]
                }
            ],
            "coreFacilityUpdate": [
                470,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        489,
                        "FacilityUpdateInput!"
                    ]
                }
            ],
            "coreOrganizationAddUser": [
                137,
                {
                    "organizationId": [
                        607,
                        "ID!"
                    ],
                    "userId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreOrganizationCreate": [
                887,
                {
                    "input": [
                        322,
                        "CreateOrganizationInput!"
                    ]
                }
            ],
            "coreOrganizationGrantEntitlement": [
                137,
                {
                    "entitlement": [
                        1199,
                        "String!"
                    ],
                    "organizationId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreOrganizationGrantUserAdmin": [
                1372,
                {
                    "organizationId": [
                        607,
                        "ID!"
                    ],
                    "userId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreOrganizationRemoveUser": [
                137,
                {
                    "organizationId": [
                        607,
                        "ID!"
                    ],
                    "userId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreOrganizationReset": [
                889,
                {
                    "organizationId": [
                        607
                    ]
                }
            ],
            "coreOrganizationRevokeEntitlement": [
                137,
                {
                    "entitlement": [
                        1199,
                        "String!"
                    ],
                    "organizationId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreOrganizationRevokeUserAdmin": [
                1372,
                {
                    "organizationId": [
                        607,
                        "ID!"
                    ],
                    "userId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreOrganizationUpdate": [
                887,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1339,
                        "UpdateOrganizationInput!"
                    ]
                }
            ],
            "corePatchScopedSettingValues": [
                137,
                {
                    "input": [
                        907,
                        "PatchScopedSettingValuesInput!"
                    ]
                }
            ],
            "coreRoleAddUsers": [
                151,
                {
                    "input": [
                        29,
                        "AddUsersToRoleInput!"
                    ]
                }
            ],
            "coreRoleCreate": [
                1059,
                {
                    "input": [
                        333,
                        "CreateRoleInput!"
                    ]
                }
            ],
            "coreRoleDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreRoleRemoveUsers": [
                151,
                {
                    "input": [
                        1055,
                        "RemoveUsersFromRoleInput!"
                    ]
                }
            ],
            "coreRoleUpdate": [
                1059,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1350,
                        "UpdateRoleInput!"
                    ]
                }
            ],
            "coreRolesArchive": [
                151,
                {
                    "input": [
                        153,
                        "BulkRoleInput!"
                    ]
                }
            ],
            "coreRolesRestore": [
                151,
                {
                    "input": [
                        153,
                        "BulkRoleInput!"
                    ]
                }
            ],
            "coreSettingCreate": [
                1162,
                {
                    "input": [
                        339,
                        "CreateSettingInput!"
                    ]
                }
            ],
            "coreSettingDelete": [
                137,
                {
                    "id": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "coreSettingUpdate": [
                1162,
                {
                    "id": [
                        1199,
                        "String!"
                    ],
                    "input": [
                        1355,
                        "UpdateSettingInput!"
                    ]
                }
            ],
            "coreSettingsGroupCreate": [
                1168,
                {
                    "input": [
                        340,
                        "CreateSettingsGroupInput!"
                    ]
                }
            ],
            "coreSettingsGroupDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreSettingsGroupUpdate": [
                1168,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1356,
                        "UpdateSettingsGroupInput!"
                    ]
                }
            ],
            "coreUpdateUserPreferences": [
                1380,
                {
                    "input": [
                        1364,
                        "UpdateUserPreferencesInput!"
                    ]
                }
            ],
            "coreUserCreate": [
                1372,
                {
                    "input": [
                        347,
                        "CreateUserInput!"
                    ]
                }
            ],
            "coreUserDisable": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreUserEnable": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreUserRoleAssign": [
                1383,
                {
                    "input": [
                        70,
                        "AssignUserRoleInput!"
                    ]
                }
            ],
            "coreUserRoleChange": [
                1383,
                {
                    "input": [
                        181,
                        "ChangeUserRoleInput!"
                    ]
                }
            ],
            "coreUserRoleRevoke": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreUserRoleRevokeAll": [
                137,
                {
                    "userId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreUserUpdate": [
                1372,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1363,
                        "UpdateUserInput!"
                    ]
                }
            ],
            "coreUsersDelete": [
                151,
                {
                    "input": [
                        154,
                        "BulkUserInput!"
                    ]
                }
            ],
            "coreUsersDisable": [
                151,
                {
                    "input": [
                        154,
                        "BulkUserInput!"
                    ]
                }
            ],
            "coreUsersEnable": [
                151,
                {
                    "input": [
                        154,
                        "BulkUserInput!"
                    ]
                }
            ],
            "createConversation": [
                306,
                {
                    "input": [
                        305,
                        "CreateConversationInput!"
                    ]
                }
            ],
            "crmAccountAddressCreate": [
                4,
                {
                    "input": [
                        291,
                        "CreateAccountAddressInput!"
                    ]
                }
            ],
            "crmAccountAddressDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "crmAccountAddressUpdate": [
                4,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1315,
                        "UpdateAccountAddressInput!"
                    ]
                }
            ],
            "crmAccountCreate": [
                3,
                {
                    "input": [
                        294,
                        "CreateAccountInput!"
                    ]
                }
            ],
            "crmAccountDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "crmAccountUpdate": [
                3,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1318,
                        "UpdateAccountInput!"
                    ]
                }
            ],
            "crmContactCreate": [
                255,
                {
                    "input": [
                        303,
                        "CreateContactInput!"
                    ]
                }
            ],
            "crmContactDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "crmContactUpdate": [
                255,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1327,
                        "UpdateContactInput!"
                    ]
                }
            ],
            "crmCustomerInvitationAccept": [
                1,
                {
                    "input": [
                        0,
                        "AcceptCustomerInvitationInput!"
                    ]
                }
            ],
            "crmCustomerInvitationCancel": [
                367,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "crmCustomerInvite": [
                367,
                {
                    "input": [
                        308,
                        "CreateCustomerInvitationInput!"
                    ]
                }
            ],
            "cycleCountLineApproveAdjustment": [
                372,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "unitCostOverride": [
                        393
                    ]
                }
            ],
            "cycleCountLineRecordCount": [
                372,
                {
                    "countedQuantity": [
                        393,
                        "Decimal!"
                    ],
                    "countedQuantityUnit": [
                        1199
                    ],
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "cycleCountLineRejectAdjustment": [
                372,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "cycleCountLineRequestRecount": [
                372,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "filesCancelPendingUpload": [
                412,
                {
                    "fileID": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "filesConfirmFileUpload": [
                494,
                {
                    "checksum": [
                        1199
                    ],
                    "fileID": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "filesCreateFile": [
                313,
                {
                    "input": [
                        312,
                        "CreateFileInput!"
                    ]
                }
            ],
            "filesCreateFiles": [
                316,
                {
                    "inputs": [
                        312,
                        "[CreateFileInput!]!"
                    ]
                }
            ],
            "filesCreateZipArchive": [
                53,
                {
                    "archiveName": [
                        1199,
                        "String!"
                    ],
                    "fileIds": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "filesDeleteFile": [
                412,
                {
                    "fileID": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "filesDeleteFiles": [
                415,
                {
                    "fileIDs": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "filesGenerateFileAccessURL": [
                580,
                {
                    "expirySeconds": [
                        619
                    ],
                    "fileIds": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "filesGenerateWOPIToken": [
                587,
                {
                    "input": [
                        586,
                        "GenerateWOPITokenInput!"
                    ]
                }
            ],
            "filesMoveFile": [
                839,
                {
                    "input": [
                        838,
                        "MoveFileInput!"
                    ]
                }
            ],
            "filesRemoveFileFromTemplate": [
                1054,
                {
                    "fileId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "filesRenameFile": [
                494,
                {
                    "fileID": [
                        607,
                        "ID!"
                    ],
                    "newName": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "filesSetFileAsTemplate": [
                1160,
                {
                    "input": [
                        1159,
                        "SetFileAsTemplateInput!"
                    ]
                }
            ],
            "filesSetTemplateAsDefault": [
                1161,
                {
                    "templateId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "filesShareFile": [
                1174,
                {
                    "input": [
                        1173,
                        "ShareFileInput!"
                    ]
                }
            ],
            "filesStartWOPIEditingSession": [
                1197,
                {
                    "input": [
                        1196,
                        "StartWOPIEditingSessionInput!"
                    ]
                }
            ],
            "filesUnshareFile": [
                1313,
                {
                    "input": [
                        1312,
                        "UnshareFileInput!"
                    ]
                }
            ],
            "filesUpdateFileMetadata": [
                494,
                {
                    "fileID": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1334,
                        "UpdateFileMetadataInput!"
                    ]
                }
            ],
            "financeAccountBankDetailCreate": [
                8,
                {
                    "input": [
                        10,
                        "AccountBankDetailInput!"
                    ]
                }
            ],
            "financeAccountBankDetailDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financeAccountBankDetailUpdate": [
                8,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        13,
                        "AccountBankDetailUpdateInput!"
                    ]
                }
            ],
            "financeAdvanceApply": [
                911,
                {
                    "input": [
                        42,
                        "ApplyAdvanceInput!"
                    ]
                }
            ],
            "financeAdvanceRemoveApplication": [
                911,
                {
                    "input": [
                        1053,
                        "RemoveAdvanceApplicationInput!"
                    ]
                }
            ],
            "financeBillCreate": [
                110,
                {
                    "input": [
                        300,
                        "CreateBillInput!"
                    ]
                }
            ],
            "financeBillMarkAsPaid": [
                110,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financeBillUpdate": [
                110,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1324,
                        "UpdateBillInput!"
                    ]
                }
            ],
            "financeBillVoid": [
                110,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financeCheckTemplateCreate": [
                183,
                {
                    "input": [
                        185,
                        "CheckTemplateInput!"
                    ]
                }
            ],
            "financeCheckTemplateDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financeCheckTemplateUpdate": [
                183,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        188,
                        "CheckTemplateUpdateInput!"
                    ]
                }
            ],
            "financeFacilityAtmCreate": [
                471,
                {
                    "input": [
                        473,
                        "FacilityAtmInput!"
                    ]
                }
            ],
            "financeFacilityAtmDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financeFacilityAtmUpdate": [
                471,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        476,
                        "FacilityAtmUpdateInput!"
                    ]
                }
            ],
            "financeFinancialAccountAdjustmentCreate": [
                519,
                {
                    "input": [
                        521,
                        "FinancialAccountAdjustmentInput!"
                    ]
                }
            ],
            "financeFinancialAccountAdjustmentDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financeFinancialAccountAdjustmentUpdate": [
                519,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        524,
                        "FinancialAccountAdjustmentUpdateInput!"
                    ]
                }
            ],
            "financeFinancialAccountCreate": [
                518,
                {
                    "input": [
                        317,
                        "CreateFinancialAccountInput!"
                    ]
                }
            ],
            "financeFinancialAccountDisable": [
                518,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financeFinancialAccountSync": [
                137,
                {
                    "facilityMappings": [
                        938,
                        "[PlaidAccountFacilityMapping!]"
                    ]
                }
            ],
            "financeFinancialAccountSyncTransactions": [
                137
            ],
            "financeFinancialAccountTransactionCreate": [
                528,
                {
                    "input": [
                        318,
                        "CreateFinancialAccountTransactionInput!"
                    ]
                }
            ],
            "financeFinancialAccountTransactionUpdate": [
                528,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1336,
                        "UpdateFinancialAccountTransactionInput!"
                    ]
                }
            ],
            "financeFinancialAccountUpdate": [
                518,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1335,
                        "UpdateFinancialAccountInput!"
                    ]
                }
            ],
            "financeGenerateCheckPdf": [
                574,
                {
                    "paymentIds": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "financeGenerateNachaFile": [
                582,
                {
                    "input": [
                        581,
                        "GenerateNachaFileInput!"
                    ]
                }
            ],
            "financeInvoiceCreate": [
                713,
                {
                    "input": [
                        319,
                        "CreateInvoiceInput!"
                    ]
                }
            ],
            "financeInvoiceMarkAsPaid": [
                713,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financeInvoiceUpdate": [
                713,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1337,
                        "UpdateInvoiceInput!"
                    ]
                }
            ],
            "financeInvoiceVoid": [
                713,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financeInvoiceWriteOff": [
                911,
                {
                    "input": [
                        1442,
                        "WriteOffInvoiceInput!"
                    ]
                }
            ],
            "financeNetPay": [
                843,
                {
                    "input": [
                        842,
                        "NetPayForAccountInput!"
                    ]
                }
            ],
            "financeNextBillDocumentNumber": [
                1199
            ],
            "financeNextInvoiceDocumentNumber": [
                1199
            ],
            "financeNextPaymentDocumentNumber": [
                1199
            ],
            "financePayBill": [
                910,
                {
                    "input": [
                        908,
                        "PayBillInput!"
                    ]
                }
            ],
            "financePaymentApplyToBill": [
                911,
                {
                    "input": [
                        43,
                        "ApplyPaymentToBillInput!"
                    ]
                }
            ],
            "financePaymentApplyToInvoice": [
                911,
                {
                    "input": [
                        44,
                        "ApplyPaymentToInvoiceInput!"
                    ]
                }
            ],
            "financePaymentCreate": [
                911,
                {
                    "input": [
                        323,
                        "CreatePaymentInput!"
                    ]
                }
            ],
            "financePaymentPost": [
                911,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financePaymentRemoveFromBill": [
                911,
                {
                    "billId": [
                        607,
                        "ID!"
                    ],
                    "paymentId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financePaymentRemoveFromInvoice": [
                911,
                {
                    "invoiceId": [
                        607,
                        "ID!"
                    ],
                    "paymentId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financePaymentTermConfigCreate": [
                921,
                {
                    "input": [
                        923,
                        "PaymentTermConfigInput!"
                    ]
                }
            ],
            "financePaymentTermConfigDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financePaymentTermConfigUpdate": [
                921,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        926,
                        "PaymentTermConfigUpdateInput!"
                    ]
                }
            ],
            "financePaymentUpdate": [
                911,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1340,
                        "UpdatePaymentInput!"
                    ]
                }
            ],
            "financePaymentVoid": [
                911,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financePaymentsConfirm": [
                152,
                {
                    "input": [
                        254,
                        "ConfirmPaymentsInput!"
                    ]
                }
            ],
            "financePaymentsUnconfirm": [
                152,
                {
                    "input": [
                        1306,
                        "UnconfirmPaymentsInput!"
                    ]
                }
            ],
            "financePositivePayTemplateCreate": [
                952,
                {
                    "input": [
                        954,
                        "PositivePayTemplateInput!"
                    ]
                }
            ],
            "financePositivePayTemplateDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financePositivePayTemplateUpdate": [
                952,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        957,
                        "PositivePayTemplateUpdateInput!"
                    ]
                }
            ],
            "financeReceiveInvoice": [
                1042,
                {
                    "input": [
                        1040,
                        "ReceiveInvoiceInput!"
                    ]
                }
            ],
            "financeReconcileCashDrawer": [
                1046,
                {
                    "input": [
                        1045,
                        "ReconcileCashDrawerInput!"
                    ]
                }
            ],
            "financeVoucherTemplateCreate": [
                1406,
                {
                    "input": [
                        1408,
                        "VoucherTemplateInput!"
                    ]
                }
            ],
            "financeVoucherTemplateDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financeVoucherTemplateUpdate": [
                1406,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1411,
                        "VoucherTemplateUpdateInput!"
                    ]
                }
            ],
            "integrationsPlaidCreateLinkToken": [
                941
            ],
            "integrationsPlaidExchangePublicToken": [
                939,
                {
                    "publicToken": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "integrationsSemaphorGenerateToken": [
                1129
            ],
            "integrationsWarehouseCredentialCreate": [
                1418,
                {
                    "input": [
                        348,
                        "CreateWarehouseCredentialInput!"
                    ],
                    "password": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "integrationsWarehouseCredentialDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "integrationsWarehouseCredentialUpdate": [
                1418,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1365,
                        "UpdateWarehouseCredentialInput!"
                    ],
                    "password": [
                        1199
                    ]
                }
            ],
            "inventoryCategoryCreate": [
                175,
                {
                    "input": [
                        177,
                        "CategoryInput!"
                    ]
                }
            ],
            "inventoryCategoryDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryCategoryUpdate": [
                175,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        180,
                        "CategoryUpdateInput!"
                    ]
                }
            ],
            "inventoryCycleCountScheduleActivate": [
                378,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryCycleCountScheduleCreate": [
                378,
                {
                    "input": [
                        380,
                        "CycleCountScheduleInput!"
                    ]
                }
            ],
            "inventoryCycleCountScheduleDeactivate": [
                378,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryCycleCountScheduleDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryCycleCountScheduleUpdate": [
                378,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        383,
                        "CycleCountScheduleUpdateInput!"
                    ]
                }
            ],
            "inventoryCycleCountTaskApprove": [
                385,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryCycleCountTaskCancel": [
                385,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "reason": [
                        1199
                    ]
                }
            ],
            "inventoryCycleCountTaskComplete": [
                385,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryCycleCountTaskCreate": [
                385,
                {
                    "input": [
                        387,
                        "CycleCountTaskInput!"
                    ]
                }
            ],
            "inventoryCycleCountTaskDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryCycleCountTaskFreeze": [
                385,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryCycleCountTaskReopen": [
                385,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryCycleCountTaskStart": [
                385,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryCycleCountTaskUnfreeze": [
                385,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryCycleCountTaskUpdate": [
                385,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        390,
                        "CycleCountTaskUpdateInput!"
                    ]
                }
            ],
            "inventoryFacilitySettingsUpdate": [
                633,
                {
                    "facilityId": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        638,
                        "InventoryFacilitySettingsUpdateInput!"
                    ]
                }
            ],
            "inventoryInventoryAccountProvisionFacilityAccounts": [
                985,
                {
                    "facilityId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryInventoryPeriodArchive": [
                675,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryInventoryPeriodConfigCreate": [
                682,
                {
                    "input": [
                        684,
                        "InventoryPeriodConfigInput!"
                    ]
                }
            ],
            "inventoryInventoryPeriodConfigUpdate": [
                682,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        687,
                        "InventoryPeriodConfigUpdateInput!"
                    ]
                }
            ],
            "inventoryInventoryPeriodCreate": [
                675,
                {
                    "input": [
                        689,
                        "InventoryPeriodInput!"
                    ]
                }
            ],
            "inventoryInventoryPeriodDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryInventoryPeriodLock": [
                675,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryInventoryPeriodUnlock": [
                675,
                {
                    "expiresAt": [
                        1446
                    ],
                    "id": [
                        607,
                        "ID!"
                    ],
                    "reason": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "inventoryInventoryPeriodUpdate": [
                675,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        692,
                        "InventoryPeriodUpdateInput!"
                    ]
                }
            ],
            "inventoryInventoryTagCreate": [
                693,
                {
                    "input": [
                        698,
                        "InventoryTagInput!"
                    ]
                }
            ],
            "inventoryInventoryTagDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryInventoryTagUpdate": [
                693,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        702,
                        "InventoryTagUpdateInput!"
                    ]
                }
            ],
            "inventoryInventoryZoneArchive": [
                706,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryInventoryZoneClose": [
                706,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryInventoryZoneCreate": [
                706,
                {
                    "input": [
                        708,
                        "InventoryZoneInput!"
                    ]
                }
            ],
            "inventoryInventoryZoneDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryInventoryZoneUpdate": [
                706,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        711,
                        "InventoryZoneUpdateInput!"
                    ]
                }
            ],
            "inventoryItemCreate": [
                727,
                {
                    "input": [
                        742,
                        "ItemInput!"
                    ]
                }
            ],
            "inventoryItemDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryItemGroupCreate": [
                736,
                {
                    "input": [
                        738,
                        "ItemGroupInput!"
                    ]
                }
            ],
            "inventoryItemGroupDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryItemGroupUpdate": [
                736,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        741,
                        "ItemGroupUpdateInput!"
                    ]
                }
            ],
            "inventoryItemUpdate": [
                727,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        769,
                        "ItemUpdateInput!"
                    ]
                }
            ],
            "inventoryLotAllocate": [
                647,
                {
                    "input": [
                        646,
                        "InventoryLotAllocateInput!"
                    ]
                }
            ],
            "inventoryLotCreate": [
                645,
                {
                    "input": [
                        651,
                        "InventoryLotCreateInput!"
                    ]
                }
            ],
            "inventoryLotCreateFromMovements": [
                650,
                {
                    "input": [
                        649,
                        "InventoryLotCreateFromMovementsInput!"
                    ]
                }
            ],
            "inventoryLotDeallocate": [
                619,
                {
                    "input": [
                        652,
                        "InventoryLotDeallocateInput!"
                    ]
                }
            ],
            "inventoryLotMerge": [
                656,
                {
                    "input": [
                        655,
                        "InventoryLotMergeInput!"
                    ]
                }
            ],
            "inventoryLotSplit": [
                660,
                {
                    "input": [
                        659,
                        "InventoryLotSplitInput!"
                    ]
                }
            ],
            "inventoryLotUpdate": [
                645,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        661,
                        "InventoryLotUpdateInput!"
                    ]
                }
            ],
            "inventoryTagAllocate": [
                695,
                {
                    "input": [
                        694,
                        "InventoryTagAllocateInput!"
                    ]
                }
            ],
            "inventoryTagDeallocate": [
                619,
                {
                    "input": [
                        696,
                        "InventoryTagDeallocateInput!"
                    ]
                }
            ],
            "inventoryTagNumberFormatUpdate": [
                137,
                {
                    "format": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "inventoryTagNumberReset": [
                137,
                {
                    "nextNumber": [
                        619,
                        "Int!"
                    ]
                }
            ],
            "inventoryTagUntag": [
                693,
                {
                    "input": [
                        1314,
                        "UntagInventoryTagInput!"
                    ]
                }
            ],
            "iotCameraCreate": [
                170,
                {
                    "input": [
                        302,
                        "CreateCameraInput!"
                    ]
                }
            ],
            "iotCameraDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "iotCameraSetCredentials": [
                170,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "password": [
                        1199,
                        "String!"
                    ],
                    "username": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "iotCameraUpdate": [
                170,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1326,
                        "UpdateCameraInput!"
                    ]
                }
            ],
            "iotPrinterCreate": [
                963,
                {
                    "input": [
                        324,
                        "CreatePrinterInput!"
                    ]
                }
            ],
            "iotPrinterDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "iotPrinterUpdate": [
                963,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1341,
                        "UpdatePrinterInput!"
                    ]
                }
            ],
            "iotScaleCreate": [
                1113,
                {
                    "input": [
                        335,
                        "CreateScaleInput!"
                    ]
                }
            ],
            "iotScaleDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "iotScaleUpdate": [
                1113,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1352,
                        "UpdateScaleInput!"
                    ]
                }
            ],
            "iotScannerCreate": [
                1121,
                {
                    "input": [
                        336,
                        "CreateScannerInput!"
                    ]
                }
            ],
            "iotScannerDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "iotScannerUpdate": [
                1121,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1353,
                        "UpdateScannerInput!"
                    ]
                }
            ],
            "iotSidecarAssignFacility": [
                1181,
                {
                    "facilityId": [
                        607,
                        "ID!"
                    ],
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "iotSidecarCreate": [
                1181,
                {
                    "input": [
                        341,
                        "CreateSidecarInput!"
                    ]
                }
            ],
            "iotSidecarDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "iotSidecarRegister": [
                1181,
                {
                    "facilityId": [
                        607,
                        "ID!"
                    ],
                    "name": [
                        1199
                    ],
                    "operatingSystem": [
                        1183
                    ],
                    "operatingSystemVersion": [
                        1199
                    ],
                    "publicKey": [
                        1199,
                        "String!"
                    ],
                    "sidecarId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "iotSidecarTriggerUpdateCheck": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "iotSidecarUpdate": [
                1181,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1357,
                        "UpdateSidecarInput!"
                    ]
                }
            ],
            "notificationArchive": [
                137,
                {
                    "ids": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "notificationDeviceRegister": [
                850,
                {
                    "input": [
                        853,
                        "NotificationDeviceRegisterInput!"
                    ]
                }
            ],
            "notificationMarkAllAsRead": [
                137,
                {
                    "channel": [
                        1199
                    ]
                }
            ],
            "notificationMarkAsRead": [
                137,
                {
                    "ids": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "notificationMarkAsSeen": [
                137,
                {
                    "ids": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "notificationPreferencesUpdate": [
                862,
                {
                    "input": [
                        863,
                        "[NotificationPreferenceBulkInput!]!"
                    ]
                }
            ],
            "presenceAnnounce": [
                137,
                {
                    "metadata": [
                        828,
                        "Map!"
                    ],
                    "room": [
                        1199,
                        "String!"
                    ],
                    "sessionId": [
                        1199
                    ]
                }
            ],
            "pricingCounterpartyGroupAddAccounts": [
                137,
                {
                    "accountIds": [
                        607,
                        "[ID!]!"
                    ],
                    "groupId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingCounterpartyGroupBulkDelete": [
                619,
                {
                    "ids": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "pricingCounterpartyGroupCreate": [
                279,
                {
                    "input": [
                        281,
                        "CounterpartyGroupInput!"
                    ]
                }
            ],
            "pricingCounterpartyGroupDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingCounterpartyGroupRemoveAccounts": [
                137,
                {
                    "accountIds": [
                        607,
                        "[ID!]!"
                    ],
                    "groupId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingCounterpartyGroupUpdate": [
                279,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        290,
                        "CounterpartyGroupUpdateInput!"
                    ]
                }
            ],
            "pricingCustomPriceListAddItemPricing": [
                755,
                {
                    "customPriceListId": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        758,
                        "ItemPricingInput!"
                    ]
                }
            ],
            "pricingCustomPriceListArchive": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingCustomPriceListBatchUpdateItemPricings": [
                755,
                {
                    "customPriceListId": [
                        607,
                        "ID!"
                    ],
                    "items": [
                        109,
                        "[BatchItemPricingUpdateItem!]!"
                    ]
                }
            ],
            "pricingCustomPriceListCopyFrom": [
                755,
                {
                    "sourceCustomPriceListId": [
                        607
                    ],
                    "sourceDefaultPriceListId": [
                        607
                    ],
                    "targetCustomPriceListId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingCustomPriceListDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingCustomPriceListDeleteItemPricing": [
                137,
                {
                    "itemPricingId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingCustomPriceListDraft": [
                359,
                {
                    "input": [
                        360,
                        "CustomPriceListDraftInput!"
                    ]
                }
            ],
            "pricingCustomPriceListDuplicate": [
                359,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "name": [
                        1199
                    ]
                }
            ],
            "pricingCustomPriceListImportFrom": [
                755,
                {
                    "itemPricingIds": [
                        607,
                        "[ID!]!"
                    ],
                    "targetCustomPriceListId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingCustomPriceListPublish": [
                359,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingCustomPriceListReorderItemPricings": [
                137,
                {
                    "customPriceListId": [
                        607,
                        "ID!"
                    ],
                    "itemPricingIds": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "pricingCustomPriceListUnarchive": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingCustomPriceListUpdate": [
                359,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        366,
                        "CustomPriceListUpdateInput!"
                    ]
                }
            ],
            "pricingCustomPriceListUpdateItemPricing": [
                755,
                {
                    "input": [
                        766,
                        "ItemPricingUpdateInput!"
                    ],
                    "itemPricingId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingDefaultPriceListAddItemPricing": [
                755,
                {
                    "input": [
                        758,
                        "ItemPricingInput!"
                    ],
                    "priceListId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingDefaultPriceListBatchUpdateItemPricings": [
                755,
                {
                    "items": [
                        109,
                        "[BatchItemPricingUpdateItem!]!"
                    ],
                    "priceListId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingDefaultPriceListCopyFrom": [
                755,
                {
                    "sourceCustomPriceListId": [
                        607
                    ],
                    "sourceDefaultPriceListId": [
                        607
                    ],
                    "targetDefaultPriceListId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingDefaultPriceListDeleteItemPricing": [
                137,
                {
                    "itemPricingId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingDefaultPriceListGetOrCreate": [
                403,
                {
                    "currency": [
                        1199,
                        "String!"
                    ],
                    "facilityId": [
                        607,
                        "ID!"
                    ],
                    "operationType": [
                        886,
                        "OperationType!"
                    ]
                }
            ],
            "pricingDefaultPriceListImportFrom": [
                755,
                {
                    "itemPricingIds": [
                        607,
                        "[ID!]!"
                    ],
                    "targetDefaultPriceListId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingDefaultPriceListReorderItemPricings": [
                137,
                {
                    "itemPricingIds": [
                        607,
                        "[ID!]!"
                    ],
                    "priceListId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingDefaultPriceListUpdate": [
                403,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        408,
                        "DefaultPriceListUpdateInput!"
                    ]
                }
            ],
            "pricingDefaultPriceListUpdateItemPricing": [
                755,
                {
                    "input": [
                        766,
                        "ItemPricingUpdateInput!"
                    ],
                    "itemPricingId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingDefaultPriceListUpdateNotes": [
                403,
                {
                    "notes": [
                        1199
                    ],
                    "priceListId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingGeneratePriceListDocument": [
                585,
                {
                    "input": [
                        584,
                        "GeneratePriceListDocumentInput!"
                    ]
                }
            ],
            "pricingItemPriceConfigurationSet": [
                749,
                {
                    "input": [
                        751,
                        "ItemPriceConfigurationInput!"
                    ]
                }
            ],
            "pricingItemPriceConfigurationUpdate": [
                749,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        754,
                        "ItemPriceConfigurationUpdateInput!"
                    ]
                }
            ],
            "pricingNotifyPriceList": [
                1132,
                {
                    "input": [
                        1131,
                        "SendPriceListNotificationInput!"
                    ]
                }
            ],
            "pricingVariableCreate": [
                1392,
                {
                    "input": [
                        1394,
                        "VariableInput!"
                    ]
                }
            ],
            "pricingVariableDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingVariableUpdate": [
                1398,
                {
                    "effectiveAt": [
                        1446
                    ],
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1397,
                        "VariableUpdateInput!"
                    ]
                }
            ],
            "productionInboundTollingAgreementCreate": [
                609,
                {
                    "input": [
                        611,
                        "InboundTollingAgreementInput!"
                    ]
                }
            ],
            "productionInboundTollingAgreementDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "productionInboundTollingAgreementUpdate": [
                609,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        614,
                        "InboundTollingAgreementUpdateInput!"
                    ]
                }
            ],
            "productionOutboundTollingAgreementCreate": [
                894,
                {
                    "input": [
                        896,
                        "OutboundTollingAgreementInput!"
                    ]
                }
            ],
            "productionOutboundTollingAgreementDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "productionOutboundTollingAgreementUpdate": [
                894,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        899,
                        "OutboundTollingAgreementUpdateInput!"
                    ]
                }
            ],
            "productionProcessingTypeCreate": [
                971,
                {
                    "input": [
                        973,
                        "ProcessingTypeInput!"
                    ]
                }
            ],
            "productionProcessingTypeDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "productionProcessingTypeUpdate": [
                971,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        984,
                        "ProcessingTypeUpdateInput!"
                    ]
                }
            ],
            "productionTollReceiptCreate": [
                1252,
                {
                    "input": [
                        1254,
                        "TollReceiptInput!"
                    ]
                }
            ],
            "productionTollReceiptUpdate": [
                1252,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1262,
                        "TollReceiptUpdateInput!"
                    ]
                }
            ],
            "productionTollShipmentCreate": [
                1263,
                {
                    "input": [
                        1265,
                        "TollShipmentInput!"
                    ]
                }
            ],
            "productionTollShipmentUpdate": [
                1263,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1273,
                        "TollShipmentUpdateInput!"
                    ]
                }
            ],
            "productionWorkOrderAllocateCosts": [
                1427,
                {
                    "workOrderId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "productionWorkOrderCalculateQuantities": [
                1427,
                {
                    "input": [
                        164,
                        "CalculateWorkOrderQuantitiesInput!"
                    ]
                }
            ],
            "productionWorkOrderCancel": [
                1427,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "reason": [
                        1199
                    ]
                }
            ],
            "productionWorkOrderComplete": [
                1427,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "productionWorkOrderCompleteWithActuals": [
                1427,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        191,
                        "CompleteWorkOrderWithActualsInput!"
                    ]
                }
            ],
            "productionWorkOrderCreate": [
                1427,
                {
                    "input": [
                        1429,
                        "WorkOrderInput!"
                    ]
                }
            ],
            "productionWorkOrderDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "productionWorkOrderOpen": [
                1427,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "productionWorkOrderStart": [
                1427,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "productionWorkOrderUpdate": [
                1427,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1441,
                        "WorkOrderUpdateInput!"
                    ]
                }
            ],
            "setDefaultPhotoRequirements": [
                401,
                {
                    "photoRequirements": [
                        402,
                        "[DefaultPhotoRequirementInput!]!"
                    ]
                }
            ],
            "tradeBookingBulkVoid": [
                156,
                {
                    "input": [
                        155,
                        "BulkVoidBookingInput!"
                    ]
                }
            ],
            "tradeBookingComplete": [
                123,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeBookingCreate": [
                123,
                {
                    "input": [
                        129,
                        "BookingInput!"
                    ]
                }
            ],
            "tradeBookingCreateDraft": [
                123,
                {
                    "input": [
                        437,
                        "DraftBookingInput!"
                    ]
                }
            ],
            "tradeBookingDelete": [
                416,
                {
                    "forceUnlink": [
                        137
                    ],
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeBookingFileCreate": [
                126,
                {
                    "bookingId": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        127,
                        "BookingFileInput!"
                    ]
                }
            ],
            "tradeBookingLoadsReceive": [
                772,
                {
                    "bookingId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeBookingLoadsReconcile": [
                772,
                {
                    "bookingId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeBookingNextDocumentNumber": [
                1199,
                {
                    "facilityId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeBookingOpen": [
                123,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeBookingSalesOrderDelete": [
                137,
                {
                    "bookingId": [
                        607,
                        "ID!"
                    ],
                    "salesOrderId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeBookingShip": [
                123,
                {
                    "input": [
                        1278,
                        "TradeBookingShipInput!"
                    ]
                }
            ],
            "tradeBookingUpdate": [
                136,
                {
                    "forceUnlink": [
                        137
                    ],
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        135,
                        "BookingUpdateInput!"
                    ]
                }
            ],
            "tradeBookingUpdateDraft": [
                123,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        438,
                        "DraftBookingUpdateInput!"
                    ]
                }
            ],
            "tradeBookingVoid": [
                1403,
                {
                    "forceUnlink": [
                        137
                    ],
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeBrokeredOrderClose": [
                138,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeBrokeredOrderCreate": [
                138,
                {
                    "input": [
                        140,
                        "BrokeredOrderInput!"
                    ]
                }
            ],
            "tradeBrokeredOrderDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeBrokeredOrderFulfill": [
                138,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeBrokeredOrderInProgress": [
                138,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeBrokeredOrderLinkOrders": [
                138,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        771,
                        "LinkBrokeredOrdersInput!"
                    ]
                }
            ],
            "tradeBrokeredOrderOpen": [
                138,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeBrokeredOrderUpdate": [
                138,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        148,
                        "BrokeredOrderUpdateInput!"
                    ]
                }
            ],
            "tradeBrokeredOrderVoid": [
                138,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeComplianceCheckOverride": [
                192,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        195,
                        "ComplianceCheckOverrideInput!"
                    ]
                }
            ],
            "tradeComplianceCheckUpdate": [
                192,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        200,
                        "ComplianceCheckUpdateInput!"
                    ]
                }
            ],
            "tradeComplianceHoldExtend": [
                223,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        226,
                        "ComplianceHoldExtendInput!"
                    ]
                }
            ],
            "tradeComplianceHoldFlagPolice": [
                223,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        228,
                        "ComplianceHoldFlagPoliceInput!"
                    ]
                }
            ],
            "tradeComplianceHoldRelease": [
                223,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        230,
                        "ComplianceHoldReleaseInput!"
                    ]
                }
            ],
            "tradeComplianceHoldUpdate": [
                223,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        234,
                        "ComplianceHoldUpdateInput!"
                    ]
                }
            ],
            "tradeContainerArriveAtFacility": [
                260,
                {
                    "containerNumber": [
                        1199
                    ],
                    "facilityId": [
                        607,
                        "ID!"
                    ],
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeContainerBatchCreate": [
                260,
                {
                    "input": [
                        261,
                        "ContainerBatchCreateInput!"
                    ]
                }
            ],
            "tradeContainerCreate": [
                260,
                {
                    "input": [
                        263,
                        "ContainerInput!"
                    ]
                }
            ],
            "tradeContainerDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeContainerDepartFacility": [
                260,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeContainerLoad": [
                260,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "loadId": [
                        607,
                        "ID!"
                    ],
                    "sealNumber": [
                        1199
                    ]
                }
            ],
            "tradeContainerPickup": [
                260,
                {
                    "containerNumber": [
                        1199
                    ],
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeContainerReturnToPort": [
                260,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeContainerRevertStatus": [
                260,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "targetStatus": [
                        266,
                        "ContainerStatus!"
                    ]
                }
            ],
            "tradeContainerRoll": [
                260,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "newBookingId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeContainerShip": [
                260,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeContainerUnload": [
                260,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeContainerUpdate": [
                260,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        272,
                        "ContainerUpdateInput!"
                    ]
                }
            ],
            "tradeContainerVoid": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeDeductionTypeCreate": [
                395,
                {
                    "input": [
                        397,
                        "DeductionTypeInput!"
                    ]
                }
            ],
            "tradeDeductionTypeDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeDeductionTypeUpdate": [
                395,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        400,
                        "DeductionTypeUpdateInput!"
                    ]
                }
            ],
            "tradeFileConfirmUpload": [
                494,
                {
                    "fileId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeFileDelete": [
                137,
                {
                    "fileId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeFileGenerateDownloadUrl": [
                1199,
                {
                    "expirySeconds": [
                        619
                    ],
                    "fileId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeGenerateDocument": [
                577,
                {
                    "input": [
                        575,
                        "GenerateDocumentInput!"
                    ]
                }
            ],
            "tradeGenerateDocumentsAndSendEmail": [
                579,
                {
                    "input": [
                        578,
                        "GenerateDocumentsAndSendEmailInput!"
                    ]
                }
            ],
            "tradeItemAliasCreate": [
                728,
                {
                    "input": [
                        730,
                        "ItemAliasInput!"
                    ]
                }
            ],
            "tradeItemAliasDelete": [
                416,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeItemAliasUpdate": [
                728,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        734,
                        "ItemAliasUpdateInput!"
                    ]
                }
            ],
            "tradeLoadAssign": [
                772,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeLoadBulkVoid": [
                158,
                {
                    "input": [
                        157,
                        "BulkVoidLoadInput!"
                    ]
                }
            ],
            "tradeLoadContainerAtFacility": [
                772,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeLoadContainerAtPort": [
                772,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeLoadContainerInTransit": [
                772,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeLoadContainerLoaded": [
                772,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeLoadContainerReadyToShip": [
                772,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeLoadContainerReturning": [
                772,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeLoadCreate": [
                772,
                {
                    "input": [
                        781,
                        "LoadInput!"
                    ]
                }
            ],
            "tradeLoadCustomerFileCreate": [
                774,
                {
                    "input": [
                        775,
                        "LoadCustomerFileInput!"
                    ],
                    "loadId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeLoadDeductionCreate": [
                776,
                {
                    "input": [
                        321,
                        "CreateLoadDeductionInput!"
                    ]
                }
            ],
            "tradeLoadDeductionDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeLoadDeductionUpdate": [
                776,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1338,
                        "UpdateLoadDeductionInput!"
                    ]
                }
            ],
            "tradeLoadDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeLoadNextDocumentNumber": [
                1199
            ],
            "tradeLoadPhotoCreate": [
                785,
                {
                    "input": [
                        786,
                        "LoadPhotoInput!"
                    ],
                    "loadId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeLoadPhotoUpdate": [
                494,
                {
                    "fileId": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        787,
                        "LoadPhotoUpdateInput!"
                    ]
                }
            ],
            "tradeLoadReceive": [
                772,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "receivedDate": [
                        168
                    ],
                    "receivedLineItems": [
                        1044,
                        "[ReceivedLineItemInput!]"
                    ],
                    "reviewed": [
                        137
                    ]
                }
            ],
            "tradeLoadReconcile": [
                772,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "invoiceId": [
                        607
                    ],
                    "items": [
                        784,
                        "[LoadLineItemReconcileInput!]"
                    ]
                }
            ],
            "tradeLoadReconciliationFileCreate": [
                789,
                {
                    "input": [
                        790,
                        "LoadReconciliationFileInput!"
                    ],
                    "reconciliationId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeLoadRecyclerFileCreate": [
                793,
                {
                    "input": [
                        794,
                        "LoadRecyclerFileInput!"
                    ],
                    "loadId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeLoadRevertStatus": [
                772,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "targetStatus": [
                        798,
                        "LoadStatus!"
                    ]
                }
            ],
            "tradeLoadReview": [
                772,
                {
                    "input": [
                        796,
                        "LoadReviewInput!"
                    ]
                }
            ],
            "tradeLoadShip": [
                772,
                {
                    "heavyWeight": [
                        1426
                    ],
                    "id": [
                        607,
                        "ID!"
                    ],
                    "lightWeight": [
                        1426
                    ],
                    "shippedDate": [
                        1446
                    ]
                }
            ],
            "tradeLoadUpdate": [
                801,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        800,
                        "LoadUpdateInput!"
                    ]
                }
            ],
            "tradeLoadVoid": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "voidReason": [
                        1199
                    ]
                }
            ],
            "tradeLocationFreightPricingCreate": [
                804,
                {
                    "input": [
                        806,
                        "LocationFreightPricingInput!"
                    ]
                }
            ],
            "tradeLocationFreightPricingDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeLocationFreightPricingUpdate": [
                804,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        809,
                        "LocationFreightPricingUpdateInput!"
                    ]
                }
            ],
            "tradePurchaseLoadCompleteInventory": [
                987,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradePurchaseLoadCompletePrice": [
                987,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradePurchaseLoadCreate": [
                987,
                {
                    "input": [
                        995,
                        "PurchaseLoadInput!"
                    ]
                }
            ],
            "tradePurchaseLoadDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradePurchaseLoadFileCreate": [
                992,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        993,
                        "PurchaseLoadFileInput!"
                    ]
                }
            ],
            "tradePurchaseLoadHold": [
                987,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradePurchaseLoadPay": [
                987,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradePurchaseLoadRelease": [
                987,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradePurchaseLoadRevertStatus": [
                987,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "targetStatus": [
                        1006,
                        "PurchaseLoadStatus!"
                    ]
                }
            ],
            "tradePurchaseLoadUpdate": [
                987,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1007,
                        "PurchaseLoadUpdateInput!"
                    ]
                }
            ],
            "tradePurchaseLoadVoid": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "voidReason": [
                        1199
                    ]
                }
            ],
            "tradePurchaseOrderClose": [
                1008,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "notes": [
                        1199
                    ]
                }
            ],
            "tradePurchaseOrderCreate": [
                1008,
                {
                    "input": [
                        330,
                        "CreatePurchaseOrderInput!"
                    ]
                }
            ],
            "tradePurchaseOrderDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradePurchaseOrderFileCreate": [
                1009,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1010,
                        "PurchaseOrderFileInput!"
                    ]
                }
            ],
            "tradePurchaseOrderFreightCreate": [
                1012,
                {
                    "input": [
                        1014,
                        "PurchaseOrderFreightInput!"
                    ]
                }
            ],
            "tradePurchaseOrderFreightDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradePurchaseOrderFreightUpdate": [
                1012,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1017,
                        "PurchaseOrderFreightUpdateInput!"
                    ]
                }
            ],
            "tradePurchaseOrderNextDocumentNumber": [
                1199
            ],
            "tradePurchaseOrderOpen": [
                1008,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradePurchaseOrderReopen": [
                1008,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradePurchaseOrderUpdate": [
                1008,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1347,
                        "UpdatePurchaseOrderInput!"
                    ]
                }
            ],
            "tradePurchaseOrderVoid": [
                1008,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeQuoteAccept": [
                1028,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeQuoteClone": [
                1028,
                {
                    "accountIds": [
                        607,
                        "[ID!]!"
                    ],
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeQuoteConvert": [
                1028,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "orderId": [
                        607
                    ]
                }
            ],
            "tradeQuoteCreate": [
                1028,
                {
                    "input": [
                        1030,
                        "QuoteInput!"
                    ]
                }
            ],
            "tradeQuoteDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeQuoteNextDocumentNumber": [
                1199
            ],
            "tradeQuoteReject": [
                1028,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeQuoteRestore": [
                1028,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeQuoteRevertToOpen": [
                1028,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeQuoteSend": [
                1028,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeQuoteUpdate": [
                1028,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1039,
                        "QuoteUpdateInput!"
                    ]
                }
            ],
            "tradeQuoteVoid": [
                1028,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeReconciliationBatchUpdate": [
                788,
                {
                    "deductions": [
                        1048,
                        "[ReconciliationDeductionInput!]"
                    ],
                    "externalNotes": [
                        1199
                    ],
                    "freightCharges": [
                        541,
                        "[FreightChargeInput!]"
                    ],
                    "internalNotes": [
                        1199
                    ],
                    "invoiceId": [
                        607
                    ],
                    "invoiceType": [
                        1199
                    ],
                    "loadId": [
                        607,
                        "ID!"
                    ],
                    "loadReceivedDate": [
                        168
                    ],
                    "millReceivedWeightPostDate": [
                        168
                    ],
                    "receivedLineItems": [
                        1044,
                        "[ReceivedLineItemInput!]"
                    ],
                    "ticketIssueDate": [
                        168
                    ],
                    "ticketNumber": [
                        1199
                    ]
                }
            ],
            "tradeSalesOrderBulkVoid": [
                160,
                {
                    "input": [
                        159,
                        "BulkVoidSalesOrderInput!"
                    ]
                }
            ],
            "tradeSalesOrderClone": [
                1090,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeSalesOrderCreate": [
                1090,
                {
                    "input": [
                        1091,
                        "SalesOrderCreateInput!"
                    ]
                }
            ],
            "tradeSalesOrderCustomerFileCreate": [
                1092,
                {
                    "input": [
                        1093,
                        "SalesOrderCustomerFileInput!"
                    ],
                    "salesOrderId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeSalesOrderDelete": [
                416,
                {
                    "forceUnlink": [
                        137
                    ],
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeSalesOrderFileCreate": [
                1094,
                {
                    "input": [
                        1095,
                        "SalesOrderFileInput!"
                    ],
                    "salesOrderId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeSalesOrderFreightCreate": [
                1097,
                {
                    "input": [
                        1099,
                        "SalesOrderFreightInput!"
                    ]
                }
            ],
            "tradeSalesOrderFreightDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeSalesOrderFreightUpdate": [
                1097,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1102,
                        "SalesOrderFreightUpdateInput!"
                    ]
                }
            ],
            "tradeSalesOrderNextDocumentNumber": [
                1199
            ],
            "tradeSalesOrderRecyclerFileCreate": [
                1105,
                {
                    "input": [
                        1106,
                        "SalesOrderRecyclerFileInput!"
                    ],
                    "salesOrderId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeSalesOrderUpdate": [
                1112,
                {
                    "forceUnlink": [
                        137
                    ],
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1111,
                        "SalesOrderUpdateInput!"
                    ]
                }
            ],
            "tradeSalesOrderVoid": [
                1405,
                {
                    "forceUnlink": [
                        137
                    ],
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeTicketFreightCreate": [
                1241,
                {
                    "input": [
                        1243,
                        "TicketFreightInput!"
                    ]
                }
            ],
            "tradeTicketFreightDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeTicketFreightUpdate": [
                1241,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1246,
                        "TicketFreightUpdateInput!"
                    ]
                }
            ],
            "transportationAddHaulers": [
                137,
                {
                    "haulerIds": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "transportationAssetCreate": [
                54,
                {
                    "input": [
                        296,
                        "CreateAssetInput!"
                    ]
                }
            ],
            "transportationAssetDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationAssetLocationHistoryCreate": [
                57,
                {
                    "input": [
                        59,
                        "AssetLocationHistoryInput!"
                    ]
                }
            ],
            "transportationAssetLocationHistoryDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationAssetTypeCreate": [
                66,
                {
                    "input": [
                        297,
                        "CreateAssetTypeInput!"
                    ]
                }
            ],
            "transportationAssetTypeDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationAssetTypeUpdate": [
                66,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1321,
                        "UpdateAssetTypeInput!"
                    ]
                }
            ],
            "transportationAssetUpdate": [
                54,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1320,
                        "UpdateAssetInput!"
                    ]
                }
            ],
            "transportationAssetUpdateFacility": [
                54,
                {
                    "facilityId": [
                        607
                    ],
                    "ids": [
                        607,
                        "[ID!]!"
                    ],
                    "movementDate": [
                        1446,
                        "ZonedDateTime!"
                    ],
                    "status": [
                        65,
                        "AssetStatus!"
                    ]
                }
            ],
            "transportationContainerTypeCreate": [
                268,
                {
                    "input": [
                        304,
                        "CreateContainerTypeInput!"
                    ]
                }
            ],
            "transportationContainerTypeDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationContainerTypeUpdate": [
                268,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1328,
                        "UpdateContainerTypeInput!"
                    ]
                }
            ],
            "transportationDetentionCreate": [
                417,
                {
                    "input": [
                        419,
                        "DetentionInput!"
                    ]
                }
            ],
            "transportationDetentionDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationDetentionUpdate": [
                417,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        422,
                        "DetentionUpdateInput!"
                    ]
                }
            ],
            "transportationDriverCertificationCreate": [
                440,
                {
                    "input": [
                        309,
                        "CreateDriverCertificationInput!"
                    ]
                }
            ],
            "transportationDriverCertificationDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationDriverCertificationUpdate": [
                440,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1330,
                        "UpdateDriverCertificationInput!"
                    ]
                }
            ],
            "transportationDriverCreate": [
                439,
                {
                    "input": [
                        310,
                        "CreateDriverInput!"
                    ]
                }
            ],
            "transportationDriverDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationDriverUpdate": [
                439,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1331,
                        "UpdateDriverInput!"
                    ]
                }
            ],
            "transportationFileConfirmUpload": [
                494,
                {
                    "fileId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationFileDelete": [
                137,
                {
                    "fileId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationFreightForwarderCreate": [
                542,
                {
                    "input": [
                        544,
                        "FreightForwarderInput!"
                    ]
                }
            ],
            "transportationFreightForwarderDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationFreightForwarderUpdate": [
                542,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        547,
                        "FreightForwarderUpdateInput!"
                    ]
                }
            ],
            "transportationFreightLaneCostCreate": [
                549,
                {
                    "input": [
                        551,
                        "FreightLaneCostInput!"
                    ]
                }
            ],
            "transportationFreightLaneCostDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationFreightLaneCostUpdate": [
                549,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        554,
                        "FreightLaneCostUpdateInput!"
                    ]
                }
            ],
            "transportationFreightLaneCreate": [
                548,
                {
                    "input": [
                        556,
                        "FreightLaneInput!"
                    ]
                }
            ],
            "transportationFreightLaneDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationFreightLaneRouteCreate": [
                558,
                {
                    "input": [
                        560,
                        "FreightLaneRouteInput!"
                    ]
                }
            ],
            "transportationFreightLaneRouteDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationFreightLaneRouteUpdate": [
                558,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        563,
                        "FreightLaneRouteUpdateInput!"
                    ]
                }
            ],
            "transportationFreightLaneUpdate": [
                548,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        565,
                        "FreightLaneUpdateInput!"
                    ]
                }
            ],
            "transportationFreightLineCreate": [
                566,
                {
                    "input": [
                        568,
                        "FreightLineInput!"
                    ]
                }
            ],
            "transportationFreightLineDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationFreightLineUpdate": [
                566,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        571,
                        "FreightLineUpdateInput!"
                    ]
                }
            ],
            "transportationRemoveHaulers": [
                137,
                {
                    "haulerIds": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "transportationRouteAssign": [
                1066,
                {
                    "assignmentStatus": [
                        71,
                        "AssignmentStatus!"
                    ],
                    "driverId": [
                        607
                    ],
                    "estimatedArrival": [
                        1446
                    ],
                    "haulerId": [
                        607
                    ],
                    "id": [
                        607,
                        "ID!"
                    ],
                    "trailerId": [
                        607
                    ],
                    "truckId": [
                        607
                    ]
                }
            ],
            "transportationRouteCreate": [
                1066,
                {
                    "input": [
                        334,
                        "CreateRouteInput!"
                    ],
                    "isTemplate": [
                        137,
                        "Boolean!"
                    ],
                    "serviceIds": [
                        607,
                        "[ID!]"
                    ]
                }
            ],
            "transportationRouteDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationRouteFreightCreate": [
                1069,
                {
                    "input": [
                        1071,
                        "RouteFreightInput!"
                    ]
                }
            ],
            "transportationRouteFreightDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationRouteFreightUpdate": [
                1069,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1074,
                        "RouteFreightUpdateInput!"
                    ]
                }
            ],
            "transportationRouteTransition": [
                1066,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "notes": [
                        1199
                    ],
                    "status": [
                        1078,
                        "RouteStatus!"
                    ]
                }
            ],
            "transportationRouteUnassign": [
                1066,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationRouteUpdate": [
                1066,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1351,
                        "UpdateRouteInput!"
                    ],
                    "serviceIds": [
                        607,
                        "[ID!]"
                    ]
                }
            ],
            "transportationRouteValidationOverrideCreate": [
                1080,
                {
                    "input": [
                        1082,
                        "RouteValidationOverrideInput!"
                    ]
                }
            ],
            "transportationRouteValidationOverrideDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationRouteValidationOverrideUpdate": [
                1080,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1085,
                        "RouteValidationOverrideUpdateInput!"
                    ]
                }
            ],
            "transportationServiceAssign": [
                1133,
                {
                    "input": [
                        1138,
                        "ServiceAssignInput!"
                    ]
                }
            ],
            "transportationServiceCreate": [
                1133,
                {
                    "input": [
                        337,
                        "CreateServiceInput!"
                    ]
                }
            ],
            "transportationServiceDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationServiceTransition": [
                1133,
                {
                    "input": [
                        1144,
                        "ServiceTransitionInput!"
                    ]
                }
            ],
            "transportationServiceTypeCreateWithDefinitions": [
                1145,
                {
                    "input": [
                        338,
                        "CreateServiceTypeWithDefinitionsInput!"
                    ]
                }
            ],
            "transportationServiceTypeTaskDefinitionCreate": [
                1150,
                {
                    "input": [
                        1153,
                        "ServiceTypeTaskDefinitionInput!"
                    ]
                }
            ],
            "transportationServiceTypeTaskDefinitionDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationServiceTypeTaskDefinitionUpdate": [
                1150,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1156,
                        "ServiceTypeTaskDefinitionUpdateInput!"
                    ]
                }
            ],
            "transportationServiceTypeUpdate": [
                1145,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1157,
                        "ServiceTypeUpdateInput!"
                    ]
                }
            ],
            "transportationServiceUnassign": [
                1133,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationServiceUpdate": [
                1133,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1354,
                        "UpdateServiceInput!"
                    ]
                }
            ],
            "transportationSetDriverDisplayOrder": [
                444,
                {
                    "driverId": [
                        607,
                        "ID!"
                    ],
                    "rank": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "transportationShippingCarrierCreate": [
                1175,
                {
                    "input": [
                        1177,
                        "ShippingCarrierInput!"
                    ]
                }
            ],
            "transportationShippingCarrierDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationShippingCarrierUpdate": [
                1175,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1180,
                        "ShippingCarrierUpdateInput!"
                    ]
                }
            ],
            "transportationTaskCancel": [
                1223,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationTaskPhotoCreate": [
                1226,
                {
                    "input": [
                        1227,
                        "TaskPhotoInput!"
                    ],
                    "taskId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationTaskTransition": [
                1223,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "reason": [
                        1199
                    ],
                    "status": [
                        1236,
                        "TaskStatus!"
                    ]
                }
            ],
            "transportationTrailerCreate": [
                1281,
                {
                    "input": [
                        344,
                        "CreateTrailerInput!"
                    ]
                }
            ],
            "transportationTrailerDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationTrailerUpdate": [
                1281,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1360,
                        "UpdateTrailerInput!"
                    ]
                }
            ],
            "transportationTransportationTypeCreate": [
                1291,
                {
                    "input": [
                        345,
                        "CreateTransportationTypeInput!"
                    ]
                }
            ],
            "transportationTransportationTypeDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationTransportationTypeUpdate": [
                1291,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1361,
                        "UpdateTransportationTypeInput!"
                    ]
                }
            ],
            "transportationTruckCreate": [
                1299,
                {
                    "input": [
                        346,
                        "CreateTruckInput!"
                    ]
                }
            ],
            "transportationTruckDelete": [
                137,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationTruckUpdate": [
                1299,
                {
                    "id": [
                        607,
                        "ID!"
                    ],
                    "input": [
                        1362,
                        "UpdateTruckInput!"
                    ]
                }
            ],
            "updateFacilityGeneralPreferences": [
                479,
                {
                    "input": [
                        1332,
                        "UpdateFacilityGeneralPreferencesInput!"
                    ]
                }
            ],
            "updateFacilitySalesPreferences": [
                487,
                {
                    "input": [
                        1333,
                        "UpdateFacilitySalesPreferencesInput!"
                    ]
                }
            ],
            "__typename": [
                1199
            ]
        },
        "NetPayForAccountInput": {
            "accountId": [
                607
            ],
            "achNumber": [
                1199
            ],
            "billIds": [
                607
            ],
            "checkAttn": [
                1199
            ],
            "checkFacilityId": [
                607
            ],
            "checkMemo": [
                1199
            ],
            "checkNumber": [
                1199
            ],
            "creatorId": [
                607
            ],
            "creatorPlatform": [
                351
            ],
            "financialAccountId": [
                607
            ],
            "invoiceIds": [
                607
            ],
            "paymentMethod": [
                916
            ],
            "transactionDate": [
                168
            ],
            "wireNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "NetPayResult": {
            "belowWarningThreshold": [
                137
            ],
            "netAmount": [
                835
            ],
            "payableTotal": [
                835
            ],
            "payment": [
                911
            ],
            "receivableTotal": [
                835
            ],
            "__typename": [
                1199
            ]
        },
        "Node": {
            "description": [
                1199
            ],
            "id": [
                607
            ],
            "label": [
                1199
            ],
            "position": [
                949
            ],
            "type": [
                848
            ],
            "on_ApprovalNode": [
                45
            ],
            "on_BusinessEventTriggerNode": [
                162
            ],
            "on_ConditionNode": [
                253
            ],
            "on_DelayNode": [
                409
            ],
            "on_EmailActionNode": [
                458
            ],
            "on_FilterNode": [
                513
            ],
            "on_HttpRequestActionNode": [
                604
            ],
            "on_HttpWebhookTriggerNode": [
                606
            ],
            "on_LoopNode": [
                811
            ],
            "on_ScheduleTriggerNode": [
                1127
            ],
            "on_SwitchNode": [
                1204
            ],
            "__typename": [
                1199
            ]
        },
        "NodeExecution": {
            "completedAt": [
                1446
            ],
            "durationMs": [
                619
            ],
            "errorMessage": [
                1199
            ],
            "input": [
                828
            ],
            "nodeId": [
                1199
            ],
            "nodeType": [
                1199
            ],
            "output": [
                828
            ],
            "startedAt": [
                1446
            ],
            "status": [
                846
            ],
            "__typename": [
                1199
            ]
        },
        "NodeExecutionStatus": {},
        "NodeInput": {
            "approvers": [
                52
            ],
            "bcc": [
                1199
            ],
            "body": [
                1199
            ],
            "bodyType": [
                1199
            ],
            "cases": [
                1203
            ],
            "cc": [
                1199
            ],
            "continueOnFail": [
                137
            ],
            "cronExpression": [
                1199
            ],
            "defaultLabel": [
                1199
            ],
            "delayType": [
                410
            ],
            "description": [
                1199
            ],
            "duration": [
                619
            ],
            "durationUnit": [
                455
            ],
            "eventType": [
                1199
            ],
            "expression": [
                1199
            ],
            "falseBranchLabel": [
                1199
            ],
            "filter": [
                828
            ],
            "headers": [
                828
            ],
            "id": [
                607
            ],
            "instructions": [
                1199
            ],
            "label": [
                1199
            ],
            "loopArrayExpression": [
                1199
            ],
            "loopItemVariableName": [
                1199
            ],
            "loopMaxIterations": [
                619
            ],
            "method": [
                603
            ],
            "position": [
                950
            ],
            "replyTo": [
                1199
            ],
            "requestBody": [
                1199
            ],
            "retryCount": [
                619
            ],
            "subject": [
                1199
            ],
            "timeout": [
                619
            ],
            "timeoutAction": [
                1248
            ],
            "timeoutDuration": [
                619
            ],
            "timeoutEnabled": [
                137
            ],
            "timeoutUnit": [
                1249
            ],
            "timezone": [
                1199
            ],
            "to": [
                1199
            ],
            "trueBranchLabel": [
                1199
            ],
            "type": [
                848
            ],
            "untilDateTime": [
                1199
            ],
            "untilExpression": [
                1199
            ],
            "url": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "NodeType": {},
        "Notification": {
            "actionLink": [
                1199
            ],
            "actorId": [
                607
            ],
            "body": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "eventId": [
                1199
            ],
            "id": [
                607
            ],
            "notificationTypeKey": [
                1199
            ],
            "resourceId": [
                1199
            ],
            "resourceType": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "title": [
                1199
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationDevice": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "deviceToken": [
                1199
            ],
            "id": [
                607
            ],
            "isActive": [
                137
            ],
            "platform": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationDeviceFilter": {
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationDeviceInput": {
            "deviceToken": [
                1199
            ],
            "isActive": [
                137
            ],
            "platform": [
                1199
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationDeviceRegisterInput": {
            "deviceToken": [
                1199
            ],
            "platform": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationDeviceResultPage": {
            "entries": [
                850
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationDeviceSortOption": {},
        "NotificationDeviceUpdateInput": {
            "deviceToken": [
                1199
            ],
            "isActive": [
                137
            ],
            "platform": [
                1199
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationFeedCursor": {
            "afterId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationFeedEntry": {
            "channel": [
                1199
            ],
            "id": [
                607
            ],
            "isArchived": [
                137
            ],
            "isRead": [
                137
            ],
            "isSeen": [
                137
            ],
            "notification": [
                849
            ],
            "readAt": [
                1446
            ],
            "seenAt": [
                1446
            ],
            "timestamps": [
                1250
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationFeedPage": {
            "entries": [
                858
            ],
            "hasMore": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationFilter": {
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationInput": {
            "actionLink": [
                1199
            ],
            "actorId": [
                607
            ],
            "body": [
                1199
            ],
            "eventId": [
                1199
            ],
            "notificationTypeKey": [
                1199
            ],
            "resourceId": [
                1199
            ],
            "resourceType": [
                1199
            ],
            "title": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationPreference": {
            "channel": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "enabled": [
                137
            ],
            "id": [
                607
            ],
            "notificationTypeKey": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationPreferenceBulkInput": {
            "channel": [
                1199
            ],
            "enabled": [
                137
            ],
            "notificationTypeKey": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationPreferenceFilter": {
            "channel": [
                1199
            ],
            "ids": [
                607
            ],
            "notificationTypeKey": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationPreferenceInput": {
            "channel": [
                1199
            ],
            "enabled": [
                137
            ],
            "notificationTypeKey": [
                1199
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationPreferenceResultPage": {
            "entries": [
                862
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationPreferenceSortOption": {},
        "NotificationPreferenceUpdateInput": {
            "channel": [
                1199
            ],
            "enabled": [
                137
            ],
            "notificationTypeKey": [
                1199
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationRecipient": {
            "channel": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "id": [
                607
            ],
            "isArchived": [
                137
            ],
            "isRead": [
                137
            ],
            "isSeen": [
                137
            ],
            "notificationId": [
                607
            ],
            "readAt": [
                1446
            ],
            "recipientId": [
                607
            ],
            "seenAt": [
                1446
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationRecipientFilter": {
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationRecipientInput": {
            "channel": [
                1199
            ],
            "isArchived": [
                137
            ],
            "isRead": [
                137
            ],
            "isSeen": [
                137
            ],
            "notificationId": [
                607
            ],
            "readAt": [
                1446
            ],
            "recipientId": [
                607
            ],
            "seenAt": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationRecipientResultPage": {
            "entries": [
                869
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationRecipientSortOption": {},
        "NotificationRecipientUpdateInput": {
            "channel": [
                1199
            ],
            "isArchived": [
                137
            ],
            "isRead": [
                137
            ],
            "isSeen": [
                137
            ],
            "notificationId": [
                607
            ],
            "readAt": [
                1446
            ],
            "recipientId": [
                607
            ],
            "seenAt": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationResultPage": {
            "entries": [
                849
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationSortOption": {},
        "NotificationType": {
            "bodyTemplate": [
                1199
            ],
            "category": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "defaultChannels": [
                828
            ],
            "icon": [
                1199
            ],
            "id": [
                607
            ],
            "isCritical": [
                137
            ],
            "key": [
                1199
            ],
            "requiredPermission": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "titleTemplate": [
                1199
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationTypeFilter": {
            "category": [
                1199
            ],
            "ids": [
                607
            ],
            "isCritical": [
                137
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationTypeInput": {
            "bodyTemplate": [
                1199
            ],
            "category": [
                1199
            ],
            "defaultChannels": [
                828
            ],
            "icon": [
                1199
            ],
            "isCritical": [
                137
            ],
            "key": [
                1199
            ],
            "requiredPermission": [
                1199
            ],
            "titleTemplate": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationTypeResultPage": {
            "entries": [
                877
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationTypeSortOption": {},
        "NotificationTypeUpdateInput": {
            "bodyTemplate": [
                1199
            ],
            "category": [
                1199
            ],
            "defaultChannels": [
                828
            ],
            "icon": [
                1199
            ],
            "isCritical": [
                137
            ],
            "key": [
                1199
            ],
            "requiredPermission": [
                1199
            ],
            "titleTemplate": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "NotificationUpdateInput": {
            "actionLink": [
                1199
            ],
            "actorId": [
                607
            ],
            "body": [
                1199
            ],
            "eventId": [
                1199
            ],
            "notificationTypeKey": [
                1199
            ],
            "resourceId": [
                1199
            ],
            "resourceType": [
                1199
            ],
            "title": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "OneTimeCodeExpired": {
            "pendingAuthenticationToken": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "Operation": {
            "description": [
                1199
            ],
            "inputSchema": [
                828
            ],
            "key": [
                1199
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "OperationType": {},
        "Organization": {
            "createdAt": [
                1446
            ],
            "customAttributes": [
                828
            ],
            "domain": [
                1199
            ],
            "entitlements": [
                1199
            ],
            "facilities": [
                470
            ],
            "facilityGroups": [
                480
            ],
            "id": [
                607
            ],
            "idpId": [
                1199
            ],
            "name": [
                1199
            ],
            "onboardedAt": [
                1446
            ],
            "timezone": [
                1251
            ],
            "updatedAt": [
                1446
            ],
            "users": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "OrganizationFilter": {
            "ids": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "OrganizationResetResult": {
            "newFacilityId": [
                607
            ],
            "newOrganizationId": [
                607
            ],
            "success": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "OrganizationResultPage": {
            "entries": [
                887
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "OrganizationSelectionError": {
            "organizations": [
                91
            ],
            "pendingAuthenticationToken": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "OrganizationSortOption": {},
        "OrphanedBookingSalesOrderLink": {
            "bookingId": [
                607
            ],
            "documentNumber": [
                1199
            ],
            "salesOrderId": [
                607
            ],
            "salesOrderNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "OutboundTollingAgreement": {
            "agreementNumber": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "effectiveDate": [
                168
            ],
            "expectedYieldPercentage": [
                393
            ],
            "expirationDate": [
                168
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "isActive": [
                137
            ],
            "pricePerUnit": [
                835
            ],
            "priceUnit": [
                1199
            ],
            "processingType": [
                971
            ],
            "processingTypeId": [
                607
            ],
            "processorAccount": [
                3
            ],
            "processorAccountId": [
                607
            ],
            "terms": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "OutboundTollingAgreementFilter": {
            "agreementNumber": [
                1199
            ],
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "fromEffectiveDate": [
                168
            ],
            "fromExpirationDate": [
                168
            ],
            "ids": [
                607
            ],
            "isActive": [
                137
            ],
            "priceUnit": [
                1199
            ],
            "processingTypeId": [
                607
            ],
            "processingTypeIds": [
                607
            ],
            "processorAccountId": [
                607
            ],
            "processorAccountIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "terms": [
                1199
            ],
            "toEffectiveDate": [
                168
            ],
            "toExpirationDate": [
                168
            ],
            "__typename": [
                1199
            ]
        },
        "OutboundTollingAgreementInput": {
            "agreementNumber": [
                1199
            ],
            "effectiveDate": [
                168
            ],
            "expectedYieldPercentage": [
                393
            ],
            "expirationDate": [
                168
            ],
            "facilityId": [
                607
            ],
            "isActive": [
                137
            ],
            "pricePerUnit": [
                836
            ],
            "priceUnit": [
                1199
            ],
            "processingTypeId": [
                607
            ],
            "processorAccountId": [
                607
            ],
            "terms": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "OutboundTollingAgreementResultPage": {
            "entries": [
                894
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "OutboundTollingAgreementSortOption": {},
        "OutboundTollingAgreementUpdateInput": {
            "agreementNumber": [
                1199
            ],
            "effectiveDate": [
                168
            ],
            "expectedYieldPercentage": [
                393
            ],
            "expirationDate": [
                168
            ],
            "facilityId": [
                607
            ],
            "isActive": [
                137
            ],
            "pricePerUnit": [
                836
            ],
            "priceUnit": [
                1199
            ],
            "processingTypeId": [
                607
            ],
            "processorAccountId": [
                607
            ],
            "terms": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "OutboxEvent": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "eventName": [
                1199
            ],
            "id": [
                607
            ],
            "lastRetry": [
                1446
            ],
            "metadata": [
                901
            ],
            "payload": [
                770
            ],
            "retryCount": [
                619
            ],
            "status": [
                903
            ],
            "timestamps": [
                1250
            ],
            "topic": [
                1199
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "version": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "OutboxEventMetadata": {
            "aggregateId": [
                1199
            ],
            "eventName": [
                1199
            ],
            "id": [
                607
            ],
            "occurredOn": [
                1446
            ],
            "organizationId": [
                607
            ],
            "topic": [
                1199
            ],
            "version": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "OutboxEventResultPage": {
            "entries": [
                900
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "OutboxEventStatus": {},
        "P2PRelayInfo": {
            "multiaddrs": [
                1199
            ],
            "peerId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "Page": {
            "limit": [
                619
            ],
            "offset": [
                619
            ],
            "total": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "PaginationInput": {
            "limit": [
                619
            ],
            "offset": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "PatchScopedSettingValuesInput": {
            "objectId": [
                607
            ],
            "scope": [
                1165
            ],
            "values": [
                41
            ],
            "__typename": [
                1199
            ]
        },
        "PayBillInput": {
            "accountId": [
                607
            ],
            "achNumber": [
                1199
            ],
            "bills": [
                909
            ],
            "checkAttn": [
                1199
            ],
            "checkFacilityId": [
                607
            ],
            "checkMemo": [
                1199
            ],
            "checkNumber": [
                1199
            ],
            "creatorId": [
                607
            ],
            "creatorPlatform": [
                351
            ],
            "financialAccountId": [
                607
            ],
            "paymentMethod": [
                916
            ],
            "transactionDate": [
                168
            ],
            "wireNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PayBillItemInput": {
            "appliedAmount": [
                836
            ],
            "billId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "PayBillResult": {
            "belowWarningThreshold": [
                137
            ],
            "payment": [
                911
            ],
            "totalDiscount": [
                835
            ],
            "__typename": [
                1199
            ]
        },
        "Payment": {
            "account": [
                3
            ],
            "achNumber": [
                1199
            ],
            "amount": [
                835
            ],
            "atmId": [
                1199
            ],
            "atmPaymentNumber": [
                1199
            ],
            "barcode": [
                1199
            ],
            "barcodeRowId": [
                619
            ],
            "bills": [
                117
            ],
            "checkAttn": [
                1199
            ],
            "checkFacilityId": [
                607
            ],
            "checkMemo": [
                1199
            ],
            "checkNumber": [
                1199
            ],
            "creatorId": [
                607
            ],
            "creatorPlatform": [
                351
            ],
            "documentNumber": [
                1199
            ],
            "financialAccount": [
                518
            ],
            "financialAccountId": [
                607
            ],
            "financialAccountTransaction": [
                528
            ],
            "financialAccountTransactionId": [
                607
            ],
            "id": [
                607
            ],
            "invoices": [
                720
            ],
            "paymentMethod": [
                916
            ],
            "paymentType": [
                927
            ],
            "status": [
                919
            ],
            "supplierPhotoId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "transactionDate": [
                168
            ],
            "unappliedAmount": [
                835
            ],
            "wireNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PaymentAllocationMethod": {},
        "PaymentApplicationType": {},
        "PaymentFilter": {
            "accountIDs": [
                607
            ],
            "currencyCode": [
                355
            ],
            "dateRange": [
                391
            ],
            "facilityIDs": [
                607
            ],
            "financialAccountIDs": [
                607
            ],
            "ids": [
                607
            ],
            "minUnappliedBalance": [
                393
            ],
            "paymentType": [
                916
            ],
            "searchTerm": [
                1199
            ],
            "status": [
                919
            ],
            "type": [
                927
            ],
            "__typename": [
                1199
            ]
        },
        "PaymentItemResult": {
            "error": [
                1199
            ],
            "paymentId": [
                607
            ],
            "success": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "PaymentMethod": {},
        "PaymentResultPage": {
            "entries": [
                911
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "PaymentSortOption": {},
        "PaymentStatus": {},
        "PaymentTerm": {},
        "PaymentTermConfig": {
            "code": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "dateDrivenDiscountPercentage": [
                393
            ],
            "discountDueBeforeDayOfMonth": [
                619
            ],
            "discountIfPaidWithinDays": [
                619
            ],
            "discountPercentage": [
                393
            ],
            "id": [
                607
            ],
            "isDateDriven": [
                137
            ],
            "isSystem": [
                137
            ],
            "name": [
                1199
            ],
            "netDueBeforeDayOfMonth": [
                619
            ],
            "netDueInDays": [
                619
            ],
            "nextMonthDueIfIssuedWithinDays": [
                619
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "PaymentTermConfigFilter": {
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "PaymentTermConfigInput": {
            "code": [
                1199
            ],
            "dateDrivenDiscountPercentage": [
                393
            ],
            "discountDueBeforeDayOfMonth": [
                619
            ],
            "discountIfPaidWithinDays": [
                619
            ],
            "discountPercentage": [
                393
            ],
            "isDateDriven": [
                137
            ],
            "isSystem": [
                137
            ],
            "name": [
                1199
            ],
            "netDueBeforeDayOfMonth": [
                619
            ],
            "netDueInDays": [
                619
            ],
            "nextMonthDueIfIssuedWithinDays": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "PaymentTermConfigResultPage": {
            "entries": [
                921
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "PaymentTermConfigSortOption": {},
        "PaymentTermConfigUpdateInput": {
            "code": [
                1199
            ],
            "dateDrivenDiscountPercentage": [
                393
            ],
            "discountDueBeforeDayOfMonth": [
                619
            ],
            "discountIfPaidWithinDays": [
                619
            ],
            "discountPercentage": [
                393
            ],
            "isDateDriven": [
                137
            ],
            "isSystem": [
                137
            ],
            "name": [
                1199
            ],
            "netDueBeforeDayOfMonth": [
                619
            ],
            "netDueInDays": [
                619
            ],
            "nextMonthDueIfIssuedWithinDays": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "PaymentType": {},
        "PendingAuthenticationError": {
            "pendingAuthenticationToken": [
                1199
            ],
            "on_EmailVerificationRequiredError": [
                461
            ],
            "on_InvalidOneTimeCode": [
                622
            ],
            "on_MfaChallengeError": [
                830
            ],
            "on_MfaEnrollmentRequiredError": [
                831
            ],
            "on_OneTimeCodeExpired": [
                884
            ],
            "on_OrganizationSelectionError": [
                891
            ],
            "on_SsoRequiredError": [
                1194
            ],
            "__typename": [
                1199
            ]
        },
        "PeriodTrialCloseResult": {
            "checklistItems": [
                1295
            ],
            "__typename": [
                1199
            ]
        },
        "Permission": {
            "action": [
                1199
            ],
            "allowed": [
                137
            ],
            "resource": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PermissionCheckInput": {
            "action": [
                1199
            ],
            "resource": [
                1199
            ],
            "resourceId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "Permissions": {
            "primaryFacilityGroup": [
                607
            ],
            "privilegedFacilities": [
                607
            ],
            "privilegedFacilityGroups": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "PermissionsInput": {
            "primaryFacilityGroup": [
                607
            ],
            "privilegedFacilities": [
                607
            ],
            "privilegedFacilityGroups": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "PhotoInstruction": {
            "id": [
                1199
            ],
            "instruction": [
                1199
            ],
            "isRequired": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "PhotoInstructionInput": {
            "id": [
                1199
            ],
            "instruction": [
                1199
            ],
            "isRequired": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "PhotoRequirement": {
            "description": [
                1199
            ],
            "id": [
                607
            ],
            "required": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "PhotoRequirementInput": {
            "description": [
                1199
            ],
            "required": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "PlaidAccountFacilityMapping": {
            "facilityID": [
                607
            ],
            "plaidAccountId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PlaidExchangeTokenResponse": {
            "itemId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PlaidItem": {
            "id": [
                1199
            ],
            "institution": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PlaidLinkToken": {
            "expiresAt": [
                619
            ],
            "token": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "Point": {
            "latitude": [
                393
            ],
            "longitude": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "PointInput": {
            "latitude": [
                393
            ],
            "longitude": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "Polygon": {
            "Points": [
                942
            ],
            "__typename": [
                1199
            ]
        },
        "Port": {
            "countryCode": [
                1199
            ],
            "id": [
                607
            ],
            "latitude": [
                393
            ],
            "locationCode": [
                1199
            ],
            "longitude": [
                393
            ],
            "name": [
                1199
            ],
            "terminals": [
                1240
            ],
            "timestamps": [
                1250
            ],
            "unLocode": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PortFilter": {
            "countryCode": [
                1199
            ],
            "ids": [
                607
            ],
            "locationCode": [
                1199
            ],
            "name": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "unLocode": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PortResultPage": {
            "entries": [
                945
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "PortSortOption": {},
        "Position": {
            "x": [
                538
            ],
            "y": [
                538
            ],
            "__typename": [
                1199
            ]
        },
        "PositionInput": {
            "x": [
                538
            ],
            "y": [
                538
            ],
            "__typename": [
                1199
            ]
        },
        "PositionSummaryStats": {
            "negativePositions": [
                619
            ],
            "totalIncoming": [
                393
            ],
            "totalItems": [
                619
            ],
            "totalOutgoing": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "PositivePayTemplate": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "definition": [
                1199
            ],
            "fileType": [
                1199
            ],
            "id": [
                607
            ],
            "templateName": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "PositivePayTemplateFilter": {
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "PositivePayTemplateInput": {
            "definition": [
                1199
            ],
            "fileType": [
                1199
            ],
            "templateName": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PositivePayTemplateResultPage": {
            "entries": [
                952
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "PositivePayTemplateSortOption": {},
        "PositivePayTemplateUpdateInput": {
            "definition": [
                1199
            ],
            "fileType": [
                1199
            ],
            "templateName": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PresenceEvent": {
            "members": [
                960
            ],
            "room": [
                1199
            ],
            "type": [
                959
            ],
            "__typename": [
                1199
            ]
        },
        "PresenceEventType": {},
        "PresenceMember": {
            "id": [
                1199
            ],
            "kind": [
                1199
            ],
            "metadata": [
                828
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PriceListType": {},
        "PricingMode": {},
        "Printer": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "driverType": [
                1199
            ],
            "firmwareVersion": [
                1199
            ],
            "id": [
                607
            ],
            "lastSeenAt": [
                1446
            ],
            "manufacturer": [
                1199
            ],
            "model": [
                1199
            ],
            "name": [
                1199
            ],
            "online": [
                137
            ],
            "pageSize": [
                965
            ],
            "printerType": [
                970
            ],
            "rollWidth": [
                967
            ],
            "sidecar": [
                1181
            ],
            "sidecarId": [
                607
            ],
            "status": [
                969
            ],
            "timestamps": [
                1250
            ],
            "uniqueId": [
                1199
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "PrinterFilter": {
            "facilityId": [
                607
            ],
            "ids": [
                607
            ],
            "printerType": [
                970
            ],
            "sidecarId": [
                607
            ],
            "status": [
                969
            ],
            "__typename": [
                1199
            ]
        },
        "PrinterPageSize": {},
        "PrinterResultPage": {
            "entries": [
                963
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "PrinterRollWidth": {},
        "PrinterSortOption": {},
        "PrinterStatus": {},
        "PrinterType": {},
        "ProcessingType": {
            "code": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "description": [
                1199
            ],
            "hasRecipe": [
                137
            ],
            "id": [
                607
            ],
            "inputItems": [
                974
            ],
            "isActive": [
                137
            ],
            "name": [
                1199
            ],
            "outputItems": [
                978
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ProcessingTypeFilter": {
            "code": [
                1199
            ],
            "description": [
                1199
            ],
            "ids": [
                607
            ],
            "isActive": [
                137
            ],
            "name": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ProcessingTypeInput": {
            "code": [
                1199
            ],
            "description": [
                1199
            ],
            "inputItems": [
                325
            ],
            "isActive": [
                137
            ],
            "name": [
                1199
            ],
            "outputItems": [
                326
            ],
            "__typename": [
                1199
            ]
        },
        "ProcessingTypeInputItem": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "id": [
                607
            ],
            "isPrimary": [
                137
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "processingTypeId": [
                607
            ],
            "sortOrder": [
                619
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ProcessingTypeInputItemFilter": {
            "ids": [
                607
            ],
            "itemId": [
                607
            ],
            "itemIds": [
                607
            ],
            "notes": [
                1199
            ],
            "processingTypeId": [
                607
            ],
            "processingTypeIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ProcessingTypeInputItemResultPage": {
            "entries": [
                974
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ProcessingTypeInputItemSortOption": {},
        "ProcessingTypeOutputItem": {
            "costAllocationPercentage": [
                393
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "id": [
                607
            ],
            "isNoCost": [
                137
            ],
            "isPrimary": [
                137
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "outputUnit": [
                1307
            ],
            "processingTypeId": [
                607
            ],
            "sortOrder": [
                619
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "yieldPercentage": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "ProcessingTypeOutputItemFilter": {
            "ids": [
                607
            ],
            "itemId": [
                607
            ],
            "itemIds": [
                607
            ],
            "notes": [
                1199
            ],
            "processingTypeId": [
                607
            ],
            "processingTypeIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ProcessingTypeOutputItemResultPage": {
            "entries": [
                978
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ProcessingTypeOutputItemSortOption": {},
        "ProcessingTypeResultPage": {
            "entries": [
                971
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ProcessingTypeSortOption": {},
        "ProcessingTypeUpdateInput": {
            "code": [
                1199
            ],
            "description": [
                1199
            ],
            "inputItems": [
                1342
            ],
            "isActive": [
                137
            ],
            "name": [
                1199
            ],
            "outputItems": [
                1343
            ],
            "__typename": [
                1199
            ]
        },
        "ProvisionFacilityAccountsResult": {
            "created_accounts": [
                625
            ],
            "existing_accounts": [
                625
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseLineItemType": {},
        "PurchaseLoad": {
            "bill": [
                110
            ],
            "billId": [
                607
            ],
            "bolNumber": [
                1199
            ],
            "carrierAccount": [
                3
            ],
            "carrierAccountId": [
                607
            ],
            "complianceChecks": [
                192
            ],
            "complianceHold": [
                223
            ],
            "containerNumber": [
                1199
            ],
            "containerType": [
                268
            ],
            "containerTypeId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "currencyCode": [
                1199
            ],
            "deductions": [
                988
            ],
            "deductionsTotal": [
                835
            ],
            "description": [
                1199
            ],
            "documentNumber": [
                1199
            ],
            "driverName": [
                1199
            ],
            "externalNotes": [
                1199
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "files": [
                494
            ],
            "freightCost": [
                835
            ],
            "freightTerms": [
                1199
            ],
            "grandTotal": [
                835
            ],
            "heavyWeight": [
                1424
            ],
            "id": [
                607
            ],
            "internalNotes": [
                1199
            ],
            "lightWeight": [
                1424
            ],
            "lineItems": [
                996
            ],
            "payments": [
                1000
            ],
            "purchaseOrder": [
                1008
            ],
            "purchaseOrderId": [
                607
            ],
            "receivedById": [
                607
            ],
            "receivedByUser": [
                1372
            ],
            "receivedDate": [
                1446
            ],
            "receivedTicketIssueDate": [
                168
            ],
            "receivingTicketNumber": [
                1199
            ],
            "scac": [
                1199
            ],
            "sealNumber": [
                1199
            ],
            "service": [
                1133
            ],
            "serviceId": [
                607
            ],
            "shippingCarrierName": [
                1199
            ],
            "sourceFacility": [
                470
            ],
            "sourceFacilityId": [
                607
            ],
            "sourceLoad": [
                772
            ],
            "sourceLoadId": [
                607
            ],
            "status": [
                1006
            ],
            "subtotal": [
                835
            ],
            "supplierAccount": [
                3
            ],
            "supplierAccountId": [
                607
            ],
            "supplierAddress": [
                4
            ],
            "supplierAddressId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "trailerNumber": [
                1199
            ],
            "truckNumber": [
                1199
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "vehicleColor": [
                1199
            ],
            "vehicleLicensePlate": [
                1199
            ],
            "vehicleMake": [
                1199
            ],
            "vehicleModel": [
                1199
            ],
            "vehiclePlateState": [
                1199
            ],
            "vehicleVin": [
                1199
            ],
            "vehicleYear": [
                1199
            ],
            "version": [
                619
            ],
            "voidReason": [
                1199
            ],
            "weightDisplayUnit": [
                1425
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseLoadDeduction": {
            "applicationType": [
                394
            ],
            "calculatedAmount": [
                835
            ],
            "deductionType": [
                395
            ],
            "deductionTypeId": [
                607
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "lineItem": [
                996
            ],
            "notes": [
                1199
            ],
            "percentage": [
                393
            ],
            "priceValue": [
                835
            ],
            "purchaseLoadId": [
                607
            ],
            "purchaseLoadLineItemId": [
                607
            ],
            "weightValue": [
                1424
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseLoadDeductionFilter": {
            "applicationType": [
                394
            ],
            "deductionTypeId": [
                607
            ],
            "deductionTypeIds": [
                607
            ],
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "notes": [
                1199
            ],
            "purchaseLoadId": [
                607
            ],
            "purchaseLoadIds": [
                607
            ],
            "purchaseLoadLineItemId": [
                607
            ],
            "purchaseLoadLineItemIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseLoadDeductionResultPage": {
            "entries": [
                988
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseLoadDeductionSortOption": {},
        "PurchaseLoadFileCreatePayload": {
            "file": [
                494
            ],
            "uploadUrl": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseLoadFileInput": {
            "fileName": [
                1199
            ],
            "fileSize": [
                619
            ],
            "mimeType": [
                1199
            ],
            "public": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseLoadFilter": {
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "fromReceivedDate": [
                1446
            ],
            "ids": [
                607
            ],
            "includeLineItems": [
                137
            ],
            "purchaseOrderId": [
                607
            ],
            "purchaseOrderIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "sourceFacilityIds": [
                607
            ],
            "sourceLoadId": [
                607
            ],
            "status": [
                1006
            ],
            "supplierAccountIds": [
                607
            ],
            "toReceivedDate": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseLoadInput": {
            "billId": [
                607
            ],
            "bolNumber": [
                1199
            ],
            "carrierAccountId": [
                607
            ],
            "containerNumber": [
                1199
            ],
            "containerTypeId": [
                607
            ],
            "currencyCode": [
                1199
            ],
            "deductions": [
                327
            ],
            "description": [
                1199
            ],
            "driverName": [
                1199
            ],
            "externalNotes": [
                1199
            ],
            "facilityId": [
                607
            ],
            "freightCost": [
                836
            ],
            "freightTerms": [
                1199
            ],
            "heavyWeight": [
                1426
            ],
            "internalNotes": [
                1199
            ],
            "lightWeight": [
                1426
            ],
            "lineItems": [
                328
            ],
            "payments": [
                329
            ],
            "purchaseOrderId": [
                607
            ],
            "receivedDate": [
                1446
            ],
            "receivedTicketIssueDate": [
                168
            ],
            "receivingTicketNumber": [
                1199
            ],
            "scac": [
                1199
            ],
            "sealNumber": [
                1199
            ],
            "serviceId": [
                607
            ],
            "shippingCarrierName": [
                1199
            ],
            "sourceFacilityId": [
                607
            ],
            "sourceLoadId": [
                607
            ],
            "supplierAccountId": [
                607
            ],
            "supplierAddressId": [
                607
            ],
            "trailerNumber": [
                1199
            ],
            "truckNumber": [
                1199
            ],
            "vehicleColor": [
                1199
            ],
            "vehicleLicensePlate": [
                1199
            ],
            "vehicleMake": [
                1199
            ],
            "vehicleModel": [
                1199
            ],
            "vehiclePlateState": [
                1199
            ],
            "vehicleVin": [
                1199
            ],
            "vehicleYear": [
                1199
            ],
            "weightDisplayUnit": [
                1425
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseLoadLineItem": {
            "catComplianceStatus": [
                1199
            ],
            "catOemCode": [
                1199
            ],
            "catSerialNumber": [
                1199
            ],
            "childLineItems": [
                996
            ],
            "estimatedPrice": [
                835
            ],
            "facilityId": [
                607
            ],
            "grossWeight": [
                1424
            ],
            "id": [
                607
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "netWeight": [
                1424
            ],
            "notes": [
                1199
            ],
            "parentLineItem": [
                996
            ],
            "parentLineItemId": [
                607
            ],
            "pricingUnit": [
                1307
            ],
            "purchaseLoadId": [
                607
            ],
            "purchaseOrderLine": [
                1018
            ],
            "purchaseOrderLineId": [
                607
            ],
            "requiresSorting": [
                137
            ],
            "settlementBasis": [
                1172
            ],
            "sortingWorkOrder": [
                1427
            ],
            "tagId": [
                607
            ],
            "tareWeight": [
                1424
            ],
            "type": [
                986
            ],
            "unitPrice": [
                835
            ],
            "vehicleMake": [
                1199
            ],
            "vehicleModel": [
                1199
            ],
            "vehicleTitleStatus": [
                1199
            ],
            "vehicleVin": [
                1199
            ],
            "vehicleYear": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseLoadLineItemFilter": {
            "catComplianceStatus": [
                1199
            ],
            "catOemCode": [
                1199
            ],
            "catSerialNumber": [
                1199
            ],
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "itemId": [
                607
            ],
            "itemIds": [
                607
            ],
            "notes": [
                1199
            ],
            "parentLineItemId": [
                607
            ],
            "parentLineItemIds": [
                607
            ],
            "purchaseLoadId": [
                607
            ],
            "purchaseLoadIds": [
                607
            ],
            "purchaseOrderLineId": [
                607
            ],
            "purchaseOrderLineIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "settlementBasis": [
                1172
            ],
            "tagId": [
                607
            ],
            "tagIds": [
                607
            ],
            "type": [
                986
            ],
            "vehicleMake": [
                1199
            ],
            "vehicleModel": [
                1199
            ],
            "vehicleTitleStatus": [
                1199
            ],
            "vehicleVin": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseLoadLineItemResultPage": {
            "entries": [
                996
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseLoadLineItemSortOption": {},
        "PurchaseLoadPayment": {
            "amount": [
                835
            ],
            "checkMemo": [
                1199
            ],
            "checkNumber": [
                1199
            ],
            "creatorId": [
                607
            ],
            "facilityId": [
                607
            ],
            "financialAccountId": [
                607
            ],
            "id": [
                607
            ],
            "legalHold": [
                137
            ],
            "paymentMethod": [
                1199
            ],
            "paymentTerm": [
                1199
            ],
            "percentage": [
                393
            ],
            "purchaseLoadId": [
                607
            ],
            "roundingMethod": [
                1199
            ],
            "roundingPrecision": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseLoadPaymentFilter": {
            "checkMemo": [
                1199
            ],
            "checkNumber": [
                1199
            ],
            "creatorId": [
                607
            ],
            "creatorIds": [
                607
            ],
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "financialAccountId": [
                607
            ],
            "financialAccountIds": [
                607
            ],
            "ids": [
                607
            ],
            "paymentMethod": [
                1199
            ],
            "paymentTerm": [
                1199
            ],
            "purchaseLoadId": [
                607
            ],
            "purchaseLoadIds": [
                607
            ],
            "roundingMethod": [
                1199
            ],
            "roundingPrecision": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseLoadPaymentResultPage": {
            "entries": [
                1000
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseLoadPaymentSortOption": {},
        "PurchaseLoadResultPage": {
            "entries": [
                987
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseLoadSortOption": {},
        "PurchaseLoadStatus": {},
        "PurchaseLoadUpdateInput": {
            "billId": [
                607
            ],
            "bolNumber": [
                1199
            ],
            "carrierAccountId": [
                607
            ],
            "containerNumber": [
                1199
            ],
            "containerTypeId": [
                607
            ],
            "currencyCode": [
                1199
            ],
            "deductions": [
                1344
            ],
            "description": [
                1199
            ],
            "driverName": [
                1199
            ],
            "expectedVersion": [
                619
            ],
            "externalNotes": [
                1199
            ],
            "facilityId": [
                607
            ],
            "freightCost": [
                836
            ],
            "freightTerms": [
                1199
            ],
            "heavyWeight": [
                1426
            ],
            "internalNotes": [
                1199
            ],
            "lightWeight": [
                1426
            ],
            "lineItems": [
                1345
            ],
            "payments": [
                1346
            ],
            "purchaseOrderId": [
                607
            ],
            "receivedDate": [
                1446
            ],
            "receivedTicketIssueDate": [
                168
            ],
            "receivingTicketNumber": [
                1199
            ],
            "scac": [
                1199
            ],
            "sealNumber": [
                1199
            ],
            "serviceId": [
                607
            ],
            "shippingCarrierName": [
                1199
            ],
            "sourceFacilityId": [
                607
            ],
            "sourceLoadId": [
                607
            ],
            "supplierAccountId": [
                607
            ],
            "supplierAddressId": [
                607
            ],
            "trailerNumber": [
                1199
            ],
            "truckNumber": [
                1199
            ],
            "vehicleColor": [
                1199
            ],
            "vehicleLicensePlate": [
                1199
            ],
            "vehicleMake": [
                1199
            ],
            "vehicleModel": [
                1199
            ],
            "vehiclePlateState": [
                1199
            ],
            "vehicleVin": [
                1199
            ],
            "vehicleYear": [
                1199
            ],
            "weightDisplayUnit": [
                1425
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseOrder": {
            "account": [
                3
            ],
            "accountAddressId": [
                607
            ],
            "accountContactId": [
                607
            ],
            "accountId": [
                607
            ],
            "accountRepresentativeId": [
                607
            ],
            "allocatedPercentage": [
                393
            ],
            "completionNotes": [
                1199
            ],
            "contact": [
                255
            ],
            "counterpartyReferenceNumber": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "documentNumber": [
                1199
            ],
            "endDate": [
                168
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "files": [
                494
            ],
            "freightTerm": [
                572
            ],
            "fulfilledPercentage": [
                393
            ],
            "id": [
                607
            ],
            "lineItems": [
                1018
            ],
            "notes": [
                1199
            ],
            "paymentCurrency": [
                1199
            ],
            "paymentTerm": [
                920
            ],
            "startDate": [
                168
            ],
            "status": [
                1024
            ],
            "timestamps": [
                1250
            ],
            "totalAllocated": [
                393
            ],
            "totalFulfilled": [
                393
            ],
            "totalQuantity": [
                393
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseOrderFileCreatePayload": {
            "file": [
                494
            ],
            "uploadUrl": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseOrderFileInput": {
            "fileName": [
                1199
            ],
            "fileSize": [
                619
            ],
            "mimeType": [
                1199
            ],
            "public": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseOrderFilter": {
            "accountAddressIds": [
                607
            ],
            "accountIds": [
                607
            ],
            "counterpartyReferenceNumber": [
                1199
            ],
            "documentNumber": [
                1199
            ],
            "facilityIds": [
                607
            ],
            "freightTerms": [
                572
            ],
            "fromEndDate": [
                168
            ],
            "fromStartDate": [
                168
            ],
            "ids": [
                607
            ],
            "includeLineItems": [
                137
            ],
            "lastUpdatedAt": [
                1446
            ],
            "paymentCurrencies": [
                1199
            ],
            "paymentTerms": [
                920
            ],
            "searchTerm": [
                1199
            ],
            "status": [
                1024
            ],
            "toEndDate": [
                168
            ],
            "toStartDate": [
                168
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseOrderFreight": {
            "carrierId": [
                607
            ],
            "chargebackFormula": [
                1199
            ],
            "chargebackVariableIds": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "freightLaneId": [
                1199
            ],
            "fuelSurchargeFormula": [
                1199
            ],
            "fuelSurchargeMode": [
                1199
            ],
            "fuelSurchargeVariableIds": [
                1199
            ],
            "id": [
                607
            ],
            "notes": [
                1199
            ],
            "purchaseOrderId": [
                607
            ],
            "rateFormula": [
                1199
            ],
            "rateVariableIds": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseOrderFreightFilter": {
            "ids": [
                607
            ],
            "purchaseOrderId": [
                607
            ],
            "purchaseOrderIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseOrderFreightInput": {
            "carrierId": [
                607
            ],
            "chargebackFormula": [
                1199
            ],
            "chargebackVariableIds": [
                1199
            ],
            "freightLaneId": [
                1199
            ],
            "fuelSurchargeFormula": [
                1199
            ],
            "fuelSurchargeMode": [
                1199
            ],
            "fuelSurchargeVariableIds": [
                1199
            ],
            "notes": [
                1199
            ],
            "purchaseOrderId": [
                607
            ],
            "rateFormula": [
                1199
            ],
            "rateVariableIds": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseOrderFreightResultPage": {
            "entries": [
                1012
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseOrderFreightSortOption": {},
        "PurchaseOrderFreightUpdateInput": {
            "carrierId": [
                607
            ],
            "chargebackFormula": [
                1199
            ],
            "chargebackVariableIds": [
                1199
            ],
            "freightLaneId": [
                1199
            ],
            "fuelSurchargeFormula": [
                1199
            ],
            "fuelSurchargeMode": [
                1199
            ],
            "fuelSurchargeVariableIds": [
                1199
            ],
            "notes": [
                1199
            ],
            "purchaseOrderId": [
                607
            ],
            "rateFormula": [
                1199
            ],
            "rateVariableIds": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseOrderLineItem": {
            "allocatedPercentage": [
                393
            ],
            "allocatedQuantity": [
                393
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "facilityId": [
                607
            ],
            "fulfilledPercentage": [
                393
            ],
            "id": [
                607
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "purchaseOrderId": [
                607
            ],
            "quantity": [
                393
            ],
            "receivedQuantity": [
                393
            ],
            "timestamps": [
                1250
            ],
            "totalPrice": [
                835
            ],
            "unit": [
                1307
            ],
            "unitPrice": [
                835
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseOrderLineItemFilter": {
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "itemId": [
                607
            ],
            "itemIds": [
                607
            ],
            "purchaseOrderId": [
                607
            ],
            "purchaseOrderIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseOrderLineItemResultPage": {
            "entries": [
                1018
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseOrderLineItemSortOption": {},
        "PurchaseOrderResultPage": {
            "entries": [
                1008
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "PurchaseOrderSortOption": {},
        "PurchaseOrderStatus": {},
        "PurchaseOrderStatusCounts": {
            "closed": [
                619
            ],
            "draft": [
                619
            ],
            "open": [
                619
            ],
            "total": [
                619
            ],
            "voided": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "QuantityCaptureMethod": {},
        "Query": {
            "_complianceServiceStatus": [
                1199
            ],
            "_notificationServiceStatus": [
                137
            ],
            "_pricingServiceStatus": [
                1199
            ],
            "account": [
                3,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "accountAddress": [
                4,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "accountAddresses": [
                6,
                {
                    "filter": [
                        5
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        7,
                        "[AccountAddressSortOption!]"
                    ]
                }
            ],
            "accountAddressesByAccountId": [
                4,
                {
                    "accountId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "accountBankDetail": [
                8,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "accountBankDetails": [
                11,
                {
                    "filter": [
                        9
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        12,
                        "[AccountBankDetailSortOption!]"
                    ]
                }
            ],
            "accounts": [
                25,
                {
                    "filter": [
                        14
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        26,
                        "[AccountSortOption!]"
                    ]
                }
            ],
            "agent": [
                35,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "agents": [
                38,
                {
                    "filter": [
                        36
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        39,
                        "[AgentSortOption!]"
                    ]
                }
            ],
            "asset": [
                54,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "assetLocationHistories": [
                60,
                {
                    "filter": [
                        58
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        61,
                        "[AssetLocationHistorySortOption!]"
                    ]
                }
            ],
            "assetLocationHistory": [
                57,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "assetType": [
                66,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "assetTypes": [
                68,
                {
                    "filter": [
                        67
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        69,
                        "[AssetTypeSortOption!]"
                    ]
                }
            ],
            "assets": [
                63,
                {
                    "filter": [
                        56
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        64,
                        "[AssetSortOption!]"
                    ]
                }
            ],
            "assetsInRegion": [
                63,
                {
                    "centroid": [
                        943,
                        "PointInput!"
                    ],
                    "filter": [
                        56
                    ],
                    "radius": [
                        538,
                        "Float!"
                    ]
                }
            ],
            "assistantChat": [
                75,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "assistantChatByShareToken": [
                75,
                {
                    "token": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "assistantChatMessages": [
                77,
                {
                    "chatId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "assistantChats": [
                81,
                {
                    "filter": [
                        76
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        83,
                        "[AssistantChatSortOption!]"
                    ]
                }
            ],
            "assistantOrganizationUsageMetrics": [
                1370,
                {
                    "filter": [
                        1369
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1371,
                        "[UsageMetricsSortOption!]"
                    ]
                }
            ],
            "assistantOutboxEventCounts": [
                85
            ],
            "assistantOutboxEvents": [
                902,
                {
                    "filter": [
                        86
                    ],
                    "pagination": [
                        906
                    ]
                }
            ],
            "assistantSystemUsageMetrics": [
                1370,
                {
                    "filter": [
                        1369
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1371,
                        "[UsageMetricsSortOption!]"
                    ]
                }
            ],
            "authenticationAvailable": [
                137
            ],
            "automation": [
                94,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "automationValidate": [
                539,
                {
                    "edges": [
                        457,
                        "[EdgeInput!]!"
                    ],
                    "nodes": [
                        847,
                        "[NodeInput!]!"
                    ]
                }
            ],
            "automationVersion": [
                102,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "automationVersions": [
                105,
                {
                    "filter": [
                        103
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        106,
                        "[AutomationVersionSortOption!]"
                    ]
                }
            ],
            "automations": [
                99,
                {
                    "filter": [
                        98
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        100,
                        "[AutomationSortOption!]"
                    ]
                }
            ],
            "automationsApprovalRequest": [
                46,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "automationsPendingApprovals": [
                48,
                {
                    "filter": [
                        47
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        49,
                        "[ApprovalRequestSortOption!]"
                    ]
                }
            ],
            "billStatusCounts": [
                121,
                {
                    "filter": [
                        114
                    ]
                }
            ],
            "bills": [
                118,
                {
                    "filter": [
                        114
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        119,
                        "[BillSortOption!]"
                    ]
                }
            ],
            "bookingStatusCounts": [
                134,
                {
                    "filter": [
                        128
                    ]
                }
            ],
            "bookings": [
                131,
                {
                    "filter": [
                        128
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        132,
                        "[BookingSortOption!]"
                    ]
                }
            ],
            "brokeredOrder": [
                138,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "brokeredOrders": [
                145,
                {
                    "filter": [
                        139
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        146,
                        "[BrokeredOrderSortOption!]"
                    ]
                }
            ],
            "camera": [
                170,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "cameras": [
                172,
                {
                    "filter": [
                        171
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        173,
                        "[CameraSortOption!]"
                    ]
                }
            ],
            "categories": [
                178,
                {
                    "filter": [
                        176
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        179,
                        "[CategorySortOption!]"
                    ]
                }
            ],
            "checkSupplierPriceListAffectsMaterials": [
                1201,
                {
                    "accountId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "checkTemplate": [
                183,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "checkTemplates": [
                186,
                {
                    "filter": [
                        184
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        187,
                        "[CheckTemplateSortOption!]"
                    ]
                }
            ],
            "checkUserPermission": [
                930,
                {
                    "input": [
                        931,
                        "PermissionCheckInput!"
                    ]
                }
            ],
            "checkUserPermissions": [
                930,
                {
                    "inputs": [
                        931,
                        "[PermissionCheckInput!]!"
                    ]
                }
            ],
            "collabUserConversations": [
                1218,
                {
                    "filter": [
                        1217,
                        "TalkJSConversationFilter!"
                    ]
                }
            ],
            "complianceCheck": [
                192,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "complianceChecks": [
                197,
                {
                    "filter": [
                        193
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        198,
                        "[ComplianceCheckSortOption!]"
                    ]
                }
            ],
            "complianceDispatchRecord": [
                208,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "complianceDispatchRecords": [
                211,
                {
                    "filter": [
                        209
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        212,
                        "[ComplianceDispatchRecordSortOption!]"
                    ]
                }
            ],
            "complianceEvaluateTransaction": [
                216,
                {
                    "input": [
                        215,
                        "ComplianceEvaluateTransactionInput!"
                    ]
                }
            ],
            "complianceFacilityRule": [
                217,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "complianceFacilityRules": [
                220,
                {
                    "filter": [
                        218
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        221,
                        "[ComplianceFacilityRuleSortOption!]"
                    ]
                }
            ],
            "complianceHold": [
                223,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "complianceHolds": [
                231,
                {
                    "filter": [
                        227
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        232,
                        "[ComplianceHoldSortOption!]"
                    ]
                }
            ],
            "complianceItemJurisdictionCode": [
                236,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "complianceItemJurisdictionCodes": [
                239,
                {
                    "filter": [
                        237
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        240,
                        "[ComplianceItemJurisdictionCodeSortOption!]"
                    ]
                }
            ],
            "complianceRuleDefinition": [
                245,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "complianceRuleDefinitions": [
                248,
                {
                    "filter": [
                        246
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        249,
                        "[ComplianceRuleDefinitionSortOption!]"
                    ]
                }
            ],
            "contact": [
                255,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "contacts": [
                257,
                {
                    "filter": [
                        256
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        258,
                        "[ContactSortOption!]"
                    ]
                }
            ],
            "contactsByAccount": [
                255,
                {
                    "accountId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "container": [
                260,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "containerStatusCounts": [
                267,
                {
                    "filter": [
                        262
                    ]
                }
            ],
            "containerType": [
                268,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "containerTypes": [
                270,
                {
                    "filter": [
                        269
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        271,
                        "[ContainerTypeSortOption!]"
                    ]
                }
            ],
            "containers": [
                264,
                {
                    "filter": [
                        262
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        265,
                        "[ContainerSortOption!]"
                    ]
                }
            ],
            "coreOutboxEventCounts": [
                277
            ],
            "coreOutboxEvents": [
                902,
                {
                    "filter": [
                        278
                    ],
                    "pagination": [
                        906
                    ]
                }
            ],
            "coreRole": [
                1059,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreRoles": [
                1061,
                {
                    "filter": [
                        1060,
                        "RoleFilter!"
                    ]
                }
            ],
            "coreUserRoleAssignment": [
                1383,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "coreUserRoleAssignments": [
                1386,
                {
                    "filter": [
                        1384
                    ]
                }
            ],
            "coreUsersByOrganization": [
                1382,
                {
                    "filter": [
                        1377
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1388,
                        "[UserSortOption!]"
                    ]
                }
            ],
            "counterpartyGroup": [
                279,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "counterpartyGroupMemberDetails": [
                282,
                {
                    "groupId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "counterpartyGroupMembers": [
                607,
                {
                    "groupId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "counterpartyGroups": [
                288,
                {
                    "filter": [
                        280
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        289,
                        "[CounterpartyGroupSortOption!]"
                    ]
                }
            ],
            "counterpartyGroupsByAccount": [
                279,
                {
                    "accountId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "crmOutboxEventCounts": [
                353
            ],
            "crmOutboxEvents": [
                902,
                {
                    "filter": [
                        354
                    ],
                    "pagination": [
                        906
                    ]
                }
            ],
            "customAttributeDefinitions": [
                356,
                {
                    "filter": [
                        358
                    ]
                }
            ],
            "customPriceList": [
                359,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "customPriceListStatusCounts": [
                365
            ],
            "customPriceLists": [
                363,
                {
                    "filter": [
                        361
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        364,
                        "[CustomPriceListSortOption!]"
                    ]
                }
            ],
            "customerBookings": [
                131,
                {
                    "filter": [
                        128
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        132,
                        "[BookingSortOption!]"
                    ]
                }
            ],
            "customerInvitationByToken": [
                367,
                {
                    "token": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "customerInvitations": [
                369,
                {
                    "filter": [
                        368
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        370,
                        "[CustomerInvitationSortOption!]"
                    ]
                }
            ],
            "customerLoads": [
                795,
                {
                    "filter": [
                        780
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        797,
                        "[LoadSortOption!]"
                    ]
                }
            ],
            "customerSalesOrders": [
                1107,
                {
                    "filter": [
                        1096
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1108,
                        "[SalesOrderSortOption!]"
                    ]
                }
            ],
            "cycleCountLine": [
                372,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "cycleCountLines": [
                375,
                {
                    "filter": [
                        373
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        376,
                        "[CycleCountLineSortOption!]"
                    ]
                }
            ],
            "cycleCountSchedule": [
                378,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "cycleCountSchedules": [
                381,
                {
                    "filter": [
                        379
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        382,
                        "[CycleCountScheduleSortOption!]"
                    ]
                }
            ],
            "cycleCountTask": [
                385,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "cycleCountTasks": [
                388,
                {
                    "filter": [
                        386
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        389,
                        "[CycleCountTaskSortOption!]"
                    ]
                }
            ],
            "deductionType": [
                395,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "deductionTypes": [
                398,
                {
                    "filter": [
                        396
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        399,
                        "[DeductionTypeSortOption!]"
                    ]
                }
            ],
            "defaultPhotoRequirements": [
                401
            ],
            "defaultPriceList": [
                403,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "detention": [
                417,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "detentions": [
                420,
                {
                    "filter": [
                        418
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        421,
                        "[DetentionSortOption!]"
                    ]
                }
            ],
            "directories": [
                494
            ],
            "doNotBuyEntries": [
                430,
                {
                    "filter": [
                        428
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        431,
                        "[DoNotBuyEntrySortOption!]"
                    ]
                }
            ],
            "doNotBuyEntry": [
                427,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "driver": [
                439,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "driverCertification": [
                440,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "driverCertifications": [
                442,
                {
                    "filter": [
                        441
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        443,
                        "[DriverCertificationSortOption!]"
                    ]
                }
            ],
            "driverTotalServicesCompleted": [
                619,
                {
                    "dateRange": [
                        391
                    ],
                    "driverId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "drivers": [
                452,
                {
                    "filter": [
                        450
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        453,
                        "[DriverSortOption!]"
                    ]
                }
            ],
            "evaluateAdHocFormulas": [
                462,
                {
                    "formulas": [
                        1199,
                        "[String!]!"
                    ]
                }
            ],
            "evaluateFormulas": [
                463,
                {
                    "asOf": [
                        1446
                    ],
                    "priceListId": [
                        607,
                        "ID!"
                    ],
                    "priceListType": [
                        961,
                        "PriceListType!"
                    ]
                }
            ],
            "executionRun": [
                465,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "executionRuns": [
                467,
                {
                    "filter": [
                        466
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        468,
                        "[ExecutionRunSortOption!]"
                    ]
                }
            ],
            "facilities": [
                486,
                {
                    "filter": [
                        478
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        488,
                        "[FacilitySortOption!]"
                    ]
                }
            ],
            "facilitiesNearby": [
                470,
                {
                    "latitude": [
                        538,
                        "Float!"
                    ],
                    "longitude": [
                        538,
                        "Float!"
                    ],
                    "radiusMeters": [
                        538,
                        "Float!"
                    ]
                }
            ],
            "facility": [
                470,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "facilityAtm": [
                471,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "facilityAtms": [
                474,
                {
                    "filter": [
                        472
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        475,
                        "[FacilityAtmSortOption!]"
                    ]
                }
            ],
            "facilityGeneralPreferences": [
                479,
                {
                    "facilityId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "facilityGroup": [
                480,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "facilityGroups": [
                483,
                {
                    "filter": [
                        481
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        484,
                        "[FacilityGroupSortOption!]"
                    ]
                }
            ],
            "facilitySalesPreferences": [
                487,
                {
                    "facilityId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "facilityServiceTypes": [
                1145,
                {
                    "facilityIDs": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "file": [
                494,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "fileTemplate": [
                504,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "fileTemplates": [
                506,
                {
                    "filter": [
                        505
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        507,
                        "[FileTemplateSortOption!]"
                    ]
                }
            ],
            "files": [
                497,
                {
                    "cursor": [
                        498
                    ],
                    "filter": [
                        501
                    ]
                }
            ],
            "filesOutboxEventCounts": [
                511
            ],
            "filesOutboxEvents": [
                902,
                {
                    "filter": [
                        512
                    ],
                    "pagination": [
                        906
                    ]
                }
            ],
            "filesWOPICanEdit": [
                137,
                {
                    "fileId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "filesWOPIDiscovery": [
                1412
            ],
            "financeAccountsWithBalance": [
                3,
                {
                    "filter": [
                        514
                    ],
                    "pagination": [
                        906
                    ]
                }
            ],
            "financeAtmPaymentsRequiringVoidConfirmation": [
                911,
                {
                    "paymentIds": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "financeGeneratePositivePayFile": [
                1199,
                {
                    "input": [
                        583,
                        "GeneratePositivePayFileInput!"
                    ]
                }
            ],
            "financeNextBillDocumentNumber": [
                1199
            ],
            "financeNextCheckNumber": [
                1199,
                {
                    "financialAccountId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financeNextInvoiceDocumentNumber": [
                1199
            ],
            "financeNextPaymentDocumentNumber": [
                1199
            ],
            "financeOutboxEventCounts": [
                516
            ],
            "financeOutboxEvents": [
                902,
                {
                    "filter": [
                        517
                    ],
                    "pagination": [
                        906
                    ]
                }
            ],
            "financeUnappliedAdvanceBalance": [
                1305,
                {
                    "accountId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financeUnappliedAdvances": [
                911,
                {
                    "accountId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financialAccountAdjustment": [
                519,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "financialAccountAdjustments": [
                522,
                {
                    "filter": [
                        520
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        523,
                        "[FinancialAccountAdjustmentSortOption!]"
                    ]
                }
            ],
            "financialAccountTransactions": [
                533,
                {
                    "filter": [
                        532
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        534,
                        "[FinancialAccountTransactionSortOption!]"
                    ]
                }
            ],
            "financialAccounts": [
                526,
                {
                    "filter": [
                        525
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        527,
                        "[FinancialAccountSortOption!]"
                    ]
                }
            ],
            "freightForwarder": [
                542,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "freightForwarders": [
                545,
                {
                    "filter": [
                        543
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        546,
                        "[FreightForwarderSortOption!]"
                    ]
                }
            ],
            "freightLane": [
                548,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "freightLaneCost": [
                549,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "freightLaneCosts": [
                552,
                {
                    "filter": [
                        550
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        553,
                        "[FreightLaneCostSortOption!]"
                    ]
                }
            ],
            "freightLaneRoute": [
                558,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "freightLaneRoutes": [
                561,
                {
                    "filter": [
                        559
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        562,
                        "[FreightLaneRouteSortOption!]"
                    ]
                }
            ],
            "freightLanes": [
                557,
                {
                    "filter": [
                        555
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        564,
                        "[FreightLaneSortOption!]"
                    ]
                }
            ],
            "freightLine": [
                566,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "freightLines": [
                569,
                {
                    "filter": [
                        567
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        570,
                        "[FreightLineSortOption!]"
                    ]
                }
            ],
            "getPersonalContact": [
                1373,
                {
                    "userId": [
                        607
                    ]
                }
            ],
            "governmentReportingConfiguration": [
                588,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "governmentReportingConfigurations": [
                591,
                {
                    "filter": [
                        589
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        592,
                        "[GovernmentReportingConfigurationSortOption!]"
                    ]
                }
            ],
            "governmentReportingFacilities": [
                597,
                {
                    "filter": [
                        595
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        598,
                        "[GovernmentReportingFacilitySortOption!]"
                    ]
                }
            ],
            "governmentReportingFacility": [
                594,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "haulers": [
                887
            ],
            "inboundTollingAgreement": [
                609,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inboundTollingAgreements": [
                612,
                {
                    "filter": [
                        610
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        613,
                        "[InboundTollingAgreementSortOption!]"
                    ]
                }
            ],
            "integrations": [
                620
            ],
            "inventoryFacilitySettings": [
                633,
                {
                    "facilityId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryLevels": [
                642,
                {
                    "filter": [
                        641
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        643,
                        "[InventoryLevelSortOption!]"
                    ]
                }
            ],
            "inventoryLot": [
                645,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryLotTraceBackward": [
                823,
                {
                    "lotId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryLotTraceForward": [
                824,
                {
                    "lotId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryLots": [
                657,
                {
                    "filter": [
                        653
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        658,
                        "[InventoryLotSortOption!]"
                    ]
                }
            ],
            "inventoryMovement": [
                662,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryMovementHistory": [
                665,
                {
                    "filter": [
                        664,
                        "InventoryMovementHistoryFilter!"
                    ],
                    "pagination": [
                        906
                    ]
                }
            ],
            "inventoryMovements": [
                667,
                {
                    "filter": [
                        663
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        668,
                        "[InventoryMovementSortOption!]"
                    ]
                }
            ],
            "inventoryOutboxEventCounts": [
                673
            ],
            "inventoryOutboxEvents": [
                902,
                {
                    "filter": [
                        674
                    ],
                    "pagination": [
                        906
                    ]
                }
            ],
            "inventoryPeriod": [
                675,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryPeriodBalance": [
                676,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryPeriodBalances": [
                679,
                {
                    "filter": [
                        677
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        680,
                        "[InventoryPeriodBalanceSortOption!]"
                    ]
                }
            ],
            "inventoryPeriodConfig": [
                682,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryPeriodConfigByOrganization": [
                682
            ],
            "inventoryPeriodTrialClose": [
                929,
                {
                    "periodId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryPeriods": [
                690,
                {
                    "filter": [
                        688
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        691,
                        "[InventoryPeriodSortOption!]"
                    ]
                }
            ],
            "inventoryTag": [
                693,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryTagByTagNumber": [
                693,
                {
                    "tagNumber": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "inventoryTagReconciliationReport": [
                1213,
                {
                    "facilityId": [
                        607
                    ]
                }
            ],
            "inventoryTags": [
                699,
                {
                    "filter": [
                        697
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        700,
                        "[InventoryTagSortOption!]"
                    ]
                }
            ],
            "inventoryTagsByCustomAttribute": [
                693,
                {
                    "attributeName": [
                        1199,
                        "String!"
                    ],
                    "attributeValue": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "inventoryZone": [
                706,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryZoneHierarchy": [
                706,
                {
                    "facilityId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "inventoryZones": [
                709,
                {
                    "filter": [
                        707
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        710,
                        "[InventoryZoneSortOption!]"
                    ]
                }
            ],
            "invoiceStatusCounts": [
                725,
                {
                    "filter": [
                        717
                    ]
                }
            ],
            "invoices": [
                722,
                {
                    "filter": [
                        717
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        723,
                        "[InvoiceSortOption!]"
                    ]
                }
            ],
            "iotP2PRelayInfo": [
                904
            ],
            "itemAliases": [
                731,
                {
                    "filter": [
                        729
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        732,
                        "[ItemAliasSortOption!]"
                    ]
                }
            ],
            "itemGroups": [
                739,
                {
                    "filter": [
                        737
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        740,
                        "[ItemGroupSortOption!]"
                    ]
                }
            ],
            "itemPriceConfiguration": [
                749,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "itemPriceConfigurations": [
                752,
                {
                    "filter": [
                        750
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        753,
                        "[ItemPriceConfigurationSortOption!]"
                    ]
                }
            ],
            "itemPricings": [
                755,
                {
                    "asOf": [
                        1446
                    ],
                    "priceListId": [
                        607,
                        "ID!"
                    ],
                    "priceListType": [
                        961,
                        "PriceListType!"
                    ]
                }
            ],
            "items": [
                767,
                {
                    "filter": [
                        735
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        768,
                        "[ItemSortOption!]"
                    ]
                }
            ],
            "load": [
                772,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "loadBoard": [
                773,
                {
                    "facilityIDs": [
                        607,
                        "[ID!]"
                    ],
                    "filter": [
                        1139
                    ]
                }
            ],
            "loadReconciliation": [
                788,
                {
                    "loadId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "loadReconciliationSummary": [
                792,
                {
                    "filter": [
                        780
                    ],
                    "pagination": [
                        906
                    ]
                }
            ],
            "loadStatusCounts": [
                799,
                {
                    "filter": [
                        780
                    ]
                }
            ],
            "loads": [
                795,
                {
                    "filter": [
                        780
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        797,
                        "[LoadSortOption!]"
                    ]
                }
            ],
            "locationFreightPricing": [
                804,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "locationFreightPricings": [
                807,
                {
                    "filter": [
                        805
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        808,
                        "[LocationFreightPricingSortOption!]"
                    ]
                }
            ],
            "notificationFeed": [
                859,
                {
                    "channel": [
                        1199
                    ],
                    "cursor": [
                        857
                    ],
                    "limit": [
                        619
                    ]
                }
            ],
            "notificationPreference": [
                862,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "notificationPreferences": [
                866,
                {
                    "filter": [
                        864
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        867,
                        "[NotificationPreferenceSortOption!]"
                    ]
                }
            ],
            "notificationType": [
                877,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "notificationTypes": [
                880,
                {
                    "filter": [
                        878
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        881,
                        "[NotificationTypeSortOption!]"
                    ]
                }
            ],
            "notificationUnreadCount": [
                619,
                {
                    "channel": [
                        1199
                    ]
                }
            ],
            "organizationByName": [
                887,
                {
                    "name": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "organizations": [
                890,
                {
                    "filter": [
                        888
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        892,
                        "[OrganizationSortOption!]"
                    ]
                }
            ],
            "outboundTollingAgreement": [
                894,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "outboundTollingAgreements": [
                897,
                {
                    "filter": [
                        895
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        898,
                        "[OutboundTollingAgreementSortOption!]"
                    ]
                }
            ],
            "paymentTermConfig": [
                921,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "paymentTermConfigs": [
                924,
                {
                    "filter": [
                        922
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        925,
                        "[PaymentTermConfigSortOption!]"
                    ]
                }
            ],
            "payments": [
                917,
                {
                    "filter": [
                        914
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        918,
                        "[PaymentSortOption!]"
                    ]
                }
            ],
            "plaidItems": [
                940
            ],
            "port": [
                945,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "portByUnLocode": [
                945,
                {
                    "unLocode": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "ports": [
                947,
                {
                    "filter": [
                        946
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        948,
                        "[PortSortOption!]"
                    ]
                }
            ],
            "positivePayTemplate": [
                952,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "positivePayTemplates": [
                955,
                {
                    "filter": [
                        953
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        956,
                        "[PositivePayTemplateSortOption!]"
                    ]
                }
            ],
            "pricingCheckCounterpartiesInGroups": [
                607,
                {
                    "counterpartyIds": [
                        607,
                        "[ID!]!"
                    ],
                    "operationType": [
                        886
                    ]
                }
            ],
            "pricingCustomPriceListHistory": [
                900,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingDefaultPriceListHistory": [
                900,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "pricingItemPricingsWithDirtyTracking": [
                756,
                {
                    "asOf": [
                        1446
                    ],
                    "dirtyProductPricingIds": [
                        607,
                        "[ID!]"
                    ],
                    "priceListId": [
                        607,
                        "ID!"
                    ],
                    "priceListType": [
                        961,
                        "PriceListType!"
                    ]
                }
            ],
            "pricingVariableHistory": [
                900,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "printer": [
                963,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "printers": [
                966,
                {
                    "filter": [
                        964
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        968,
                        "[PrinterSortOption!]"
                    ]
                }
            ],
            "processingType": [
                971,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "processingTypes": [
                982,
                {
                    "filter": [
                        972
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        983,
                        "[ProcessingTypeSortOption!]"
                    ]
                }
            ],
            "purchaseLoad": [
                987,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "purchaseLoads": [
                1004,
                {
                    "filter": [
                        994
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1005,
                        "[PurchaseLoadSortOption!]"
                    ]
                }
            ],
            "purchaseOrderCountByStatus": [
                1025,
                {
                    "accountIds": [
                        607,
                        "[ID!]"
                    ],
                    "facilityIds": [
                        607,
                        "[ID!]"
                    ]
                }
            ],
            "purchaseOrderFreight": [
                1012,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "purchaseOrderFreights": [
                1015,
                {
                    "filter": [
                        1013
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1016,
                        "[PurchaseOrderFreightSortOption!]"
                    ]
                }
            ],
            "purchaseOrders": [
                1022,
                {
                    "filter": [
                        1011
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1023,
                        "[PurchaseOrderSortOption!]"
                    ]
                }
            ],
            "quote": [
                1028,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "quotes": [
                1035,
                {
                    "filter": [
                        1029
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1036,
                        "[QuoteSortOption!]"
                    ]
                }
            ],
            "resolveItemPrice": [
                748,
                {
                    "input": [
                        1057,
                        "ResolveItemPriceInput!"
                    ]
                }
            ],
            "route": [
                1066,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "routeFreight": [
                1069,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "routeFreights": [
                1072,
                {
                    "filter": [
                        1070
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1073,
                        "[RouteFreightSortOption!]"
                    ]
                }
            ],
            "routeLegs": [
                1075,
                {
                    "serviceIds": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "routeValidationOverride": [
                1080,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "routeValidationOverrides": [
                1083,
                {
                    "filter": [
                        1081
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1084,
                        "[RouteValidationOverrideSortOption!]"
                    ]
                }
            ],
            "routes": [
                1076,
                {
                    "filter": [
                        1068
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1077,
                        "[RouteSortOption!]"
                    ]
                }
            ],
            "salesOrderFreight": [
                1097,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "salesOrderFreights": [
                1100,
                {
                    "filter": [
                        1098
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1101,
                        "[SalesOrderFreightSortOption!]"
                    ]
                }
            ],
            "salesOrders": [
                1107,
                {
                    "filter": [
                        1096
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1108,
                        "[SalesOrderSortOption!]"
                    ]
                }
            ],
            "scale": [
                1113,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "scales": [
                1118,
                {
                    "filter": [
                        1115
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1119,
                        "[ScaleSortOption!]"
                    ]
                }
            ],
            "scanner": [
                1121,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "scanners": [
                1123,
                {
                    "filter": [
                        1122
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1124,
                        "[ScannerSortOption!]"
                    ]
                }
            ],
            "service": [
                1133,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "serviceType": [
                1145,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "serviceTypeTaskDefinition": [
                1150,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "serviceTypeTaskDefinitions": [
                1154,
                {
                    "filter": [
                        1151
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1155,
                        "[ServiceTypeTaskDefinitionSortOption!]"
                    ]
                }
            ],
            "serviceTypes": [
                1148,
                {
                    "filter": [
                        1146
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1149,
                        "[ServiceTypeSortOption!]"
                    ]
                }
            ],
            "services": [
                1141,
                {
                    "filter": [
                        1139
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1142,
                        "[ServiceSortOption!]"
                    ]
                }
            ],
            "setting": [
                1162,
                {
                    "id": [
                        1199,
                        "String!"
                    ]
                }
            ],
            "settings": [
                1164,
                {
                    "filter": [
                        1163
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1166,
                        "[SettingSortOption!]"
                    ]
                }
            ],
            "settingsGroup": [
                1168,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "settingsGroups": [
                1170,
                {
                    "filter": [
                        1169
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1171,
                        "[SettingsGroupSortOption!]"
                    ]
                }
            ],
            "shippingCarrier": [
                1175,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "shippingCarriers": [
                1178,
                {
                    "filter": [
                        1176
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1179,
                        "[ShippingCarrierSortOption!]"
                    ]
                }
            ],
            "sidecar": [
                1181,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "sidecars": [
                1184,
                {
                    "filter": [
                        1182
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1187,
                        "[SidecarSortOption!]"
                    ]
                }
            ],
            "storageQuota": [
                1198
            ],
            "task": [
                1223,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "taskService": [
                1229,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "taskServices": [
                1232,
                {
                    "filter": [
                        1230
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1233,
                        "[TaskServiceSortOption!]"
                    ]
                }
            ],
            "tasks": [
                1228,
                {
                    "filter": [
                        1224
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1235,
                        "[TaskSortOption!]"
                    ]
                }
            ],
            "ticketFreight": [
                1241,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "ticketFreights": [
                1244,
                {
                    "filter": [
                        1242
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1245,
                        "[TicketFreightSortOption!]"
                    ]
                }
            ],
            "tollReceipt": [
                1252,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tollReceipts": [
                1259,
                {
                    "filter": [
                        1253
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1260,
                        "[TollReceiptSortOption!]"
                    ]
                }
            ],
            "tollShipment": [
                1263,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tollShipments": [
                1270,
                {
                    "filter": [
                        1264
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1271,
                        "[TollShipmentSortOption!]"
                    ]
                }
            ],
            "tradeBrokeredOrderCalculateMargins": [
                743,
                {
                    "input": [
                        163,
                        "CalculateBrokeredMarginsInput!"
                    ]
                }
            ],
            "tradeBrokeredOrderValidate": [
                150,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "tradeItemPositions": [
                746,
                {
                    "filter": [
                        745
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        747,
                        "[ItemPositionSortOption!]"
                    ]
                }
            ],
            "tradeOutboxEventCounts": [
                1279
            ],
            "tradeOutboxEvents": [
                902,
                {
                    "filter": [
                        1280
                    ],
                    "pagination": [
                        906
                    ]
                }
            ],
            "trailer": [
                1281,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "trailers": [
                1283,
                {
                    "filter": [
                        1282
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1284,
                        "[TrailerSortOption!]"
                    ]
                }
            ],
            "transportationAccounts": [
                3,
                {
                    "filter": [
                        1286
                    ],
                    "pagination": [
                        906
                    ]
                }
            ],
            "transportationFacilities": [
                470,
                {
                    "filter": [
                        1288
                    ],
                    "pagination": [
                        906
                    ]
                }
            ],
            "transportationOutboxEventCounts": [
                1289
            ],
            "transportationOutboxEvents": [
                902,
                {
                    "filter": [
                        1290
                    ],
                    "pagination": [
                        906
                    ]
                }
            ],
            "transportationRouteValidate": [
                1086,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationServiceValidate": [
                1086,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationType": [
                1291,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "transportationTypes": [
                1293,
                {
                    "filter": [
                        1292
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1294,
                        "[TransportationTypeSortOption!]"
                    ]
                }
            ],
            "truck": [
                1299,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "trucks": [
                1302,
                {
                    "filter": [
                        1300
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1303,
                        "[TruckSortOption!]"
                    ]
                }
            ],
            "userContactsList": [
                1375,
                {
                    "filter": [
                        1374,
                        "UserContactsFilter!"
                    ]
                }
            ],
            "userPreferences": [
                1380,
                {
                    "userId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "users": [
                1382,
                {
                    "filter": [
                        1377
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1388,
                        "[UserSortOption!]"
                    ]
                }
            ],
            "variable": [
                1392,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "variables": [
                1395,
                {
                    "filter": [
                        1393
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1396,
                        "[VariableSortOption!]"
                    ]
                }
            ],
            "voucherTemplate": [
                1406,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "voucherTemplates": [
                1409,
                {
                    "filter": [
                        1407
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1410,
                        "[VoucherTemplateSortOption!]"
                    ]
                }
            ],
            "warehouseCredential": [
                1418,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "warehouseCredentials": [
                1420,
                {
                    "filter": [
                        1419
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1421,
                        "[WarehouseCredentialSortOption!]"
                    ]
                }
            ],
            "workOrder": [
                1427,
                {
                    "id": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "workOrders": [
                1438,
                {
                    "filter": [
                        1428
                    ],
                    "pagination": [
                        906
                    ],
                    "sorting": [
                        1439,
                        "[WorkOrderSortOption!]"
                    ]
                }
            ],
            "__typename": [
                1199
            ]
        },
        "Quote": {
            "account": [
                3
            ],
            "accountId": [
                607
            ],
            "convertedToOrder": [
                1090
            ],
            "convertedToOrderId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "documentNumber": [
                1199
            ],
            "expectedShipDate": [
                1446
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "freightCoveredByCustomer": [
                137
            ],
            "freightTerm": [
                572
            ],
            "id": [
                607
            ],
            "lineItems": [
                1031
            ],
            "notes": [
                1199
            ],
            "paymentCurrency": [
                355
            ],
            "paymentTerm": [
                920
            ],
            "quoteDeadline": [
                1446
            ],
            "status": [
                1037
            ],
            "subtotal": [
                835
            ],
            "terms": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "type": [
                1038
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "validUntil": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "QuoteFilter": {
            "accountIds": [
                607
            ],
            "documentNumber": [
                1199
            ],
            "facilityIds": [
                607
            ],
            "fromCreatedAt": [
                1446
            ],
            "ids": [
                607
            ],
            "includeLineItems": [
                137
            ],
            "searchTerm": [
                1199
            ],
            "statuses": [
                1037
            ],
            "toCreatedAt": [
                1446
            ],
            "types": [
                1038
            ],
            "__typename": [
                1199
            ]
        },
        "QuoteInput": {
            "accountId": [
                607
            ],
            "documentNumber": [
                1199
            ],
            "expectedShipDate": [
                1446
            ],
            "facilityId": [
                607
            ],
            "freightCoveredByCustomer": [
                137
            ],
            "freightTerm": [
                572
            ],
            "lineItems": [
                332
            ],
            "notes": [
                1199
            ],
            "paymentCurrency": [
                355
            ],
            "paymentTerm": [
                920
            ],
            "quoteDeadline": [
                1446
            ],
            "terms": [
                1199
            ],
            "type": [
                1038
            ],
            "validUntil": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "QuoteLineItem": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "id": [
                607
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "packageFormat": [
                1199
            ],
            "quantity": [
                393
            ],
            "quote": [
                1028
            ],
            "quoteId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "totalPrice": [
                835
            ],
            "unit": [
                1307
            ],
            "unitPrice": [
                835
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "QuoteLineItemFilter": {
            "ids": [
                607
            ],
            "itemId": [
                607
            ],
            "itemIds": [
                607
            ],
            "notes": [
                1199
            ],
            "packageFormat": [
                1199
            ],
            "quoteId": [
                607
            ],
            "quoteIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "QuoteLineItemResultPage": {
            "entries": [
                1031
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "QuoteLineItemSortOption": {},
        "QuoteResultPage": {
            "entries": [
                1028
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "QuoteSortOption": {},
        "QuoteStatus": {},
        "QuoteType": {},
        "QuoteUpdateInput": {
            "accountId": [
                607
            ],
            "documentNumber": [
                1199
            ],
            "expectedShipDate": [
                1446
            ],
            "facilityId": [
                607
            ],
            "freightCoveredByCustomer": [
                137
            ],
            "freightTerm": [
                572
            ],
            "lineItems": [
                1349
            ],
            "notes": [
                1199
            ],
            "paymentCurrency": [
                355
            ],
            "paymentTerm": [
                920
            ],
            "quoteDeadline": [
                1446
            ],
            "terms": [
                1199
            ],
            "type": [
                1038
            ],
            "validUntil": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "ReceiveInvoiceInput": {
            "accountId": [
                607
            ],
            "achNumber": [
                1199
            ],
            "checkAttn": [
                1199
            ],
            "checkFacilityId": [
                607
            ],
            "checkMemo": [
                1199
            ],
            "checkNumber": [
                1199
            ],
            "creatorId": [
                607
            ],
            "creatorPlatform": [
                351
            ],
            "financialAccountId": [
                607
            ],
            "invoices": [
                1041
            ],
            "paymentMethod": [
                916
            ],
            "transactionDate": [
                168
            ],
            "wireNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ReceiveInvoiceItemInput": {
            "appliedAmount": [
                836
            ],
            "invoiceId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ReceiveInvoiceResult": {
            "belowWarningThreshold": [
                137
            ],
            "payment": [
                911
            ],
            "__typename": [
                1199
            ]
        },
        "ReceivedLineItem": {
            "customerGrossWeight": [
                1424
            ],
            "customerTareWeight": [
                1424
            ],
            "customerUnitPrice": [
                835
            ],
            "grossWeight": [
                1424
            ],
            "id": [
                607
            ],
            "itemId": [
                607
            ],
            "loadLineItemId": [
                607
            ],
            "materialType": [
                1199
            ],
            "netWeight": [
                1424
            ],
            "notes": [
                1199
            ],
            "pricingUnit": [
                1199
            ],
            "tareWeight": [
                1424
            ],
            "timestamps": [
                1250
            ],
            "totalValue": [
                835
            ],
            "unitPrice": [
                835
            ],
            "__typename": [
                1199
            ]
        },
        "ReceivedLineItemInput": {
            "customerGrossWeight": [
                1426
            ],
            "customerTareWeight": [
                1426
            ],
            "customerUnitPrice": [
                836
            ],
            "grossWeight": [
                1426
            ],
            "id": [
                607
            ],
            "itemId": [
                607
            ],
            "loadLineItemId": [
                607
            ],
            "materialType": [
                1199
            ],
            "notes": [
                1199
            ],
            "pricingUnit": [
                1199
            ],
            "tareWeight": [
                1426
            ],
            "unitPrice": [
                836
            ],
            "__typename": [
                1199
            ]
        },
        "ReconcileCashDrawerInput": {
            "financialAccountId": [
                607
            ],
            "notes": [
                1199
            ],
            "physicalCount": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "ReconcileCashDrawerPayload": {
            "adjustment": [
                519
            ],
            "discrepancy": [
                393
            ],
            "systemBalance": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "ReconciliationDeduction": {
            "deductionType": [
                395
            ],
            "deductionTypeId": [
                607
            ],
            "id": [
                607
            ],
            "loadLineItemId": [
                607
            ],
            "priceQuantity": [
                835
            ],
            "receivedLineItemId": [
                607
            ],
            "reconciliationId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "totalDeduction": [
                835
            ],
            "weightQuantity": [
                1424
            ],
            "__typename": [
                1199
            ]
        },
        "ReconciliationDeductionInput": {
            "deductionTypeId": [
                607
            ],
            "id": [
                607
            ],
            "loadLineItemId": [
                607
            ],
            "priceQuantity": [
                836
            ],
            "receivedLineItemId": [
                607
            ],
            "weightQuantity": [
                1426
            ],
            "__typename": [
                1199
            ]
        },
        "RecurrenceType": {},
        "RecurringSchedule": {
            "dayOfMonth": [
                619
            ],
            "duration": [
                619
            ],
            "firstOccurrenceAt": [
                1446
            ],
            "interval": [
                619
            ],
            "monthlyOccurrence": [
                837
            ],
            "monthlyWeekday": [
                1423
            ],
            "repeatUntil": [
                1446
            ],
            "type": [
                1049
            ],
            "weekdays": [
                1423
            ],
            "__typename": [
                1199
            ]
        },
        "RecurringScheduleInput": {
            "dayOfMonth": [
                619
            ],
            "interval": [
                619
            ],
            "monthlyOccurrence": [
                837
            ],
            "monthlyWeekday": [
                1423
            ],
            "type": [
                1049
            ],
            "weekdays": [
                1423
            ],
            "__typename": [
                1199
            ]
        },
        "RelationshipType": {},
        "RemoveAdvanceApplicationInput": {
            "documentId": [
                607
            ],
            "documentType": [
                913
            ],
            "paymentId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "RemoveFileFromTemplatePayload": {
            "success": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "RemoveUsersFromRoleInput": {
            "facilityId": [
                607
            ],
            "roleId": [
                607
            ],
            "userIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ReportingUploadType": {},
        "ResolveItemPriceInput": {
            "counterpartyAccountId": [
                607
            ],
            "currency": [
                1199
            ],
            "displayPricingUnit": [
                1307
            ],
            "facilityId": [
                607
            ],
            "itemId": [
                607
            ],
            "operationType": [
                886
            ],
            "__typename": [
                1199
            ]
        },
        "RespondApprovalInput": {
            "approved": [
                137
            ],
            "comment": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "Role": {
            "archived": [
                137
            ],
            "description": [
                1199
            ],
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "organizationId": [
                607
            ],
            "permissions": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "type": [
                1063
            ],
            "__typename": [
                1199
            ]
        },
        "RoleFilter": {
            "ids": [
                607
            ],
            "includeArchived": [
                137
            ],
            "pagination": [
                906
            ],
            "searchTerm": [
                1199
            ],
            "sorting": [
                1062
            ],
            "type": [
                1063
            ],
            "__typename": [
                1199
            ]
        },
        "RoleResultPage": {
            "entries": [
                1059
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "RoleSortOption": {},
        "RoleType": {},
        "RoundingMethod": {},
        "RoundingPrecision": {},
        "Route": {
            "assignedAt": [
                1446
            ],
            "assignmentStatus": [
                71
            ],
            "completedAt": [
                1446
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "description": [
                1199
            ],
            "documentNumber": [
                1199
            ],
            "driver": [
                439
            ],
            "driverId": [
                607
            ],
            "driverProgress": [
                451
            ],
            "estimatedArrival": [
                1446
            ],
            "facilityGroupId": [
                607
            ],
            "haulerId": [
                607
            ],
            "haulerProgress": [
                601
            ],
            "id": [
                607
            ],
            "isTemplate": [
                137
            ],
            "legs": [
                1075
            ],
            "notes": [
                1199
            ],
            "priority": [
                619
            ],
            "rank": [
                1199
            ],
            "routeDate": [
                1446
            ],
            "services": [
                1133
            ],
            "startedAt": [
                1446
            ],
            "status": [
                1078
            ],
            "tasks": [
                1223
            ],
            "timestamps": [
                1250
            ],
            "trailerId": [
                607
            ],
            "truckId": [
                607
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "RouteAssignInput": {
            "assignmentStatus": [
                71
            ],
            "driverId": [
                607
            ],
            "estimatedArrival": [
                1446
            ],
            "haulerId": [
                607
            ],
            "id": [
                607
            ],
            "trailerId": [
                607
            ],
            "truckId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "RouteFilter": {
            "completedAfter": [
                1446
            ],
            "completedBefore": [
                1446
            ],
            "driverIds": [
                607
            ],
            "haulerIds": [
                607
            ],
            "ids": [
                607
            ],
            "lastUpdatedAt": [
                1446
            ],
            "routeDateAfter": [
                1446
            ],
            "routeDateBefore": [
                1446
            ],
            "routeIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "serviceIds": [
                607
            ],
            "startedAfter": [
                1446
            ],
            "startedBefore": [
                1446
            ],
            "status": [
                1078
            ],
            "trailerIds": [
                607
            ],
            "truckIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "RouteFreight": {
            "baseCostAmount": [
                393
            ],
            "baseCostCurrencyCode": [
                1199
            ],
            "carrierId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "destinationLocationId": [
                607
            ],
            "detentionCostAmount": [
                393
            ],
            "detentionCostCurrencyCode": [
                1199
            ],
            "distance": [
                393
            ],
            "freightLaneId": [
                607
            ],
            "fuelSurchargeAmount": [
                393
            ],
            "fuelSurchargeCurrencyCode": [
                1199
            ],
            "id": [
                607
            ],
            "originLocationId": [
                607
            ],
            "routeId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "totalCost": [
                835
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "RouteFreightFilter": {
            "carrierId": [
                607
            ],
            "ids": [
                607
            ],
            "routeId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "RouteFreightInput": {
            "baseCostAmount": [
                393
            ],
            "baseCostCurrencyCode": [
                1199
            ],
            "carrierId": [
                607
            ],
            "destinationLocationId": [
                607
            ],
            "detentionCostAmount": [
                393
            ],
            "detentionCostCurrencyCode": [
                1199
            ],
            "distance": [
                393
            ],
            "freightLaneId": [
                607
            ],
            "fuelSurchargeAmount": [
                393
            ],
            "fuelSurchargeCurrencyCode": [
                1199
            ],
            "originLocationId": [
                607
            ],
            "routeId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "RouteFreightResultPage": {
            "entries": [
                1069
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "RouteFreightSortOption": {},
        "RouteFreightUpdateInput": {
            "baseCostAmount": [
                393
            ],
            "baseCostCurrencyCode": [
                1199
            ],
            "carrierId": [
                607
            ],
            "destinationLocationId": [
                607
            ],
            "detentionCostAmount": [
                393
            ],
            "detentionCostCurrencyCode": [
                1199
            ],
            "distance": [
                393
            ],
            "freightLaneId": [
                607
            ],
            "fuelSurchargeAmount": [
                393
            ],
            "fuelSurchargeCurrencyCode": [
                1199
            ],
            "originLocationId": [
                607
            ],
            "routeId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "RouteLeg": {
            "distance": [
                538
            ],
            "duration": [
                619
            ],
            "end": [
                1133
            ],
            "start": [
                1133
            ],
            "__typename": [
                1199
            ]
        },
        "RouteResultPage": {
            "entries": [
                1066
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "RouteSortOption": {},
        "RouteStatus": {},
        "RouteTransitionInput": {
            "id": [
                607
            ],
            "notes": [
                1199
            ],
            "status": [
                1078
            ],
            "__typename": [
                1199
            ]
        },
        "RouteValidationOverride": {
            "approvedBy": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "facilityGroup": [
                480
            ],
            "facilityGroupId": [
                607
            ],
            "id": [
                607
            ],
            "justification": [
                1199
            ],
            "routeId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "violationKey": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "RouteValidationOverrideFilter": {
            "facilityGroupId": [
                607
            ],
            "facilityGroupIds": [
                607
            ],
            "ids": [
                607
            ],
            "justification": [
                1199
            ],
            "routeId": [
                607
            ],
            "routeIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "violationKey": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "RouteValidationOverrideInput": {
            "approvedBy": [
                607
            ],
            "facilityGroupId": [
                607
            ],
            "justification": [
                1199
            ],
            "routeId": [
                607
            ],
            "violationKey": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "RouteValidationOverrideResultPage": {
            "entries": [
                1080
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "RouteValidationOverrideSortOption": {},
        "RouteValidationOverrideUpdateInput": {
            "approvedBy": [
                607
            ],
            "facilityGroupId": [
                607
            ],
            "justification": [
                1199
            ],
            "routeId": [
                607
            ],
            "violationKey": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "RouteValidationResult": {
            "canOverride": [
                137
            ],
            "isValid": [
                137
            ],
            "requiredOverrides": [
                1199
            ],
            "violations": [
                1087
            ],
            "__typename": [
                1199
            ]
        },
        "RouteValidationViolation": {
            "assetId": [
                607
            ],
            "message": [
                1199
            ],
            "overrideKey": [
                1199
            ],
            "routePosition": [
                538
            ],
            "serviceId": [
                607
            ],
            "severity": [
                1400
            ],
            "taskId": [
                607
            ],
            "type": [
                1401
            ],
            "__typename": [
                1199
            ]
        },
        "SalesItemLineType": {},
        "SalesLoadLineItemPhase": {},
        "SalesOrder": {
            "account": [
                3
            ],
            "accountId": [
                607
            ],
            "accountRepresentative": [
                1372
            ],
            "accountRepresentativeId": [
                607
            ],
            "billingAddress": [
                30
            ],
            "billingAddressId": [
                607
            ],
            "bookings": [
                123
            ],
            "completionNotes": [
                1199
            ],
            "contact": [
                255
            ],
            "contactId": [
                607
            ],
            "counterpartyReferenceNumber": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "customAttributes": [
                828
            ],
            "customerExternalNotes": [
                1199
            ],
            "customerFiles": [
                494
            ],
            "customerInternalNotes": [
                1199
            ],
            "doNotShip": [
                137
            ],
            "documentNumber": [
                1199
            ],
            "endDate": [
                168
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "freightTerm": [
                572
            ],
            "fulfilledPercentage": [
                393
            ],
            "id": [
                607
            ],
            "lineItems": [
                1103
            ],
            "netWeight": [
                1424
            ],
            "organization": [
                887
            ],
            "organizationId": [
                607
            ],
            "paymentCurrency": [
                1199
            ],
            "paymentTerm": [
                920
            ],
            "recyclerExternalNotes": [
                1199
            ],
            "recyclerFiles": [
                494
            ],
            "recyclerInternalNotes": [
                1199
            ],
            "shippedLoadsCount": [
                619
            ],
            "shippingAddress": [
                30
            ],
            "shippingAddressId": [
                607
            ],
            "startDate": [
                168
            ],
            "status": [
                1109
            ],
            "timestamps": [
                1250
            ],
            "totalPrice": [
                835
            ],
            "type": [
                1110
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "weightDisplayUnit": [
                1425
            ],
            "__typename": [
                1199
            ]
        },
        "SalesOrderCreateInput": {
            "accountId": [
                607
            ],
            "accountRepresentativeId": [
                607
            ],
            "billingAddress": [
                31
            ],
            "billingAddressId": [
                607
            ],
            "bookingIds": [
                607
            ],
            "completionNotes": [
                1199
            ],
            "contactId": [
                607
            ],
            "counterpartyReferenceNumber": [
                1199
            ],
            "customAttributes": [
                828
            ],
            "customerExternalNotes": [
                1199
            ],
            "customerInternalNotes": [
                1199
            ],
            "doNotShip": [
                137
            ],
            "documentNumber": [
                1199
            ],
            "endDate": [
                168
            ],
            "facilityId": [
                607
            ],
            "freightTerm": [
                572
            ],
            "lineItems": [
                1104
            ],
            "paymentCurrency": [
                1199
            ],
            "paymentTerm": [
                920
            ],
            "recyclerExternalNotes": [
                1199
            ],
            "recyclerInternalNotes": [
                1199
            ],
            "shippingAddress": [
                31
            ],
            "shippingAddressId": [
                607
            ],
            "startDate": [
                168
            ],
            "status": [
                1109
            ],
            "type": [
                1110
            ],
            "weightDisplayUnit": [
                1425
            ],
            "__typename": [
                1199
            ]
        },
        "SalesOrderCustomerFileCreatePayload": {
            "file": [
                494
            ],
            "uploadUrl": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "SalesOrderCustomerFileInput": {
            "fileName": [
                1199
            ],
            "fileSize": [
                619
            ],
            "mimeType": [
                1199
            ],
            "public": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "SalesOrderFileCreatePayload": {
            "file": [
                494
            ],
            "uploadUrl": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "SalesOrderFileInput": {
            "fileName": [
                1199
            ],
            "fileSize": [
                619
            ],
            "mimeType": [
                1199
            ],
            "public": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "SalesOrderFilter": {
            "accountIds": [
                607
            ],
            "accountRepresentativeIds": [
                607
            ],
            "contactIds": [
                607
            ],
            "counterpartyReferenceNumber": [
                1199
            ],
            "createdBy": [
                607
            ],
            "documentNumber": [
                1199
            ],
            "facilityIds": [
                607
            ],
            "freightTerms": [
                572
            ],
            "fromCreatedAt": [
                168
            ],
            "fromEndDate": [
                168
            ],
            "fromStartDate": [
                168
            ],
            "ids": [
                607
            ],
            "includeLineItems": [
                137
            ],
            "lastUpdatedAt": [
                1446
            ],
            "paymentCurrencies": [
                1199
            ],
            "paymentTerms": [
                920
            ],
            "searchTerm": [
                1199
            ],
            "status": [
                1109
            ],
            "toCreatedAt": [
                168
            ],
            "toEndDate": [
                168
            ],
            "toStartDate": [
                168
            ],
            "type": [
                1110
            ],
            "updatedBy": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "SalesOrderFreight": {
            "carrierId": [
                607
            ],
            "chargebackFormula": [
                1199
            ],
            "chargebackVariableIds": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "freightLaneId": [
                1199
            ],
            "fuelSurchargeFormula": [
                1199
            ],
            "fuelSurchargeMode": [
                1199
            ],
            "fuelSurchargeVariableIds": [
                1199
            ],
            "id": [
                607
            ],
            "notes": [
                1199
            ],
            "rateFormula": [
                1199
            ],
            "rateVariableIds": [
                1199
            ],
            "salesOrderId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "SalesOrderFreightFilter": {
            "ids": [
                607
            ],
            "salesOrderId": [
                607
            ],
            "salesOrderIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "SalesOrderFreightInput": {
            "carrierId": [
                607
            ],
            "chargebackFormula": [
                1199
            ],
            "chargebackVariableIds": [
                1199
            ],
            "freightLaneId": [
                1199
            ],
            "fuelSurchargeFormula": [
                1199
            ],
            "fuelSurchargeMode": [
                1199
            ],
            "fuelSurchargeVariableIds": [
                1199
            ],
            "notes": [
                1199
            ],
            "rateFormula": [
                1199
            ],
            "rateVariableIds": [
                1199
            ],
            "salesOrderId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "SalesOrderFreightResultPage": {
            "entries": [
                1097
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "SalesOrderFreightSortOption": {},
        "SalesOrderFreightUpdateInput": {
            "carrierId": [
                607
            ],
            "chargebackFormula": [
                1199
            ],
            "chargebackVariableIds": [
                1199
            ],
            "freightLaneId": [
                1199
            ],
            "fuelSurchargeFormula": [
                1199
            ],
            "fuelSurchargeMode": [
                1199
            ],
            "fuelSurchargeVariableIds": [
                1199
            ],
            "notes": [
                1199
            ],
            "rateFormula": [
                1199
            ],
            "rateVariableIds": [
                1199
            ],
            "salesOrderId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "SalesOrderLineItem": {
            "id": [
                607
            ],
            "item": [
                727
            ],
            "quantity": [
                393
            ],
            "timestamps": [
                1250
            ],
            "totalPrice": [
                835
            ],
            "unit": [
                1307
            ],
            "unitPrice": [
                835
            ],
            "__typename": [
                1199
            ]
        },
        "SalesOrderLineItemInput": {
            "id": [
                607
            ],
            "itemId": [
                607
            ],
            "quantity": [
                393
            ],
            "totalPrice": [
                836
            ],
            "unit": [
                1307
            ],
            "unitPrice": [
                836
            ],
            "__typename": [
                1199
            ]
        },
        "SalesOrderRecyclerFileCreatePayload": {
            "file": [
                494
            ],
            "uploadUrl": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "SalesOrderRecyclerFileInput": {
            "fileName": [
                1199
            ],
            "fileSize": [
                619
            ],
            "mimeType": [
                1199
            ],
            "public": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "SalesOrderResultPage": {
            "entries": [
                1090
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "SalesOrderSortOption": {},
        "SalesOrderStatus": {},
        "SalesOrderType": {},
        "SalesOrderUpdateInput": {
            "accountId": [
                607
            ],
            "accountRepresentativeId": [
                607
            ],
            "billingAddress": [
                31
            ],
            "billingAddressId": [
                607
            ],
            "bookingIds": [
                607
            ],
            "completionNotes": [
                1199
            ],
            "contactId": [
                607
            ],
            "counterpartyReferenceNumber": [
                1199
            ],
            "customAttributes": [
                828
            ],
            "customerExternalNotes": [
                1199
            ],
            "customerInternalNotes": [
                1199
            ],
            "doNotShip": [
                137
            ],
            "documentNumber": [
                1199
            ],
            "endDate": [
                168
            ],
            "facilityId": [
                607
            ],
            "freightTerm": [
                572
            ],
            "lineItems": [
                1104
            ],
            "paymentCurrency": [
                1199
            ],
            "paymentTerm": [
                920
            ],
            "recyclerExternalNotes": [
                1199
            ],
            "recyclerInternalNotes": [
                1199
            ],
            "shippingAddress": [
                31
            ],
            "shippingAddressId": [
                607
            ],
            "startDate": [
                168
            ],
            "status": [
                1109
            ],
            "type": [
                1110
            ],
            "weightDisplayUnit": [
                1425
            ],
            "__typename": [
                1199
            ]
        },
        "SalesOrderUpdateResult": {
            "blockingLoads": [
                34
            ],
            "removedBookingId": [
                607
            ],
            "requiresConfirmation": [
                137
            ],
            "salesOrder": [
                1090
            ],
            "unlinkableLoads": [
                34
            ],
            "__typename": [
                1199
            ]
        },
        "Scale": {
            "baudRate": [
                619
            ],
            "camera": [
                170
            ],
            "cameraId": [
                607
            ],
            "connectionType": [
                1114
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "dataBits": [
                619
            ],
            "driverType": [
                1199
            ],
            "id": [
                607
            ],
            "lastSeenAt": [
                1446
            ],
            "measurementIncrement": [
                393
            ],
            "measurementMode": [
                1117
            ],
            "name": [
                1199
            ],
            "onDemandString": [
                1199
            ],
            "online": [
                137
            ],
            "parity": [
                1199
            ],
            "scaleFormatType": [
                1116
            ],
            "serialPortPath": [
                1199
            ],
            "sidecar": [
                1181
            ],
            "sidecarId": [
                607
            ],
            "status": [
                1120
            ],
            "stopBits": [
                1199
            ],
            "tcpHost": [
                1199
            ],
            "tcpPort": [
                619
            ],
            "timestamps": [
                1250
            ],
            "uniqueId": [
                1199
            ],
            "unitOfMeasurement": [
                1199
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ScaleConnectionType": {},
        "ScaleFilter": {
            "facilityId": [
                607
            ],
            "ids": [
                607
            ],
            "sidecarId": [
                607
            ],
            "status": [
                1120
            ],
            "__typename": [
                1199
            ]
        },
        "ScaleFormatType": {},
        "ScaleMeasurementMode": {},
        "ScaleResultPage": {
            "entries": [
                1113
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ScaleSortOption": {},
        "ScaleStatus": {},
        "Scanner": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "driverType": [
                1199
            ],
            "firmwareVersion": [
                1199
            ],
            "id": [
                607
            ],
            "lastSeenAt": [
                1446
            ],
            "manufacturer": [
                1199
            ],
            "model": [
                1199
            ],
            "name": [
                1199
            ],
            "online": [
                137
            ],
            "sidecar": [
                1181
            ],
            "sidecarId": [
                607
            ],
            "status": [
                1125
            ],
            "timestamps": [
                1250
            ],
            "uniqueId": [
                1199
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ScannerFilter": {
            "facilityId": [
                607
            ],
            "ids": [
                607
            ],
            "sidecarId": [
                607
            ],
            "status": [
                1125
            ],
            "__typename": [
                1199
            ]
        },
        "ScannerResultPage": {
            "entries": [
                1121
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ScannerSortOption": {},
        "ScannerStatus": {},
        "ScheduleTriggerConfigOutput": {
            "cron": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ScheduleTriggerNode": {
            "cronExpression": [
                1199
            ],
            "description": [
                1199
            ],
            "id": [
                607
            ],
            "label": [
                1199
            ],
            "position": [
                949
            ],
            "timezone": [
                1199
            ],
            "type": [
                848
            ],
            "__typename": [
                1199
            ]
        },
        "SecureString": {},
        "SemaphorToken": {
            "accessToken": [
                1199
            ],
            "dashboardId": [
                1199
            ],
            "refreshToken": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "SendAssistantChatMessageInput": {
            "content": [
                1199
            ],
            "fileIds": [
                607
            ],
            "metadata": [
                182
            ],
            "__typename": [
                1199
            ]
        },
        "SendPriceListNotificationInput": {
            "bcc": [
                1199
            ],
            "body": [
                1199
            ],
            "cc": [
                1199
            ],
            "priceListId": [
                607
            ],
            "priceListType": [
                1199
            ],
            "subject": [
                1199
            ],
            "templateFileId": [
                1199
            ],
            "to": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "SendPriceListNotificationResult": {
            "fileId": [
                607
            ],
            "messageId": [
                1199
            ],
            "success": [
                137
            ],
            "workflowId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "Service": {
            "account": [
                3
            ],
            "accountAddress": [
                4
            ],
            "accountAddressId": [
                607
            ],
            "accountId": [
                607
            ],
            "actions": [
                1134
            ],
            "address": [
                30
            ],
            "assetRequirements": [
                1134
            ],
            "assignedAt": [
                1446
            ],
            "assignmentStatus": [
                71
            ],
            "completedAt": [
                1446
            ],
            "contactId": [
                607
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "deadline": [
                1446
            ],
            "destinationFacilityId": [
                607
            ],
            "documentNumber": [
                1199
            ],
            "driver": [
                439
            ],
            "driverId": [
                607
            ],
            "driverNotes": [
                1199
            ],
            "driverProgress": [
                451
            ],
            "estimatedArrival": [
                1446
            ],
            "externalNotes": [
                1199
            ],
            "facility": [
                470
            ],
            "facilityGroupId": [
                607
            ],
            "facilityId": [
                607
            ],
            "haulerId": [
                607
            ],
            "haulerProgress": [
                601
            ],
            "id": [
                607
            ],
            "internalNotes": [
                1199
            ],
            "isRequest": [
                137
            ],
            "isTemplate": [
                137
            ],
            "nonDefaultTrailer": [
                137
            ],
            "nonDefaultTruck": [
                137
            ],
            "priority": [
                619
            ],
            "rank": [
                1199
            ],
            "recurringSchedule": [
                1050
            ],
            "recurringTaskId": [
                607
            ],
            "relationshipType": [
                1052
            ],
            "requirements": [
                1140
            ],
            "routeId": [
                607
            ],
            "routePosition": [
                393
            ],
            "scheduledWindowEnd": [
                1446
            ],
            "scheduledWindowStart": [
                1446
            ],
            "serviceType": [
                1145
            ],
            "serviceTypeId": [
                607
            ],
            "startedAt": [
                1446
            ],
            "status": [
                1143
            ],
            "tasks": [
                1223
            ],
            "timestamps": [
                1250
            ],
            "trailer": [
                1281
            ],
            "trailerId": [
                607
            ],
            "truck": [
                1299
            ],
            "truckId": [
                607
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceAction": {
            "actionType": [
                28
            ],
            "asset": [
                54
            ],
            "assetGroup": [
                619
            ],
            "assetId": [
                607
            ],
            "assetType": [
                66
            ],
            "assetTypeId": [
                607
            ],
            "quantity": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceActionInput": {
            "actionType": [
                28
            ],
            "assetGroup": [
                619
            ],
            "assetId": [
                607
            ],
            "assetTypeId": [
                607
            ],
            "quantity": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceAssetInput": {
            "assetId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceAssetTypeInput": {
            "assetGroup": [
                619
            ],
            "assetTypeId": [
                607
            ],
            "quantity": [
                538
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceAssignInput": {
            "assignmentStatus": [
                71
            ],
            "driverId": [
                607
            ],
            "estimatedArrival": [
                1446
            ],
            "haulerId": [
                607
            ],
            "id": [
                607
            ],
            "trailerId": [
                607
            ],
            "truckId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceFilter": {
            "accountAddressIds": [
                607
            ],
            "accountIds": [
                607
            ],
            "completedAfter": [
                1446
            ],
            "completedBefore": [
                1446
            ],
            "driverIds": [
                607
            ],
            "haulerIds": [
                607
            ],
            "ids": [
                607
            ],
            "isStandalone": [
                137
            ],
            "lastUpdatedAt": [
                1446
            ],
            "maxPriority": [
                619
            ],
            "minPriority": [
                619
            ],
            "routeIds": [
                607
            ],
            "scheduledEndAfter": [
                1446
            ],
            "scheduledEndBefore": [
                1446
            ],
            "scheduledStartAfter": [
                1446
            ],
            "scheduledStartBefore": [
                1446
            ],
            "searchTerm": [
                1199
            ],
            "serviceTypeId": [
                607
            ],
            "status": [
                1143
            ],
            "trailerIds": [
                607
            ],
            "truckIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceRequirement": {},
        "ServiceResultPage": {
            "entries": [
                1133
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceSortOption": {},
        "ServiceStatus": {},
        "ServiceTransitionInput": {
            "id": [
                607
            ],
            "notes": [
                1199
            ],
            "status": [
                1143
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceType": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "description": [
                1199
            ],
            "id": [
                607
            ],
            "isActive": [
                137
            ],
            "isSystemDefault": [
                137
            ],
            "name": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceTypeFilter": {
            "description": [
                1199
            ],
            "ids": [
                607
            ],
            "isActive": [
                137
            ],
            "isSystemDefault": [
                137
            ],
            "name": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceTypeInput": {
            "description": [
                1199
            ],
            "isActive": [
                137
            ],
            "isSystemDefault": [
                137
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceTypeResultPage": {
            "entries": [
                1145
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceTypeSortOption": {},
        "ServiceTypeTaskDefinition": {
            "allowLocationOverride": [
                137
            ],
            "assetGroup": [
                619
            ],
            "assetRole": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "fillStateCondition": [
                1199
            ],
            "id": [
                607
            ],
            "locationRef": [
                1199
            ],
            "sequence": [
                619
            ],
            "serviceTypeId": [
                607
            ],
            "taskType": [
                1237
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceTypeTaskDefinitionFilter": {
            "assetRole": [
                1199
            ],
            "fillStateCondition": [
                1199
            ],
            "ids": [
                607
            ],
            "locationRef": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "serviceTypeId": [
                607
            ],
            "serviceTypeIds": [
                607
            ],
            "taskType": [
                1237
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceTypeTaskDefinitionInlineInput": {
            "sequence": [
                619
            ],
            "taskType": [
                1237
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceTypeTaskDefinitionInput": {
            "allowLocationOverride": [
                137
            ],
            "assetGroup": [
                619
            ],
            "assetRole": [
                1199
            ],
            "fillStateCondition": [
                1199
            ],
            "locationRef": [
                1199
            ],
            "sequence": [
                619
            ],
            "serviceTypeId": [
                607
            ],
            "taskType": [
                1237
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceTypeTaskDefinitionResultPage": {
            "entries": [
                1150
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceTypeTaskDefinitionSortOption": {},
        "ServiceTypeTaskDefinitionUpdateInput": {
            "allowLocationOverride": [
                137
            ],
            "assetGroup": [
                619
            ],
            "assetRole": [
                1199
            ],
            "fillStateCondition": [
                1199
            ],
            "locationRef": [
                1199
            ],
            "sequence": [
                619
            ],
            "serviceTypeId": [
                607
            ],
            "taskType": [
                1237
            ],
            "__typename": [
                1199
            ]
        },
        "ServiceTypeUpdateInput": {
            "description": [
                1199
            ],
            "isActive": [
                137
            ],
            "isSystemDefault": [
                137
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "SetAgentToolsInput": {
            "toolIds": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "SetFileAsTemplateInput": {
            "description": [
                1199
            ],
            "fileId": [
                607
            ],
            "isDefault": [
                137
            ],
            "type": [
                508
            ],
            "__typename": [
                1199
            ]
        },
        "SetFileAsTemplatePayload": {
            "template": [
                504
            ],
            "__typename": [
                1199
            ]
        },
        "SetTemplateAsDefaultPayload": {
            "template": [
                504
            ],
            "__typename": [
                1199
            ]
        },
        "Setting": {
            "constraints": [
                491
            ],
            "dataType": [
                493
            ],
            "defaultValue": [
                41
            ],
            "description": [
                1199
            ],
            "id": [
                1199
            ],
            "name": [
                1199
            ],
            "scope": [
                1165
            ],
            "settingsGroup": [
                1168
            ],
            "settingsGroupId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "values": [
                1167
            ],
            "__typename": [
                1199
            ]
        },
        "SettingFilter": {
            "dataType": [
                493
            ],
            "scope": [
                1165
            ],
            "searchTerm": [
                1199
            ],
            "settingsGroupId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "SettingResultPage": {
            "entries": [
                1162
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "SettingScope": {},
        "SettingSortOption": {},
        "SettingValue": {
            "objectId": [
                607
            ],
            "scope": [
                1165
            ],
            "value": [
                41
            ],
            "__typename": [
                1199
            ]
        },
        "SettingsGroup": {
            "createdAt": [
                1446
            ],
            "description": [
                1199
            ],
            "icon": [
                1199
            ],
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "settings": [
                1162
            ],
            "updatedAt": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "SettingsGroupFilter": {
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "SettingsGroupResultPage": {
            "entries": [
                1168
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "SettingsGroupSortOption": {},
        "SettlementBasis": {},
        "ShareFileInput": {
            "fileId": [
                607
            ],
            "permission": [
                502
            ],
            "userIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "ShareFilePayload": {
            "file": [
                494
            ],
            "sharedWithCount": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "ShippingCarrier": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "ShippingCarrierFilter": {
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ShippingCarrierInput": {
            "facilityId": [
                607
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ShippingCarrierResultPage": {
            "entries": [
                1175
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "ShippingCarrierSortOption": {},
        "ShippingCarrierUpdateInput": {
            "facilityId": [
                607
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "Sidecar": {
            "connectedAt": [
                1446
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "jitterMs": [
                393
            ],
            "lastHeartbeatAt": [
                1446
            ],
            "latencyMs": [
                393
            ],
            "linkSpeedDownstream": [
                619
            ],
            "linkSpeedUpstream": [
                619
            ],
            "localIpAddress": [
                1199
            ],
            "multiaddrs": [
                1199
            ],
            "name": [
                1199
            ],
            "online": [
                137
            ],
            "operatingSystem": [
                1183
            ],
            "operatingSystemVersion": [
                1199
            ],
            "peerId": [
                1199
            ],
            "publicKey": [
                1199
            ],
            "remoteIpAddressV4": [
                1199
            ],
            "remoteIpAddressV6": [
                1199
            ],
            "settings": [
                1185
            ],
            "status": [
                1188
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "version": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "SidecarFilter": {
            "facilityId": [
                607
            ],
            "ids": [
                607
            ],
            "operatingSystem": [
                1183
            ],
            "status": [
                1188
            ],
            "__typename": [
                1199
            ]
        },
        "SidecarOperatingSystem": {},
        "SidecarResultPage": {
            "entries": [
                1181
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "SidecarSettings": {
            "discoveryEnabled": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "SidecarSettingsInput": {
            "discoveryEnabled": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "SidecarSortOption": {},
        "SidecarStatus": {},
        "SignUpCompleteResult": {
            "on_InvalidSignUpInvitationError": [
                623
            ],
            "on_SignUpCompletedResult": [
                1190
            ],
            "__typename": [
                1199
            ]
        },
        "SignUpCompletedResult": {
            "email": [
                1199
            ],
            "organizationId": [
                607
            ],
            "success": [
                137
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "SignUpInitiateResult": {
            "on_InvalidCredentialsError": [
                621
            ],
            "on_SignUpInitiatedResult": [
                1192
            ],
            "__typename": [
                1199
            ]
        },
        "SignUpInitiatedResult": {
            "email": [
                1199
            ],
            "success": [
                137
            ],
            "token": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "SortOrder": {},
        "SsoRequiredError": {
            "pendingAuthenticationToken": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "StandaloneAuthResult": {
            "redirectUri": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "StartWOPIEditingSessionInput": {
            "fileId": [
                607
            ],
            "permission": [
                1415
            ],
            "__typename": [
                1199
            ]
        },
        "StartWOPIEditingSessionPayload": {
            "session": [
                1413
            ],
            "__typename": [
                1199
            ]
        },
        "StorageQuota": {
            "availableBytes": [
                619
            ],
            "fileCount": [
                619
            ],
            "quotaBytes": [
                619
            ],
            "usagePercentage": [
                538
            ],
            "usedBytes": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "String": {},
        "Subscription": {
            "assistantChatEvents": [
                72,
                {
                    "beginningAt": [
                        607
                    ],
                    "chatId": [
                        607,
                        "ID!"
                    ]
                }
            ],
            "crmAccountAddressChanges": [
                4,
                {
                    "ids": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "crmAccountChanges": [
                3,
                {
                    "ids": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "crmContactChanges": [
                255,
                {
                    "ids": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "crmCustomerInvitationChanges": [
                367,
                {
                    "ids": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "filesFilesystemChanged": [
                496
            ],
            "iotCameraEvents": [
                170
            ],
            "iotPrinterEvents": [
                963
            ],
            "iotScaleEvents": [
                1113
            ],
            "iotScannerEvents": [
                1121
            ],
            "iotSidecarEvents": [
                1181
            ],
            "notificationReceived": [
                858
            ],
            "presenceEvents": [
                958,
                {
                    "join": [
                        137
                    ],
                    "room": [
                        1199,
                        "String!"
                    ],
                    "sessionId": [
                        1199
                    ]
                }
            ],
            "tradeLoadChanges": [
                772,
                {
                    "ids": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "tradePurchaseLoadChanges": [
                987,
                {
                    "ids": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "transportationRouteChanges": [
                1066,
                {
                    "ids": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "transportationServiceChanges": [
                1133,
                {
                    "ids": [
                        607,
                        "[ID!]!"
                    ]
                }
            ],
            "__typename": [
                1199
            ]
        },
        "SupplierPriceListAffectsMaterialsResult": {
            "affectedItemIds": [
                607
            ],
            "hasAffectingPriceList": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "SwitchCase": {
            "label": [
                1199
            ],
            "value": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "SwitchCaseInput": {
            "label": [
                1199
            ],
            "value": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "SwitchNode": {
            "cases": [
                1202
            ],
            "defaultLabel": [
                1199
            ],
            "description": [
                1199
            ],
            "expression": [
                1199
            ],
            "id": [
                607
            ],
            "label": [
                1199
            ],
            "position": [
                949
            ],
            "type": [
                848
            ],
            "__typename": [
                1199
            ]
        },
        "TagAllocation": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "movement": [
                662
            ],
            "movementId": [
                607
            ],
            "quantity": [
                1424
            ],
            "tag": [
                693
            ],
            "tagId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "TagAllocationFilter": {
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "movementId": [
                607
            ],
            "movementIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "tagId": [
                607
            ],
            "tagIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "TagAllocationInput": {
            "movementId": [
                607
            ],
            "quantity": [
                1426
            ],
            "tagId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "TagAllocationResultPage": {
            "entries": [
                1205
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "TagAllocationSortOption": {},
        "TagAllocationUpdateInput": {
            "movementId": [
                607
            ],
            "quantity": [
                1426
            ],
            "tagId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "TagMovementAllocationInput": {
            "movementId": [
                607
            ],
            "quantity": [
                1426
            ],
            "__typename": [
                1199
            ]
        },
        "TagQuantitySummary": {
            "inQuantity": [
                1424
            ],
            "netQuantity": [
                1424
            ],
            "outQuantity": [
                1424
            ],
            "tagId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "TagReconciliationReport": {
            "quantityMismatchCount": [
                619
            ],
            "tagsWithMovements": [
                619
            ],
            "tagsWithoutMovements": [
                619
            ],
            "totalTags": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "TagType": {},
        "TaggingType": {},
        "TalkJSConversation": {
            "createdAt": [
                1446
            ],
            "custom": [
                828
            ],
            "id": [
                1199
            ],
            "isUnread": [
                137
            ],
            "lastMessage": [
                1219
            ],
            "participants": [
                1221
            ],
            "photoUrl": [
                1199
            ],
            "subject": [
                1199
            ],
            "topicId": [
                1199
            ],
            "unreadMessageCount": [
                619
            ],
            "welcomeMessages": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "TalkJSConversationFilter": {
            "limit": [
                619
            ],
            "onlyUnread": [
                137
            ],
            "peopleType": [
                1222
            ],
            "startingAfter": [
                1199
            ],
            "subject": [
                1199
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "TalkJSConversationListResult": {
            "data": [
                1216
            ],
            "hasMore": [
                137
            ],
            "nextCursor": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "TalkJSMessage": {
            "conversationId": [
                1199
            ],
            "createdAt": [
                1446
            ],
            "custom": [
                828
            ],
            "id": [
                1199
            ],
            "readBy": [
                1220
            ],
            "senderId": [
                1199
            ],
            "text": [
                1199
            ],
            "type": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "TalkJSMessageRead": {
            "readAt": [
                1446
            ],
            "userId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "TalkJSParticipant": {
            "access": [
                1199
            ],
            "name": [
                1199
            ],
            "notify": [
                137
            ],
            "participantId": [
                1199
            ],
            "userId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "TalkJSPeopleType": {},
        "Task": {
            "accountAddressId": [
                607
            ],
            "accountId": [
                607
            ],
            "asset": [
                54
            ],
            "assetGroup": [
                619
            ],
            "assetId": [
                607
            ],
            "assetTypeId": [
                607
            ],
            "completedAt": [
                1446
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "failureReason": [
                1199
            ],
            "fillStateCondition": [
                1199
            ],
            "fulfillmentServiceId": [
                607
            ],
            "id": [
                607
            ],
            "routeId": [
                607
            ],
            "routePosition": [
                393
            ],
            "sourceServiceId": [
                607
            ],
            "startedAt": [
                1446
            ],
            "status": [
                1236
            ],
            "timestamps": [
                1250
            ],
            "type": [
                1237
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "TaskFilter": {
            "accountAddressId": [
                607
            ],
            "accountAddressIds": [
                607
            ],
            "accountId": [
                607
            ],
            "accountIds": [
                607
            ],
            "assetId": [
                607
            ],
            "assetIds": [
                607
            ],
            "assetTypeId": [
                607
            ],
            "assetTypeIds": [
                607
            ],
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "failureReason": [
                1199
            ],
            "fillStateCondition": [
                1199
            ],
            "fromCompletedAt": [
                1446
            ],
            "fromStartedAt": [
                1446
            ],
            "fulfillmentServiceId": [
                607
            ],
            "fulfillmentServiceIds": [
                607
            ],
            "ids": [
                607
            ],
            "routeId": [
                607
            ],
            "routeIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "sourceServiceId": [
                607
            ],
            "sourceServiceIds": [
                607
            ],
            "status": [
                1236
            ],
            "toCompletedAt": [
                1446
            ],
            "toStartedAt": [
                1446
            ],
            "type": [
                1237
            ],
            "__typename": [
                1199
            ]
        },
        "TaskInput": {
            "accountAddressId": [
                607
            ],
            "accountId": [
                607
            ],
            "assetGroup": [
                619
            ],
            "assetId": [
                607
            ],
            "assetTypeId": [
                607
            ],
            "completedAt": [
                1446
            ],
            "facilityId": [
                607
            ],
            "failureReason": [
                1199
            ],
            "fillStateCondition": [
                1199
            ],
            "fulfillmentServiceId": [
                607
            ],
            "routeId": [
                607
            ],
            "routePosition": [
                393
            ],
            "sourceServiceId": [
                607
            ],
            "startedAt": [
                1446
            ],
            "status": [
                1236
            ],
            "type": [
                1237
            ],
            "__typename": [
                1199
            ]
        },
        "TaskPhotoCreatePayload": {
            "file": [
                494
            ],
            "uploadUrl": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "TaskPhotoInput": {
            "fileName": [
                1199
            ],
            "fileSize": [
                619
            ],
            "mimeType": [
                1199
            ],
            "public": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "TaskResultPage": {
            "entries": [
                1223
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "TaskService": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "id": [
                607
            ],
            "relationshipType": [
                1199
            ],
            "serviceId": [
                607
            ],
            "taskId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "TaskServiceFilter": {
            "ids": [
                607
            ],
            "relationshipType": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "serviceId": [
                607
            ],
            "serviceIds": [
                607
            ],
            "taskId": [
                607
            ],
            "taskIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "TaskServiceInput": {
            "relationshipType": [
                1199
            ],
            "serviceId": [
                607
            ],
            "taskId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "TaskServiceResultPage": {
            "entries": [
                1229
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "TaskServiceSortOption": {},
        "TaskServiceUpdateInput": {
            "relationshipType": [
                1199
            ],
            "serviceId": [
                607
            ],
            "taskId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "TaskSortOption": {},
        "TaskStatus": {},
        "TaskType": {},
        "TaskUpdateInput": {
            "accountAddressId": [
                607
            ],
            "accountId": [
                607
            ],
            "assetGroup": [
                619
            ],
            "assetId": [
                607
            ],
            "assetTypeId": [
                607
            ],
            "completedAt": [
                1446
            ],
            "facilityId": [
                607
            ],
            "failureReason": [
                1199
            ],
            "fillStateCondition": [
                1199
            ],
            "fulfillmentServiceId": [
                607
            ],
            "routeId": [
                607
            ],
            "routePosition": [
                393
            ],
            "sourceServiceId": [
                607
            ],
            "startedAt": [
                1446
            ],
            "status": [
                1236
            ],
            "type": [
                1237
            ],
            "__typename": [
                1199
            ]
        },
        "TemplateDataInput": {
            "key": [
                1199
            ],
            "value": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "Terminal": {
            "id": [
                607
            ],
            "latitude": [
                393
            ],
            "longitude": [
                393
            ],
            "name": [
                1199
            ],
            "port": [
                945
            ],
            "portId": [
                607
            ],
            "terminalCode": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "__typename": [
                1199
            ]
        },
        "TicketFreight": {
            "carrier": [
                3
            ],
            "carrierId": [
                607
            ],
            "chargebackAmountAmount": [
                393
            ],
            "chargebackAmountCurrencyCode": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "deliveryNumber": [
                1199
            ],
            "destinationLocationId": [
                607
            ],
            "formulaVariableIds": [
                1199
            ],
            "freightLaneCostId": [
                1199
            ],
            "id": [
                607
            ],
            "invoiceDate": [
                168
            ],
            "invoiceNumber": [
                1199
            ],
            "load": [
                772
            ],
            "loadId": [
                607
            ],
            "notes": [
                1199
            ],
            "originLocationId": [
                607
            ],
            "purchaseLoadId": [
                607
            ],
            "purchase_load": [
                987
            ],
            "route": [
                558
            ],
            "routeId": [
                607
            ],
            "sourceId": [
                1199
            ],
            "sourceType": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "totalCostAmount": [
                393
            ],
            "totalCostCurrencyCode": [
                1199
            ],
            "transportationType": [
                1199
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "userSet": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "TicketFreightFilter": {
            "carrierId": [
                607
            ],
            "ids": [
                607
            ],
            "loadId": [
                607
            ],
            "purchaseLoadId": [
                607
            ],
            "sourceType": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "TicketFreightInput": {
            "carrierId": [
                607
            ],
            "chargebackAmountAmount": [
                393
            ],
            "chargebackAmountCurrencyCode": [
                1199
            ],
            "deliveryNumber": [
                1199
            ],
            "destinationLocationId": [
                607
            ],
            "formulaVariableIds": [
                1199
            ],
            "freightLaneCostId": [
                1199
            ],
            "invoiceDate": [
                168
            ],
            "invoiceNumber": [
                1199
            ],
            "loadId": [
                607
            ],
            "notes": [
                1199
            ],
            "originLocationId": [
                607
            ],
            "purchaseLoadId": [
                607
            ],
            "routeId": [
                607
            ],
            "sourceId": [
                1199
            ],
            "sourceType": [
                1199
            ],
            "totalCostAmount": [
                393
            ],
            "totalCostCurrencyCode": [
                1199
            ],
            "transportationType": [
                1199
            ],
            "userSet": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "TicketFreightResultPage": {
            "entries": [
                1241
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "TicketFreightSortOption": {},
        "TicketFreightUpdateInput": {
            "carrierId": [
                607
            ],
            "chargebackAmountAmount": [
                393
            ],
            "chargebackAmountCurrencyCode": [
                1199
            ],
            "deliveryNumber": [
                1199
            ],
            "destinationLocationId": [
                607
            ],
            "formulaVariableIds": [
                1199
            ],
            "freightLaneCostId": [
                1199
            ],
            "invoiceDate": [
                168
            ],
            "invoiceNumber": [
                1199
            ],
            "loadId": [
                607
            ],
            "notes": [
                1199
            ],
            "originLocationId": [
                607
            ],
            "purchaseLoadId": [
                607
            ],
            "routeId": [
                607
            ],
            "sourceId": [
                1199
            ],
            "sourceType": [
                1199
            ],
            "totalCostAmount": [
                393
            ],
            "totalCostCurrencyCode": [
                1199
            ],
            "transportationType": [
                1199
            ],
            "userSet": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "Time": {},
        "TimeoutAction": {},
        "TimeoutUnit": {},
        "Timestamps": {
            "createdAt": [
                1446
            ],
            "updatedAt": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "Timezone": {},
        "TollReceipt": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "customerAccount": [
                3
            ],
            "customerAccountId": [
                607
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "inboundTollingAgreement": [
                609
            ],
            "items": [
                1255
            ],
            "notes": [
                1199
            ],
            "receiptNumber": [
                1199
            ],
            "receivedAt": [
                1446
            ],
            "status": [
                1261
            ],
            "timestamps": [
                1250
            ],
            "tollProcessingAgreementId": [
                607
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "TollReceiptFilter": {
            "customerAccountId": [
                607
            ],
            "customerAccountIds": [
                607
            ],
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "fromReceivedAt": [
                1446
            ],
            "ids": [
                607
            ],
            "notes": [
                1199
            ],
            "receiptNumber": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "status": [
                1261
            ],
            "toReceivedAt": [
                1446
            ],
            "tollProcessingAgreementId": [
                607
            ],
            "tollProcessingAgreementIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "TollReceiptInput": {
            "customerAccountId": [
                607
            ],
            "facilityId": [
                607
            ],
            "items": [
                342
            ],
            "notes": [
                1199
            ],
            "receiptNumber": [
                1199
            ],
            "receivedAt": [
                1446
            ],
            "status": [
                1261
            ],
            "tollProcessingAgreementId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "TollReceiptItem": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "lot": [
                645
            ],
            "lotId": [
                607
            ],
            "notes": [
                1199
            ],
            "quantity": [
                393
            ],
            "quantityUnit": [
                1307
            ],
            "timestamps": [
                1250
            ],
            "tollReceipt": [
                1252
            ],
            "tollReceiptId": [
                607
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "TollReceiptItemFilter": {
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "itemId": [
                607
            ],
            "itemIds": [
                607
            ],
            "lotId": [
                607
            ],
            "lotIds": [
                607
            ],
            "notes": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "tollReceiptId": [
                607
            ],
            "tollReceiptIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "TollReceiptItemResultPage": {
            "entries": [
                1255
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "TollReceiptItemSortOption": {},
        "TollReceiptResultPage": {
            "entries": [
                1252
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "TollReceiptSortOption": {},
        "TollReceiptStatus": {},
        "TollReceiptUpdateInput": {
            "customerAccountId": [
                607
            ],
            "facilityId": [
                607
            ],
            "items": [
                1358
            ],
            "notes": [
                1199
            ],
            "receiptNumber": [
                1199
            ],
            "receivedAt": [
                1446
            ],
            "status": [
                1261
            ],
            "tollProcessingAgreementId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "TollShipment": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "customerAccount": [
                3
            ],
            "customerAccountId": [
                607
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "inboundTollingAgreement": [
                609
            ],
            "items": [
                1266
            ],
            "notes": [
                1199
            ],
            "processingFee": [
                835
            ],
            "shipmentNumber": [
                1199
            ],
            "shippedAt": [
                1446
            ],
            "status": [
                1272
            ],
            "timestamps": [
                1250
            ],
            "tollProcessingAgreementId": [
                607
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "TollShipmentFilter": {
            "customerAccountId": [
                607
            ],
            "customerAccountIds": [
                607
            ],
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "fromShippedAt": [
                1446
            ],
            "ids": [
                607
            ],
            "notes": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "shipmentNumber": [
                1199
            ],
            "status": [
                1272
            ],
            "toShippedAt": [
                1446
            ],
            "tollProcessingAgreementId": [
                607
            ],
            "tollProcessingAgreementIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "TollShipmentInput": {
            "customerAccountId": [
                607
            ],
            "facilityId": [
                607
            ],
            "items": [
                343
            ],
            "notes": [
                1199
            ],
            "processingFee": [
                836
            ],
            "shipmentNumber": [
                1199
            ],
            "shippedAt": [
                1446
            ],
            "status": [
                1272
            ],
            "tollProcessingAgreementId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "TollShipmentItem": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "lot": [
                645
            ],
            "lotId": [
                607
            ],
            "notes": [
                1199
            ],
            "processingFee": [
                835
            ],
            "quantity": [
                393
            ],
            "quantityUnit": [
                1307
            ],
            "timestamps": [
                1250
            ],
            "tollShipment": [
                1263
            ],
            "tollShipmentId": [
                607
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "TollShipmentItemFilter": {
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "itemId": [
                607
            ],
            "itemIds": [
                607
            ],
            "lotId": [
                607
            ],
            "lotIds": [
                607
            ],
            "notes": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "tollShipmentId": [
                607
            ],
            "tollShipmentIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "TollShipmentItemResultPage": {
            "entries": [
                1266
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "TollShipmentItemSortOption": {},
        "TollShipmentResultPage": {
            "entries": [
                1263
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "TollShipmentSortOption": {},
        "TollShipmentStatus": {},
        "TollShipmentUpdateInput": {
            "customerAccountId": [
                607
            ],
            "facilityId": [
                607
            ],
            "items": [
                1359
            ],
            "notes": [
                1199
            ],
            "processingFee": [
                836
            ],
            "shipmentNumber": [
                1199
            ],
            "shippedAt": [
                1446
            ],
            "status": [
                1272
            ],
            "tollProcessingAgreementId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "TollingType": {},
        "ToolCall": {
            "arguments": [
                828
            ],
            "id": [
                1199
            ],
            "name": [
                1199
            ],
            "result": [
                828
            ],
            "__typename": [
                1199
            ]
        },
        "TotpConfig": {
            "qrCode": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "TradeAggregateType": {},
        "TradeBookingShipInput": {
            "id": [
                607
            ],
            "shippedDate": [
                168
            ],
            "__typename": [
                1199
            ]
        },
        "TradeOutboxEventCounts": {
            "booking": [
                619
            ],
            "load": [
                619
            ],
            "purchaseOrder": [
                619
            ],
            "salesOrder": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "TradeOutboxEventFilter": {
            "aggregateId": [
                607
            ],
            "aggregateTypes": [
                1277
            ],
            "createdAtRange": [
                1447
            ],
            "statuses": [
                903
            ],
            "__typename": [
                1199
            ]
        },
        "Trailer": {
            "capacity": [
                538
            ],
            "country": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "currentLocation": [
                942
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "lastLocationTime": [
                1446
            ],
            "licensePlate": [
                1199
            ],
            "licensePlateExpiration": [
                1446
            ],
            "notes": [
                1199
            ],
            "state": [
                1199
            ],
            "status": [
                1285
            ],
            "taskCount": [
                619
            ],
            "timestamps": [
                1250
            ],
            "transportationType": [
                1291
            ],
            "transportationTypeId": [
                607
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "vin": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "TrailerFilter": {
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "lastUpdatedAt": [
                1446
            ],
            "licensePlate": [
                1199
            ],
            "maxCapacity": [
                538
            ],
            "minCapacity": [
                538
            ],
            "searchTerm": [
                1199
            ],
            "status": [
                1285
            ],
            "transportationTypeId": [
                607
            ],
            "vin": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "TrailerResultPage": {
            "entries": [
                1281
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "TrailerSortOption": {},
        "TrailerStatus": {},
        "TransportationAccountsFilterInput": {
            "hasActiveTask": [
                137
            ],
            "hasAsset": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "TransportationAggregateType": {},
        "TransportationFacilitiesFilterInput": {
            "hasActiveTask": [
                137
            ],
            "hasAsset": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "TransportationOutboxEventCounts": {
            "asset": [
                619
            ],
            "containerType": [
                619
            ],
            "driver": [
                619
            ],
            "freightForwarder": [
                619
            ],
            "freightLine": [
                619
            ],
            "route": [
                619
            ],
            "service": [
                619
            ],
            "shippingCarrier": [
                619
            ],
            "trailer": [
                619
            ],
            "transportationType": [
                619
            ],
            "truck": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "TransportationOutboxEventFilter": {
            "aggregateId": [
                607
            ],
            "aggregateTypes": [
                1287
            ],
            "createdAtRange": [
                1447
            ],
            "statuses": [
                903
            ],
            "__typename": [
                1199
            ]
        },
        "TransportationType": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "description": [
                1199
            ],
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "TransportationTypeFilter": {
            "description": [
                1199
            ],
            "ids": [
                607
            ],
            "name": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "TransportationTypeResultPage": {
            "entries": [
                1291
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "TransportationTypeSortOption": {},
        "TrialCloseChecklistItem": {
            "blocking": [
                137
            ],
            "count": [
                619
            ],
            "description": [
                1199
            ],
            "details": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "TriggerConfig": {
            "on_BusinessEventTriggerConfigOutput": [
                161
            ],
            "on_HttpWebhookTriggerConfigOutput": [
                605
            ],
            "on_ScheduleTriggerConfigOutput": [
                1126
            ],
            "__typename": [
                1199
            ]
        },
        "TriggerConfigInput": {
            "cron": [
                1199
            ],
            "entityType": [
                1199
            ],
            "eventCase": [
                1199
            ],
            "filterExpression": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "TriggerType": {},
        "Truck": {
            "capacity": [
                538
            ],
            "country": [
                1199
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "currentLocation": [
                942
            ],
            "defaultTrailer": [
                1281
            ],
            "defaultTrailerId": [
                607
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "lastLocationTime": [
                1446
            ],
            "licensePlate": [
                1199
            ],
            "licensePlateExpiration": [
                1446
            ],
            "locationHistory": [
                1301
            ],
            "model": [
                1199
            ],
            "notes": [
                1199
            ],
            "state": [
                1199
            ],
            "status": [
                1304
            ],
            "taskCount": [
                619
            ],
            "timestamps": [
                1250
            ],
            "transportationType": [
                1291
            ],
            "transportationTypeId": [
                607
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "vin": [
                1199
            ],
            "year": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "TruckFilter": {
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "lastUpdatedAt": [
                1446
            ],
            "licensePlate": [
                1199
            ],
            "maxCapacity": [
                538
            ],
            "minCapacity": [
                538
            ],
            "model": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "status": [
                1304
            ],
            "transportationTypeId": [
                607
            ],
            "vin": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "TruckLocationHistory": {
            "id": [
                607
            ],
            "location": [
                942
            ],
            "source": [
                1199
            ],
            "timestamp": [
                1446
            ],
            "timestamps": [
                1250
            ],
            "truck": [
                1299
            ],
            "truckId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "TruckResultPage": {
            "entries": [
                1299
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "TruckSortOption": {},
        "TruckStatus": {},
        "UnappliedAdvanceBalance": {
            "accountId": [
                607
            ],
            "balances": [
                835
            ],
            "__typename": [
                1199
            ]
        },
        "UnconfirmPaymentsInput": {
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "Unit": {},
        "UnitFamily": {},
        "UnitPriceFormula": {
            "formula": [
                1199
            ],
            "variableIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "UnitPriceFormulaInput": {
            "formula": [
                1199
            ],
            "variableIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "UnitSystem": {},
        "UnshareFileInput": {
            "fileId": [
                607
            ],
            "permission": [
                1199
            ],
            "userIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "UnshareFilePayload": {
            "file": [
                494
            ],
            "removedCount": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "UntagInventoryTagInput": {
            "reason": [
                1199
            ],
            "tagId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateAccountAddressInput": {
            "address": [
                31
            ],
            "contacts": [
                1327
            ],
            "customAttributes": [
                828
            ],
            "id": [
                607
            ],
            "locationType": [
                32
            ],
            "name": [
                1199
            ],
            "operatingHours": [
                828
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateAccountIdentityDocumentInput": {
            "documentNumber": [
                1199
            ],
            "documentType": [
                608
            ],
            "expirationDate": [
                168
            ],
            "id": [
                607
            ],
            "issueDate": [
                168
            ],
            "issuingState": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateAccountIndividualDetailsInput": {
            "dateOfBirth": [
                168
            ],
            "employer": [
                1199
            ],
            "eyeColor": [
                615
            ],
            "hairColor": [
                616
            ],
            "height": [
                619
            ],
            "id": [
                607
            ],
            "identityDocuments": [
                1316
            ],
            "race": [
                617
            ],
            "sex": [
                618
            ],
            "weight": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateAccountInput": {
            "accountManagerIds": [
                607
            ],
            "addresses": [
                1315
            ],
            "customAttributes": [
                828
            ],
            "defaultPurchasePaymentTermId": [
                607
            ],
            "defaultSalesPaymentTermId": [
                607
            ],
            "dotNumber": [
                1199
            ],
            "email": [
                1199
            ],
            "individualDetails": [
                1317
            ],
            "insuranceExpiration": [
                168
            ],
            "linkedOrganizationId": [
                607
            ],
            "mcNumber": [
                1199
            ],
            "name": [
                1199
            ],
            "notes": [
                1199
            ],
            "paymentSchedulePreference": [
                1199
            ],
            "paymentTypePreference": [
                1199
            ],
            "phone": [
                1199
            ],
            "relationship": [
                24
            ],
            "scac": [
                1199
            ],
            "type": [
                27
            ],
            "w9OnFile": [
                137
            ],
            "website": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateAgentInput": {
            "agentIdentifier": [
                1199
            ],
            "content": [
                1199
            ],
            "description": [
                1199
            ],
            "model": [
                1199
            ],
            "modelProvider": [
                834
            ],
            "name": [
                1199
            ],
            "organizationId": [
                607
            ],
            "providerApiKey": [
                1199
            ],
            "providerBaseUrl": [
                1199
            ],
            "reasoningBudget": [
                619
            ],
            "reasoningEnabled": [
                137
            ],
            "temperature": [
                538
            ],
            "type": [
                40
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateAssetInput": {
            "accountAddressId": [
                607
            ],
            "accountId": [
                607
            ],
            "currentLocation": [
                31
            ],
            "customAttributes": [
                828
            ],
            "description": [
                1199
            ],
            "facilityId": [
                607
            ],
            "fillState": [
                55
            ],
            "identifier": [
                1199
            ],
            "lastLocationTime": [
                1446
            ],
            "notes": [
                1199
            ],
            "status": [
                65
            ],
            "tareWeight": [
                1426
            ],
            "typeId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateAssetTypeInput": {
            "capacity": [
                538
            ],
            "description": [
                1199
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateAssistantChatInput": {
            "title": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateAutomationInput": {
            "description": [
                1199
            ],
            "edges": [
                457
            ],
            "name": [
                1199
            ],
            "nodes": [
                847
            ],
            "triggerConfig": [
                1297
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateBillInput": {
            "amount": [
                836
            ],
            "compliance": [
                111
            ],
            "documentDate": [
                168
            ],
            "documentNumber": [
                1199
            ],
            "dueDate": [
                168
            ],
            "eligibleAt": [
                168
            ],
            "facilityID": [
                607
            ],
            "lineItems": [
                116
            ],
            "notes": [
                1199
            ],
            "paymentTerm": [
                920
            ],
            "paymentTermId": [
                607
            ],
            "preferredPaymentMethod": [
                916
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateBrokeredOrderLineItemInput": {
            "brokeredOrderId": [
                607
            ],
            "id": [
                607
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "quantity": [
                393
            ],
            "unit": [
                1307
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateCameraInput": {
            "driverType": [
                1199
            ],
            "name": [
                1199
            ],
            "sidecarId": [
                607
            ],
            "snapshotUrl": [
                1199
            ],
            "streamProfile": [
                1199
            ],
            "streamUrl": [
                1199
            ],
            "uniqueId": [
                1199
            ],
            "username": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateContactInput": {
            "accountId": [
                607
            ],
            "addressAs": [
                1199
            ],
            "addressId": [
                607
            ],
            "customAttributes": [
                828
            ],
            "department": [
                1199
            ],
            "email": [
                1199
            ],
            "fullName": [
                1199
            ],
            "id": [
                607
            ],
            "isPrimary": [
                137
            ],
            "notes": [
                1199
            ],
            "ownerUserId": [
                607
            ],
            "phone": [
                1199
            ],
            "prefix": [
                1199
            ],
            "role": [
                1199
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateContainerTypeInput": {
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateCustomAttributeInput": {
            "constraints": [
                492
            ],
            "id": [
                607
            ],
            "isDisabled": [
                137
            ],
            "name": [
                1199
            ],
            "order": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateDriverCertificationInput": {
            "driverId": [
                607
            ],
            "expirationDate": [
                1446
            ],
            "issuedDate": [
                1446
            ],
            "issuingBody": [
                1199
            ],
            "number": [
                1199
            ],
            "type": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateDriverInput": {
            "address": [
                31
            ],
            "currentLocation": [
                943
            ],
            "defaultTrailerId": [
                607
            ],
            "defaultTruckId": [
                607
            ],
            "email": [
                1199
            ],
            "firstName": [
                1199
            ],
            "lastLocationTime": [
                1446
            ],
            "lastName": [
                1199
            ],
            "licenseExpiration": [
                1446
            ],
            "licenseNumber": [
                1199
            ],
            "phoneNumber": [
                1199
            ],
            "status": [
                454
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateFacilityGeneralPreferencesInput": {
            "currency": [
                355
            ],
            "dateFormat": [
                1199
            ],
            "defaultUnitSystem": [
                1311
            ],
            "facilityId": [
                607
            ],
            "imperialEnabled": [
                137
            ],
            "language": [
                1199
            ],
            "metricEnabled": [
                137
            ],
            "timezone": [
                1199
            ],
            "weekStartDay": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateFacilitySalesPreferencesInput": {
            "askForDeletionConfirmation": [
                137
            ],
            "defaultPort": [
                1199
            ],
            "defaultWeightDisplayUnit": [
                1199
            ],
            "enableDefaultPrinting": [
                137
            ],
            "facilityId": [
                607
            ],
            "photoInstructions": [
                935
            ],
            "skipScalePayment": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateFileMetadataInput": {
            "metadata": [
                828
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateFinancialAccountInput": {
            "accountNumber": [
                1199
            ],
            "bankName": [
                1199
            ],
            "checkBusinessName": [
                1199
            ],
            "checkLogo": [
                1199
            ],
            "checkMailingAddress": [
                1199
            ],
            "checkNumberGeneration": [
                137
            ],
            "checkPhoneNumber": [
                1199
            ],
            "checkSignature": [
                1199
            ],
            "customAttributes": [
                828
            ],
            "ezcashEndpoint": [
                1199
            ],
            "ezcashTimeoutSeconds": [
                619
            ],
            "ezcashToken": [
                1199
            ],
            "facilityID": [
                607
            ],
            "lastCheckNumber": [
                619
            ],
            "nachaCompanyIdentification": [
                1199
            ],
            "nachaCompanyName": [
                1199
            ],
            "nachaDefaultSecCode": [
                1199
            ],
            "name": [
                1199
            ],
            "paymentAllocationMethod": [
                912
            ],
            "roundingMethod": [
                1064
            ],
            "roundingPrecision": [
                1065
            ],
            "routingNumber": [
                1199
            ],
            "type": [
                537
            ],
            "visibleInPayments": [
                137
            ],
            "warningThreshold": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateFinancialAccountTransactionInput": {
            "amount": [
                393
            ],
            "authorizedDate": [
                168
            ],
            "channel": [
                529
            ],
            "checkNumber": [
                1199
            ],
            "counterpartyIds": [
                607
            ],
            "date": [
                168
            ],
            "financialAccountOwnerId": [
                1199
            ],
            "imageUrl": [
                1199
            ],
            "location": [
                31
            ],
            "pendingTransactionId": [
                607
            ],
            "reference": [
                1199
            ],
            "status": [
                535
            ],
            "transferNumber": [
                1199
            ],
            "type": [
                536
            ],
            "website": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateInvoiceInput": {
            "amount": [
                836
            ],
            "documentDate": [
                168
            ],
            "documentNumber": [
                1199
            ],
            "dueDate": [
                168
            ],
            "facilityID": [
                607
            ],
            "lineItems": [
                719
            ],
            "notes": [
                1199
            ],
            "paymentTerm": [
                920
            ],
            "paymentTermId": [
                607
            ],
            "status": [
                724
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateLoadDeductionInput": {
            "applicationType": [
                394
            ],
            "deductionTypeId": [
                607
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "loadId": [
                607
            ],
            "loadLineItemId": [
                607
            ],
            "notes": [
                1199
            ],
            "percentage": [
                393
            ],
            "priceValue": [
                836
            ],
            "weightValue": [
                1426
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateOrganizationInput": {
            "domain": [
                1199
            ],
            "idpId": [
                1199
            ],
            "name": [
                1199
            ],
            "onboardAt": [
                1446
            ],
            "timezone": [
                1251
            ],
            "__typename": [
                1199
            ]
        },
        "UpdatePaymentInput": {
            "achNumber": [
                1199
            ],
            "amount": [
                836
            ],
            "atmId": [
                1199
            ],
            "atmPaymentNumber": [
                1199
            ],
            "barcode": [
                1199
            ],
            "barcodeRowId": [
                619
            ],
            "checkAttn": [
                1199
            ],
            "checkFacilityId": [
                607
            ],
            "checkMemo": [
                1199
            ],
            "checkNumber": [
                1199
            ],
            "documentNumber": [
                1199
            ],
            "financialAccountId": [
                607
            ],
            "financialAccountTransactionId": [
                607
            ],
            "paymentMethod": [
                916
            ],
            "supplierPhotoId": [
                607
            ],
            "transactionDate": [
                168
            ],
            "wireNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UpdatePrinterInput": {
            "driverType": [
                1199
            ],
            "name": [
                1199
            ],
            "pageSize": [
                965
            ],
            "printerType": [
                970
            ],
            "rollWidth": [
                967
            ],
            "sidecarId": [
                607
            ],
            "uniqueId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateProcessingTypeInputItemInput": {
            "id": [
                607
            ],
            "isPrimary": [
                137
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "processingTypeId": [
                607
            ],
            "sortOrder": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateProcessingTypeOutputItemInput": {
            "costAllocationPercentage": [
                393
            ],
            "id": [
                607
            ],
            "isNoCost": [
                137
            ],
            "isPrimary": [
                137
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "outputUnit": [
                1307
            ],
            "processingTypeId": [
                607
            ],
            "sortOrder": [
                619
            ],
            "yieldPercentage": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "UpdatePurchaseLoadDeductionInput": {
            "applicationType": [
                394
            ],
            "deductionTypeId": [
                607
            ],
            "id": [
                607
            ],
            "notes": [
                1199
            ],
            "percentage": [
                393
            ],
            "priceValue": [
                836
            ],
            "purchaseLoadId": [
                607
            ],
            "purchaseLoadLineItemId": [
                607
            ],
            "weightValue": [
                1426
            ],
            "__typename": [
                1199
            ]
        },
        "UpdatePurchaseLoadLineItemInput": {
            "catComplianceStatus": [
                1199
            ],
            "catOemCode": [
                1199
            ],
            "catSerialNumber": [
                1199
            ],
            "estimatedPrice": [
                836
            ],
            "grossWeight": [
                1426
            ],
            "id": [
                607
            ],
            "itemId": [
                607
            ],
            "netWeight": [
                1426
            ],
            "notes": [
                1199
            ],
            "parentLineItemId": [
                607
            ],
            "pricingUnit": [
                1307
            ],
            "purchaseLoadId": [
                607
            ],
            "purchaseOrderLineId": [
                607
            ],
            "requiresSorting": [
                137
            ],
            "settlementBasis": [
                1172
            ],
            "tagId": [
                607
            ],
            "tareWeight": [
                1426
            ],
            "type": [
                986
            ],
            "unitPrice": [
                836
            ],
            "vehicleMake": [
                1199
            ],
            "vehicleModel": [
                1199
            ],
            "vehicleTitleStatus": [
                1199
            ],
            "vehicleVin": [
                1199
            ],
            "vehicleYear": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "UpdatePurchaseLoadPaymentInput": {
            "amount": [
                836
            ],
            "checkMemo": [
                1199
            ],
            "checkNumber": [
                1199
            ],
            "creatorId": [
                607
            ],
            "financialAccountId": [
                607
            ],
            "id": [
                607
            ],
            "legalHold": [
                137
            ],
            "paymentMethod": [
                1199
            ],
            "paymentTerm": [
                1199
            ],
            "percentage": [
                393
            ],
            "purchaseLoadId": [
                607
            ],
            "roundingMethod": [
                1199
            ],
            "roundingPrecision": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UpdatePurchaseOrderInput": {
            "accountAddressId": [
                607
            ],
            "accountContactId": [
                607
            ],
            "accountId": [
                607
            ],
            "accountRepresentativeId": [
                607
            ],
            "completionNotes": [
                1199
            ],
            "counterpartyReferenceNumber": [
                1199
            ],
            "customAttributes": [
                828
            ],
            "documentNumber": [
                1199
            ],
            "endDate": [
                168
            ],
            "facilityId": [
                607
            ],
            "freightTerm": [
                572
            ],
            "lineItems": [
                1348
            ],
            "notes": [
                1199
            ],
            "paymentCurrency": [
                1199
            ],
            "paymentTerm": [
                920
            ],
            "startDate": [
                168
            ],
            "__typename": [
                1199
            ]
        },
        "UpdatePurchaseOrderLineItemInput": {
            "id": [
                607
            ],
            "itemId": [
                607
            ],
            "purchaseOrderId": [
                607
            ],
            "quantity": [
                393
            ],
            "totalPrice": [
                836
            ],
            "unit": [
                1307
            ],
            "unitPrice": [
                836
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateQuoteLineItemInput": {
            "id": [
                607
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "packageFormat": [
                1199
            ],
            "quantity": [
                393
            ],
            "quoteId": [
                607
            ],
            "unit": [
                1307
            ],
            "unitPrice": [
                836
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateRoleInput": {
            "description": [
                1199
            ],
            "name": [
                1199
            ],
            "permissions": [
                1199
            ],
            "type": [
                1063
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateRouteInput": {
            "driverId": [
                607
            ],
            "facilityGroupId": [
                607
            ],
            "haulerId": [
                607
            ],
            "routeDate": [
                1446
            ],
            "status": [
                1078
            ],
            "trailerId": [
                607
            ],
            "truckId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateScaleInput": {
            "baudRate": [
                619
            ],
            "cameraId": [
                607
            ],
            "connectionType": [
                1114
            ],
            "dataBits": [
                619
            ],
            "measurementIncrement": [
                393
            ],
            "measurementMode": [
                1117
            ],
            "name": [
                1199
            ],
            "onDemandString": [
                1199
            ],
            "parity": [
                1199
            ],
            "scaleFormatType": [
                1116
            ],
            "serialPortPath": [
                1199
            ],
            "sidecarId": [
                607
            ],
            "stopBits": [
                1199
            ],
            "tcpHost": [
                1199
            ],
            "tcpPort": [
                619
            ],
            "unitOfMeasurement": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateScannerInput": {
            "driverType": [
                1199
            ],
            "name": [
                1199
            ],
            "sidecarId": [
                607
            ],
            "uniqueId": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateServiceInput": {
            "accountAddressId": [
                607
            ],
            "accountId": [
                607
            ],
            "actions": [
                1135
            ],
            "address": [
                31
            ],
            "assetTypes": [
                1137
            ],
            "assets": [
                1136
            ],
            "assignmentStatus": [
                71
            ],
            "contactId": [
                607
            ],
            "deadline": [
                1446
            ],
            "destinationFacilityId": [
                607
            ],
            "driverId": [
                607
            ],
            "driverNotes": [
                1199
            ],
            "estimatedArrival": [
                1446
            ],
            "externalNotes": [
                1199
            ],
            "facilityGroupId": [
                607
            ],
            "facilityId": [
                607
            ],
            "haulerId": [
                607
            ],
            "internalNotes": [
                1199
            ],
            "priority": [
                619
            ],
            "rank": [
                1199
            ],
            "recurringSchedule": [
                1051
            ],
            "routeId": [
                607
            ],
            "routePosition": [
                393
            ],
            "scheduledWindowEnd": [
                1446
            ],
            "scheduledWindowStart": [
                1446
            ],
            "serviceTypeId": [
                607
            ],
            "status": [
                1143
            ],
            "trailerId": [
                607
            ],
            "truckId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateSettingInput": {
            "constraints": [
                492
            ],
            "dataType": [
                493
            ],
            "defaultValue": [
                41
            ],
            "description": [
                1199
            ],
            "name": [
                1199
            ],
            "scope": [
                1165
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateSettingsGroupInput": {
            "description": [
                1199
            ],
            "icon": [
                1199
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateSidecarInput": {
            "facilityId": [
                607
            ],
            "name": [
                1199
            ],
            "operatingSystem": [
                1183
            ],
            "operatingSystemVersion": [
                1199
            ],
            "settings": [
                1186
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateTollReceiptItemInput": {
            "id": [
                607
            ],
            "itemId": [
                607
            ],
            "lotId": [
                607
            ],
            "notes": [
                1199
            ],
            "quantity": [
                393
            ],
            "quantityUnit": [
                1307
            ],
            "tollReceiptId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateTollShipmentItemInput": {
            "id": [
                607
            ],
            "itemId": [
                607
            ],
            "lotId": [
                607
            ],
            "notes": [
                1199
            ],
            "processingFee": [
                836
            ],
            "quantity": [
                393
            ],
            "quantityUnit": [
                1307
            ],
            "tollShipmentId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateTrailerInput": {
            "capacity": [
                538
            ],
            "country": [
                1199
            ],
            "currentLocation": [
                943
            ],
            "facilityId": [
                607
            ],
            "lastLocationTime": [
                1446
            ],
            "licensePlate": [
                1199
            ],
            "licensePlateExpiration": [
                1446
            ],
            "notes": [
                1199
            ],
            "state": [
                1199
            ],
            "status": [
                1285
            ],
            "transportationTypeId": [
                607
            ],
            "vin": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateTransportationTypeInput": {
            "description": [
                1199
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateTruckInput": {
            "capacity": [
                538
            ],
            "country": [
                1199
            ],
            "currentLocation": [
                943
            ],
            "defaultTrailerId": [
                607
            ],
            "facilityId": [
                607
            ],
            "lastLocationTime": [
                1446
            ],
            "licensePlate": [
                1199
            ],
            "licensePlateExpiration": [
                1446
            ],
            "model": [
                1199
            ],
            "notes": [
                1199
            ],
            "state": [
                1199
            ],
            "status": [
                1304
            ],
            "transportationTypeId": [
                607
            ],
            "vin": [
                1199
            ],
            "year": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateUserInput": {
            "email": [
                1199
            ],
            "firstName": [
                1199
            ],
            "idpId": [
                1199
            ],
            "lastName": [
                1199
            ],
            "phoneNumber": [
                1199
            ],
            "timezone": [
                1251
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateUserPreferencesInput": {
            "defaultCashDrawerId": [
                607
            ],
            "enableDefaultPrinting": [
                137
            ],
            "primaryFacilityId": [
                607
            ],
            "primaryScaleId": [
                607
            ],
            "primarySidecarId": [
                607
            ],
            "skipScalePayment": [
                137
            ],
            "userId": [
                607
            ],
            "ustudioBrightness": [
                619
            ],
            "ustudioEnabled": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateWarehouseCredentialInput": {
            "databaseName": [
                1199
            ],
            "enabled": [
                137
            ],
            "host": [
                1199
            ],
            "port": [
                619
            ],
            "ssl": [
                137
            ],
            "username": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateWorkOrderInputItemInput": {
            "actualQuantity": [
                393
            ],
            "actualQuantityUnit": [
                1307
            ],
            "id": [
                607
            ],
            "itemId": [
                607
            ],
            "lotId": [
                607
            ],
            "notes": [
                1199
            ],
            "plannedQuantity": [
                393
            ],
            "plannedQuantityUnit": [
                1307
            ],
            "tagId": [
                607
            ],
            "unitCost": [
                836
            ],
            "workOrderId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "UpdateWorkOrderOutputItemInput": {
            "actualQuantity": [
                393
            ],
            "actualQuantityUnit": [
                1307
            ],
            "allocatedCost": [
                836
            ],
            "costAllocationPercentage": [
                393
            ],
            "expectedQuantity": [
                393
            ],
            "expectedQuantityUnit": [
                1307
            ],
            "id": [
                607
            ],
            "isNoCost": [
                137
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "targetLotId": [
                607
            ],
            "targetTagId": [
                607
            ],
            "unitCost": [
                836
            ],
            "workOrderId": [
                607
            ],
            "yieldPercentage": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "UsageMetricsAggregation": {
            "model": [
                1199
            ],
            "modelProvider": [
                1199
            ],
            "organization": [
                887
            ],
            "periodEnd": [
                168
            ],
            "periodStart": [
                168
            ],
            "recordCount": [
                619
            ],
            "totalCacheReadTokens": [
                619
            ],
            "totalCost": [
                835
            ],
            "totalInputTokens": [
                619
            ],
            "totalOutputTokens": [
                619
            ],
            "totalReasoningTokens": [
                619
            ],
            "totalTokens": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "UsageMetricsFilterInput": {
            "dateFrom": [
                168
            ],
            "dateTo": [
                168
            ],
            "model": [
                1199
            ],
            "modelProvider": [
                1199
            ],
            "organizationIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "UsageMetricsResultPage": {
            "entries": [
                1368
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "UsageMetricsSortOption": {},
        "User": {
            "createdAt": [
                1446
            ],
            "email": [
                1199
            ],
            "facilities": [
                470
            ],
            "facilityGroups": [
                480
            ],
            "firstName": [
                1199
            ],
            "id": [
                607
            ],
            "idpId": [
                1199
            ],
            "lastName": [
                1199
            ],
            "organizations": [
                887
            ],
            "phoneNumber": [
                1199
            ],
            "status": [
                1389
            ],
            "timezone": [
                1251
            ],
            "updatedAt": [
                1446
            ],
            "__typename": [
                1199
            ]
        },
        "UserContact": {
            "contactType": [
                259
            ],
            "email": [
                1199
            ],
            "id": [
                607
            ],
            "isOnline": [
                137
            ],
            "name": [
                1199
            ],
            "organizationName": [
                1199
            ],
            "phone": [
                1199
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "UserContactsFilter": {
            "contactType": [
                259
            ],
            "limit": [
                619
            ],
            "offset": [
                619
            ],
            "searchTerm": [
                1199
            ],
            "sortBy": [
                1376
            ],
            "sortOrder": [
                1193
            ],
            "__typename": [
                1199
            ]
        },
        "UserContactsListResult": {
            "data": [
                1373
            ],
            "totalCount": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "UserContactsSortBy": {},
        "UserFilter": {
            "ids": [
                607
            ],
            "organizationId": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "status": [
                1389
            ],
            "__typename": [
                1199
            ]
        },
        "UserInvitationAcceptResult": {
            "on_InvalidUserInvitationError": [
                624
            ],
            "on_UserInvitationAcceptedResult": [
                1379
            ],
            "__typename": [
                1199
            ]
        },
        "UserInvitationAcceptedResult": {
            "email": [
                1199
            ],
            "success": [
                137
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "UserPreferences": {
            "defaultCashDrawerId": [
                607
            ],
            "enableDefaultPrinting": [
                137
            ],
            "primaryFacilityId": [
                607
            ],
            "primaryScaleId": [
                607
            ],
            "primarySidecarId": [
                607
            ],
            "skipScalePayment": [
                137
            ],
            "ustudioBrightness": [
                619
            ],
            "ustudioEnabled": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "UserRegistrationInput": {
            "firstName": [
                1199
            ],
            "lastName": [
                1199
            ],
            "password": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "UserResultPage": {
            "entries": [
                1372
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "UserRoleAssignment": {
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "organizationId": [
                607
            ],
            "role": [
                1059
            ],
            "roleId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "user": [
                1372
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "UserRoleAssignmentFilter": {
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "pagination": [
                906
            ],
            "roleId": [
                607
            ],
            "sorting": [
                1387
            ],
            "userId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "UserRoleAssignmentInput": {
            "facilityId": [
                607
            ],
            "roleId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "UserRoleAssignmentResultPage": {
            "entries": [
                1383
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "UserRoleAssignmentSortOption": {},
        "UserSortOption": {},
        "UserStatus": {},
        "ValidationIssue": {
            "code": [
                1199
            ],
            "field": [
                1199
            ],
            "message": [
                1199
            ],
            "nodeId": [
                1199
            ],
            "severity": [
                1391
            ],
            "__typename": [
                1199
            ]
        },
        "ValidationSeverity": {},
        "Variable": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "description": [
                1199
            ],
            "id": [
                607
            ],
            "name": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedById": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "value": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "VariableFilter": {
            "ids": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "VariableInput": {
            "description": [
                1199
            ],
            "name": [
                1199
            ],
            "updatedById": [
                607
            ],
            "value": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "VariableResultPage": {
            "entries": [
                1392
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "VariableSortOption": {},
        "VariableUpdateInput": {
            "description": [
                1199
            ],
            "name": [
                1199
            ],
            "updatedById": [
                607
            ],
            "value": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "VariableUpdateResult": {
            "affectedTierCount": [
                619
            ],
            "validationErrors": [
                1399
            ],
            "variable": [
                1392
            ],
            "__typename": [
                1199
            ]
        },
        "VariableValidationError": {
            "calculatedValues": [
                828
            ],
            "formulaType": [
                1199
            ],
            "itemId": [
                607
            ],
            "itemPricingId": [
                607
            ],
            "priceListName": [
                1199
            ],
            "priceListType": [
                1199
            ],
            "tierIndex": [
                619
            ],
            "__typename": [
                1199
            ]
        },
        "ViolationSeverity": {},
        "ViolationType": {},
        "VoidBookingItemResult": {
            "blockingLoads": [
                34
            ],
            "booking": [
                123
            ],
            "requiresConfirmation": [
                137
            ],
            "unlinkableLoads": [
                34
            ],
            "__typename": [
                1199
            ]
        },
        "VoidBookingResult": {
            "blockingLoads": [
                34
            ],
            "booking": [
                123
            ],
            "requiresConfirmation": [
                137
            ],
            "unlinkableLoads": [
                34
            ],
            "__typename": [
                1199
            ]
        },
        "VoidSalesOrderItemResult": {
            "blockingLoads": [
                34
            ],
            "requiresConfirmation": [
                137
            ],
            "salesOrder": [
                1090
            ],
            "unlinkableLoads": [
                34
            ],
            "__typename": [
                1199
            ]
        },
        "VoidSalesOrderResult": {
            "blockingLoads": [
                34
            ],
            "requiresConfirmation": [
                137
            ],
            "salesOrder": [
                1090
            ],
            "unlinkableLoads": [
                34
            ],
            "__typename": [
                1199
            ]
        },
        "VoucherTemplate": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "facilityId": [
                607
            ],
            "financialAccountId": [
                607
            ],
            "id": [
                607
            ],
            "showAccountNumber": [
                137
            ],
            "showDiscountAmount": [
                137
            ],
            "showInvoiceAmount": [
                137
            ],
            "showInvoiceDate": [
                137
            ],
            "showInvoiceNumber": [
                137
            ],
            "showMemo": [
                137
            ],
            "showNetAmount": [
                137
            ],
            "showPayeeAddress": [
                137
            ],
            "showPayeeName": [
                137
            ],
            "showPaymentDate": [
                137
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "__typename": [
                1199
            ]
        },
        "VoucherTemplateFilter": {
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "VoucherTemplateInput": {
            "facilityId": [
                607
            ],
            "financialAccountId": [
                607
            ],
            "showAccountNumber": [
                137
            ],
            "showDiscountAmount": [
                137
            ],
            "showInvoiceAmount": [
                137
            ],
            "showInvoiceDate": [
                137
            ],
            "showInvoiceNumber": [
                137
            ],
            "showMemo": [
                137
            ],
            "showNetAmount": [
                137
            ],
            "showPayeeAddress": [
                137
            ],
            "showPayeeName": [
                137
            ],
            "showPaymentDate": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "VoucherTemplateResultPage": {
            "entries": [
                1406
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "VoucherTemplateSortOption": {},
        "VoucherTemplateUpdateInput": {
            "facilityId": [
                607
            ],
            "financialAccountId": [
                607
            ],
            "showAccountNumber": [
                137
            ],
            "showDiscountAmount": [
                137
            ],
            "showInvoiceAmount": [
                137
            ],
            "showInvoiceDate": [
                137
            ],
            "showInvoiceNumber": [
                137
            ],
            "showMemo": [
                137
            ],
            "showNetAmount": [
                137
            ],
            "showPayeeAddress": [
                137
            ],
            "showPayeeName": [
                137
            ],
            "showPaymentDate": [
                137
            ],
            "__typename": [
                1199
            ]
        },
        "WOPIDiscoveryInfo": {
            "collaboraUrl": [
                1199
            ],
            "discoveryUrl": [
                1199
            ],
            "maxFileSize": [
                619
            ],
            "supportedFileTypes": [
                1416
            ],
            "wopiSrc": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "WOPIEditingSession": {
            "collaboraUrl": [
                1199
            ],
            "editUrl": [
                1199
            ],
            "fileId": [
                607
            ],
            "token": [
                1417
            ],
            "__typename": [
                1199
            ]
        },
        "WOPIFileAction": {},
        "WOPIPermission": {},
        "WOPISupportedFileType": {
            "actions": [
                1414
            ],
            "defaultAction": [
                1414
            ],
            "extension": [
                1199
            ],
            "mimeType": [
                1199
            ],
            "name": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "WOPIToken": {
            "expiresAt": [
                1247
            ],
            "fileId": [
                607
            ],
            "permission": [
                1415
            ],
            "token": [
                1199
            ],
            "tokenId": [
                1199
            ],
            "userEmail": [
                1199
            ],
            "userId": [
                607
            ],
            "userName": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "WarehouseCredential": {
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "databaseName": [
                1199
            ],
            "enabled": [
                137
            ],
            "host": [
                1199
            ],
            "id": [
                607
            ],
            "port": [
                619
            ],
            "ssl": [
                137
            ],
            "timestamps": [
                1250
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "username": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "WarehouseCredentialFilter": {
            "ids": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "WarehouseCredentialResultPage": {
            "entries": [
                1418
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "WarehouseCredentialSortOption": {},
        "WebhookEndpoint": {
            "automationId": [
                607
            ],
            "id": [
                607
            ],
            "isActive": [
                137
            ],
            "lastUsedAt": [
                1446
            ],
            "path": [
                1199
            ],
            "secret": [
                1199
            ],
            "timestamps": [
                1250
            ],
            "__typename": [
                1199
            ]
        },
        "Weekday": {},
        "Weight": {
            "unit": [
                1307
            ],
            "value": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "WeightDisplayUnit": {},
        "WeightInput": {
            "unit": [
                1307
            ],
            "value": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "WorkOrder": {
            "actualEndDate": [
                1446
            ],
            "actualStartDate": [
                1446
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "facility": [
                470
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "inboundTollingAgreement": [
                609
            ],
            "inboundTollingAgreementId": [
                607
            ],
            "inputItems": [
                1430
            ],
            "notes": [
                1199
            ],
            "outboundTollingAgreementId": [
                607
            ],
            "outputItems": [
                1434
            ],
            "processingType": [
                971
            ],
            "processingTypeId": [
                607
            ],
            "scheduledEndDate": [
                1446
            ],
            "scheduledStartDate": [
                1446
            ],
            "sourcePurchaseLoadLineItem": [
                996
            ],
            "sourcePurchaseLoadLineItemId": [
                607
            ],
            "status": [
                1440
            ],
            "timestamps": [
                1250
            ],
            "tollCustomerAccount": [
                3
            ],
            "tollCustomerAccountId": [
                607
            ],
            "tollingType": [
                1274
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "workOrderNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "WorkOrderFilter": {
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "fromActualEndDate": [
                1446
            ],
            "fromActualStartDate": [
                1446
            ],
            "fromScheduledEndDate": [
                1446
            ],
            "fromScheduledStartDate": [
                1446
            ],
            "ids": [
                607
            ],
            "inboundTollingAgreementId": [
                607
            ],
            "inboundTollingAgreementIds": [
                607
            ],
            "notes": [
                1199
            ],
            "outboundTollingAgreementId": [
                607
            ],
            "outboundTollingAgreementIds": [
                607
            ],
            "processingTypeId": [
                607
            ],
            "processingTypeIds": [
                607
            ],
            "searchTerm": [
                1199
            ],
            "sourcePurchaseLoadLineItemId": [
                607
            ],
            "sourcePurchaseLoadLineItemIds": [
                607
            ],
            "status": [
                1440
            ],
            "toActualEndDate": [
                1446
            ],
            "toActualStartDate": [
                1446
            ],
            "toScheduledEndDate": [
                1446
            ],
            "toScheduledStartDate": [
                1446
            ],
            "tollCustomerAccountId": [
                607
            ],
            "tollCustomerAccountIds": [
                607
            ],
            "tollingType": [
                1274
            ],
            "workOrderNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "WorkOrderInput": {
            "actualEndDate": [
                1446
            ],
            "actualStartDate": [
                1446
            ],
            "facilityId": [
                607
            ],
            "inboundTollingAgreementId": [
                607
            ],
            "inputItems": [
                349
            ],
            "notes": [
                1199
            ],
            "outboundTollingAgreementId": [
                607
            ],
            "outputItems": [
                350
            ],
            "processingTypeId": [
                607
            ],
            "scheduledEndDate": [
                1446
            ],
            "scheduledStartDate": [
                1446
            ],
            "sourcePurchaseLoadLineItemId": [
                607
            ],
            "status": [
                1440
            ],
            "tollCustomerAccountId": [
                607
            ],
            "tollingType": [
                1274
            ],
            "workOrderNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "WorkOrderInputItem": {
            "actualQuantity": [
                393
            ],
            "actualQuantityUnit": [
                1307
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "lot": [
                645
            ],
            "lotId": [
                607
            ],
            "notes": [
                1199
            ],
            "plannedQuantity": [
                393
            ],
            "plannedQuantityUnit": [
                1307
            ],
            "tag": [
                693
            ],
            "tagId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "unitCost": [
                835
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "workOrderId": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "WorkOrderInputItemFilter": {
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "itemId": [
                607
            ],
            "itemIds": [
                607
            ],
            "lotId": [
                607
            ],
            "lotIds": [
                607
            ],
            "notes": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "tagId": [
                607
            ],
            "tagIds": [
                607
            ],
            "workOrderId": [
                607
            ],
            "workOrderIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "WorkOrderInputItemResultPage": {
            "entries": [
                1430
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "WorkOrderInputItemSortOption": {},
        "WorkOrderOutputItem": {
            "actualQuantity": [
                393
            ],
            "actualQuantityUnit": [
                1307
            ],
            "allocatedCost": [
                835
            ],
            "costAllocationPercentage": [
                393
            ],
            "createdBy": [
                607
            ],
            "createdByUser": [
                1372
            ],
            "expectedQuantity": [
                393
            ],
            "expectedQuantityUnit": [
                1307
            ],
            "facilityId": [
                607
            ],
            "id": [
                607
            ],
            "isNoCost": [
                137
            ],
            "item": [
                727
            ],
            "itemId": [
                607
            ],
            "notes": [
                1199
            ],
            "targetLot": [
                645
            ],
            "targetLotId": [
                607
            ],
            "targetTag": [
                693
            ],
            "targetTagId": [
                607
            ],
            "timestamps": [
                1250
            ],
            "unitCost": [
                835
            ],
            "updatedBy": [
                607
            ],
            "updatedByUser": [
                1372
            ],
            "workOrderId": [
                607
            ],
            "yieldPercentage": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "WorkOrderOutputItemFilter": {
            "facilityId": [
                607
            ],
            "facilityIds": [
                607
            ],
            "ids": [
                607
            ],
            "itemId": [
                607
            ],
            "itemIds": [
                607
            ],
            "notes": [
                1199
            ],
            "searchTerm": [
                1199
            ],
            "targetLotId": [
                607
            ],
            "targetLotIds": [
                607
            ],
            "targetTagId": [
                607
            ],
            "targetTagIds": [
                607
            ],
            "workOrderId": [
                607
            ],
            "workOrderIds": [
                607
            ],
            "__typename": [
                1199
            ]
        },
        "WorkOrderOutputItemResultPage": {
            "entries": [
                1434
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "WorkOrderOutputItemSortOption": {},
        "WorkOrderResultPage": {
            "entries": [
                1427
            ],
            "page": [
                905
            ],
            "__typename": [
                1199
            ]
        },
        "WorkOrderSortOption": {},
        "WorkOrderStatus": {},
        "WorkOrderUpdateInput": {
            "actualEndDate": [
                1446
            ],
            "actualStartDate": [
                1446
            ],
            "facilityId": [
                607
            ],
            "inboundTollingAgreementId": [
                607
            ],
            "inputItems": [
                1366
            ],
            "notes": [
                1199
            ],
            "outboundTollingAgreementId": [
                607
            ],
            "outputItems": [
                1367
            ],
            "processingTypeId": [
                607
            ],
            "scheduledEndDate": [
                1446
            ],
            "scheduledStartDate": [
                1446
            ],
            "sourcePurchaseLoadLineItemId": [
                607
            ],
            "tollCustomerAccountId": [
                607
            ],
            "tollingType": [
                1274
            ],
            "workOrderNumber": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "WriteOffInvoiceInput": {
            "amount": [
                836
            ],
            "invoiceId": [
                607
            ],
            "notes": [
                1199
            ],
            "__typename": [
                1199
            ]
        },
        "ZoneStatus": {},
        "ZoneType": {},
        "ZoneUtilization": {
            "availableCapacity": [
                393
            ],
            "totalCapacity": [
                393
            ],
            "usedCapacity": [
                393
            ],
            "utilizationPercentage": [
                393
            ],
            "__typename": [
                1199
            ]
        },
        "ZonedDateTime": {},
        "ZonedDateTimeRangeInput": {
            "end": [
                1446
            ],
            "start": [
                1446
            ],
            "__typename": [
                1199
            ]
        }
    }
}